function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("8vJyT", function(module, exports) {
    $parcel$export(module.exports, "performSideEffects", ()=>$c52370d1937e44fa$export$6a031656e7e476a0);
    var $aXdeS = parcelRequire("aXdeS");
    parcelRequire("ginVq");
    var $65Ltd;
    var $dJl1T;
    var $4R6GH;
    var $cfDZ3;
    var $fjcgS;
    var $krjHY;
    var $dMAhS;
    var $jDwcu;
    var $2McXs;
    var $gxmom;
    var $i5RmH;
    var $hAzkC;
    var $84zci;
    var $50DPg;
    var $aVXdO;
    var $3Vshz;
    const $c52370d1937e44fa$var$routeTimeoutOverride = {
        [(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_VIEW)]: 1500
    };
    const $c52370d1937e44fa$export$6a031656e7e476a0 = async ()=>{
        const action = window.connectHost != null && window.connectHost !== (0, ($parcel$interopDefault($aXdeS))) ? 'replaced' : 'loaded';
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((analyticsClient)=>{
            analyticsClient.getInstance().sendOperationalEvent({
                source: 'connect-loader',
                actionSubject: 'connectHost',
                action: action,
                attributes: {
                    isSpa: !!window.__SPA__,
                    userLocation: (0, (0, parcelRequire("cfDZ3")).getUserLocation)()
                }
            });
        });
        window.connectHost = (0, ($parcel$interopDefault($aXdeS)));
        (0, ($parcel$interopDefault($aXdeS))).__FLAVOUR__ = 'MODERN';
        const routeName = (0, (0, parcelRequire("cfDZ3")).getRouteName)();
        const loadingTimeout = (0, (0, parcelRequire("4R6GH")).fg)('endeavour_improve_dashboard_connect_scripts') ? $c52370d1937e44fa$var$routeTimeoutOverride[routeName] ?? 5000 : 5000;
        const loaderPromises = [
            (0, (0, parcelRequire("3Vshz")).waitForLegacyConnectWRM)(loadingTimeout),
            (0, (0, parcelRequire("2McXs")).registerDialogOptions)(),
            (0, (0, parcelRequire("gxmom")).registerAcCreate)(),
            (0, (0, parcelRequire("gxmom")).registerIframeHandlers)((0, ($parcel$interopDefault($aXdeS)))),
            (0, (0, parcelRequire("gxmom")).registerAnalyticsHandler)(),
            (0, (0, parcelRequire("jDwcu")).registerContentResolver)((0, ($parcel$interopDefault($aXdeS)))),
            (0, (0, parcelRequire("dMAhS")).registerContextCache)((0, ($parcel$interopDefault($aXdeS)))),
            (0, (0, parcelRequire("i5RmH")).registerCoreModules)((0, ($parcel$interopDefault($aXdeS)))),
            (0, (0, parcelRequire("hAzkC")).registerDashboardItemEvents)((0, ($parcel$interopDefault($aXdeS)))),
            (0, (0, parcelRequire("50DPg")).registerJiraRoutes)(),
            (0, (0, parcelRequire("aVXdO")).registerWorkflowEvents)((0, ($parcel$interopDefault($aXdeS)))),
            (0, (0, parcelRequire("84zci")).registerJiraModules)((0, ($parcel$interopDefault($aXdeS)))),
            (0, (0, parcelRequire("krjHY")).registerConnectStyles)()
        ];
        await Promise.all(loaderPromises).catch((error)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('connect.loader', `Failed to fully load connectHost on route ${routeName}: ${error}`);
        });
    };
});
parcelRegister("aXdeS", function(module, exports) {
    (function(global1, factory) {
        module.exports = factory();
    })(module.exports, function() {
        'use strict';
        function _extends() {
            _extends = Object.assign ? Object.assign.bind() : function(target) {
                for(var i = 1; i < arguments.length; i++){
                    var source = arguments[i];
                    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
                }
                return target;
            };
            return _extends.apply(this, arguments);
        }
        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                o.__proto__ = p;
                return o;
            };
            return _setPrototypeOf(o, p);
        }
        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            _setPrototypeOf(subClass, superClass);
        }
        var domain;
        function EventHandlers() {}
        EventHandlers.prototype = Object.create(null);
        function EventEmitter() {
            EventEmitter.init.call(this);
        }
        EventEmitter.EventEmitter = EventEmitter;
        EventEmitter.usingDomains = false;
        EventEmitter.prototype.domain = undefined;
        EventEmitter.prototype._events = undefined;
        EventEmitter.prototype._maxListeners = undefined;
        EventEmitter.defaultMaxListeners = 10;
        EventEmitter.init = function() {
            this.domain = null;
            if (EventEmitter.usingDomains) domain.active;
            if (!this._events || this._events === Object.getPrototypeOf(this)._events) {
                this._events = new EventHandlers();
                this._eventsCount = 0;
            }
            this._maxListeners = this._maxListeners || undefined;
        };
        EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
            if (typeof n !== 'number' || n < 0 || isNaN(n)) throw new TypeError('"n" argument must be a positive number');
            this._maxListeners = n;
            return this;
        };
        function $getMaxListeners(that) {
            if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
            return that._maxListeners;
        }
        EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
            return $getMaxListeners(this);
        };
        function emitNone(handler, isFn, self1) {
            if (isFn) handler.call(self1);
            else {
                var len = handler.length;
                var listeners = arrayClone(handler, len);
                for(var i = 0; i < len; ++i)listeners[i].call(self1);
            }
        }
        function emitOne(handler, isFn, self1, arg1) {
            if (isFn) handler.call(self1, arg1);
            else {
                var len = handler.length;
                var listeners = arrayClone(handler, len);
                for(var i = 0; i < len; ++i)listeners[i].call(self1, arg1);
            }
        }
        function emitTwo(handler, isFn, self1, arg1, arg2) {
            if (isFn) handler.call(self1, arg1, arg2);
            else {
                var len = handler.length;
                var listeners = arrayClone(handler, len);
                for(var i = 0; i < len; ++i)listeners[i].call(self1, arg1, arg2);
            }
        }
        function emitThree(handler, isFn, self1, arg1, arg2, arg3) {
            if (isFn) handler.call(self1, arg1, arg2, arg3);
            else {
                var len = handler.length;
                var listeners = arrayClone(handler, len);
                for(var i = 0; i < len; ++i)listeners[i].call(self1, arg1, arg2, arg3);
            }
        }
        function emitMany(handler, isFn, self1, args) {
            if (isFn) handler.apply(self1, args);
            else {
                var len = handler.length;
                var listeners = arrayClone(handler, len);
                for(var i = 0; i < len; ++i)listeners[i].apply(self1, args);
            }
        }
        EventEmitter.prototype.emit = function emit(type) {
            var er, handler, len, args, i, events, domain;
            var doError = type === 'error';
            events = this._events;
            if (events) doError = doError && events.error == null;
            else if (!doError) return false;
            domain = this.domain;
            if (doError) {
                er = arguments[1];
                if (domain) {
                    if (!er) er = new Error('Uncaught, unspecified "error" event');
                    er.domainEmitter = this;
                    er.domain = domain;
                    er.domainThrown = false;
                    domain.emit('error', er);
                } else if (er instanceof Error) throw er;
                else {
                    var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
                    err.context = er;
                    throw err;
                }
                return false;
            }
            handler = events[type];
            if (!handler) return false;
            var isFn = typeof handler === 'function';
            len = arguments.length;
            switch(len){
                case 1:
                    emitNone(handler, isFn, this);
                    break;
                case 2:
                    emitOne(handler, isFn, this, arguments[1]);
                    break;
                case 3:
                    emitTwo(handler, isFn, this, arguments[1], arguments[2]);
                    break;
                case 4:
                    emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
                    break;
                default:
                    args = new Array(len - 1);
                    for(i = 1; i < len; i++)args[i - 1] = arguments[i];
                    emitMany(handler, isFn, this, args);
            }
            return true;
        };
        function _addListener(target, type, listener, prepend) {
            var m;
            var events;
            var existing;
            if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
            events = target._events;
            if (!events) {
                events = target._events = new EventHandlers();
                target._eventsCount = 0;
            } else {
                if (events.newListener) {
                    target.emit('newListener', type, listener.listener ? listener.listener : listener);
                    events = target._events;
                }
                existing = events[type];
            }
            if (!existing) {
                existing = events[type] = listener;
                ++target._eventsCount;
            } else {
                if (typeof existing === 'function') existing = events[type] = prepend ? [
                    listener,
                    existing
                ] : [
                    existing,
                    listener
                ];
                else if (prepend) existing.unshift(listener);
                else existing.push(listener);
                if (!existing.warned) {
                    m = $getMaxListeners(target);
                    if (m && m > 0 && existing.length > m) {
                        existing.warned = true;
                        var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + type + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit');
                        w.name = 'MaxListenersExceededWarning';
                        w.emitter = target;
                        w.type = type;
                        w.count = existing.length;
                        emitWarning(w);
                    }
                }
            }
            return target;
        }
        function emitWarning(e) {
            typeof console.warn === 'function' ? console.warn(e) : console.log(e);
        }
        EventEmitter.prototype.addListener = function addListener(type, listener) {
            return _addListener(this, type, listener, false);
        };
        EventEmitter.prototype.on = EventEmitter.prototype.addListener;
        EventEmitter.prototype.prependListener = function prependListener(type, listener) {
            return _addListener(this, type, listener, true);
        };
        function _onceWrap(target, type, listener) {
            var fired = false;
            function g() {
                target.removeListener(type, g);
                if (!fired) {
                    fired = true;
                    listener.apply(target, arguments);
                }
            }
            g.listener = listener;
            return g;
        }
        EventEmitter.prototype.once = function once(type, listener) {
            if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
            this.on(type, _onceWrap(this, type, listener));
            return this;
        };
        EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
            if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
            this.prependListener(type, _onceWrap(this, type, listener));
            return this;
        };
        EventEmitter.prototype.removeListener = function removeListener(type, listener) {
            var list, events, position, i, originalListener;
            if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
            events = this._events;
            if (!events) return this;
            list = events[type];
            if (!list) return this;
            if (list === listener || list.listener && list.listener === listener) {
                if (--this._eventsCount === 0) this._events = new EventHandlers();
                else {
                    delete events[type];
                    if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
                }
            } else if (typeof list !== 'function') {
                position = -1;
                for(i = list.length; i-- > 0;)if (list[i] === listener || list[i].listener && list[i].listener === listener) {
                    originalListener = list[i].listener;
                    position = i;
                    break;
                }
                if (position < 0) return this;
                if (list.length === 1) {
                    list[0] = undefined;
                    if (--this._eventsCount === 0) {
                        this._events = new EventHandlers();
                        return this;
                    } else delete events[type];
                } else spliceOne(list, position);
                if (events.removeListener) this.emit('removeListener', type, originalListener || listener);
            }
            return this;
        };
        EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
            var listeners, events;
            events = this._events;
            if (!events) return this;
            if (!events.removeListener) {
                if (arguments.length === 0) {
                    this._events = new EventHandlers();
                    this._eventsCount = 0;
                } else if (events[type]) {
                    if (--this._eventsCount === 0) this._events = new EventHandlers();
                    else delete events[type];
                }
                return this;
            }
            if (arguments.length === 0) {
                var keys = Object.keys(events);
                for(var i = 0, key; i < keys.length; ++i){
                    key = keys[i];
                    if (key === 'removeListener') continue;
                    this.removeAllListeners(key);
                }
                this.removeAllListeners('removeListener');
                this._events = new EventHandlers();
                this._eventsCount = 0;
                return this;
            }
            listeners = events[type];
            if (typeof listeners === 'function') this.removeListener(type, listeners);
            else if (listeners) do this.removeListener(type, listeners[listeners.length - 1]);
            while (listeners[0])
            return this;
        };
        EventEmitter.prototype.listeners = function listeners(type) {
            var evlistener;
            var ret;
            var events = this._events;
            if (!events) ret = [];
            else {
                evlistener = events[type];
                if (!evlistener) ret = [];
                else if (typeof evlistener === 'function') ret = [
                    evlistener.listener || evlistener
                ];
                else ret = unwrapListeners(evlistener);
            }
            return ret;
        };
        EventEmitter.listenerCount = function(emitter, type) {
            if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
            else return listenerCount.call(emitter, type);
        };
        EventEmitter.prototype.listenerCount = listenerCount;
        function listenerCount(type) {
            var events = this._events;
            if (events) {
                var evlistener = events[type];
                if (typeof evlistener === 'function') return 1;
                else if (evlistener) return evlistener.length;
            }
            return 0;
        }
        EventEmitter.prototype.eventNames = function eventNames() {
            return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
        };
        function spliceOne(list, index) {
            for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
            list.pop();
        }
        function arrayClone(arr, i) {
            var copy = new Array(i);
            while(i--)copy[i] = arr[i];
            return copy;
        }
        function unwrapListeners(arr) {
            var ret = new Array(arr.length);
            for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
            return ret;
        }
        var EventDispatcher = function(_EventEmitter) {
            _inheritsLoose(EventDispatcher, _EventEmitter);
            function EventDispatcher() {
                var _this;
                _this = _EventEmitter.call(this) || this;
                _this.setMaxListeners(20);
                return _this;
            }
            var _proto = EventDispatcher.prototype;
            _proto.dispatch = function dispatch(action) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                this.emit.apply(this, [
                    'before:' + action
                ].concat(args));
                this.emit.apply(this, arguments);
                this.emit.apply(this, [
                    'after:' + action
                ].concat(args));
            };
            _proto.registerOnce = function registerOnce(action, callback) {
                if (typeof action === 'string') this.once(action, callback);
                else throw 'ACJS: event name must be string';
            };
            _proto.register = function register(action, callback) {
                if (typeof action === 'string') this.on(action, callback);
                else throw 'ACJS: event name must be string';
            };
            _proto.unregister = function unregister(action, callback) {
                if (typeof action === 'string') this.removeListener(action, callback);
                else throw 'ACJS: event name must be string';
            };
            return EventDispatcher;
        }(EventEmitter);
        var EventDispatcher$1 = new EventDispatcher();
        var LoadingIndicatorActions = {
            timeout: function timeout($el, extension) {
                EventDispatcher$1.dispatch('iframe-bridge-timeout', {
                    $el: $el,
                    extension: extension
                });
            },
            cancelled: function cancelled($el, extension) {
                EventDispatcher$1.dispatch('iframe-bridge-cancelled', {
                    $el: $el,
                    extension: extension
                });
            }
        };
        var $ = window.AJS && window.AJS.$ || function() {
            console.error('[ACJS] jQuery was not loaded before Connect. If in product frontend, make sure to load via a wrapper, eg withConnectHost()');
        };
        var LOADING_INDICATOR_CLASS = 'ap-status-indicator';
        var LOADING_STATUSES = {
            loading: '<div class="ap-loading"><div class="small-spinner"></div>Loading app...</div>',
            'load-timeout': '<div class="ap-load-timeout"><div class="small-spinner"></div>App is not responding. Wait or <a href="#" class="ap-btn-cancel">cancel</a>?</div>',
            'load-error': 'App failed to load.'
        };
        var LOADING_TIMEOUT = 12000;
        var LoadingIndicator = function() {
            function LoadingIndicator() {
                this._stateRegistry = {};
            }
            var _proto = LoadingIndicator.prototype;
            _proto._loadingContainer = function _loadingContainer($iframeContainer) {
                return $iframeContainer.find('.' + LOADING_INDICATOR_CLASS);
            };
            _proto.render = function render() {
                var container = document.createElement('div');
                container.classList.add(LOADING_INDICATOR_CLASS);
                container.innerHTML = LOADING_STATUSES.loading;
                var $container = $(container);
                this._startSpinner($container);
                return $container;
            };
            _proto._startSpinner = function _startSpinner($container) {
                setTimeout(function() {
                    var spinner = $container.find('.small-spinner');
                    if (spinner.length && spinner.spin) spinner.spin({
                        lines: 12,
                        length: 3,
                        width: 2,
                        radius: 3,
                        trail: 60,
                        speed: 1.5,
                        zIndex: 1
                    });
                }, 10);
            };
            _proto.hide = function hide($iframeContainer, extensionId) {
                this._clearTimeout(extensionId);
                this._loadingContainer($iframeContainer)[0].style.display = 'none';
            };
            _proto.cancelled = function cancelled($iframeContainer, extensionId) {
                var status = LOADING_STATUSES['load-error'];
                this._loadingContainer($iframeContainer).empty().text(status);
            };
            _proto._setupTimeout = function _setupTimeout($container, extension) {
                this._stateRegistry[extension.id] = setTimeout(function() {
                    LoadingIndicatorActions.timeout($container, extension);
                }, LOADING_TIMEOUT);
            };
            _proto._clearTimeout = function _clearTimeout(extensionId) {
                if (this._stateRegistry[extensionId]) {
                    clearTimeout(this._stateRegistry[extensionId]);
                    delete this._stateRegistry[extensionId];
                }
            };
            _proto.timeout = function timeout($iframeContainer, extensionId) {
                var status = $(LOADING_STATUSES['load-timeout']);
                var container = this._loadingContainer($iframeContainer);
                container.empty().append(status);
                this._startSpinner(container);
                $('a.ap-btn-cancel', container).click(function() {
                    LoadingIndicatorActions.cancelled($iframeContainer, extensionId);
                });
                this._clearTimeout(extensionId);
                return container;
            };
            return LoadingIndicator;
        }();
        var LoadingComponent = new LoadingIndicator();
        EventDispatcher$1.register('iframe-create', function(data) {
            if (!data.extension.options.noDom) LoadingComponent._setupTimeout(data.$el.parents('.ap-iframe-container'), data.extension);
        });
        EventDispatcher$1.register('iframe-bridge-established', function(data) {
            if (!data.extension.options.noDom) LoadingComponent.hide(data.$el.parents('.ap-iframe-container'), data.extension.id);
        });
        EventDispatcher$1.register('iframe-bridge-timeout', function(data) {
            if (!data.extension.options.noDom) LoadingComponent.timeout(data.$el, data.extension.id);
        });
        EventDispatcher$1.register('iframe-bridge-cancelled', function(data) {
            if (!data.extension.options.noDom) LoadingComponent.cancelled(data.$el, data.extension.id);
        });
        EventDispatcher$1.register('iframe-destroyed', function(data) {
            LoadingComponent._clearTimeout(data.extension.extension_id);
        });
        function _objectWithoutPropertiesLoose(source, excluded) {
            if (source == null) return {};
            var target = {};
            var sourceKeys = Object.keys(source);
            var key, i;
            for(i = 0; i < sourceKeys.length; i++){
                key = sourceKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                target[key] = source[key];
            }
            return target;
        }
        function _isNativeReflectConstruct$1() {
            if (typeof Reflect === "undefined" || !Reflect.construct) return false;
            if (Reflect.construct.sham) return false;
            if (typeof Proxy === "function") return true;
            try {
                Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                return true;
            } catch (e) {
                return false;
            }
        }
        function _construct(Parent, args, Class) {
            if (_isNativeReflectConstruct$1()) _construct = Reflect.construct.bind();
            else _construct = function _construct(Parent, args, Class) {
                var a = [
                    null
                ];
                a.push.apply(a, args);
                var Constructor = Function.bind.apply(Parent, a);
                var instance = new Constructor();
                if (Class) _setPrototypeOf(instance, Class.prototype);
                return instance;
            };
            return _construct.apply(null, arguments);
        }
        var LOG_PREFIX = "[Simple-XDM] ";
        var nativeBind = Function.prototype.bind;
        var util = {
            locationOrigin: function locationOrigin() {
                if (!window.location.origin) return window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
                else return window.location.origin;
            },
            randomString: function randomString() {
                return Math.floor(Math.random() * 1000000000).toString(16);
            },
            isString: function isString(str) {
                return typeof str === "string" || str instanceof String;
            },
            argumentsToArray: function argumentsToArray(arrayLike) {
                return Array.prototype.slice.call(arrayLike);
            },
            argumentNames: function argumentNames(fn) {
                return fn.toString().replace(/((\/\/.*$)|(\/\*[^]*?\*\/))/mg, '').replace(/[^(]+\(([^)]*)[^]+/, '$1').match(/([^\s,]+)/g) || [];
            },
            hasCallback: function hasCallback(args) {
                var length = args.length;
                return length > 0 && typeof args[length - 1] === 'function';
            },
            error: function error(msg) {
                if (window.console && window.console.error) {
                    var outputError = [];
                    if (typeof msg === "string") {
                        outputError.push(LOG_PREFIX + msg);
                        outputError = outputError.concat(Array.prototype.slice.call(arguments, 1));
                    } else {
                        outputError.push(LOG_PREFIX);
                        outputError = outputError.concat(Array.prototype.slice.call(arguments));
                    }
                    window.console.error.apply(null, outputError);
                }
            },
            warn: function warn(msg) {
                if (window.console) console.warn(LOG_PREFIX + msg);
            },
            log: function log(msg) {
                if (window.console) window.console.log(LOG_PREFIX + msg);
            },
            _bind: function _bind(thisp, fn) {
                if (nativeBind && fn.bind === nativeBind) return fn.bind(thisp);
                return function() {
                    return fn.apply(thisp, arguments);
                };
            },
            throttle: function throttle(func, wait, context) {
                var previous = 0;
                return function() {
                    var now = Date.now();
                    if (now - previous > wait) {
                        previous = now;
                        func.apply(context, arguments);
                    }
                };
            },
            each: function each(list, iteratee) {
                var length;
                var key;
                if (list) {
                    length = list.length;
                    if (length != null && typeof list !== 'function') {
                        key = 0;
                        while(key < length){
                            if (iteratee.call(list[key], key, list[key]) === false) break;
                            key += 1;
                        }
                    } else {
                        for(key in list)if (list.hasOwnProperty(key)) {
                            if (iteratee.call(list[key], key, list[key]) === false) break;
                        }
                    }
                }
            },
            extend: function extend(dest) {
                var args = arguments;
                var srcs = [].slice.call(args, 1, args.length);
                srcs.forEach(function(source) {
                    if (typeof source === "object") Object.getOwnPropertyNames(source).forEach(function(name) {
                        dest[name] = source[name];
                    });
                });
                return dest;
            },
            sanitizeStructuredClone: function sanitizeStructuredClone(object) {
                var whiteList = [
                    Boolean,
                    String,
                    Date,
                    RegExp,
                    Blob,
                    File,
                    FileList,
                    ArrayBuffer
                ];
                var blackList = [
                    Error,
                    Node
                ];
                var warn = util.warn;
                var visitedObjects = [];
                function _clone(value) {
                    if (typeof value === 'function') {
                        warn("A function was detected and removed from the message.");
                        return null;
                    }
                    if (blackList.some(function(t) {
                        if (value instanceof t) {
                            warn(t.name + " object was detected and removed from the message.");
                            return true;
                        }
                        return false;
                    })) return {};
                    if (value && typeof value === 'object' && whiteList.every(function(t) {
                        return !(value instanceof t);
                    })) {
                        var newValue;
                        if (Array.isArray(value)) newValue = value.map(function(element) {
                            return _clone(element);
                        });
                        else {
                            if (visitedObjects.indexOf(value) > -1) {
                                warn("A circular reference was detected and removed from the message.");
                                return null;
                            }
                            visitedObjects.push(value);
                            newValue = {};
                            for(var name in value)if (value.hasOwnProperty(name)) {
                                var clonedValue = _clone(value[name]);
                                if (clonedValue !== null) newValue[name] = clonedValue;
                            }
                            visitedObjects.pop();
                        }
                        return newValue;
                    }
                    return value;
                }
                return _clone(object);
            },
            getOrigin: function getOrigin(url, base) {
                if (typeof URL === 'function') try {
                    return new URL(url, base).origin;
                } catch (e) {}
                var doc = document.implementation.createHTMLDocument('');
                if (base) {
                    var baseElement = doc.createElement('base');
                    baseElement.href = base;
                    doc.head.appendChild(baseElement);
                }
                var anchorElement = doc.createElement('a');
                anchorElement.href = url;
                doc.body.appendChild(anchorElement);
                var origin = anchorElement.protocol + '//' + anchorElement.hostname;
                if (url.match(/\/\/[^/]+:[0-9]+\//)) origin += anchorElement.port ? ':' + anchorElement.port : '';
                return origin;
            }
        };
        var PostMessage = function() {
            function PostMessage(data) {
                var d = data || {};
                this._registerListener(d.listenOn);
            }
            var _proto = PostMessage.prototype;
            _proto._registerListener = function _registerListener(listenOn) {
                if (!listenOn || !listenOn.addEventListener) listenOn = window;
                listenOn.addEventListener("message", util._bind(this, this._receiveMessage), false);
            };
            _proto._receiveMessage = function _receiveMessage(event) {
                var handler = this._messageHandlers[event.data.type], extensionId = event.data.eid, reg;
                if (extensionId && this._registeredExtensions) reg = this._registeredExtensions[extensionId];
                if (!handler || !this._checkOrigin(event, reg)) return false;
                handler.call(this, event, reg);
            };
            return PostMessage;
        }();
        var VALID_EVENT_TIME_MS = 30000;
        var XDMRPC = function(_PostMessage) {
            _inheritsLoose(XDMRPC, _PostMessage);
            var _proto = XDMRPC.prototype;
            _proto._padUndefinedArguments = function _padUndefinedArguments(array, length) {
                return array.length >= length ? array : array.concat(new Array(length - array.length));
            };
            function XDMRPC(config) {
                var _this;
                config = config || {};
                _this = _PostMessage.call(this, config) || this;
                _this._registeredExtensions = config.extensions || {};
                _this._registeredAPIModules = {};
                _this._registeredAPIModules._globals = {};
                _this._pendingCallbacks = {};
                _this._keycodeCallbacks = {};
                _this._clickHandler = null;
                _this._pendingEvents = {};
                _this._messageHandlers = {
                    init: _this._handleInit,
                    req: _this._handleRequest,
                    resp: _this._handleResponse,
                    broadcast: _this._handleBroadcast,
                    event_query: _this._handleEventQuery,
                    key_triggered: _this._handleKeyTriggered,
                    addon_clicked: _this._handleAddonClick,
                    get_host_offset: _this._getHostOffset,
                    unload: _this._handleUnload
                };
                return _this;
            }
            _proto._verifyAPI = function _verifyAPI(event, reg) {
                var untrustedTargets = event.data.targets;
                if (!untrustedTargets) return;
                var trustedSpec = this.getApiSpec();
                var tampered = false;
                function check(trusted, untrusted) {
                    Object.getOwnPropertyNames(untrusted).forEach(function(name) {
                        if (typeof untrusted[name] === 'object' && trusted[name]) check(trusted[name], untrusted[name]);
                        else if (untrusted[name] === 'parent' && trusted[name]) tampered = true;
                    });
                }
                check(trustedSpec, untrustedTargets);
                event.source.postMessage({
                    type: 'api_tamper',
                    tampered: tampered
                }, reg.extension.url);
            };
            _proto._handleInit = function _handleInit(event, reg) {
                event.source.postMessage({
                    type: 'init_received'
                }, reg.extension.url);
                this._registeredExtensions[reg.extension_id].source = event.source;
                if (reg.initCallback) {
                    reg.initCallback(event.data.eid);
                    delete reg.initCallback;
                }
                if (event.data.targets) this._verifyAPI(event, reg);
            };
            _proto._getHostOffset = function _getHostOffset(event, _window) {
                var hostWindow = event.source;
                var hostFrameOffset = null;
                var windowReference = _window || window;
                if (windowReference === windowReference.top && typeof windowReference.getHostOffsetFunctionOverride === 'function') hostFrameOffset = windowReference.getHostOffsetFunctionOverride(hostWindow);
                if (typeof hostFrameOffset !== 'number') {
                    hostFrameOffset = 0;
                    while(!this._hasSameOrigin(hostWindow)){
                        hostFrameOffset++;
                        hostWindow = hostWindow.parent;
                    }
                }
                event.source.postMessage({
                    hostFrameOffset: hostFrameOffset
                }, event.origin);
            };
            _proto._hasSameOrigin = function _hasSameOrigin(window1) {
                if (window1 === window1.top) return true;
                try {
                    var testVariableName = 'test_var_' + Math.random().toString(16).substr(2);
                    window1[testVariableName] = true;
                    return window1[testVariableName];
                } catch (e) {}
                return false;
            };
            _proto._handleResponse = function _handleResponse(event) {
                var data = event.data;
                var pendingCallback = this._pendingCallbacks[data.mid];
                if (pendingCallback) {
                    delete this._pendingCallbacks[data.mid];
                    pendingCallback.apply(window, data.args);
                }
            };
            _proto.registerRequestNotifier = function registerRequestNotifier(cb) {
                this._registeredRequestNotifier = cb;
            };
            _proto._handleRequest = function _handleRequest(event, reg) {
                function sendResponse() {
                    var args = util.sanitizeStructuredClone(util.argumentsToArray(arguments));
                    event.source.postMessage({
                        mid: event.data.mid,
                        type: 'resp',
                        forPlugin: true,
                        args: args
                    }, reg.extension.url);
                }
                var data = event.data;
                var module1 = this._registeredAPIModules[data.mod];
                var extension = this.getRegisteredExtensions(reg.extension)[0];
                if (module1) {
                    var fnName = data.fn;
                    if (data._cls) {
                        var Cls = module1[data._cls];
                        var ns = data.mod + '-' + data._cls + '-';
                        sendResponse._id = data._id;
                        if (fnName === 'constructor') {
                            if (!Cls._construct) {
                                Cls.constructor.prototype._destroy = function() {
                                    delete this._context._proxies[ns + this._id];
                                };
                                Cls._construct = function() {
                                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                                    var inst = _construct(Cls.constructor, args);
                                    var callback = args[args.length - 1];
                                    inst._id = callback._id;
                                    inst._context = callback._context;
                                    inst._context._proxies[ns + inst._id] = inst;
                                    return inst;
                                };
                            }
                            module1 = Cls;
                            fnName = '_construct';
                        } else module1 = extension._proxies[ns + data._id];
                    }
                    var method = module1[fnName];
                    if (method) {
                        var methodArgs = data.args;
                        var padLength = method.length - 1;
                        if (fnName === '_construct') padLength = module1.constructor.length - 1;
                        sendResponse._context = extension;
                        methodArgs = this._padUndefinedArguments(methodArgs, padLength);
                        methodArgs.push(sendResponse);
                        var promiseResult = method.apply(module1, methodArgs);
                        if (method.returnsPromise) {
                            if (!(typeof promiseResult === 'object' || typeof promiseResult === 'function') || typeof promiseResult.then !== 'function') sendResponse('Defined module method did not return a promise.');
                            else promiseResult.then(function(result) {
                                sendResponse(undefined, result);
                            }).catch(function(err) {
                                err = err instanceof Error ? err.message : err;
                                sendResponse(err);
                            });
                        }
                        if (this._registeredRequestNotifier) this._registeredRequestNotifier.call(null, {
                            module: data.mod,
                            fn: data.fn,
                            type: data.type,
                            addon_key: reg.extension.addon_key,
                            key: reg.extension.key,
                            extension_id: reg.extension_id
                        });
                    }
                }
            };
            _proto._handleBroadcast = function _handleBroadcast(event, reg) {
                var event_data = event.data;
                var targetSpec = function targetSpec(r) {
                    return r.extension.addon_key === reg.extension.addon_key && r.extension_id !== reg.extension_id;
                };
                this.dispatch(event_data.etyp, targetSpec, event_data.evnt, null, null);
            };
            _proto._handleKeyTriggered = function _handleKeyTriggered(event, reg) {
                var eventData = event.data;
                var keycodeEntry = this._keycodeKey(eventData.keycode, eventData.modifiers, reg.extension_id);
                var listeners = this._keycodeCallbacks[keycodeEntry];
                if (listeners) listeners.forEach(function(listener) {
                    listener.call(null, {
                        addon_key: reg.extension.addon_key,
                        key: reg.extension.key,
                        extension_id: reg.extension_id,
                        keycode: eventData.keycode,
                        modifiers: eventData.modifiers
                    });
                }, this);
            };
            _proto.defineAPIModule = function defineAPIModule(module1, moduleName) {
                moduleName = moduleName || '_globals';
                this._registeredAPIModules[moduleName] = util.extend({}, this._registeredAPIModules[moduleName] || {}, module1);
                return this._registeredAPIModules;
            };
            _proto.isAPIModuleDefined = function isAPIModuleDefined(moduleName) {
                return typeof this._registeredAPIModules[moduleName] !== 'undefined';
            };
            _proto._pendingEventKey = function _pendingEventKey(targetSpec, time) {
                var key = targetSpec.addon_key || 'global';
                if (targetSpec.key) key = key + "@@" + targetSpec.key;
                key = key + "@@" + time;
                return key;
            };
            _proto.queueEvent = function queueEvent(type, targetSpec, event, callback) {
                var loaded_frame, targets = this._findRegistrations(targetSpec);
                loaded_frame = targets.some(function(target) {
                    return target.registered_events !== undefined;
                }, this);
                if (loaded_frame) this.dispatch(type, targetSpec, event, callback);
                else {
                    this._cleanupInvalidEvents();
                    var time = new Date().getTime();
                    this._pendingEvents[this._pendingEventKey(targetSpec, time)] = {
                        type: type,
                        targetSpec: targetSpec,
                        event: event,
                        callback: callback,
                        time: time,
                        uid: util.randomString()
                    };
                }
            };
            _proto._cleanupInvalidEvents = function _cleanupInvalidEvents() {
                var _this2 = this;
                var now = new Date().getTime();
                var keys = Object.keys(this._pendingEvents);
                keys.forEach(function(index) {
                    var element = _this2._pendingEvents[index];
                    var eventIsValid = now - element.time <= VALID_EVENT_TIME_MS;
                    if (!eventIsValid) delete _this2._pendingEvents[index];
                });
            };
            _proto._handleEventQuery = function _handleEventQuery(message, extension) {
                var _this3 = this;
                var executed = {};
                var now = new Date().getTime();
                var keys = Object.keys(this._pendingEvents);
                keys.forEach(function(index) {
                    var element = _this3._pendingEvents[index];
                    var eventIsValid = now - element.time <= VALID_EVENT_TIME_MS;
                    var isSameTarget = !element.targetSpec || _this3._findRegistrations(element.targetSpec).length !== 0;
                    if (isSameTarget && element.targetSpec.key) isSameTarget = element.targetSpec.addon_key === extension.extension.addon_key && element.targetSpec.key === extension.extension.key;
                    if (eventIsValid && isSameTarget) {
                        executed[index] = element;
                        element.targetSpec = element.targetSpec || {};
                        _this3.dispatch(element.type, element.targetSpec, element.event, element.callback, message.source);
                    } else if (!eventIsValid) delete _this3._pendingEvents[index];
                });
                this._registeredExtensions[extension.extension_id].registered_events = message.data.args;
                return executed;
            };
            _proto._handleUnload = function _handleUnload(event, reg) {
                if (!reg) return;
                if (reg.extension_id && this._registeredExtensions[reg.extension_id]) delete this._registeredExtensions[reg.extension_id].source;
                if (reg.unloadCallback) reg.unloadCallback(event.data.eid);
            };
            _proto.dispatch = function dispatch(type, targetSpec, event, callback, source) {
                function sendEvent(reg, evnt) {
                    if (reg.source && reg.source.postMessage) {
                        var mid;
                        if (callback) {
                            mid = util.randomString();
                            this._pendingCallbacks[mid] = callback;
                        }
                        reg.source.postMessage({
                            type: 'evt',
                            mid: mid,
                            etyp: type,
                            evnt: evnt
                        }, reg.extension.url);
                    }
                }
                var registrations = this._findRegistrations(targetSpec || {});
                registrations.forEach(function(reg) {
                    if (source && !reg.source) reg.source = source;
                    if (reg.source) util._bind(this, sendEvent)(reg, event);
                }, this);
            };
            _proto._findRegistrations = function _findRegistrations(targetSpec) {
                var _this4 = this;
                if (this._registeredExtensions.length === 0) {
                    util.error('no registered extensions', this._registeredExtensions);
                    return [];
                }
                var keys = Object.getOwnPropertyNames(targetSpec);
                var registrations = Object.getOwnPropertyNames(this._registeredExtensions).map(function(key) {
                    return _this4._registeredExtensions[key];
                });
                if (targetSpec instanceof Function) return registrations.filter(targetSpec);
                else return registrations.filter(function(reg) {
                    return keys.every(function(key) {
                        return reg.extension[key] === targetSpec[key];
                    });
                });
            };
            _proto.registerExtension = function registerExtension(extension_id, data) {
                data._proxies = {};
                data.extension_id = extension_id;
                this._registeredExtensions[extension_id] = data;
            };
            _proto._keycodeKey = function _keycodeKey(key, modifiers, extension_id) {
                var code = key;
                if (modifiers) {
                    if (typeof modifiers === "string") modifiers = [
                        modifiers
                    ];
                    modifiers.sort();
                    modifiers.forEach(function(modifier) {
                        code += '$$' + modifier;
                    }, this);
                }
                return code + '__' + extension_id;
            };
            _proto.registerKeyListener = function registerKeyListener(extension_id, key, modifiers, callback) {
                if (typeof modifiers === "string") modifiers = [
                    modifiers
                ];
                var reg = this._registeredExtensions[extension_id];
                var keycodeEntry = this._keycodeKey(key, modifiers, extension_id);
                if (!this._keycodeCallbacks[keycodeEntry]) {
                    this._keycodeCallbacks[keycodeEntry] = [];
                    reg.source.postMessage({
                        type: 'key_listen',
                        keycode: key,
                        modifiers: modifiers,
                        action: 'add'
                    }, reg.extension.url);
                }
                this._keycodeCallbacks[keycodeEntry].push(callback);
            };
            _proto.unregisterKeyListener = function unregisterKeyListener(extension_id, key, modifiers, callback) {
                var keycodeEntry = this._keycodeKey(key, modifiers, extension_id);
                var potentialCallbacks = this._keycodeCallbacks[keycodeEntry];
                var reg = this._registeredExtensions[extension_id];
                if (potentialCallbacks) {
                    if (callback) {
                        var index = potentialCallbacks.indexOf(callback);
                        this._keycodeCallbacks[keycodeEntry].splice(index, 1);
                    } else delete this._keycodeCallbacks[keycodeEntry];
                    if (reg.source && reg.source.postMessage) reg.source.postMessage({
                        type: 'key_listen',
                        keycode: key,
                        modifiers: modifiers,
                        action: 'remove'
                    }, reg.extension.url);
                }
            };
            _proto.registerClickHandler = function registerClickHandler(callback) {
                if (typeof callback !== 'function') throw new Error('callback must be a function');
                if (this._clickHandler !== null) throw new Error('ClickHandler already registered');
                this._clickHandler = callback;
            };
            _proto._handleAddonClick = function _handleAddonClick(event, reg) {
                if (typeof this._clickHandler === 'function') this._clickHandler({
                    addon_key: reg.extension.addon_key,
                    key: reg.extension.key,
                    extension_id: reg.extension_id
                });
            };
            _proto.unregisterClickHandler = function unregisterClickHandler() {
                this._clickHandler = null;
            };
            _proto.getApiSpec = function getApiSpec(addonKey) {
                var _this5 = this;
                function getModuleDefinition(mod) {
                    return Object.getOwnPropertyNames(mod).reduce(function(accumulator, memberName) {
                        var member = mod[memberName];
                        switch(typeof member){
                            case 'function':
                                accumulator[memberName] = {
                                    args: util.argumentNames(member),
                                    returnsPromise: member.returnsPromise || false
                                };
                                break;
                            case 'object':
                                if (member.hasOwnProperty('constructor')) accumulator[memberName] = getModuleDefinition(member);
                                break;
                        }
                        return accumulator;
                    }, {});
                }
                return Object.getOwnPropertyNames(this._registeredAPIModules).reduce(function(accumulator, moduleName) {
                    var module1 = _this5._registeredAPIModules[moduleName];
                    if (typeof module1.addonKey === 'undefined' || module1.addonKey === addonKey) accumulator[moduleName] = getModuleDefinition(module1);
                    return accumulator;
                }, {});
            };
            _proto._originEqual = function _originEqual(url, origin) {
                function strCheck(str) {
                    return typeof str === 'string' && str.length > 0;
                }
                var urlOrigin = util.getOrigin(url);
                if (!strCheck(url) || !strCheck(origin) || !strCheck(urlOrigin)) return false;
                return origin === urlOrigin;
            };
            _proto._checkOrigin = function _checkOrigin(event, reg) {
                var no_source_types = [
                    'init'
                ];
                var isNoSourceType = reg && !reg.source && no_source_types.indexOf(event.data.type) > -1;
                var sourceTypeMatches = reg && event.source === reg.source;
                var hasExtensionUrl = reg && this._originEqual(reg.extension.url, event.origin);
                var isValidOrigin = hasExtensionUrl && (isNoSourceType || sourceTypeMatches);
                if (event.data.type === 'get_host_offset' && window === window.top) isValidOrigin = true;
                if (event.data.type === 'unload' && (sourceTypeMatches || event.source === undefined)) isValidOrigin = true;
                return isValidOrigin;
            };
            _proto.getRegisteredExtensions = function getRegisteredExtensions(filter) {
                if (filter) return this._findRegistrations(filter);
                return this._registeredExtensions;
            };
            _proto.unregisterExtension = function unregisterExtension(filter) {
                var registrations = this._findRegistrations(filter);
                if (registrations.length !== 0) registrations.forEach(function(registration) {
                    var _this6 = this;
                    var keys = Object.keys(this._pendingEvents);
                    keys.forEach(function(index) {
                        var element = _this6._pendingEvents[index];
                        var targetSpec = element.targetSpec || {};
                        if (targetSpec.addon_key === registration.extension.addon_key && targetSpec.key === registration.extension.key) delete _this6._pendingEvents[index];
                    });
                    delete this._registeredExtensions[registration.extension_id];
                }, this);
            };
            _proto.setFeatureFlagGetter = function setFeatureFlagGetter(getBooleanFeatureFlag) {
                this._getBooleanFeatureFlag = getBooleanFeatureFlag;
            };
            return XDMRPC;
        }(PostMessage);
        var Connect = function() {
            function Connect() {
                this._xdm = new XDMRPC();
            }
            var _proto = Connect.prototype;
            _proto.dispatch = function dispatch(type, targetSpec, event, callback) {
                this._xdm.queueEvent(type, targetSpec, event, callback);
                return this.getExtensions(targetSpec);
            };
            _proto.broadcast = function broadcast(type, targetSpec, event) {
                this._xdm.dispatch(type, targetSpec, event, null, null);
                return this.getExtensions(targetSpec);
            };
            _proto._createId = function _createId(extension) {
                if (!extension.addon_key || !extension.key) throw Error('Extensions require addon_key and key');
                return extension.addon_key + '__' + extension.key + '__' + util.randomString();
            };
            _proto.create = function create(extension, initCallback, unloadCallback) {
                var extension_id = this.registerExtension(extension, initCallback, unloadCallback);
                var options = extension.options || {};
                var data = {
                    extension_id: extension_id,
                    api: this._xdm.getApiSpec(extension.addon_key),
                    origin: util.locationOrigin(),
                    options: options
                };
                return {
                    id: extension_id,
                    name: JSON.stringify(data),
                    src: extension.url
                };
            };
            _proto.registerRequestNotifier = function registerRequestNotifier(callback) {
                this._xdm.registerRequestNotifier(callback);
            };
            _proto.registerExtension = function registerExtension(extension, initCallback, unloadCallback) {
                var extension_id = this._createId(extension);
                this._xdm.registerExtension(extension_id, {
                    extension: extension,
                    initCallback: initCallback,
                    unloadCallback: unloadCallback
                });
                return extension_id;
            };
            _proto.registerKeyListener = function registerKeyListener(extension_id, key, modifiers, callback) {
                this._xdm.registerKeyListener(extension_id, key, modifiers, callback);
            };
            _proto.unregisterKeyListener = function unregisterKeyListener(extension_id, key, modifiers, callback) {
                this._xdm.unregisterKeyListener(extension_id, key, modifiers, callback);
            };
            _proto.registerClickHandler = function registerClickHandler(callback) {
                this._xdm.registerClickHandler(callback);
            };
            _proto.unregisterClickHandler = function unregisterClickHandler() {
                this._xdm.unregisterClickHandler();
            };
            _proto.defineModule = function defineModule(moduleName, module1, options) {
                this._xdm.defineAPIModule(module1, moduleName, options);
            };
            _proto.isModuleDefined = function isModuleDefined(moduleName) {
                return this._xdm.isAPIModuleDefined(moduleName);
            };
            _proto.defineGlobals = function defineGlobals(module1) {
                this._xdm.defineAPIModule(module1);
            };
            _proto.getExtensions = function getExtensions(filter) {
                return this._xdm.getRegisteredExtensions(filter);
            };
            _proto.unregisterExtension = function unregisterExtension(filter) {
                return this._xdm.unregisterExtension(filter);
            };
            _proto.returnsPromise = function returnsPromise(wrappedMethod) {
                wrappedMethod.returnsPromise = true;
            };
            _proto.setFeatureFlagGetter = function setFeatureFlagGetter(getBooleanFeatureFlag) {
                this._xdm.setFeatureFlagGetter(getBooleanFeatureFlag);
            };
            _proto.registerExistingExtension = function registerExistingExtension(extension_id, data) {
                return this._xdm.registerExtension(extension_id, data);
            };
            return Connect;
        }();
        var host$1 = new Connect();
        var _excluded$1 = [
            "contextJwt",
            "url"
        ];
        var EventActions = {
            targetSpecNoDialogs: function targetSpecNoDialogs(registration) {
                var _registration$extensi;
                return (registration == null || (_registration$extensi = registration.extension) == null || (_registration$extensi = _registration$extensi.options) == null ? void 0 : _registration$extensi.moduleType) !== 'dialogs';
            },
            broadcast: function broadcast(type, targetSpec, event) {
                host$1.dispatch(type, targetSpec, event);
                EventDispatcher$1.dispatch('event-dispatch', {
                    type: type,
                    targetSpec: targetSpec,
                    event: event
                });
            },
            broadcastPublic: function broadcastPublic(type, event, sender) {
                EventDispatcher$1.dispatch('event-public-dispatch', {
                    type: type,
                    event: event,
                    sender: sender
                });
                var _ref = sender.options || {};
                _ref.contextJwt;
                _ref.url;
                var filteredOptions = _objectWithoutPropertiesLoose(_ref, _excluded$1);
                host$1.dispatch(type, {}, {
                    sender: {
                        addonKey: sender.addon_key,
                        key: sender.key,
                        options: util.sanitizeStructuredClone(filteredOptions)
                    },
                    event: event
                });
            }
        };
        function escapeSelector(s) {
            if (!s) throw new Error('No selector to escape');
            return s.replace(/[!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~]/g, '\\$&');
        }
        function stringToDimension(value) {
            var percent = false;
            var unit = 'px';
            if (typeof value === 'string') {
                percent = value.indexOf('%') === value.length - 1;
                value = parseInt(value, 10);
                if (percent) unit = '%';
            }
            if (!isNaN(value)) return value + unit;
        }
        function getIframeByExtensionId(id) {
            return $('iframe#' + escapeSelector(id));
        }
        function first(arr, numb) {
            if (numb) return arr.slice(0, numb);
            return arr[0];
        }
        function last(arr) {
            return arr[arr.length - 1];
        }
        function pick(obj, keys) {
            if (typeof obj !== 'object') return {};
            return Object.keys(obj).filter(function(key) {
                return keys.indexOf(key) >= 0;
            }).reduce(function(newObj, key) {
                var _Object$assign;
                return Object.assign(newObj, (_Object$assign = {}, _Object$assign[key] = obj[key], _Object$assign));
            }, {});
        }
        function debounce$1(fn, wait) {
            var timeout;
            return function() {
                var ctx = this;
                var args = [].slice.call(arguments);
                function later() {
                    timeout = null;
                    fn.apply(ctx, args);
                }
                if (timeout) clearTimeout(timeout);
                timeout = setTimeout(later, wait || 50);
            };
        }
        function isSupported(domElem, attr, value, defaultValue) {
            if (domElem && domElem[attr] && domElem[attr].supports) return domElem[attr].supports(value);
            else return defaultValue;
        }
        function guessProductFromModuleDefined(connectHost) {
            if (connectHost.isModuleDefined('jira')) return 'Jira';
            if (connectHost.isModuleDefined('confluence')) return 'Confluence';
            return '';
        }
        var Util = {
            escapeSelector: escapeSelector,
            stringToDimension: stringToDimension,
            getIframeByExtensionId: getIframeByExtensionId,
            first: first,
            last: last,
            pick: pick,
            debounce: debounce$1,
            isSupported: isSupported,
            extend: Object.assign,
            guessProductFromModuleDefined: guessProductFromModuleDefined
        };
        var events = {
            emit: function emit(name) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                var callback = Util.last(args);
                args = Util.first(args, -1);
                EventActions.broadcast(name, {
                    addon_key: callback._context.extension.addon_key
                }, args);
            },
            emitPublic: function emitPublic(name) {
                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                var callback = Util.last(args);
                var extension = callback._context.extension;
                args = Util.first(args, -1);
                EventActions.broadcastPublic(name, args, extension);
            },
            emitToDataProvider: function emitToDataProvider() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                var callback = Util.last(args);
                callback._context.extension;
                args = Util.first(args, -1);
                EventActions.broadcast('dataProviderEvent', {
                    addon_key: callback._context.extension.addon_key
                }, args);
            }
        };
        var DialogExtensionActions = {
            open: function open(extension, options) {
                EventDispatcher$1.dispatch('dialog-extension-open', {
                    extension: extension,
                    options: options
                });
            },
            close: function close() {
                EventDispatcher$1.dispatch('dialog-close-active', {});
            },
            addUserButton: function addUserButton(options, extension) {
                EventDispatcher$1.dispatch('dialog-button-add', {
                    button: {
                        text: options.text,
                        identifier: options.identifier,
                        data: {
                            userButton: true
                        }
                    },
                    extension: extension
                });
            }
        };
        var DialogActions = {
            close: function close(data) {
                EventDispatcher$1.dispatch('dialog-close', {
                    dialog: data.dialog,
                    extension: data.extension,
                    customData: data.customData
                });
            },
            closeActive: function closeActive(data) {
                EventDispatcher$1.dispatch('dialog-close-active', data);
            },
            clickButton: function clickButton(identifier, $el, extension) {
                EventDispatcher$1.dispatch('dialog-button-click', {
                    identifier: identifier,
                    $el: $el,
                    extension: extension
                });
            },
            toggleButton: function toggleButton(data) {
                EventDispatcher$1.dispatch('dialog-button-toggle', data);
            },
            toggleButtonVisibility: function toggleButtonVisibility(data) {
                EventDispatcher$1.dispatch('dialog-button-toggle-visibility', data);
            }
        };
        var DomEventActions = {
            registerKeyEvent: function registerKeyEvent(data) {
                host$1.registerKeyListener(data.extension_id, data.key, data.modifiers, data.callback);
                EventDispatcher$1.dispatch('dom-event-register', data);
            },
            unregisterKeyEvent: function unregisterKeyEvent(data) {
                host$1.unregisterKeyListener(data.extension_id, data.key, data.modifiers, data.callback);
                EventDispatcher$1.dispatch('dom-event-unregister', data);
            },
            registerWindowKeyEvent: function registerWindowKeyEvent(data) {
                window.addEventListener('keydown', function(event) {
                    if (event.keyCode === data.keyCode) data.callback();
                });
            },
            registerClickHandler: function registerClickHandler(handleIframeClick) {
                host$1.registerClickHandler(function(data) {
                    var iframe = document.getElementById(data.extension_id);
                    if (iframe) handleIframeClick(iframe);
                });
            },
            unregisterClickHandler: function unregisterClickHandler() {
                host$1.unregisterClickHandler();
            }
        };
        var ButtonUtils = function() {
            function ButtonUtils() {}
            var _proto = ButtonUtils.prototype;
            _proto.randomIdentifier = function randomIdentifier() {
                return Math.random().toString(16).substring(7);
            };
            return ButtonUtils;
        }();
        var buttonUtilsInstance = new ButtonUtils();
        var threshold = 0.25;
        var targets = [];
        var observe;
        var observed = function observed(target) {
            targets = targets.filter(function(_ref) {
                var element = _ref.element, callback = _ref.callback;
                if (element === target) {
                    callback();
                    return false;
                }
                return true;
            });
        };
        if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window) {
            var observer = new IntersectionObserver(function(entries) {
                entries.forEach(function(_ref2) {
                    var intersectionRatio = _ref2.intersectionRatio, target = _ref2.target;
                    if (intersectionRatio > 0) {
                        observer.unobserve(target);
                        observed(target);
                    }
                });
            }, {
                threshold: threshold
            });
            observe = observer.observe.bind(observer);
        }
        var observe$1 = function(element, callback) {
            if (typeof callback === 'function' && element instanceof Element) {
                targets.push({
                    element: element,
                    callback: callback
                });
                observe(element);
            }
        };
        var LOADING_TIME_THRESHOLD = 20000;
        var LOADING_TIME_TRIMP_PRECISION = 100;
        function bucketLoadingTime(value) {
            var bucket = value > LOADING_TIME_THRESHOLD ? LOADING_TIME_THRESHOLD : value;
            return Math.ceil(bucket / LOADING_TIME_TRIMP_PRECISION) * LOADING_TIME_TRIMP_PRECISION;
        }
        var CONTENT_RESOLVER_SAMPLE_RATE = 0.1;
        var INVOKE_METHOD_SAMPLE_RATE = 0.1;
        var IFRAME_LOAD_SAMPLE_RATE = 0.1;
        var AnalyticsDispatcher = function() {
            function AnalyticsDispatcher() {
                this._addons = {};
            }
            var _proto = AnalyticsDispatcher.prototype;
            _proto._shouldSampleEvent = function _shouldSampleEvent(rate) {
                return Math.random() * 100 <= rate;
            };
            _proto._trackGasV3 = function _trackGasV3(eventType, event, sendExternal) {
                if (event.attributes) event.attributes.apVersion = window._AP && window._AP.version ? window._AP.version : undefined;
                if (sendExternal) this._forwardGasV3AnalyticsEvent(eventType, event);
                try {
                    var analyticsCrossProduct = window.require('ac/analytics');
                    analyticsCrossProduct.emitGasV3(eventType, event);
                } catch (e) {
                    if (!window.Confluence && !window.__karma__) console.info('Connect GasV3 catch', e);
                }
            };
            _proto._trackAndForwardGasV3 = function _trackAndForwardGasV3(eventType, event) {
                this._trackGasV3(eventType, event, true);
            };
            _proto._forwardGasV3AnalyticsEvent = function _forwardGasV3AnalyticsEvent(eventType, event) {
                EventDispatcher$1.dispatch('analytics-forward-event', eventType, event);
            };
            _proto._time = function _time() {
                return window.performance && window.performance.now ? window.performance.now() : new Date().getTime();
            };
            _proto.trackLoadingStarted = function trackLoadingStarted(extension) {
                if (this._addons && extension && extension.id) {
                    extension.startLoading = this._time();
                    this._addons[extension.id] = extension;
                } else console.error('ACJS: cannot track loading analytics', this._addons, extension);
            };
            _proto.trackGasV3UseOfDeprecatedMethod = function trackGasV3UseOfDeprecatedMethod(methodUsed, extension) {
                this._trackAndForwardGasV3('operational', {
                    action: 'deprecatedMethod',
                    actionSubject: 'connectAddon',
                    actionSubjectId: extension.addon_key,
                    attributes: {
                        moduleKey: extension.key,
                        methodUsed: methodUsed
                    },
                    source: extension.addon_key
                });
            };
            _proto.trackGasV3MultipleDialogOpening = function trackGasV3MultipleDialogOpening(dialogType, extension) {
                this._trackAndForwardGasV3('operational', {
                    action: 'multipleDialogOpened',
                    actionSubject: 'connectAddon',
                    actionSubjectId: extension.addon_key,
                    attributes: {
                        moduleKey: extension.key,
                        dialogType: dialogType
                    },
                    source: extension.addon_key
                });
            };
            _proto.trackIframePerformance = function trackIframePerformance(metrics, extension) {
                if (!this._shouldSampleEvent(IFRAME_LOAD_SAMPLE_RATE)) return;
                this._trackGasV3('operational', {
                    source: extension.addon_key,
                    action: 'iframeRendered',
                    actionSubject: 'connectAddon',
                    actionSubjectId: extension.addon_key,
                    attributes: {
                        key: extension['key'],
                        pearApp: this._getPearApp(extension),
                        moduleType: this._getModuleType(extension),
                        iframeIsCacheable: this._isCacheable(extension),
                        moduleLocation: this._getModuleLocation(extension),
                        domainLookupTime: metrics.domainLookupTime,
                        connectionTime: metrics.connectionTime,
                        decodedBodySize: metrics.decodedBodySize,
                        domContentLoadedTime: metrics.domContentLoadedTime,
                        fetchTime: metrics.fetchTime
                    }
                });
            };
            _proto.dispatch = function dispatch(name, data) {
                this._trackGasV3External(name, data);
            };
            _proto.trackExternal = function trackExternal(name, data) {
                this._trackGasV3External(name, data);
            };
            _proto._trackGasV3External = function _trackGasV3External(name, data) {
                this._trackAndForwardGasV3('operational', {
                    action: 'externalEvent',
                    actionSubject: 'connectAddon',
                    actionSubjectId: name,
                    attributes: _extends({
                        eventName: name
                    }, typeof data === 'object' ? data : {
                        values: data
                    }),
                    source: 'connectAddon'
                });
            };
            _proto._resetAnalyticsDueToUnreliable = function _resetAnalyticsDueToUnreliable(extensionId) {
                if (!extensionId) throw new Error('Cannot reset analytics due to no extension id');
                if (this._addons[extensionId]) {
                    clearTimeout(this._addons[extensionId]);
                    delete this._addons[extensionId];
                } else console.info('Cannot clear analytics, cache does not contain extension id');
            };
            _proto._isCacheable = function _isCacheable(extension) {
                var href = extension.url;
                return href !== undefined && href.indexOf('xdm_e=') === -1;
            };
            _proto._getModuleType = function _getModuleType(extension) {
                return extension.options ? extension.options.moduleType : undefined;
            };
            _proto._getModuleLocation = function _getModuleLocation(extension) {
                return extension.options ? extension.options.moduleLocation : undefined;
            };
            _proto._getPearApp = function _getPearApp(extension) {
                return extension.options && extension.options.pearApp === 'true';
            };
            _proto.trackGasV3Visible = function trackGasV3Visible(extension) {
                if (!this._shouldSampleEvent(IFRAME_LOAD_SAMPLE_RATE)) return;
                this._trackGasV3('operational', {
                    action: 'iframeViewed',
                    actionSubject: 'connectAddon',
                    actionSubjectId: extension['addon_key'],
                    attributes: {
                        moduleType: this._getModuleType(extension),
                        iframeIsCacheable: this._isCacheable(extension),
                        moduleKey: extension.key,
                        moduleLocation: this._getModuleLocation(extension),
                        pearApp: this._getPearApp(extension)
                    },
                    source: extension.addon_key
                });
            };
            _proto.trackGasV3InvokeMethod = function trackGasV3InvokeMethod(extension, module1, method) {
                if (!this._shouldSampleEvent(INVOKE_METHOD_SAMPLE_RATE)) return;
                this._trackAndForwardGasV3('operational', {
                    action: 'invokeMethod',
                    actionSubject: 'connectAddon',
                    actionSubjectId: extension['addon_key'],
                    attributes: {
                        module: module1,
                        method: method,
                        moduleType: this._getModuleType(extension),
                        moduleKey: extension.key,
                        moduleLocation: this._getModuleLocation(extension),
                        pearApp: this._getPearApp(extension)
                    },
                    source: extension.addon_key
                });
            };
            _proto.trackGasV3ContentResolver = function trackGasV3ContentResolver(isSuccess, extra) {
                if (!this._shouldSampleEvent(CONTENT_RESOLVER_SAMPLE_RATE)) return;
                var extension = extra.extension;
                var attrs = extra.attrs;
                var action = isSuccess ? 'contentResolverSucceeded' : 'contentResolverFailed';
                this._trackGasV3('operational', {
                    action: action,
                    actionSubject: 'connectAddon',
                    actionSubjectId: extension['addon_key'],
                    attributes: Object.assign({}, attrs, {
                        moduleType: this._getModuleType(extension),
                        moduleKey: extension.key,
                        moduleLocation: this._getModuleLocation(extension),
                        pearApp: this._getPearApp(extension)
                    }),
                    source: extension.addon_key
                });
            };
            _proto.trackGasV3LoadingEnded = function trackGasV3LoadingEnded(extension) {
                if (!this._shouldSampleEvent(IFRAME_LOAD_SAMPLE_RATE)) return;
                var iframeLoadMillis = this._time() - this._addons[extension.id].startLoading;
                this._trackGasV3('operational', {
                    action: 'iframeLoaded',
                    actionSubject: 'connectAddon',
                    actionSubjectId: extension['addon_key'],
                    attributes: {
                        moduleType: this._getModuleType(extension),
                        iframeIsCacheable: this._isCacheable(extension),
                        iframeLoadMillis: iframeLoadMillis,
                        iframeLoadBucket: bucketLoadingTime(iframeLoadMillis),
                        moduleKey: extension.key,
                        moduleLocation: this._getModuleLocation(extension),
                        pearApp: this._getPearApp(extension)
                    },
                    source: extension.addon_key
                });
            };
            _proto.trackGasV3LoadingTimeout = function trackGasV3LoadingTimeout(extension) {
                if (!this._shouldSampleEvent(IFRAME_LOAD_SAMPLE_RATE)) return;
                this._trackGasV3('operational', {
                    action: 'iframeTimeout',
                    actionSubject: 'connectAddon',
                    actionSubjectId: extension['addon_key'],
                    attributes: {
                        moduleType: this._getModuleType(extension),
                        iframeIsCacheable: this._isCacheable(extension),
                        moduleKey: extension.key,
                        moduleLocation: this._getModuleLocation(extension),
                        pearApp: this._getPearApp(extension),
                        connectedStatus: typeof window.navigator.onLine === 'boolean' ? window.navigator.onLine.toString() : 'not-supported'
                    },
                    source: extension.addon_key
                });
            };
            _proto.trackGasV3InlineDialogOpened = function trackGasV3InlineDialogOpened(data) {
                var extension = data.extension;
                this._trackAndForwardGasV3('operational', {
                    action: 'inlineDialogOpened',
                    actionSubject: 'connectAddon',
                    actionSubjectId: extension['addon_key'],
                    attributes: {
                        moduleKey: extension.key,
                        moduleLocation: this._getModuleLocation(extension),
                        eventType: data.eventType,
                        onHoverEnabled: data.onHover
                    },
                    source: extension.addon_key
                });
            };
            _proto.trackGasV3LegacyDialogOpened = function trackGasV3LegacyDialogOpened(data) {
                var extension = data.extension;
                this._trackAndForwardGasV3('operational', {
                    action: 'legacyDialogOpened',
                    actionSubject: 'connectAddon',
                    actionSubjectId: extension['addon_key'],
                    attributes: {
                        moduleKey: extension.key,
                        moduleLocation: this._getModuleLocation(extension),
                        parentIds: data.parentIds
                    },
                    source: extension.addon_key
                });
            };
            _proto.trackGasV3FeatureFlagDefaultFalse = function trackGasV3FeatureFlagDefaultFalse(featureFlag) {
                this._trackAndForwardGasV3('operational', {
                    action: 'returned',
                    actionSubject: 'defaultFalseFeatureFlag',
                    attributes: {
                        featureFlag: featureFlag
                    },
                    source: window.AP ? 'Iframe' : 'Host'
                });
            };
            return AnalyticsDispatcher;
        }();
        var analytics$1 = new AnalyticsDispatcher();
        if ($.fn) EventDispatcher$1.register('iframe-create', function(data) {
            analytics$1.trackLoadingStarted(data.extension);
        });
        EventDispatcher$1.register('method-invoked', function(data) {
            analytics$1.trackGasV3InvokeMethod(data.extension, data.module, data.fn);
        });
        EventDispatcher$1.register('iframe-bridge-start', function(data) {
            analytics$1.trackLoadingStarted(data.extension);
        });
        EventDispatcher$1.register('iframe-bridge-established', function(data) {
            analytics$1.trackGasV3LoadingEnded(data.extension);
            observe$1(document.getElementById(data.extension.id), function() {
                EventDispatcher$1.dispatch('iframe-visible', data.extension);
                analytics$1.trackGasV3Visible(data.extension);
            });
        });
        EventDispatcher$1.register('iframe-bridge-timeout', function(data) {
            analytics$1.trackGasV3LoadingTimeout(data.extension);
        });
        EventDispatcher$1.register('analytics-deprecated-method-used', function(data) {
            analytics$1.trackGasV3UseOfDeprecatedMethod(data.methodUsed, data.extension);
        });
        EventDispatcher$1.register('analytics-iframe-performance', function(data) {
            analytics$1.trackIframePerformance(data.metrics, data.extension);
        });
        EventDispatcher$1.register('iframe-destroyed', function(data) {
            analytics$1._resetAnalyticsDueToUnreliable(data.extension.extension_id);
        });
        EventDispatcher$1.register('analytics-external-event-track', function(data) {
            analytics$1.trackExternal(data.eventName, data.values);
        });
        EventDispatcher$1.register('analytics-content-resolver-track', function(data) {
            var success = data.success;
            var extra = data.extra;
            analytics$1.trackGasV3ContentResolver(success, extra);
        });
        EventDispatcher$1.register('analytics-inline-dialog-opened', function(data) {
            analytics$1.trackGasV3InlineDialogOpened(data);
        });
        EventDispatcher$1.register('analytics-legacy-dialog-opened', function(data) {
            analytics$1.trackGasV3LegacyDialogOpened(data);
        });
        var DialogUtils = function() {
            function DialogUtils() {}
            var _proto = DialogUtils.prototype;
            _proto._maxDimension = function _maxDimension(val, maxPxVal) {
                var parsed = Util.stringToDimension(val);
                var parsedInt = parseInt(parsed, 10);
                var parsedMaxPxVal = parseInt(maxPxVal, 10);
                if (parsed.indexOf('%') > -1 && parsedInt >= 100 || parsedInt > parsedMaxPxVal) return '100%';
                return parsed;
            };
            _proto._closeOnEscape = function _closeOnEscape(options) {
                if (options.closeOnEscape === false) return false;
                else return true;
            };
            _proto._size = function _size(options) {
                var size = options.size;
                if (options.size === 'x-large') size = 'xlarge';
                if (options.size !== 'maximum' && options.width === '100%' && options.height === '100%') size = 'fullscreen';
                return size;
            };
            _proto._header = function _header(text) {
                var headerText = '';
                switch(typeof text){
                    case 'string':
                        headerText = text;
                        break;
                    case 'object':
                        headerText = text.value;
                        break;
                }
                return headerText;
            };
            _proto._hint = function _hint(text) {
                if (typeof text === 'string') return text;
                return '';
            };
            _proto._chrome = function _chrome(options) {
                var returnval = false;
                if (typeof options.chrome === 'boolean') returnval = options.chrome;
                if (options.size === 'fullscreen') returnval = true;
                if (options.size === 'maximum') returnval = false;
                return returnval;
            };
            _proto._width = function _width(options) {
                if (options.size) return undefined;
                if (options.width) return this._maxDimension(options.width, $(window).width());
                return '50%';
            };
            _proto._height = function _height(options) {
                if (options.size) return undefined;
                if (options.height) return this._maxDimension(options.height, $(window).height());
                return '50%';
            };
            _proto._actions = function _actions(options) {
                var sanitizedActions = [];
                options = options || {};
                if (!options.actions) sanitizedActions = [
                    {
                        name: 'submit',
                        identifier: 'submit',
                        text: options.submitText || 'Submit',
                        type: 'primary',
                        disabled: true
                    },
                    {
                        name: 'cancel',
                        identifier: 'cancel',
                        text: options.cancelText || 'Cancel',
                        type: 'link',
                        immutable: true
                    }
                ];
                if (options.buttons) sanitizedActions = sanitizedActions.concat(this._buttons(options));
                return sanitizedActions;
            };
            _proto._id = function _id(str) {
                if (typeof str !== 'string') str = Math.random().toString(36).substring(2, 8);
                return str;
            };
            _proto._buttons = function _buttons(options) {
                var buttons = [];
                if (options.buttons && Array.isArray(options.buttons)) options.buttons.forEach(function(button) {
                    var text;
                    var identifier;
                    var disabled = false;
                    if (button.text && typeof button.text === 'string') text = button.text;
                    if (button.identifier && typeof button.identifier === 'string') identifier = button.identifier;
                    else identifier = buttonUtilsInstance.randomIdentifier();
                    if (button.disabled && button.disabled === true) disabled = true;
                    buttons.push({
                        text: text,
                        identifier: identifier,
                        type: 'secondary',
                        custom: true,
                        disabled: disabled
                    });
                });
                return buttons;
            };
            _proto._onHide = function _onHide(options) {
                var noop = function noop() {};
                if (typeof options.onHide === 'function') return options.onHide;
                else return noop;
            };
            _proto.sanitizeOptions = function sanitizeOptions(options) {
                options = options || {};
                var sanitized = {
                    chrome: this._chrome(options),
                    header: this._header(options.header),
                    hint: this._hint(options.hint),
                    width: this._width(options),
                    height: this._height(options),
                    $content: options.$content,
                    extension: options.extension,
                    actions: this._actions(options),
                    id: this._id(options.id),
                    size: options.size,
                    closeOnEscape: this._closeOnEscape(options),
                    onHide: this._onHide(options)
                };
                sanitized.size = this._size(sanitized);
                return sanitized;
            };
            _proto.moduleOptionsFromGlobal = function moduleOptionsFromGlobal(addon_key, key) {
                var defaultOptions = {
                    chrome: true,
                    hostFrameOffset: 1
                };
                if (window._AP && window._AP.dialogModules && window._AP.dialogModules[addon_key] && window._AP.dialogModules[addon_key][key]) return Util.extend({}, defaultOptions, window._AP.dialogModules[addon_key][key].options);
                return false;
            };
            _proto.trackMultipleDialogOpening = function trackMultipleDialogOpening(dialogExtension, options) {
                var trackingDescription;
                var size = this._size(options);
                if ($('.ap-aui-dialog2:visible').length) {
                    if ($('#macro-browser-dialog').length || AJS.Confluence && AJS.Confluence.Editor && AJS.Confluence.Editor.currentEditMode) {
                        if (size === 'fullscreen') trackingDescription = 'connect-macro-multiple-fullscreen';
                        else trackingDescription = 'connect-macro-multiple';
                    } else trackingDescription = 'connect-multiple';
                    analytics$1.trackGasV3MultipleDialogOpening(trackingDescription, dialogExtension);
                }
            };
            _proto.assertActiveDialogOrThrow = function assertActiveDialogOrThrow(dialogProvider, addon_key) {
                if (!dialogProvider.isActiveDialog(addon_key)) throw new Error('Failed to find an active dialog for: ' + addon_key);
            };
            return DialogUtils;
        }();
        var dialogUtilsInstance = new DialogUtils();
        var IframeActions = {
            notifyIframeCreated: function notifyIframeCreated($el, extension) {
                EventDispatcher$1.dispatch('iframe-create', {
                    $el: $el,
                    extension: extension
                });
            },
            notifyBridgeEstablished: function notifyBridgeEstablished($el, extension) {
                EventDispatcher$1.dispatch('iframe-bridge-established', {
                    $el: $el,
                    extension: extension
                });
            },
            notifyIframeDestroyed: function notifyIframeDestroyed(filter) {
                if (typeof filter === 'string') filter = {
                    id: filter
                };
                var extensions = host$1.getExtensions(filter);
                extensions.forEach(function(extension) {
                    EventDispatcher$1.dispatch('iframe-destroyed', {
                        extension: extension
                    });
                    host$1.unregisterExtension({
                        id: extension.extension_id
                    });
                }, this);
            },
            notifyUnloaded: function notifyUnloaded($el, extension) {
                EventDispatcher$1.dispatch('iframe-unload', {
                    $el: $el,
                    extension: extension
                });
            }
        };
        var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
        function getDefaultExportFromCjs(x) {
            return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
        }
        var queryString = {};
        var strictUriEncode = function(str) {
            return encodeURIComponent(str).replace(/[!'()*]/g, function(x) {
                return "%" + x.charCodeAt(0).toString(16).toUpperCase();
            });
        };
        var token = '%[a-f0-9]{2}';
        var singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
        var multiMatcher = new RegExp('(' + token + ')+', 'gi');
        function decodeComponents(components, split) {
            try {
                return [
                    decodeURIComponent(components.join(''))
                ];
            } catch (err) {}
            if (components.length === 1) return components;
            split = split || 1;
            var left = components.slice(0, split);
            var right = components.slice(split);
            return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
        }
        function decode$1(input) {
            try {
                return decodeURIComponent(input);
            } catch (err) {
                var tokens = input.match(singleMatcher) || [];
                for(var i = 1; i < tokens.length; i++){
                    input = decodeComponents(tokens, i).join('');
                    tokens = input.match(singleMatcher) || [];
                }
                return input;
            }
        }
        function customDecodeURIComponent(input) {
            var replaceMap = {
                '%FE%FF': "\uFFFD\uFFFD",
                '%FF%FE': "\uFFFD\uFFFD"
            };
            var match = multiMatcher.exec(input);
            while(match){
                try {
                    replaceMap[match[0]] = decodeURIComponent(match[0]);
                } catch (err) {
                    var result = decode$1(match[0]);
                    if (result !== match[0]) replaceMap[match[0]] = result;
                }
                match = multiMatcher.exec(input);
            }
            replaceMap['%C2'] = "\uFFFD";
            var entries = Object.keys(replaceMap);
            for(var i = 0; i < entries.length; i++){
                var key = entries[i];
                input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
            }
            return input;
        }
        var decodeUriComponent = function(encodedURI) {
            if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
            try {
                encodedURI = encodedURI.replace(/\+/g, ' ');
                return decodeURIComponent(encodedURI);
            } catch (err) {
                return customDecodeURIComponent(encodedURI);
            }
        };
        var splitOnFirst = function(string, separator) {
            if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
            if (separator === '') return [
                string
            ];
            var separatorIndex = string.indexOf(separator);
            if (separatorIndex === -1) return [
                string
            ];
            return [
                string.slice(0, separatorIndex),
                string.slice(separatorIndex + separator.length)
            ];
        };
        var filterObj = function(obj, predicate) {
            var ret = {};
            var keys = Object.keys(obj);
            var isArr = Array.isArray(predicate);
            for(var i = 0; i < keys.length; i++){
                var key = keys[i];
                var val = obj[key];
                if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
            }
            return ret;
        };
        (function(exports) {
            const strictUriEncode$1 = strictUriEncode;
            const decodeComponent = decodeUriComponent;
            const splitOnFirst$1 = splitOnFirst;
            const filterObject = filterObj;
            const isNullOrUndefined = (value)=>value === null || value === undefined;
            const encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
            function encoderForArrayFormat(options) {
                switch(options.arrayFormat){
                    case 'index':
                        return (key)=>(result, value)=>{
                                const index = result.length;
                                if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                                if (value === null) return [
                                    ...result,
                                    [
                                        encode(key, options),
                                        '[',
                                        index,
                                        ']'
                                    ].join('')
                                ];
                                return [
                                    ...result,
                                    [
                                        encode(key, options),
                                        '[',
                                        encode(index, options),
                                        ']=',
                                        encode(value, options)
                                    ].join('')
                                ];
                            };
                    case 'bracket':
                        return (key)=>(result, value)=>{
                                if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                                if (value === null) return [
                                    ...result,
                                    [
                                        encode(key, options),
                                        '[]'
                                    ].join('')
                                ];
                                return [
                                    ...result,
                                    [
                                        encode(key, options),
                                        '[]=',
                                        encode(value, options)
                                    ].join('')
                                ];
                            };
                    case 'colon-list-separator':
                        return (key)=>(result, value)=>{
                                if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                                if (value === null) return [
                                    ...result,
                                    [
                                        encode(key, options),
                                        ':list='
                                    ].join('')
                                ];
                                return [
                                    ...result,
                                    [
                                        encode(key, options),
                                        ':list=',
                                        encode(value, options)
                                    ].join('')
                                ];
                            };
                    case 'comma':
                    case 'separator':
                    case 'bracket-separator':
                        {
                            const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                            return (key)=>(result, value)=>{
                                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                                    value = value === null ? '' : value;
                                    if (result.length === 0) return [
                                        [
                                            encode(key, options),
                                            keyValueSep,
                                            encode(value, options)
                                        ].join('')
                                    ];
                                    return [
                                        [
                                            result,
                                            encode(value, options)
                                        ].join(options.arrayFormatSeparator)
                                    ];
                                };
                        }
                    default:
                        return (key)=>(result, value)=>{
                                if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                                if (value === null) return [
                                    ...result,
                                    encode(key, options)
                                ];
                                return [
                                    ...result,
                                    [
                                        encode(key, options),
                                        '=',
                                        encode(value, options)
                                    ].join('')
                                ];
                            };
                }
            }
            function parserForArrayFormat(options) {
                let result;
                switch(options.arrayFormat){
                    case 'index':
                        return (key, value, accumulator)=>{
                            result = /\[(\d*)\]$/.exec(key);
                            key = key.replace(/\[\d*\]$/, '');
                            if (!result) {
                                accumulator[key] = value;
                                return;
                            }
                            if (accumulator[key] === undefined) accumulator[key] = {};
                            accumulator[key][result[1]] = value;
                        };
                    case 'bracket':
                        return (key, value, accumulator)=>{
                            result = /(\[\])$/.exec(key);
                            key = key.replace(/\[\]$/, '');
                            if (!result) {
                                accumulator[key] = value;
                                return;
                            }
                            if (accumulator[key] === undefined) {
                                accumulator[key] = [
                                    value
                                ];
                                return;
                            }
                            accumulator[key] = [].concat(accumulator[key], value);
                        };
                    case 'colon-list-separator':
                        return (key, value, accumulator)=>{
                            result = /(:list)$/.exec(key);
                            key = key.replace(/:list$/, '');
                            if (!result) {
                                accumulator[key] = value;
                                return;
                            }
                            if (accumulator[key] === undefined) {
                                accumulator[key] = [
                                    value
                                ];
                                return;
                            }
                            accumulator[key] = [].concat(accumulator[key], value);
                        };
                    case 'comma':
                    case 'separator':
                        return (key, value, accumulator)=>{
                            const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                            const isEncodedArray = typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator);
                            value = isEncodedArray ? decode(value, options) : value;
                            const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>decode(item, options)) : value === null ? value : decode(value, options);
                            accumulator[key] = newValue;
                        };
                    case 'bracket-separator':
                        return (key, value, accumulator)=>{
                            const isArray = /(\[\])$/.test(key);
                            key = key.replace(/\[\]$/, '');
                            if (!isArray) {
                                accumulator[key] = value ? decode(value, options) : value;
                                return;
                            }
                            const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>decode(item, options));
                            if (accumulator[key] === undefined) {
                                accumulator[key] = arrayValue;
                                return;
                            }
                            accumulator[key] = [].concat(accumulator[key], arrayValue);
                        };
                    default:
                        return (key, value, accumulator)=>{
                            if (accumulator[key] === undefined) {
                                accumulator[key] = value;
                                return;
                            }
                            accumulator[key] = [].concat(accumulator[key], value);
                        };
                }
            }
            function validateArrayFormatSeparator(value) {
                if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
            }
            function encode(value, options) {
                if (options.encode) return options.strict ? strictUriEncode$1(value) : encodeURIComponent(value);
                return value;
            }
            function decode(value, options) {
                if (options.decode) return decodeComponent(value);
                return value;
            }
            function keysSorter(input) {
                if (Array.isArray(input)) return input.sort();
                if (typeof input === 'object') return keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
                return input;
            }
            function removeHash(input) {
                const hashStart = input.indexOf('#');
                if (hashStart !== -1) input = input.slice(0, hashStart);
                return input;
            }
            function getHash(url) {
                let hash = '';
                const hashStart = url.indexOf('#');
                if (hashStart !== -1) hash = url.slice(hashStart);
                return hash;
            }
            function extract(input) {
                input = removeHash(input);
                const queryStart = input.indexOf('?');
                if (queryStart === -1) return '';
                return input.slice(queryStart + 1);
            }
            function parseValue(value, options) {
                if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
                else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
                return value;
            }
            function parse(query, options) {
                options = Object.assign({
                    decode: true,
                    sort: true,
                    arrayFormat: 'none',
                    arrayFormatSeparator: ',',
                    parseNumbers: false,
                    parseBooleans: false
                }, options);
                validateArrayFormatSeparator(options.arrayFormatSeparator);
                const formatter = parserForArrayFormat(options);
                const ret = Object.create(null);
                if (typeof query !== 'string') return ret;
                query = query.trim().replace(/^[?#&]/, '');
                if (!query) return ret;
                for (const param of query.split('&')){
                    if (param === '') continue;
                    let [key, value] = splitOnFirst$1(options.decode ? param.replace(/\+/g, ' ') : param, '=');
                    value = value === undefined ? null : [
                        'comma',
                        'separator',
                        'bracket-separator'
                    ].includes(options.arrayFormat) ? value : decode(value, options);
                    formatter(decode(key, options), value, ret);
                }
                for (const key of Object.keys(ret)){
                    const value = ret[key];
                    if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = parseValue(value[k], options);
                    else ret[key] = parseValue(value, options);
                }
                if (options.sort === false) return ret;
                return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
                    const value = ret[key];
                    if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) result[key] = keysSorter(value);
                    else result[key] = value;
                    return result;
                }, Object.create(null));
            }
            exports.extract = extract;
            exports.parse = parse;
            exports.stringify = (object, options)=>{
                if (!object) return '';
                options = Object.assign({
                    encode: true,
                    strict: true,
                    arrayFormat: 'none',
                    arrayFormatSeparator: ','
                }, options);
                validateArrayFormatSeparator(options.arrayFormatSeparator);
                const shouldFilter = (key)=>options.skipNull && isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
                const formatter = encoderForArrayFormat(options);
                const objectCopy = {};
                for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
                const keys = Object.keys(objectCopy);
                if (options.sort !== false) keys.sort(options.sort);
                return keys.map((key)=>{
                    const value = object[key];
                    if (value === undefined) return '';
                    if (value === null) return encode(key, options);
                    if (Array.isArray(value)) {
                        if (value.length === 0 && options.arrayFormat === 'bracket-separator') return encode(key, options) + '[]';
                        return value.reduce(formatter(key), []).join('&');
                    }
                    return encode(key, options) + '=' + encode(value, options);
                }).filter((x)=>x.length > 0).join('&');
            };
            exports.parseUrl = (url, options)=>{
                options = Object.assign({
                    decode: true
                }, options);
                const [url_, hash] = splitOnFirst$1(url, '#');
                return Object.assign({
                    url: url_.split('?')[0] || '',
                    query: parse(extract(url), options)
                }, options && options.parseFragmentIdentifier && hash ? {
                    fragmentIdentifier: decode(hash, options)
                } : {});
            };
            exports.stringifyUrl = (object, options)=>{
                options = Object.assign({
                    encode: true,
                    strict: true,
                    [encodeFragmentIdentifier]: true
                }, options);
                const url = removeHash(object.url).split('?')[0] || '';
                const queryFromUrl = exports.extract(object.url);
                const parsedQueryFromUrl = exports.parse(queryFromUrl, {
                    sort: false
                });
                const query = Object.assign(parsedQueryFromUrl, object.query);
                let queryString = exports.stringify(query, options);
                if (queryString) queryString = `?${queryString}`;
                let hash = getHash(object.url);
                if (object.fragmentIdentifier) hash = `#${options[encodeFragmentIdentifier] ? encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
                return `${url}${queryString}${hash}`;
            };
            exports.pick = (input, filter, options)=>{
                options = Object.assign({
                    parseFragmentIdentifier: true,
                    [encodeFragmentIdentifier]: false
                }, options);
                const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = exports.parseUrl(input, options);
                return exports.stringifyUrl({
                    url: url,
                    query: filterObject(query, filter),
                    fragmentIdentifier: fragmentIdentifier
                }, options);
            };
            exports.exclude = (input, filter, options)=>{
                const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
                return exports.pick(input, exclusionFilter, options);
            };
        })(queryString);
        var toByteArray_1 = toByteArray;
        var lookup = [];
        var revLookup = [];
        var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
        var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
        for(var i = 0, len = code.length; i < len; ++i){
            lookup[i] = code[i];
            revLookup[code.charCodeAt(i)] = i;
        }
        revLookup['-'.charCodeAt(0)] = 62;
        revLookup['_'.charCodeAt(0)] = 63;
        function getLens(b64) {
            var len = b64.length;
            if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
            var validLen = b64.indexOf('=');
            if (validLen === -1) validLen = len;
            var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
            return [
                validLen,
                placeHoldersLen
            ];
        }
        function _byteLength(b64, validLen, placeHoldersLen) {
            return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
        }
        function toByteArray(b64) {
            var tmp;
            var lens = getLens(b64);
            var validLen = lens[0];
            var placeHoldersLen = lens[1];
            var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
            var curByte = 0;
            var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
            for(var i = 0; i < len; i += 4){
                tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
                arr[curByte++] = tmp >> 16 & 0xFF;
                arr[curByte++] = tmp >> 8 & 0xFF;
                arr[curByte++] = tmp & 0xFF;
            }
            if (placeHoldersLen === 2) {
                tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
                arr[curByte++] = tmp & 0xFF;
            }
            if (placeHoldersLen === 1) {
                tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
                arr[curByte++] = tmp >> 8 & 0xFF;
                arr[curByte++] = tmp & 0xFF;
            }
            return arr;
        }
        function decode(string) {
            var padding = 4 - string.length % 4;
            if (padding === 1) string += '=';
            else if (padding === 2) string += '==';
            return new TextDecoder().decode(toByteArray_1(string));
        }
        var JWT_SKEW = 60;
        function parseJwtIssuer(jwt) {
            return parseJwtClaims(jwt)['iss'];
        }
        function parseJwtClaims(jwt) {
            if (null === jwt || '' === jwt) throw 'Invalid JWT: must be neither null nor empty-string.';
            var firstPeriodIndex = jwt.indexOf('.');
            var secondPeriodIndex = jwt.indexOf('.', firstPeriodIndex + 1);
            if (firstPeriodIndex < 0 || secondPeriodIndex <= firstPeriodIndex) throw 'Invalid JWT: must contain 2 period (".") characters.';
            var encodedClaims = jwt.substring(firstPeriodIndex + 1, secondPeriodIndex);
            if (null === encodedClaims || '' === encodedClaims) throw 'Invalid JWT: encoded claims must be neither null nor empty-string.';
            var claimsString = decode.call(window, encodedClaims);
            return JSON.parse(claimsString);
        }
        function isJwtExpired$1(jwtString, skew) {
            if (skew === undefined) skew = JWT_SKEW;
            var claims = parseJwtClaims(jwtString);
            var expires = 0;
            var now = Math.floor(Date.now() / 1000);
            if (claims && claims.exp) expires = claims.exp;
            if (expires - skew < now) return true;
            return false;
        }
        EventDispatcher$1.register('jwt-skew-set', function(data) {
            JWT_SKEW = data.skew;
        });
        var jwtUtil = {
            parseJwtIssuer: parseJwtIssuer,
            parseJwtClaims: parseJwtClaims,
            isJwtExpired: isJwtExpired$1
        };
        function isJwtExpired(urlStr) {
            var jwtStr = _getJwt(urlStr);
            return jwtUtil.isJwtExpired(jwtStr);
        }
        function _getJwt(urlStr) {
            var query = queryString.parse(queryString.extract(urlStr));
            return query['jwt'];
        }
        function hasJwt(url) {
            var jwt = _getJwt(url);
            return jwt && _getJwt(url).length !== 0;
        }
        var urlUtils = {
            hasJwt: hasJwt,
            isJwtExpired: isJwtExpired
        };
        var jwtActions = {
            registerContentResolver: function registerContentResolver(data) {
                EventDispatcher$1.dispatch('content-resolver-register-by-extension', data);
            },
            requestRefreshUrl: function requestRefreshUrl(data) {
                if (!data.resolver) throw Error('ACJS: No content resolver supplied');
                var promise = data.resolver.call(null, Util.extend({
                    classifier: 'json'
                }, data.extension));
                promise.fail(function(promiseData, error) {
                    EventDispatcher$1.dispatch('jwt-url-refreshed-failed', {
                        extension: data.extension,
                        $container: data.$container,
                        errorText: error.text
                    });
                });
                promise.done(function(promiseData) {
                    var newExtensionConfiguration = {};
                    if (typeof promiseData === 'object') newExtensionConfiguration = promiseData;
                    else if (typeof promiseData === 'string') try {
                        newExtensionConfiguration = JSON.parse(promiseData);
                    } catch (e) {
                        console.error('ACJS: invalid response from content resolver');
                    }
                    data.extension.url = newExtensionConfiguration.url;
                    Util.extend(data.extension.options, newExtensionConfiguration.options);
                    EventDispatcher$1.dispatch('jwt-url-refreshed', {
                        extension: data.extension,
                        $container: data.$container,
                        url: data.extension.url
                    });
                });
                EventDispatcher$1.dispatch('jwt-url-refresh-request', {
                    data: data
                });
            },
            setClockSkew: function setClockSkew(skew) {
                if (typeof skew === 'number') EventDispatcher$1.dispatch('jwt-skew-set', {
                    skew: skew
                });
                else console.error('ACJS: invalid JWT clock skew set');
            }
        };
        var iframeUtils = {
            optionsToAttributes: function optionsToAttributes(options) {
                var sanitized = {};
                if (options && typeof options === 'object') {
                    if (options.width) sanitized.width = Util.stringToDimension(options.width);
                    if (options.height) sanitized.height = Util.stringToDimension(options.height);
                    if (typeof options.sandbox === 'string') {
                        var domElem = document.createElement('iframe');
                        sanitized.sandbox = options.sandbox.split(' ').filter(function(value) {
                            return Util.isSupported(domElem, 'sandbox', value, true);
                        }).join(' ');
                    }
                }
                return sanitized;
            }
        };
        var ExtensionConfigurationOptionsStore = function() {
            function ExtensionConfigurationOptionsStore() {
                this.store = {};
            }
            var _proto = ExtensionConfigurationOptionsStore.prototype;
            _proto.set = function set(obj, val) {
                if (val) {
                    var toSet = {};
                    toSet[obj] = val;
                } else toSet = obj;
                Util.extend(this.store, toSet);
            };
            _proto.get = function get(key) {
                if (key) return this.store[key];
                return Util.extend({}, this.store);
            };
            return ExtensionConfigurationOptionsStore;
        }();
        var ExtensionConfigurationOptionsStore$1 = new ExtensionConfigurationOptionsStore();
        function _objectWithoutProperties(source, excluded) {
            if (source == null) return {};
            var target = _objectWithoutPropertiesLoose(source, excluded);
            var key, i;
            if (Object.getOwnPropertySymbols) {
                var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
                for(i = 0; i < sourceSymbolKeys.length; i++){
                    key = sourceSymbolKeys[i];
                    if (excluded.indexOf(key) >= 0) continue;
                    if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                    target[key] = source[key];
                }
            }
            return target;
        }
        function _arrayWithHoles(arr) {
            if (Array.isArray(arr)) return arr;
        }
        function _iterableToArrayLimit(r, l) {
            var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
            if (null != t) {
                var e, n, i, u, a = [], f = !0, o = !1;
                try {
                    if (i = (t = t.call(r)).next, 0 === l) {
                        if (Object(t) !== t) return;
                        f = !1;
                    } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
                } catch (r) {
                    o = !0, n = r;
                } finally{
                    try {
                        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
                    } finally{
                        if (o) throw n;
                    }
                }
                return a;
            }
        }
        function _arrayLikeToArray$1(arr, len) {
            if (len == null || len > arr.length) len = arr.length;
            for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
            return arr2;
        }
        function _unsupportedIterableToArray$1(o, minLen) {
            if (!o) return;
            if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if (n === "Object" && o.constructor) n = o.constructor.name;
            if (n === "Map" || n === "Set") return Array.from(o);
            if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
        }
        function _nonIterableRest() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        function _slicedToArray(arr, i) {
            return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest();
        }
        function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
            try {
                var info = gen[key](arg);
                var value = info.value;
            } catch (error) {
                reject(error);
                return;
            }
            if (info.done) resolve(value);
            else Promise.resolve(value).then(_next, _throw);
        }
        function _asyncToGenerator(fn) {
            return function() {
                var self1 = this, args = arguments;
                return new Promise(function(resolve, reject) {
                    var gen = fn.apply(self1, args);
                    function _next(value) {
                        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
                    }
                    function _throw(err) {
                        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
                    }
                    _next(undefined);
                });
            };
        }
        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function _typeof$1(o) {
            "@babel/helpers - typeof";
            return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
                return typeof o;
            } : function(o) {
                return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
            }, _typeof$1(o);
        }
        function _toPrimitive(input, hint) {
            if (_typeof$1(input) !== "object" || input === null) return input;
            var prim = input[Symbol.toPrimitive];
            if (prim !== undefined) {
                var res = prim.call(input, hint || "default");
                if (_typeof$1(res) !== "object") return res;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return (hint === "string" ? String : Number)(input);
        }
        function _toPropertyKey(arg) {
            var key = _toPrimitive(arg, "string");
            return _typeof$1(key) === "symbol" ? key : String(key);
        }
        function _defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
            }
        }
        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) _defineProperties(Constructor.prototype, protoProps);
            if (staticProps) _defineProperties(Constructor, staticProps);
            Object.defineProperty(Constructor, "prototype", {
                writable: false
            });
            return Constructor;
        }
        function _defineProperty(obj, key, value) {
            key = _toPropertyKey(key);
            if (key in obj) Object.defineProperty(obj, key, {
                value: value,
                enumerable: true,
                configurable: true,
                writable: true
            });
            else obj[key] = value;
            return obj;
        }
        var regeneratorRuntime$1 = {
            exports: {}
        };
        var _typeof = {
            exports: {}
        };
        (function(module1) {
            function _typeof(o) {
                "@babel/helpers - typeof";
                return module1.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
                    return typeof o;
                } : function(o) {
                    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
                }, module1.exports.__esModule = true, module1.exports["default"] = module1.exports, _typeof(o);
            }
            module1.exports = _typeof, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
        })(_typeof);
        (function(module1) {
            var _typeof$1 = _typeof.exports["default"];
            function _regeneratorRuntime() {
                module1.exports = _regeneratorRuntime = function _regeneratorRuntime() {
                    return e;
                }, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
                var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
                    t[e] = r.value;
                }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
                function define(t, e, r) {
                    return Object.defineProperty(t, e, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }), t[e];
                }
                try {
                    define({}, "");
                } catch (t) {
                    define = function define(t, e, r) {
                        return t[e] = r;
                    };
                }
                function wrap(t, e, r, n) {
                    var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
                    return o(a, "_invoke", {
                        value: makeInvokeMethod(t, r, c)
                    }), a;
                }
                function tryCatch(t, e, r) {
                    try {
                        return {
                            type: "normal",
                            arg: t.call(e, r)
                        };
                    } catch (t) {
                        return {
                            type: "throw",
                            arg: t
                        };
                    }
                }
                e.wrap = wrap;
                var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
                function Generator() {}
                function GeneratorFunction() {}
                function GeneratorFunctionPrototype() {}
                var p = {};
                define(p, a, function() {
                    return this;
                });
                var d = Object.getPrototypeOf, v = d && d(d(values([])));
                v && v !== r && n.call(v, a) && (p = v);
                var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
                function defineIteratorMethods(t) {
                    [
                        "next",
                        "throw",
                        "return"
                    ].forEach(function(e) {
                        define(t, e, function(t) {
                            return this._invoke(e, t);
                        });
                    });
                }
                function AsyncIterator(t, e) {
                    function invoke(r, o, i, a) {
                        var c = tryCatch(t[r], t, o);
                        if ("throw" !== c.type) {
                            var u = c.arg, h = u.value;
                            return h && "object" == _typeof$1(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                                invoke("next", t, i, a);
                            }, function(t) {
                                invoke("throw", t, i, a);
                            }) : e.resolve(h).then(function(t) {
                                u.value = t, i(u);
                            }, function(t) {
                                return invoke("throw", t, i, a);
                            });
                        }
                        a(c.arg);
                    }
                    var r;
                    o(this, "_invoke", {
                        value: function value(t, n) {
                            function callInvokeWithMethodAndArg() {
                                return new e(function(e, r) {
                                    invoke(t, n, e, r);
                                });
                            }
                            return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
                        }
                    });
                }
                function makeInvokeMethod(e, r, n) {
                    var o = h;
                    return function(i, a) {
                        if (o === f) throw new Error("Generator is already running");
                        if (o === s) {
                            if ("throw" === i) throw a;
                            return {
                                value: t,
                                done: !0
                            };
                        }
                        for(n.method = i, n.arg = a;;){
                            var c = n.delegate;
                            if (c) {
                                var u = maybeInvokeDelegate(c, n);
                                if (u) {
                                    if (u === y) continue;
                                    return u;
                                }
                            }
                            if ("next" === n.method) n.sent = n._sent = n.arg;
                            else if ("throw" === n.method) {
                                if (o === h) throw o = s, n.arg;
                                n.dispatchException(n.arg);
                            } else "return" === n.method && n.abrupt("return", n.arg);
                            o = f;
                            var p = tryCatch(e, r, n);
                            if ("normal" === p.type) {
                                if (o = n.done ? s : l, p.arg === y) continue;
                                return {
                                    value: p.arg,
                                    done: n.done
                                };
                            }
                            "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
                        }
                    };
                }
                function maybeInvokeDelegate(e, r) {
                    var n = r.method, o = e.iterator[n];
                    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                    var i = tryCatch(o, e.iterator, r.arg);
                    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
                    var a = i.arg;
                    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
                }
                function pushTryEntry(t) {
                    var e = {
                        tryLoc: t[0]
                    };
                    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
                }
                function resetTryEntry(t) {
                    var e = t.completion || {};
                    e.type = "normal", delete e.arg, t.completion = e;
                }
                function Context(t) {
                    this.tryEntries = [
                        {
                            tryLoc: "root"
                        }
                    ], t.forEach(pushTryEntry, this), this.reset(!0);
                }
                function values(e) {
                    if (e || "" === e) {
                        var r = e[a];
                        if (r) return r.call(e);
                        if ("function" == typeof e.next) return e;
                        if (!isNaN(e.length)) {
                            var o = -1, i = function next() {
                                for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                                return next.value = t, next.done = !0, next;
                            };
                            return i.next = i;
                        }
                    }
                    throw new TypeError(_typeof$1(e) + " is not iterable");
                }
                return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
                    value: GeneratorFunctionPrototype,
                    configurable: !0
                }), o(GeneratorFunctionPrototype, "constructor", {
                    value: GeneratorFunction,
                    configurable: !0
                }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
                    var e = "function" == typeof t && t.constructor;
                    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
                }, e.mark = function(t) {
                    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
                }, e.awrap = function(t) {
                    return {
                        __await: t
                    };
                }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
                    return this;
                }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
                    void 0 === i && (i = Promise);
                    var a = new AsyncIterator(wrap(t, r, n, o), i);
                    return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
                        return t.done ? t.value : a.next();
                    });
                }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
                    return this;
                }), define(g, "toString", function() {
                    return "[object Generator]";
                }), e.keys = function(t) {
                    var e = Object(t), r = [];
                    for(var n in e)r.push(n);
                    return r.reverse(), function next() {
                        for(; r.length;){
                            var t = r.pop();
                            if (t in e) return next.value = t, next.done = !1, next;
                        }
                        return next.done = !0, next;
                    };
                }, e.values = values, Context.prototype = {
                    constructor: Context,
                    reset: function reset(e) {
                        if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
                    },
                    stop: function stop() {
                        this.done = !0;
                        var t = this.tryEntries[0].completion;
                        if ("throw" === t.type) throw t.arg;
                        return this.rval;
                    },
                    dispatchException: function dispatchException(e) {
                        if (this.done) throw e;
                        var r = this;
                        function handle(n, o) {
                            return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
                        }
                        for(var o = this.tryEntries.length - 1; o >= 0; --o){
                            var i = this.tryEntries[o], a = i.completion;
                            if ("root" === i.tryLoc) return handle("end");
                            if (i.tryLoc <= this.prev) {
                                var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                                if (c && u) {
                                    if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                                    if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                                } else if (c) {
                                    if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                                } else {
                                    if (!u) throw new Error("try statement without catch or finally");
                                    if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                                }
                            }
                        }
                    },
                    abrupt: function abrupt(t, e) {
                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                            var o = this.tryEntries[r];
                            if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                                var i = o;
                                break;
                            }
                        }
                        i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                        var a = i ? i.completion : {};
                        return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
                    },
                    complete: function complete(t, e) {
                        if ("throw" === t.type) throw t.arg;
                        return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
                    },
                    finish: function finish(t) {
                        for(var e = this.tryEntries.length - 1; e >= 0; --e){
                            var r = this.tryEntries[e];
                            if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
                        }
                    },
                    "catch": function _catch(t) {
                        for(var e = this.tryEntries.length - 1; e >= 0; --e){
                            var r = this.tryEntries[e];
                            if (r.tryLoc === t) {
                                var n = r.completion;
                                if ("throw" === n.type) {
                                    var o = n.arg;
                                    resetTryEntry(r);
                                }
                                return o;
                            }
                        }
                        throw new Error("illegal catch attempt");
                    },
                    delegateYield: function delegateYield(e, r, n) {
                        return this.delegate = {
                            iterator: values(e),
                            resultName: r,
                            nextLoc: n
                        }, "next" === this.method && (this.arg = t), y;
                    }
                }, e;
            }
            module1.exports = _regeneratorRuntime, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
        })(regeneratorRuntime$1);
        var runtime = regeneratorRuntime$1.exports();
        var regenerator = runtime;
        try {
            regeneratorRuntime = runtime;
        } catch (accidentalStrictMode) {
            if (typeof globalThis === "object") globalThis.regeneratorRuntime = runtime;
            else Function("r", "regeneratorRuntime = r")(runtime);
        }
        var dist = {};
        var Errors = {};
        (function(exports) {
            var __extends = commonjsGlobal && commonjsGlobal.__extends || function() {
                var _extendStatics = function extendStatics(d, b) {
                    _extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return _extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    _extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.StatsigSDKKeyMismatchError = exports.StatsigInvalidArgumentError = exports.StatsigUninitializedError = exports.StatsigErrorMessage = void 0;
            var StatsigErrorMessage;
            (function(StatsigErrorMessage) {
                StatsigErrorMessage["REQUIRE_ASYNC_INITIALIZE"] = "Call initialize() first.";
                StatsigErrorMessage["REQUIRE_SYNC_INITIALIZE"] = "Call and wait for initialize() to finish first.";
                StatsigErrorMessage["REQUIRE_INITIALIZE_FOR_LOG_EVENT"] = "Must initialize() before logging events.";
            })(StatsigErrorMessage = exports.StatsigErrorMessage || (exports.StatsigErrorMessage = {}));
            var StatsigUninitializedError = function(_super) {
                __extends(StatsigUninitializedError, _super);
                function StatsigUninitializedError(message) {
                    var _this = _super.call(this, message !== null && message !== void 0 ? message : StatsigErrorMessage.REQUIRE_SYNC_INITIALIZE) || this;
                    Object.setPrototypeOf(_this, StatsigUninitializedError.prototype);
                    return _this;
                }
                return StatsigUninitializedError;
            }(Error);
            exports.StatsigUninitializedError = StatsigUninitializedError;
            var StatsigInvalidArgumentError = function(_super) {
                __extends(StatsigInvalidArgumentError, _super);
                function StatsigInvalidArgumentError(message) {
                    var _this = _super.call(this, message) || this;
                    Object.setPrototypeOf(_this, StatsigInvalidArgumentError.prototype);
                    return _this;
                }
                return StatsigInvalidArgumentError;
            }(Error);
            exports.StatsigInvalidArgumentError = StatsigInvalidArgumentError;
            var StatsigSDKKeyMismatchError = function(_super) {
                __extends(StatsigSDKKeyMismatchError, _super);
                function StatsigSDKKeyMismatchError(message) {
                    var _this = _super.call(this, message) || this;
                    Object.setPrototypeOf(_this, StatsigSDKKeyMismatchError.prototype);
                    return _this;
                }
                return StatsigSDKKeyMismatchError;
            }(Error);
            exports.StatsigSDKKeyMismatchError = StatsigSDKKeyMismatchError;
        })(Errors);
        var StatsigClient$1 = {};
        var DynamicConfig$1 = {};
        Object.defineProperty(DynamicConfig$1, "__esModule", {
            value: true
        });
        var DynamicConfig = function() {
            function DynamicConfig(configName, configValue, ruleID, evaluationDetails, secondaryExposures, allocatedExperimentName, onDefaultValueFallback) {
                if (secondaryExposures === void 0) secondaryExposures = [];
                if (allocatedExperimentName === void 0) allocatedExperimentName = '';
                if (onDefaultValueFallback === void 0) onDefaultValueFallback = null;
                this._onDefaultValueFallback = null;
                this.value = JSON.parse(JSON.stringify(configValue !== null && configValue !== void 0 ? configValue : {}));
                this._name = configName;
                this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
                this._secondaryExposures = secondaryExposures;
                this._allocatedExperimentName = allocatedExperimentName;
                this._evaluationDetails = evaluationDetails;
                this._onDefaultValueFallback = onDefaultValueFallback;
            }
            DynamicConfig.prototype.get = function(key, defaultValue, typeGuard) {
                var _a, _b;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : typeof defaultValue;
                var actualType = Array.isArray(val) ? 'array' : typeof val;
                if (typeGuard) {
                    if (typeGuard(val)) return val;
                    (_a = this._onDefaultValueFallback) === null || _a === void 0 || _a.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) return val;
                (_b = this._onDefaultValueFallback) === null || _b === void 0 || _b.call(this, this, key, expectedType, actualType);
                return defaultValue;
            };
            DynamicConfig.prototype.getValue = function(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                return this.value[key];
            };
            return DynamicConfig;
        }();
        DynamicConfig$1.default = DynamicConfig;
        var ErrorBoundary = {};
        (function(exports) {
            var __awaiter = commonjsGlobal && commonjsGlobal.__awaiter || function(thisArg, _arguments, P, generator) {
                function adopt(value) {
                    return value instanceof P ? value : new P(function(resolve) {
                        resolve(value);
                    });
                }
                return new (P || (P = Promise))(function(resolve, reject) {
                    function fulfilled(value) {
                        try {
                            step(generator.next(value));
                        } catch (e) {
                            reject(e);
                        }
                    }
                    function rejected(value) {
                        try {
                            step(generator["throw"](value));
                        } catch (e) {
                            reject(e);
                        }
                    }
                    function step(result) {
                        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                    }
                    step((generator = generator.apply(thisArg, _arguments || [])).next());
                });
            };
            var __generator = commonjsGlobal && commonjsGlobal.__generator || function(thisArg, body) {
                var _ = {
                    label: 0,
                    sent: function sent() {
                        if (t[0] & 1) throw t[1];
                        return t[1];
                    },
                    trys: [],
                    ops: []
                }, f, y, t, g;
                return g = {
                    next: verb(0),
                    "throw": verb(1),
                    "return": verb(2)
                }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                    return this;
                }), g;
                function verb(n) {
                    return function(v) {
                        return step([
                            n,
                            v
                        ]);
                    };
                }
                function step(op) {
                    if (f) throw new TypeError("Generator is already executing.");
                    while(g && (g = 0, op[0] && (_ = 0)), _)try {
                        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                        if (y = 0, t) op = [
                            op[0] & 2,
                            t.value
                        ];
                        switch(op[0]){
                            case 0:
                            case 1:
                                t = op;
                                break;
                            case 4:
                                _.label++;
                                return {
                                    value: op[1],
                                    done: false
                                };
                            case 5:
                                _.label++;
                                y = op[1];
                                op = [
                                    0
                                ];
                                continue;
                            case 7:
                                op = _.ops.pop();
                                _.trys.pop();
                                continue;
                            default:
                                if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                    _ = 0;
                                    continue;
                                }
                                if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                    _.label = op[1];
                                    break;
                                }
                                if (op[0] === 6 && _.label < t[1]) {
                                    _.label = t[1];
                                    t = op;
                                    break;
                                }
                                if (t && _.label < t[2]) {
                                    _.label = t[2];
                                    _.ops.push(op);
                                    break;
                                }
                                if (t[2]) _.ops.pop();
                                _.trys.pop();
                                continue;
                        }
                        op = body.call(thisArg, _);
                    } catch (e) {
                        op = [
                            6,
                            e
                        ];
                        y = 0;
                    } finally{
                        f = t = 0;
                    }
                    if (op[0] & 5) throw op[1];
                    return {
                        value: op[0] ? op[1] : void 0,
                        done: true
                    };
                }
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.ExceptionEndpoint = void 0;
            var Errors_1 = Errors;
            exports.ExceptionEndpoint = 'https://statsigapi.net/v1/sdk_exception';
            var ErrorBoundary = function() {
                function ErrorBoundary(sdkKey, options) {
                    this._seen = new Set();
                    this._sdkKey = sdkKey;
                    this._options = options;
                }
                ErrorBoundary.prototype._setStatsigMetadata = function(statsigMetadata) {
                    this._statsigMetadata = statsigMetadata;
                };
                ErrorBoundary.prototype._swallow = function(tag, task) {
                    this._capture(tag, task, function() {
                        return undefined;
                    });
                };
                ErrorBoundary.prototype._capture = function(tag, task, recover, getExtraData) {
                    var _this = this;
                    try {
                        var result = task();
                        if (result instanceof Promise) return result.catch(function(e) {
                            return _this._onCaught(tag, e, recover, getExtraData);
                        });
                        return result;
                    } catch (error) {
                        return this._onCaught(tag, error, recover, getExtraData);
                    }
                };
                ErrorBoundary.prototype._logError = function(tag, error, getExtraData) {
                    var _this = this;
                    if (this._options.disableAllLogging) return;
                    try {
                        var impl = function impl() {
                            return __awaiter(_this, void 0, void 0, function() {
                                var extra, _a, unwrapped, isError, name, info, metadata, body;
                                var _b;
                                return __generator(this, function(_c) {
                                    switch(_c.label){
                                        case 0:
                                            if (!(typeof getExtraData === 'function')) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                getExtraData()
                                            ];
                                        case 1:
                                            _a = _c.sent();
                                            return [
                                                3,
                                                3
                                            ];
                                        case 2:
                                            _a = null;
                                            _c.label = 3;
                                        case 3:
                                            extra = _a;
                                            unwrapped = error !== null && error !== void 0 ? error : Error('[Statsig] Error was empty');
                                            isError = unwrapped instanceof Error;
                                            name = isError ? unwrapped.name : 'No Name';
                                            if (this._seen.has(name)) return [
                                                2
                                            ];
                                            this._seen.add(name);
                                            info = isError ? unwrapped.stack : this._getDescription(unwrapped);
                                            metadata = (_b = this._statsigMetadata) !== null && _b !== void 0 ? _b : {};
                                            body = JSON.stringify({
                                                tag: tag,
                                                exception: name,
                                                info: info,
                                                statsigMetadata: metadata,
                                                extra: extra !== null && extra !== void 0 ? extra : {}
                                            });
                                            return [
                                                2,
                                                fetch(exports.ExceptionEndpoint, {
                                                    method: 'POST',
                                                    headers: {
                                                        'STATSIG-API-KEY': this._sdkKey,
                                                        'STATSIG-SDK-TYPE': String(metadata['sdkType']),
                                                        'STATSIG-SDK-VERSION': String(metadata['sdkVersion']),
                                                        'Content-Type': 'application/json',
                                                        'Content-Length': "".concat(body.length)
                                                    },
                                                    body: body
                                                })
                                            ];
                                    }
                                });
                            });
                        };
                        impl().then(function() {}).catch(function() {});
                    } catch (_error) {}
                };
                ErrorBoundary.prototype._onCaught = function(tag, error, recover, getExtraData) {
                    if (error instanceof Errors_1.StatsigUninitializedError || error instanceof Errors_1.StatsigInvalidArgumentError) throw error;
                    console.error('[Statsig] An unexpected exception occurred.', error);
                    this._logError(tag, error, getExtraData);
                    return recover();
                };
                ErrorBoundary.prototype._getDescription = function(obj) {
                    try {
                        return JSON.stringify(obj);
                    } catch (_a) {
                        return '[Statsig] Failed to get string for error.';
                    }
                };
                return ErrorBoundary;
            }();
            exports.default = ErrorBoundary;
        })(ErrorBoundary);
        var Layer$1 = {};
        Object.defineProperty(Layer$1, "__esModule", {
            value: true
        });
        var Layer = function() {
            function Layer(name, layerValue, ruleID, evaluationDetails, logParameterFunction, secondaryExposures, undelegatedSecondaryExposures, allocatedExperimentName, explicitParameters) {
                if (logParameterFunction === void 0) logParameterFunction = null;
                if (secondaryExposures === void 0) secondaryExposures = [];
                if (undelegatedSecondaryExposures === void 0) undelegatedSecondaryExposures = [];
                if (allocatedExperimentName === void 0) allocatedExperimentName = '';
                if (explicitParameters === void 0) explicitParameters = [];
                this._logParameterFunction = logParameterFunction;
                this._name = name;
                this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
                this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
                this._evaluationDetails = evaluationDetails;
                this._secondaryExposures = secondaryExposures;
                this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
                this._allocatedExperimentName = allocatedExperimentName;
                this._explicitParameters = explicitParameters;
            }
            Layer._create = function(name, value, ruleID, evaluationDetails, logParameterFunction, secondaryExposures, undelegatedSecondaryExposures, allocatedExperimentName, explicitParameters) {
                if (logParameterFunction === void 0) logParameterFunction = null;
                if (secondaryExposures === void 0) secondaryExposures = [];
                if (undelegatedSecondaryExposures === void 0) undelegatedSecondaryExposures = [];
                if (allocatedExperimentName === void 0) allocatedExperimentName = '';
                if (explicitParameters === void 0) explicitParameters = [];
                return new Layer(name, value, ruleID, evaluationDetails, logParameterFunction, secondaryExposures, undelegatedSecondaryExposures, allocatedExperimentName, explicitParameters);
            };
            Layer.prototype.get = function(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if (typeof val === typeof defaultValue && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            };
            Layer.prototype.getValue = function(key, defaultValue) {
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            };
            Layer.prototype._logLayerParameterExposure = function(parameterName) {
                var _a;
                (_a = this._logParameterFunction) === null || _a === void 0 || _a.call(this, this, parameterName);
            };
            return Layer;
        }();
        Layer$1.default = Layer;
        var StatsigIdentity = {};
        var Constants = {};
        Object.defineProperty(Constants, "__esModule", {
            value: true
        });
        Constants.LOCAL_STORAGE_KEYS = Constants.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY = Constants.STATSIG_STABLE_ID_KEY = Constants.INTERNAL_STORE_KEY = void 0;
        Constants.INTERNAL_STORE_KEY = 'STATSIG_STORE';
        Constants.STATSIG_STABLE_ID_KEY = 'STATSIG_STABLE_ID';
        Constants.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY = 'STATSIG_LOGS';
        Constants.LOCAL_STORAGE_KEYS = {
            INTERNAL_STORE_KEY: true,
            STATSIG_STABLE_ID_KEY: true,
            STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY: true
        };
        var Hashing = {};
        Object.defineProperty(Hashing, "__esModule", {
            value: true
        });
        Hashing.getUserCacheKey = Hashing.getSortedObject = Hashing.djb2HashForObject = Hashing.getHashValue = Hashing.SimpleHash = void 0;
        function SimpleHash(value) {
            var hash = 0;
            for(var i = 0; i < value.length; i++){
                var character = value.charCodeAt(i);
                hash = (hash << 5) - hash + character;
                hash = hash & hash;
            }
            return String(hash >>> 0);
        }
        Hashing.SimpleHash = SimpleHash;
        function getHashValue(value, hash_used) {
            if (hash_used === 'none') return value;
            return SimpleHash(value);
        }
        Hashing.getHashValue = getHashValue;
        function djb2HashForObject(object) {
            return SimpleHash(JSON.stringify(getSortedObject(object)));
        }
        Hashing.djb2HashForObject = djb2HashForObject;
        function getSortedObject(object) {
            if (object == null) return null;
            var keys = Object.keys(object).sort();
            var sortedObject = {};
            keys.forEach(function(key) {
                var value = object[key];
                if (value instanceof Object) value = getSortedObject(value);
                sortedObject[key] = value;
            });
            return sortedObject;
        }
        Hashing.getSortedObject = getSortedObject;
        function getUserCacheKey(user) {
            var _a;
            var key = "userID:".concat(String((_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''));
            var customIDs = user === null || user === void 0 ? void 0 : user.customIDs;
            if (customIDs != null) for(var _i = 0, _b = Object.entries(customIDs); _i < _b.length; _i++){
                var _c = _b[_i], type = _c[0], value = _c[1];
                key += ";".concat(type, ":").concat(value);
            }
            return SimpleHash(key);
        }
        Hashing.getUserCacheKey = getUserCacheKey;
        var StatsigLocalStorage$1 = {};
        Object.defineProperty(StatsigLocalStorage$1, "__esModule", {
            value: true
        });
        var StatsigLocalStorage = function() {
            function StatsigLocalStorage() {}
            StatsigLocalStorage.getItem = function(key) {
                var _a;
                try {
                    if (this.isStorageAccessible()) return window.localStorage.getItem(key);
                } catch (e) {}
                return (_a = this.fallbackSessionCache[key]) !== null && _a !== void 0 ? _a : null;
            };
            StatsigLocalStorage.setItem = function(key, value) {
                try {
                    if (this.isStorageAccessible()) {
                        window.localStorage.setItem(key, value);
                        return;
                    }
                } catch (e) {}
                this.fallbackSessionCache[key] = value;
            };
            StatsigLocalStorage.removeItem = function(key) {
                try {
                    if (this.isStorageAccessible()) {
                        window.localStorage.removeItem(key);
                        return;
                    }
                } catch (e) {}
                delete this.fallbackSessionCache[key];
            };
            StatsigLocalStorage.isStorageAccessible = function(ignoreDisabledOption) {
                if (ignoreDisabledOption === void 0) ignoreDisabledOption = false;
                if (this.canAccessStorageAccessible == null) this.canAccessStorageAccessible = typeof Storage !== 'undefined' && typeof window !== 'undefined' && window != null && window.localStorage != null;
                var canAccess = this.canAccessStorageAccessible;
                if (ignoreDisabledOption) return canAccess;
                return !this.disabled && canAccess;
            };
            StatsigLocalStorage.disabled = false;
            StatsigLocalStorage.fallbackSessionCache = {};
            StatsigLocalStorage.canAccessStorageAccessible = null;
            return StatsigLocalStorage;
        }();
        StatsigLocalStorage$1.default = StatsigLocalStorage;
        var SDKVersion = {};
        Object.defineProperty(SDKVersion, "__esModule", {
            value: true
        });
        SDKVersion.version = void 0;
        SDKVersion.version = '1.3.0';
        var __importDefault$2 = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
            return mod && mod.__esModule ? mod : {
                "default": mod
            };
        };
        Object.defineProperty(StatsigIdentity, "__esModule", {
            value: true
        });
        var Constants_1$1 = Constants;
        var Hashing_1$1 = Hashing;
        var StatsigLocalStorage_1$2 = __importDefault$2(StatsigLocalStorage$1);
        var SDKVersion_1 = SDKVersion;
        var Identity = function() {
            function Identity(sdkKey, user, overrideStableID) {
                var _a;
                this._sdkType = 'js-lite';
                this._sdkKey = sdkKey;
                this._user = user;
                this._sdkVersion = SDKVersion_1.version;
                var stableID = overrideStableID;
                stableID = (_a = stableID !== null && stableID !== void 0 ? stableID : StatsigLocalStorage_1$2.default.getItem(Constants_1$1.STATSIG_STABLE_ID_KEY)) !== null && _a !== void 0 ? _a : this._getUUID();
                this._statsigMetadata = {
                    stableID: stableID,
                    sdkType: this._sdkType,
                    sdkVersion: this._sdkVersion
                };
            }
            Identity.prototype.saveStableID = function() {
                if (this._statsigMetadata.stableID != null) StatsigLocalStorage_1$2.default.setItem(Constants_1$1.STATSIG_STABLE_ID_KEY, this._statsigMetadata.stableID);
            };
            Identity.prototype.getUserCacheKey = function() {
                return (0, Hashing_1$1.getUserCacheKey)(this._user);
            };
            Identity.prototype._getUUID = function() {
                var uuid = '';
                for(var i = 0; i < 32; i++){
                    if (i === 8 || i === 12 || i === 16 || i === 20) uuid += '-';
                    var randomDigit = Math.random() * 16 | 0;
                    if (i === 12) uuid += '4';
                    else if (i === 16) uuid += (randomDigit & 3 | 8).toString(16);
                    else uuid += randomDigit.toString(16);
                }
                return uuid;
            };
            return Identity;
        }();
        StatsigIdentity.default = Identity;
        var StatsigLogger$1 = {};
        var LogEvent = {};
        var __assign$2 = commonjsGlobal && commonjsGlobal.__assign || function() {
            __assign$2 = Object.assign || function(t) {
                for(var s, i = 1, n = arguments.length; i < n; i++){
                    s = arguments[i];
                    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
            return __assign$2.apply(this, arguments);
        };
        Object.defineProperty(LogEvent, "__esModule", {
            value: true
        });
        function makeLogEvent(eventName, user, statsigMetadata, value, metadata, secondaryExposures) {
            if (value === void 0) value = null;
            if (metadata === void 0) metadata = null;
            var logUser = user;
            if (logUser === null || logUser === void 0 ? void 0 : logUser.privateAttributes) {
                logUser = __assign$2({}, user);
                delete logUser.privateAttributes;
            }
            return {
                time: Date.now(),
                eventName: eventName,
                statsigMetadata: statsigMetadata,
                user: logUser,
                value: value,
                metadata: metadata,
                secondaryExposures: secondaryExposures
            };
        }
        LogEvent.default = makeLogEvent;
        var StatsigNetwork = {};
        (function(exports) {
            var __awaiter = commonjsGlobal && commonjsGlobal.__awaiter || function(thisArg, _arguments, P, generator) {
                function adopt(value) {
                    return value instanceof P ? value : new P(function(resolve) {
                        resolve(value);
                    });
                }
                return new (P || (P = Promise))(function(resolve, reject) {
                    function fulfilled(value) {
                        try {
                            step(generator.next(value));
                        } catch (e) {
                            reject(e);
                        }
                    }
                    function rejected(value) {
                        try {
                            step(generator["throw"](value));
                        } catch (e) {
                            reject(e);
                        }
                    }
                    function step(result) {
                        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                    }
                    step((generator = generator.apply(thisArg, _arguments || [])).next());
                });
            };
            var __generator = commonjsGlobal && commonjsGlobal.__generator || function(thisArg, body) {
                var _ = {
                    label: 0,
                    sent: function sent() {
                        if (t[0] & 1) throw t[1];
                        return t[1];
                    },
                    trys: [],
                    ops: []
                }, f, y, t, g;
                return g = {
                    next: verb(0),
                    "throw": verb(1),
                    "return": verb(2)
                }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                    return this;
                }), g;
                function verb(n) {
                    return function(v) {
                        return step([
                            n,
                            v
                        ]);
                    };
                }
                function step(op) {
                    if (f) throw new TypeError("Generator is already executing.");
                    while(g && (g = 0, op[0] && (_ = 0)), _)try {
                        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                        if (y = 0, t) op = [
                            op[0] & 2,
                            t.value
                        ];
                        switch(op[0]){
                            case 0:
                            case 1:
                                t = op;
                                break;
                            case 4:
                                _.label++;
                                return {
                                    value: op[1],
                                    done: false
                                };
                            case 5:
                                _.label++;
                                y = op[1];
                                op = [
                                    0
                                ];
                                continue;
                            case 7:
                                op = _.ops.pop();
                                _.trys.pop();
                                continue;
                            default:
                                if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                    _ = 0;
                                    continue;
                                }
                                if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                    _.label = op[1];
                                    break;
                                }
                                if (op[0] === 6 && _.label < t[1]) {
                                    _.label = t[1];
                                    t = op;
                                    break;
                                }
                                if (t && _.label < t[2]) {
                                    _.label = t[2];
                                    _.ops.push(op);
                                    break;
                                }
                                if (t[2]) _.ops.pop();
                                _.trys.pop();
                                continue;
                        }
                        op = body.call(thisArg, _);
                    } catch (e) {
                        op = [
                            6,
                            e
                        ];
                        y = 0;
                    } finally{
                        f = t = 0;
                    }
                    if (op[0] & 5) throw op[1];
                    return {
                        value: op[0] ? op[1] : void 0,
                        done: true
                    };
                }
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.StatsigEndpoint = void 0;
            var StatsigEndpoint;
            (function(StatsigEndpoint) {
                StatsigEndpoint["Initialize"] = "initialize";
                StatsigEndpoint["Rgstr"] = "rgstr";
                StatsigEndpoint["LogEventBeacon"] = "log_event_beacon";
            })(StatsigEndpoint = exports.StatsigEndpoint || (exports.StatsigEndpoint = {}));
            var NO_CONTENT = 204;
            var StatsigNetwork = function() {
                function StatsigNetwork(options, identity, errorBoundary) {
                    this.retryCodes = {
                        408: true,
                        500: true,
                        502: true,
                        503: true,
                        504: true,
                        522: true,
                        524: true,
                        599: true
                    };
                    this.canUseKeepalive = false;
                    this._options = options;
                    this._identity = identity;
                    this._errorBoundary = errorBoundary;
                    this.leakyBucket = {};
                    this._init();
                }
                StatsigNetwork.prototype.fetchValues = function(user, sinceTime, timeout, previousDerivedFields) {
                    var input = {
                        user: user,
                        statsigMetadata: this._identity._statsigMetadata,
                        sinceTime: sinceTime !== null && sinceTime !== void 0 ? sinceTime : undefined,
                        hash: 'djb2',
                        previousDerivedFields: previousDerivedFields
                    };
                    return this._postWithTimeout(StatsigEndpoint.Initialize, input, timeout, 3);
                };
                StatsigNetwork.prototype.sendLogBeacon = function(payload) {
                    if (this._options.localMode) return true;
                    var url = new URL(this._options.eventLoggingApi + StatsigEndpoint.LogEventBeacon);
                    url.searchParams.append('k', this._identity._sdkKey);
                    payload.clientTime = Date.now() + '';
                    var stringPayload = null;
                    try {
                        stringPayload = JSON.stringify(payload);
                    } catch (_e) {
                        return false;
                    }
                    return navigator.sendBeacon(url.toString(), stringPayload);
                };
                StatsigNetwork.prototype.postToEndpoint = function(endpointName, body, retries, backoff, useKeepalive) {
                    if (retries === void 0) retries = 0;
                    if (backoff === void 0) backoff = 1000;
                    if (useKeepalive === void 0) useKeepalive = false;
                    return __awaiter(this, void 0, void 0, function() {
                        var api, url, counter, postBody, statsigMetadata, params;
                        var _this = this;
                        return __generator(this, function(_a) {
                            if (this._options.localMode) return [
                                2,
                                Promise.reject('no network requests in localMode')
                            ];
                            if (typeof fetch !== 'function') return [
                                2,
                                Promise.reject('fetch is not defined')
                            ];
                            if (typeof window === 'undefined' && !this._options.ignoreWindowUndefined) return [
                                2,
                                Promise.reject('window is not defined')
                            ];
                            api = [
                                StatsigEndpoint.Initialize
                            ].includes(endpointName) ? this._options.api : this._options.eventLoggingApi;
                            url = api + endpointName;
                            counter = this.leakyBucket[url];
                            if (counter != null && counter >= 30) return [
                                2,
                                Promise.reject(new Error('Request failed because you are making the same request too frequently.'))
                            ];
                            if (counter == null) this.leakyBucket[url] = 1;
                            else this.leakyBucket[url] = counter + 1;
                            postBody = JSON.stringify(body);
                            statsigMetadata = this._identity._statsigMetadata;
                            params = {
                                method: 'POST',
                                body: postBody,
                                headers: {
                                    'Content-type': 'application/json; charset=UTF-8',
                                    'STATSIG-API-KEY': this._identity._sdkKey,
                                    'STATSIG-CLIENT-TIME': Date.now() + '',
                                    'STATSIG-SDK-TYPE': statsigMetadata.sdkType,
                                    'STATSIG-SDK-VERSION': statsigMetadata.sdkVersion
                                }
                            };
                            if (this.canUseKeepalive && useKeepalive) params.keepalive = true;
                            return [
                                2,
                                fetch(url, params).then(function(res) {
                                    return __awaiter(_this, void 0, void 0, function() {
                                        var networkResponse, text, errorText;
                                        return __generator(this, function(_a) {
                                            switch(_a.label){
                                                case 0:
                                                    if (!res.ok) return [
                                                        3,
                                                        4
                                                    ];
                                                    networkResponse = res;
                                                    if (!(res.status === NO_CONTENT)) return [
                                                        3,
                                                        1
                                                    ];
                                                    networkResponse.data = {
                                                        has_updates: false,
                                                        is_no_content: true
                                                    };
                                                    return [
                                                        3,
                                                        3
                                                    ];
                                                case 1:
                                                    return [
                                                        4,
                                                        res.text()
                                                    ];
                                                case 2:
                                                    text = _a.sent();
                                                    networkResponse.data = JSON.parse(text);
                                                    _a.label = 3;
                                                case 3:
                                                    return [
                                                        2,
                                                        Promise.resolve(networkResponse)
                                                    ];
                                                case 4:
                                                    if (!this.retryCodes[res.status]) retries = 0;
                                                    return [
                                                        4,
                                                        res.text()
                                                    ];
                                                case 5:
                                                    errorText = _a.sent();
                                                    return [
                                                        2,
                                                        Promise.reject(new Error("".concat(res.status, ": ").concat(errorText)))
                                                    ];
                                            }
                                        });
                                    });
                                }).catch(function(e) {
                                    if (retries > 0) return new Promise(function(resolve, reject) {
                                        setTimeout(function() {
                                            _this.leakyBucket[url] = Math.max(_this.leakyBucket[url] - 1, 0);
                                            _this.postToEndpoint(endpointName, body, retries - 1, backoff * 2, useKeepalive).then(resolve).catch(reject);
                                        }, backoff);
                                    });
                                    return Promise.reject(e);
                                }).finally(function() {
                                    _this.leakyBucket[url] = Math.max(_this.leakyBucket[url] - 1, 0);
                                })
                            ];
                        });
                    });
                };
                StatsigNetwork.prototype.supportsKeepalive = function() {
                    return this.canUseKeepalive;
                };
                StatsigNetwork.prototype._init = function() {
                    if (!this._options.disableNetworkKeepalive) try {
                        this.canUseKeepalive = 'keepalive' in new Request('');
                    } catch (_e) {}
                };
                StatsigNetwork.prototype._postWithTimeout = function(endpointName, body, timeout, retries, backoff) {
                    var _this = this;
                    if (timeout === void 0) timeout = 0;
                    if (retries === void 0) retries = 0;
                    if (backoff === void 0) backoff = 1000;
                    var hasTimedOut = false;
                    var timer = null;
                    var cachedReturnValue = null;
                    var eventuals = [];
                    var eventually = function eventually(boundScope) {
                        return function(fn) {
                            if (hasTimedOut && cachedReturnValue) fn(cachedReturnValue);
                            else eventuals.push(fn);
                            return boundScope;
                        };
                    };
                    if (timeout != 0) timer = new Promise(function(resolve, reject) {
                        setTimeout(function() {
                            hasTimedOut = true;
                            reject(new Error("The initialization timeout of ".concat(timeout, "ms has been hit before the network request has completed.")));
                        }, timeout);
                    });
                    var fetchPromise = this.postToEndpoint(endpointName, body, retries, backoff).then(function(res) {
                        if (!res.ok) return Promise.reject(new Error("Request to ".concat(endpointName, " failed with status ").concat(res.status)));
                        if (typeof res.data !== 'object') {
                            var error = new Error("Request to ".concat(endpointName, " received invalid response type. Expected 'object' but got '").concat(typeof res.data, "'"));
                            _this._errorBoundary._logError('postWithTimeoutInvalidRes', error, function() {
                                return __awaiter(_this, void 0, void 0, function() {
                                    return __generator(this, function(_a) {
                                        return [
                                            2,
                                            this._getErrorData(endpointName, body, retries, backoff, res)
                                        ];
                                    });
                                });
                            });
                            return Promise.reject(error);
                        }
                        var json = res.data;
                        return _this._errorBoundary._capture('postWithTimeout', function() {
                            return __awaiter(_this, void 0, void 0, function() {
                                return __generator(this, function(_a) {
                                    cachedReturnValue = json;
                                    if (hasTimedOut) {
                                        eventuals.forEach(function(fn) {
                                            return fn(json);
                                        });
                                        eventuals = [];
                                    }
                                    return [
                                        2,
                                        Promise.resolve(json)
                                    ];
                                });
                            });
                        }, function() {
                            return Promise.resolve({});
                        }, function() {
                            return __awaiter(_this, void 0, void 0, function() {
                                return __generator(this, function(_a) {
                                    return [
                                        2,
                                        this._getErrorData(endpointName, body, retries, backoff, res)
                                    ];
                                });
                            });
                        });
                    }).catch(function(e) {
                        return Promise.reject(e);
                    });
                    var racingPromise = timer ? Promise.race([
                        fetchPromise,
                        timer
                    ]) : fetchPromise;
                    racingPromise.eventually = eventually(racingPromise);
                    return racingPromise;
                };
                StatsigNetwork.prototype._getErrorData = function(endpointName, body, retries, backoff, res) {
                    var _a;
                    return __awaiter(this, void 0, void 0, function() {
                        var headers_1;
                        return __generator(this, function(_b) {
                            try {
                                headers_1 = {};
                                ((_a = res.headers) !== null && _a !== void 0 ? _a : []).forEach(function(value, key) {
                                    headers_1[key] = value;
                                });
                                return [
                                    2,
                                    {
                                        responseInfo: {
                                            headers: headers_1,
                                            status: res.status,
                                            statusText: res.statusText,
                                            type: res.type,
                                            url: res.url,
                                            redirected: res.redirected,
                                            bodySnippet: res.data ? JSON.stringify(res.data).slice(0, 500) : null
                                        },
                                        requestInfo: {
                                            endpointName: endpointName,
                                            bodySnippet: JSON.stringify(body).slice(0, 500),
                                            retries: retries,
                                            backoff: backoff
                                        }
                                    }
                                ];
                            } catch (_e) {
                                return [
                                    2,
                                    {
                                        statusText: 'statsig::failed to extract extra data'
                                    }
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return StatsigNetwork;
            }();
            exports.default = StatsigNetwork;
        })(StatsigNetwork);
        var __awaiter$1 = commonjsGlobal && commonjsGlobal.__awaiter || function(thisArg, _arguments, P, generator) {
            function adopt(value) {
                return value instanceof P ? value : new P(function(resolve) {
                    resolve(value);
                });
            }
            return new (P || (P = Promise))(function(resolve, reject) {
                function fulfilled(value) {
                    try {
                        step(generator.next(value));
                    } catch (e) {
                        reject(e);
                    }
                }
                function rejected(value) {
                    try {
                        step(generator["throw"](value));
                    } catch (e) {
                        reject(e);
                    }
                }
                function step(result) {
                    result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                }
                step((generator = generator.apply(thisArg, _arguments || [])).next());
            });
        };
        var __generator$1 = commonjsGlobal && commonjsGlobal.__generator || function(thisArg, body) {
            var _ = {
                label: 0,
                sent: function sent() {
                    if (t[0] & 1) throw t[1];
                    return t[1];
                },
                trys: [],
                ops: []
            }, f, y, t, g;
            return g = {
                next: verb(0),
                "throw": verb(1),
                "return": verb(2)
            }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                return this;
            }), g;
            function verb(n) {
                return function(v) {
                    return step([
                        n,
                        v
                    ]);
                };
            }
            function step(op) {
                if (f) throw new TypeError("Generator is already executing.");
                while(g && (g = 0, op[0] && (_ = 0)), _)try {
                    if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                    if (y = 0, t) op = [
                        op[0] & 2,
                        t.value
                    ];
                    switch(op[0]){
                        case 0:
                        case 1:
                            t = op;
                            break;
                        case 4:
                            _.label++;
                            return {
                                value: op[1],
                                done: false
                            };
                        case 5:
                            _.label++;
                            y = op[1];
                            op = [
                                0
                            ];
                            continue;
                        case 7:
                            op = _.ops.pop();
                            _.trys.pop();
                            continue;
                        default:
                            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                _ = 0;
                                continue;
                            }
                            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                _.label = op[1];
                                break;
                            }
                            if (op[0] === 6 && _.label < t[1]) {
                                _.label = t[1];
                                t = op;
                                break;
                            }
                            if (t && _.label < t[2]) {
                                _.label = t[2];
                                _.ops.push(op);
                                break;
                            }
                            if (t[2]) _.ops.pop();
                            _.trys.pop();
                            continue;
                    }
                    op = body.call(thisArg, _);
                } catch (e) {
                    op = [
                        6,
                        e
                    ];
                    y = 0;
                } finally{
                    f = t = 0;
                }
                if (op[0] & 5) throw op[1];
                return {
                    value: op[0] ? op[1] : void 0,
                    done: true
                };
            }
        };
        var __importDefault$1 = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
            return mod && mod.__esModule ? mod : {
                "default": mod
            };
        };
        Object.defineProperty(StatsigLogger$1, "__esModule", {
            value: true
        });
        var LogEvent_1$1 = __importDefault$1(LogEvent);
        var StatsigNetwork_1$1 = StatsigNetwork;
        var Constants_1 = Constants;
        var StatsigLocalStorage_1$1 = __importDefault$1(StatsigLocalStorage$1);
        var INTERNAL_EVENT_PREFIX = 'statsig::';
        var CONFIG_EXPOSURE_EVENT = INTERNAL_EVENT_PREFIX + 'config_exposure';
        var LAYER_EXPOSURE_EVENT = INTERNAL_EVENT_PREFIX + 'layer_exposure';
        var GATE_EXPOSURE_EVENT = INTERNAL_EVENT_PREFIX + 'gate_exposure';
        var LOG_FAILURE_EVENT = INTERNAL_EVENT_PREFIX + 'log_event_failed';
        var DEFAULT_VALUE_WARNING = INTERNAL_EVENT_PREFIX + 'default_value_type_mismatch';
        var MS_RETRY_LOGS_CUTOFF = 432000000;
        var MAX_BATCHES_TO_RETRY = 100;
        var MAX_FAILED_EVENTS = 1000;
        var MAX_LOCAL_STORAGE_SIZE = 1024 * MAX_FAILED_EVENTS;
        var StatsigLogger = function() {
            function StatsigLogger(options, identity, network, errorBoundary) {
                var _this = this;
                this._failedLogEventCount = 0;
                this.logConfigDefaultValueFallback = function(user, message, metadata) {
                    var defaultValueEvent = (0, LogEvent_1$1.default)(DEFAULT_VALUE_WARNING, user, _this._identity._statsigMetadata, message, metadata);
                    _this.log(defaultValueEvent);
                    _this._loggedErrors.add(message);
                };
                this._options = options;
                this._identity = identity;
                this._network = network;
                this._errorBoundary = errorBoundary;
                this._queue = [];
                this._flushInterval = null;
                this._loggedErrors = new Set();
                this._failedLogEvents = [];
                this._exposureDedupeKeys = {};
                this._failedLogEventCount = 0;
                this._init();
            }
            StatsigLogger.prototype.log = function(event) {
                if (this._options.disableAllLogging) return;
                try {
                    if (!this._options.disableCurrentPageLogging && typeof window !== 'undefined' && window != null && typeof window.location === 'object' && typeof window.location.href === 'string') {
                        var parts = window.location.href.split(/[?#]/);
                        if ((parts === null || parts === void 0 ? void 0 : parts.length) > 0) event.statsigMetadata.currentPage = parts[0];
                    }
                } catch (_e) {}
                this._queue.push(event);
                if (this._queue.length >= this._options.loggingBufferMaxSize) this.flush();
            };
            StatsigLogger.prototype.resetDedupeKeys = function() {
                this._exposureDedupeKeys = {};
            };
            StatsigLogger.prototype.logGateExposure = function(user, gateName, gateValue, ruleID, secondaryExposures, details, isManualExposure) {
                var dedupeKey = gateName + String(gateValue) + ruleID + details.reason;
                if (!this._shouldLogExposure(dedupeKey)) return;
                var metadata = {
                    gate: gateName,
                    gateValue: String(gateValue),
                    ruleID: ruleID,
                    reason: details.reason,
                    time: details.time
                };
                if (isManualExposure) metadata['isManualExposure'] = 'true';
                var gateExposure = (0, LogEvent_1$1.default)(GATE_EXPOSURE_EVENT, user, this._identity._statsigMetadata, null, metadata, secondaryExposures);
                this.log(gateExposure);
            };
            StatsigLogger.prototype.logConfigExposure = function(user, configName, ruleID, secondaryExposures, details, isManualExposure) {
                var dedupeKey = configName + ruleID + details.reason;
                if (!this._shouldLogExposure(dedupeKey)) return;
                var metadata = {
                    config: configName,
                    ruleID: ruleID,
                    reason: details.reason,
                    time: details.time
                };
                if (isManualExposure) metadata['isManualExposure'] = 'true';
                var configExposure = (0, LogEvent_1$1.default)(CONFIG_EXPOSURE_EVENT, user, this._identity._statsigMetadata, null, metadata, secondaryExposures);
                this.log(configExposure);
            };
            StatsigLogger.prototype.logLayerExposure = function(user, configName, ruleID, secondaryExposures, allocatedExperiment, parameterName, isExplicitParameter, details, isManualExposure) {
                var dedupeKey = [
                    configName,
                    ruleID,
                    allocatedExperiment,
                    parameterName,
                    String(isExplicitParameter),
                    details.reason
                ].join('|');
                if (!this._shouldLogExposure(dedupeKey)) return;
                var metadata = {
                    config: configName,
                    ruleID: ruleID,
                    allocatedExperiment: allocatedExperiment,
                    parameterName: parameterName,
                    isExplicitParameter: String(isExplicitParameter),
                    reason: details.reason,
                    time: details.time
                };
                if (isManualExposure) metadata['isManualExposure'] = 'true';
                var configExposure = (0, LogEvent_1$1.default)(LAYER_EXPOSURE_EVENT, user, this._identity._statsigMetadata, null, metadata, secondaryExposures);
                this.log(configExposure);
            };
            StatsigLogger.prototype.shutdown = function() {
                if (this._flushInterval) {
                    clearInterval(this._flushInterval);
                    this._flushInterval = null;
                }
                this.flush(true);
            };
            StatsigLogger.prototype.flush = function(isClosing) {
                var _this = this;
                if (isClosing === void 0) isClosing = false;
                if (this._queue.length === 0) return;
                var statsigMetadata = this._identity._statsigMetadata;
                var oldQueue = this._queue;
                this._queue = [];
                if (isClosing && !this._network.supportsKeepalive() && typeof navigator !== 'undefined' && navigator != null && navigator.sendBeacon) {
                    var beacon = this._network.sendLogBeacon({
                        events: oldQueue,
                        statsigMetadata: statsigMetadata
                    });
                    if (!beacon) {
                        this._queue = oldQueue.concat(this._queue);
                        if (this._queue.length > 0) {
                            this._addFailedRequest({
                                events: this._queue,
                                statsigMetadata: statsigMetadata,
                                time: Date.now()
                            });
                            this._queue = [];
                        }
                        this._saveFailedRequests();
                    }
                    return;
                }
                var processor = this;
                this._network.postToEndpoint(StatsigNetwork_1$1.StatsigEndpoint.Rgstr, {
                    events: oldQueue,
                    statsigMetadata: statsigMetadata
                }, 3, 1000, isClosing).then(function(response) {
                    if (!response.ok) throw response;
                }).catch(function(error) {
                    if (typeof error.text === 'function') error.text().then(function(errorText) {
                        _this._errorBoundary._logError(LOG_FAILURE_EVENT, error, function() {
                            return __awaiter$1(_this, void 0, void 0, function() {
                                return __generator$1(this, function(_a) {
                                    return [
                                        2,
                                        {
                                            eventCount: oldQueue.length,
                                            error: errorText
                                        }
                                    ];
                                });
                            });
                        });
                    });
                    else _this._errorBoundary._logError(LOG_FAILURE_EVENT, error, function() {
                        return __awaiter$1(_this, void 0, void 0, function() {
                            return __generator$1(this, function(_a) {
                                return [
                                    2,
                                    {
                                        eventCount: oldQueue.length,
                                        error: error.message
                                    }
                                ];
                            });
                        });
                    });
                    processor._newFailedRequest(LOG_FAILURE_EVENT, oldQueue);
                }).finally(function() {
                    return __awaiter$1(_this, void 0, void 0, function() {
                        return __generator$1(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    if (!isClosing) return [
                                        3,
                                        2
                                    ];
                                    if (this._queue.length > 0) {
                                        this._addFailedRequest({
                                            events: this._queue,
                                            statsigMetadata: statsigMetadata,
                                            time: Date.now()
                                        });
                                        this._queue = [];
                                    }
                                    return [
                                        4,
                                        processor._saveFailedRequests()
                                    ];
                                case 1:
                                    _a.sent();
                                    _a.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                });
            };
            StatsigLogger.prototype.sendSavedRequests = function() {
                return __awaiter$1(this, void 0, void 0, function() {
                    var failedRequests, fireAndForget, requestBodies, _loop_1, this_1, _i, requestBodies_1, requestBody;
                    var _this = this;
                    return __generator$1(this, function(_a) {
                        fireAndForget = false;
                        failedRequests = StatsigLocalStorage_1$1.default.getItem(Constants_1.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY);
                        if (failedRequests == null) {
                            this._clearLocalStorageRequests();
                            return [
                                2
                            ];
                        }
                        if (failedRequests.length > MAX_LOCAL_STORAGE_SIZE) fireAndForget = true;
                        requestBodies = [];
                        try {
                            requestBodies = JSON.parse(failedRequests);
                            _loop_1 = function _loop_1(requestBody) {
                                if (requestBody != null && requestBody.events && Array.isArray(requestBody.events)) this_1._network.postToEndpoint(StatsigNetwork_1$1.StatsigEndpoint.Rgstr, requestBody).then(function(response) {
                                    if (!response.ok) throw Error(response.status + '');
                                }).catch(function(_e) {
                                    if (fireAndForget) return;
                                    _this._addFailedRequest(requestBody);
                                });
                            };
                            this_1 = this;
                            for(_i = 0, requestBodies_1 = requestBodies; _i < requestBodies_1.length; _i++){
                                requestBody = requestBodies_1[_i];
                                _loop_1(requestBody);
                            }
                        } catch (_e) {} finally{
                            this._clearLocalStorageRequests();
                        }
                        return [
                            2
                        ];
                    });
                });
            };
            StatsigLogger.prototype._init = function() {
                var _this = this;
                if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
                    window.addEventListener('blur', function() {
                        return _this.flush(true);
                    });
                    window.addEventListener('beforeunload', function() {
                        return _this.flush(true);
                    });
                    window.addEventListener('load', function() {
                        setTimeout(function() {
                            return _this.flush();
                        }, 100);
                        setTimeout(function() {
                            return _this.flush();
                        }, 1000);
                    });
                }
                if (typeof document !== 'undefined' && typeof document.addEventListener === 'function') document.addEventListener('visibilitychange', function() {
                    _this.flush(document.visibilityState !== 'visible');
                });
                if (!this._options.ignoreWindowUndefined && (typeof window === 'undefined' || window == null)) return;
                if (this._options.localMode) return;
                var me = this;
                this._flushInterval = setInterval(function() {
                    me.flush();
                }, this._options.loggingIntervalMillis);
                setTimeout(function() {
                    return _this.flush();
                }, 100);
                setTimeout(function() {
                    return _this.flush();
                }, 1000);
            };
            StatsigLogger.prototype._shouldLogExposure = function(key) {
                var lastTime = this._exposureDedupeKeys[key];
                var now = Date.now();
                if (lastTime == null) {
                    this._exposureDedupeKeys[key] = now;
                    return true;
                }
                if (lastTime >= now - 600000) return false;
                this._exposureDedupeKeys[key] = now;
                return true;
            };
            StatsigLogger.prototype._saveFailedRequests = function() {
                return __awaiter$1(this, void 0, void 0, function() {
                    var requestsCopy;
                    return __generator$1(this, function(_a) {
                        if (this._failedLogEvents.length > 0) {
                            requestsCopy = JSON.stringify(this._failedLogEvents);
                            if (requestsCopy.length > MAX_LOCAL_STORAGE_SIZE) {
                                this._clearLocalStorageRequests();
                                return [
                                    2
                                ];
                            }
                            StatsigLocalStorage_1$1.default.setItem(Constants_1.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY, requestsCopy);
                        }
                        return [
                            2
                        ];
                    });
                });
            };
            StatsigLogger.prototype._addFailedRequest = function(requestBody) {
                if (requestBody.time < Date.now() - MS_RETRY_LOGS_CUTOFF) return;
                if (this._failedLogEvents.length > MAX_BATCHES_TO_RETRY) return;
                var additionalEvents = requestBody.events.length;
                if (this._failedLogEventCount + additionalEvents > MAX_FAILED_EVENTS) return;
                this._failedLogEvents.push(requestBody);
                this._failedLogEventCount += additionalEvents;
            };
            StatsigLogger.prototype._clearLocalStorageRequests = function() {
                StatsigLocalStorage_1$1.default.removeItem(Constants_1.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY);
            };
            StatsigLogger.prototype._newFailedRequest = function(name, queue) {
                if (this._loggedErrors.has(name)) return;
                this._loggedErrors.add(name);
                this._failedLogEvents.push({
                    events: queue,
                    statsigMetadata: this._identity._statsigMetadata,
                    time: Date.now()
                });
                this._saveFailedRequests().then(function() {});
            };
            return StatsigLogger;
        }();
        StatsigLogger$1.default = StatsigLogger;
        var StatsigSDKOptions = {};
        (function(exports) {
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.INIT_TIMEOUT_DEFAULT_MS = void 0;
            var DEFAULT_FEATURE_GATE_API = 'https://featuregates.org/v1/';
            var DEFAULT_EVENT_LOGGING_API = 'https://events.statsigapi.net/v1/';
            exports.INIT_TIMEOUT_DEFAULT_MS = 3000;
            var StatsigSDKOptions = function() {
                function StatsigSDKOptions(options) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
                    if (options == null) options = {};
                    var api = (_a = options.api) !== null && _a !== void 0 ? _a : DEFAULT_FEATURE_GATE_API;
                    this.api = api.endsWith('/') ? api : api + '/';
                    this.disableCurrentPageLogging = (_b = options.disableCurrentPageLogging) !== null && _b !== void 0 ? _b : false;
                    this.environment = (_c = options.environment) !== null && _c !== void 0 ? _c : null;
                    this.loggingIntervalMillis = this.normalizeNumberInput(options.loggingIntervalMillis, {
                        default: 10000,
                        min: 1000,
                        max: 60000
                    });
                    this.loggingBufferMaxSize = this.normalizeNumberInput(options.loggingBufferMaxSize, {
                        default: 100,
                        min: 2,
                        max: 500
                    });
                    this.disableNetworkKeepalive = (_d = options.disableNetworkKeepalive) !== null && _d !== void 0 ? _d : false;
                    this.overrideStableID = (_e = options.overrideStableID) !== null && _e !== void 0 ? _e : null;
                    this.localMode = (_f = options.localMode) !== null && _f !== void 0 ? _f : false;
                    this.initTimeoutMs = options.initTimeoutMs && options.initTimeoutMs >= 0 ? options.initTimeoutMs : exports.INIT_TIMEOUT_DEFAULT_MS;
                    this.disableErrorLogging = (_g = options.disableErrorLogging) !== null && _g !== void 0 ? _g : false;
                    this.disableAutoMetricsLogging = (_h = options.disableAutoMetricsLogging) !== null && _h !== void 0 ? _h : false;
                    this.initializeValues = (_j = options.initializeValues) !== null && _j !== void 0 ? _j : null;
                    var eventLoggingApi = (_l = (_k = options.eventLoggingApi) !== null && _k !== void 0 ? _k : options.api) !== null && _l !== void 0 ? _l : DEFAULT_EVENT_LOGGING_API;
                    this.eventLoggingApi = eventLoggingApi.endsWith('/') ? eventLoggingApi : eventLoggingApi + '/';
                    this.disableLocalStorage = (_m = options.disableLocalStorage) !== null && _m !== void 0 ? _m : false;
                    this.ignoreWindowUndefined = (_o = options === null || options === void 0 ? void 0 : options.ignoreWindowUndefined) !== null && _o !== void 0 ? _o : false;
                    this.updateUserCompletionCallback = (_p = options === null || options === void 0 ? void 0 : options.updateUserCompletionCallback) !== null && _p !== void 0 ? _p : null;
                    this.disableAllLogging = (_q = options === null || options === void 0 ? void 0 : options.disableAllLogging) !== null && _q !== void 0 ? _q : false;
                }
                StatsigSDKOptions.prototype.normalizeNumberInput = function(input, bounds) {
                    if (input == null) return bounds.default;
                    return Math.max(Math.min(input, bounds.max), bounds.min);
                };
                return StatsigSDKOptions;
            }();
            exports.default = StatsigSDKOptions;
        })(StatsigSDKOptions);
        var StatsigStore = {};
        var BootstrapValidator$1 = {};
        var __assign$1 = commonjsGlobal && commonjsGlobal.__assign || function() {
            __assign$1 = Object.assign || function(t) {
                for(var s, i = 1, n = arguments.length; i < n; i++){
                    s = arguments[i];
                    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
            return __assign$1.apply(this, arguments);
        };
        Object.defineProperty(BootstrapValidator$1, "__esModule", {
            value: true
        });
        var BootstrapValidator = function() {
            function BootstrapValidator() {}
            BootstrapValidator.isValid = function(user, values) {
                try {
                    var evaluatedKeys = values['evaluated_keys'];
                    if (!evaluatedKeys || typeof evaluatedKeys !== 'object') return true;
                    var evaluatedKeysRecord = this.copyObject(evaluatedKeys);
                    var userToCompare = user == null ? null : this.copyObject(user);
                    return BootstrapValidator.validate(evaluatedKeysRecord, userToCompare) && BootstrapValidator.validate(userToCompare, evaluatedKeysRecord);
                } catch (error) {}
                return true;
            };
            BootstrapValidator.validate = function(one, two) {
                if (one == null) return two == null;
                else if (two == null) return false;
                for(var _i = 0, _a = Object.entries(one); _i < _a.length; _i++){
                    var _b = _a[_i], key = _b[0], value = _b[1];
                    if (key === 'stableID') continue;
                    if (typeof value !== typeof two[key]) return false;
                    if (typeof value === 'string') {
                        if (value !== two[key]) return false;
                    } else if (typeof value === 'object') return this.validate(value, two[key]);
                    else return false;
                }
                return true;
            };
            BootstrapValidator.copyObject = function(obj) {
                if (obj == null) return null;
                var copy = {};
                if (obj === null || obj === void 0 ? void 0 : obj.userID) copy['userID'] = obj === null || obj === void 0 ? void 0 : obj.userID;
                if (obj === null || obj === void 0 ? void 0 : obj.customIDs) {
                    var customIDs = __assign$1({}, obj.customIDs);
                    delete customIDs['stableID'];
                    if (Object.keys(customIDs).length !== 0) copy['customIDs'] = customIDs;
                }
                return copy;
            };
            return BootstrapValidator;
        }();
        BootstrapValidator$1.default = BootstrapValidator;
        (function(exports) {
            var __awaiter = commonjsGlobal && commonjsGlobal.__awaiter || function(thisArg, _arguments, P, generator) {
                function adopt(value) {
                    return value instanceof P ? value : new P(function(resolve) {
                        resolve(value);
                    });
                }
                return new (P || (P = Promise))(function(resolve, reject) {
                    function fulfilled(value) {
                        try {
                            step(generator.next(value));
                        } catch (e) {
                            reject(e);
                        }
                    }
                    function rejected(value) {
                        try {
                            step(generator["throw"](value));
                        } catch (e) {
                            reject(e);
                        }
                    }
                    function step(result) {
                        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                    }
                    step((generator = generator.apply(thisArg, _arguments || [])).next());
                });
            };
            var __generator = commonjsGlobal && commonjsGlobal.__generator || function(thisArg, body) {
                var _ = {
                    label: 0,
                    sent: function sent() {
                        if (t[0] & 1) throw t[1];
                        return t[1];
                    },
                    trys: [],
                    ops: []
                }, f, y, t, g;
                return g = {
                    next: verb(0),
                    "throw": verb(1),
                    "return": verb(2)
                }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                    return this;
                }), g;
                function verb(n) {
                    return function(v) {
                        return step([
                            n,
                            v
                        ]);
                    };
                }
                function step(op) {
                    if (f) throw new TypeError("Generator is already executing.");
                    while(g && (g = 0, op[0] && (_ = 0)), _)try {
                        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                        if (y = 0, t) op = [
                            op[0] & 2,
                            t.value
                        ];
                        switch(op[0]){
                            case 0:
                            case 1:
                                t = op;
                                break;
                            case 4:
                                _.label++;
                                return {
                                    value: op[1],
                                    done: false
                                };
                            case 5:
                                _.label++;
                                y = op[1];
                                op = [
                                    0
                                ];
                                continue;
                            case 7:
                                op = _.ops.pop();
                                _.trys.pop();
                                continue;
                            default:
                                if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                    _ = 0;
                                    continue;
                                }
                                if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                    _.label = op[1];
                                    break;
                                }
                                if (op[0] === 6 && _.label < t[1]) {
                                    _.label = t[1];
                                    t = op;
                                    break;
                                }
                                if (t && _.label < t[2]) {
                                    _.label = t[2];
                                    _.ops.push(op);
                                    break;
                                }
                                if (t[2]) _.ops.pop();
                                _.trys.pop();
                                continue;
                        }
                        op = body.call(thisArg, _);
                    } catch (e) {
                        op = [
                            6,
                            e
                        ];
                        y = 0;
                    } finally{
                        f = t = 0;
                    }
                    if (op[0] & 5) throw op[1];
                    return {
                        value: op[0] ? op[1] : void 0,
                        done: true
                    };
                }
            };
            var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
                return mod && mod.__esModule ? mod : {
                    "default": mod
                };
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.EvaluationReason = void 0;
            var DynamicConfig_1 = __importDefault(DynamicConfig$1);
            var Layer_1 = __importDefault(Layer$1);
            var BootstrapValidator_1 = __importDefault(BootstrapValidator$1);
            var Constants_1 = Constants;
            var Hashing_1 = Hashing;
            var StatsigLocalStorage_1 = __importDefault(StatsigLocalStorage$1);
            var EvaluationReason;
            (function(EvaluationReason) {
                EvaluationReason["Network"] = "Network";
                EvaluationReason["Bootstrap"] = "Bootstrap";
                EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
                EvaluationReason["Cache"] = "Cache";
                EvaluationReason["Unrecognized"] = "Unrecognized";
                EvaluationReason["Uninitialized"] = "Uninitialized";
                EvaluationReason["Error"] = "Error";
                EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
                EvaluationReason["LocalOverride"] = "LocalOverride";
            })(EvaluationReason = exports.EvaluationReason || (exports.EvaluationReason = {}));
            var MAX_USER_VALUE_CACHED = 10;
            var StatsigStore = function() {
                function StatsigStore(identity, onDefaultValueFallback, initializeValues) {
                    this._identity = identity;
                    this._onDefaultValueFallback = onDefaultValueFallback;
                    this._userCacheKey = this._identity.getUserCacheKey();
                    this._values = {};
                    this._userValues = this._getDefaultUserCacheValues();
                    this._loaded = false;
                    this._reason = EvaluationReason.Uninitialized;
                    if (initializeValues) this.bootstrap(initializeValues);
                    else this._loadFromLocalStorage();
                }
                StatsigStore.prototype.updateUser = function() {
                    this._userCacheKey = this._identity.getUserCacheKey();
                    return this._setUserValueFromCache();
                };
                StatsigStore.prototype.bootstrap = function(initializeValues) {
                    var _a, _b, _c;
                    var key = this._identity.getUserCacheKey();
                    var user = this._identity._user;
                    var reason = BootstrapValidator_1.default.isValid(user, initializeValues) ? EvaluationReason.Bootstrap : EvaluationReason.InvalidBootstrap;
                    this._loaded = true;
                    try {
                        this._userValues.feature_gates = (_a = initializeValues.feature_gates) !== null && _a !== void 0 ? _a : {};
                        this._userValues.dynamic_configs = (_b = initializeValues.dynamic_configs) !== null && _b !== void 0 ? _b : {};
                        this._userValues.layer_configs = (_c = initializeValues.layer_configs) !== null && _c !== void 0 ? _c : {};
                        this._userValues.evaluation_time = Date.now();
                        this._userValues.time = Date.now();
                        this._values[key] = this._userValues;
                        this._reason = reason;
                    } catch (_e) {
                        return;
                    }
                };
                StatsigStore.prototype.isLoaded = function() {
                    return this._loaded;
                };
                StatsigStore.prototype.getLastUpdateTime = function(user) {
                    var userHash = (0, Hashing_1.djb2HashForObject)(user);
                    if (this._userValues.user_hash == userHash) return this._userValues.time;
                    return null;
                };
                StatsigStore.prototype.getPreviousDerivedFields = function(user) {
                    var userHash = (0, Hashing_1.djb2HashForObject)(user);
                    if (this._userValues.user_hash == userHash) return this._userValues.derived_fields;
                    return undefined;
                };
                StatsigStore.prototype.setEvaluationReason = function(evalReason) {
                    this._reason = evalReason;
                };
                StatsigStore.prototype.save = function(user, jsonConfigs, updateState) {
                    if (updateState === void 0) updateState = true;
                    return __awaiter(this, void 0, void 0, function() {
                        var requestedUserCacheKey, initResponse, userValues, _a;
                        return __generator(this, function(_b) {
                            switch(_b.label){
                                case 0:
                                    requestedUserCacheKey = (0, Hashing_1.getUserCacheKey)(user);
                                    initResponse = jsonConfigs;
                                    this._mergeInitializeResponseIntoUserMap(initResponse, this._values, requestedUserCacheKey, user, function(userValues) {
                                        return userValues;
                                    });
                                    if (updateState) {
                                        userValues = this._values[requestedUserCacheKey];
                                        if (userValues && requestedUserCacheKey && requestedUserCacheKey == this._userCacheKey) {
                                            this._userValues = userValues;
                                            this._reason = EvaluationReason.Network;
                                        }
                                    }
                                    _a = this;
                                    return [
                                        4,
                                        this._writeValuesToStorage(this._values)
                                    ];
                                case 1:
                                    _a._values = _b.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                };
                StatsigStore.prototype.checkGate = function(gateName) {
                    var _a;
                    var gateNameHash = (0, Hashing_1.getHashValue)(gateName, this._userValues.hash_used);
                    var gateValue = {
                        name: gateName,
                        value: false,
                        rule_id: '',
                        secondary_exposures: []
                    };
                    var details;
                    var value = (_a = this._userValues) === null || _a === void 0 ? void 0 : _a.feature_gates[gateNameHash];
                    if (value) gateValue = value;
                    details = this._getEvaluationDetails(value != null);
                    return {
                        evaluationDetails: details,
                        gate: gateValue
                    };
                };
                StatsigStore.prototype.getConfig = function(configName) {
                    var _a, _b;
                    var configNameHash = (0, Hashing_1.getHashValue)(configName, this._userValues.hash_used);
                    var configValue;
                    var details;
                    if (((_a = this._userValues) === null || _a === void 0 ? void 0 : _a.dynamic_configs[configNameHash]) != null) {
                        var rawConfigValue = (_b = this._userValues) === null || _b === void 0 ? void 0 : _b.dynamic_configs[configNameHash];
                        details = this._getEvaluationDetails(true);
                        configValue = this._createDynamicConfig(configName, rawConfigValue, details);
                    } else {
                        details = this._getEvaluationDetails(false);
                        configValue = new DynamicConfig_1.default(configName, {}, '', details);
                    }
                    return configValue;
                };
                StatsigStore.prototype.getLayer = function(logParameterFunction, layerName) {
                    var _a, _b, _c;
                    var latestValue = this._getLatestValue(layerName, 'layer_configs');
                    var details = this._getEvaluationDetails(latestValue != null);
                    return Layer_1.default._create(layerName, (_a = latestValue === null || latestValue === void 0 ? void 0 : latestValue.value) !== null && _a !== void 0 ? _a : {}, (_b = latestValue === null || latestValue === void 0 ? void 0 : latestValue.rule_id) !== null && _b !== void 0 ? _b : '', details, logParameterFunction, latestValue === null || latestValue === void 0 ? void 0 : latestValue.secondary_exposures, latestValue === null || latestValue === void 0 ? void 0 : latestValue.undelegated_secondary_exposures, (_c = latestValue === null || latestValue === void 0 ? void 0 : latestValue.allocated_experiment_name) !== null && _c !== void 0 ? _c : '', latestValue === null || latestValue === void 0 ? void 0 : latestValue.explicit_parameters);
                };
                StatsigStore.prototype.getGlobalEvaluationDetails = function() {
                    var _a, _b;
                    return {
                        reason: (_a = this._reason) !== null && _a !== void 0 ? _a : EvaluationReason.Uninitialized,
                        time: (_b = this._userValues.evaluation_time) !== null && _b !== void 0 ? _b : 0
                    };
                };
                StatsigStore.prototype._loadFromLocalStorage = function() {
                    this._parseCachedValues(StatsigLocalStorage_1.default.getItem(Constants_1.INTERNAL_STORE_KEY));
                    this._loaded = true;
                };
                StatsigStore.prototype._parseCachedValues = function(allValues) {
                    try {
                        this._values = allValues ? JSON.parse(allValues) : this._values;
                        this._setUserValueFromCache();
                    } catch (e) {
                        this._removeFromStorage(Constants_1.INTERNAL_STORE_KEY);
                    }
                };
                StatsigStore.prototype._setUserValueFromCache = function() {
                    var _a;
                    var cachedValues = this._values[this._userCacheKey];
                    if (cachedValues == null) {
                        this._resetUserValues();
                        this._reason = EvaluationReason.Uninitialized;
                        return null;
                    }
                    this._userValues = cachedValues;
                    this._reason = EvaluationReason.Cache;
                    return (_a = cachedValues.evaluation_time) !== null && _a !== void 0 ? _a : 0;
                };
                StatsigStore.prototype._removeFromStorage = function(key) {
                    StatsigLocalStorage_1.default.removeItem(key);
                };
                StatsigStore.prototype._mergeInitializeResponseIntoUserMap = function(data, configMap, requestedUserCacheKey, user, mergeFn) {
                    if (requestedUserCacheKey) {
                        var requestedUserValues = this._convertAPIDataToCacheValues(data, requestedUserCacheKey);
                        if (data.has_updates && data.time) {
                            var userHash = (0, Hashing_1.djb2HashForObject)(user);
                            requestedUserValues.user_hash = userHash;
                        }
                        configMap[requestedUserCacheKey] = mergeFn(requestedUserValues, requestedUserCacheKey);
                    }
                };
                StatsigStore.prototype._getDefaultUserCacheValues = function() {
                    return {
                        feature_gates: {},
                        layer_configs: {},
                        dynamic_configs: {},
                        time: 0,
                        evaluation_time: 0,
                        has_updates: false
                    };
                };
                StatsigStore.prototype._writeValuesToStorage = function(valuesToWrite) {
                    return __awaiter(this, void 0, void 0, function() {
                        var filteredValues;
                        return __generator(this, function(_a) {
                            filteredValues = Object.entries(valuesToWrite).sort(function(_a, _b) {
                                var _c, _d;
                                var a = _a[1];
                                var b = _b[1];
                                if (a == null) return 1;
                                if (b == null) return -1;
                                return ((_c = b === null || b === void 0 ? void 0 : b.evaluation_time) !== null && _c !== void 0 ? _c : b === null || b === void 0 ? void 0 : b.time) - ((_d = a === null || a === void 0 ? void 0 : a.evaluation_time) !== null && _d !== void 0 ? _d : a === null || a === void 0 ? void 0 : a.time);
                            }).slice(0, MAX_USER_VALUE_CACHED);
                            valuesToWrite = Object.fromEntries(filteredValues);
                            StatsigLocalStorage_1.default.setItem(Constants_1.INTERNAL_STORE_KEY, JSON.stringify(valuesToWrite));
                            return [
                                2,
                                valuesToWrite
                            ];
                        });
                    });
                };
                StatsigStore.prototype._getLatestValue = function(name, topLevelKey) {
                    var _a, _b, _c, _d, _f;
                    var hash = (0, Hashing_1.getHashValue)(name, this._userValues.hash_used);
                    return (_c = (_b = (_a = this._userValues) === null || _a === void 0 ? void 0 : _a[topLevelKey]) === null || _b === void 0 ? void 0 : _b[hash]) !== null && _c !== void 0 ? _c : (_f = (_d = this._userValues) === null || _d === void 0 ? void 0 : _d[topLevelKey]) === null || _f === void 0 ? void 0 : _f[name];
                };
                StatsigStore.prototype._createDynamicConfig = function(name, apiConfig, details) {
                    var _a, _b, _c;
                    return new DynamicConfig_1.default(name, (_a = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.value) !== null && _a !== void 0 ? _a : {}, (_b = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.rule_id) !== null && _b !== void 0 ? _b : '', details, apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.secondary_exposures, (_c = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.allocated_experiment_name) !== null && _c !== void 0 ? _c : '', this._makeOnConfigDefaultValueFallback(this._identity._user));
                };
                StatsigStore.prototype._getEvaluationDetails = function(valueExists, reasonOverride) {
                    var _a;
                    if (valueExists) return {
                        reason: this._reason,
                        time: (_a = this._userValues.evaluation_time) !== null && _a !== void 0 ? _a : Date.now()
                    };
                    else return {
                        reason: reasonOverride !== null && reasonOverride !== void 0 ? reasonOverride : this._reason == EvaluationReason.Uninitialized ? EvaluationReason.Uninitialized : EvaluationReason.Unrecognized,
                        time: Date.now()
                    };
                };
                StatsigStore.prototype._resetUserValues = function() {
                    this._userValues = this._getDefaultUserCacheValues();
                };
                StatsigStore.prototype._convertAPIDataToCacheValues = function(data, cacheKey) {
                    return {
                        feature_gates: data.feature_gates,
                        layer_configs: data.layer_configs,
                        dynamic_configs: data.dynamic_configs,
                        time: data.time == null || isNaN(data.time) ? 0 : data.time,
                        evaluation_time: Date.now(),
                        derived_fields: data.derived_fields,
                        hash_used: data.hash_used
                    };
                };
                StatsigStore.prototype._makeOnConfigDefaultValueFallback = function(user) {
                    var _this = this;
                    return function(config, parameter, defaultValueType, valueType) {
                        if (!_this.isLoaded()) return;
                        _this._onDefaultValueFallback(user, "Parameter ".concat(parameter, " is a value of type ").concat(valueType, ".\n          Returning requested defaultValue type ").concat(defaultValueType), {
                            name: config._name,
                            ruleID: config._ruleID,
                            parameter: parameter,
                            defaultValueType: defaultValueType,
                            valueType: valueType
                        });
                    };
                };
                return StatsigStore;
            }();
            exports.default = StatsigStore;
        })(StatsigStore);
        var ResponseVerification = {};
        Object.defineProperty(ResponseVerification, "__esModule", {
            value: true
        });
        ResponseVerification.verifySDKKeyUsed = void 0;
        var Errors_1$1 = Errors;
        var Hashing_1 = Hashing;
        function verifySDKKeyUsed(json, sdkKey, errorBoundary) {
            var hashedSDKKeyUsed = json === null || json === void 0 ? void 0 : json.hashed_sdk_key_used;
            if (hashedSDKKeyUsed != null && hashedSDKKeyUsed !== (0, Hashing_1.SimpleHash)(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '')) {
                errorBoundary._logError('fetchAndSaveValues', new Errors_1$1.StatsigSDKKeyMismatchError('The SDK key provided does not match the one used to generate values.'));
                return false;
            }
            return true;
        }
        ResponseVerification.verifySDKKeyUsed = verifySDKKeyUsed;
        var Timing = {};
        Object.defineProperty(Timing, "__esModule", {
            value: true
        });
        Timing.difference = Timing.now = void 0;
        function now() {
            if (typeof performance === 'undefined' || !performance) return Date.now();
            return performance.now() | 0;
        }
        Timing.now = now;
        function difference(time) {
            return now() - time;
        }
        Timing.difference = difference;
        var LocalOverrides = {};
        (function(exports) {
            var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
                return mod && mod.__esModule ? mod : {
                    "default": mod
                };
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.saveOverridesToLocalStorage = exports.loadOverridesFromLocalStorage = exports.makeEmptyOverrides = exports.STORAGE_KEY = void 0;
            var StatsigLocalStorage_1 = __importDefault(StatsigLocalStorage$1);
            exports.STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
            function makeEmptyOverrides() {
                return {
                    gates: {},
                    configs: {},
                    layers: {}
                };
            }
            exports.makeEmptyOverrides = makeEmptyOverrides;
            function loadOverridesFromLocalStorage() {
                var raw = StatsigLocalStorage_1.default.getItem(exports.STORAGE_KEY);
                if (raw) try {
                    return JSON.parse(raw);
                } catch (error) {}
                return makeEmptyOverrides();
            }
            exports.loadOverridesFromLocalStorage = loadOverridesFromLocalStorage;
            function saveOverridesToLocalStorage(overrides) {
                StatsigLocalStorage_1.default.setItem(exports.STORAGE_KEY, JSON.stringify(overrides));
            }
            exports.saveOverridesToLocalStorage = saveOverridesToLocalStorage;
        })(LocalOverrides);
        var __assign = commonjsGlobal && commonjsGlobal.__assign || function() {
            __assign = Object.assign || function(t) {
                for(var s, i = 1, n = arguments.length; i < n; i++){
                    s = arguments[i];
                    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
            return __assign.apply(this, arguments);
        };
        var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
            if (k2 === undefined) k2 = k;
            var desc = Object.getOwnPropertyDescriptor(m, k);
            if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
                enumerable: true,
                get: function get() {
                    return m[k];
                }
            };
            Object.defineProperty(o, k2, desc);
        } : function(o, m, k, k2) {
            if (k2 === undefined) k2 = k;
            o[k2] = m[k];
        });
        var __setModuleDefault = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
            Object.defineProperty(o, "default", {
                enumerable: true,
                value: v
            });
        } : function(o, v) {
            o["default"] = v;
        });
        var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function(mod) {
            if (mod && mod.__esModule) return mod;
            var result = {};
            if (mod != null) {
                for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
            }
            __setModuleDefault(result, mod);
            return result;
        };
        var __awaiter = commonjsGlobal && commonjsGlobal.__awaiter || function(thisArg, _arguments, P, generator) {
            function adopt(value) {
                return value instanceof P ? value : new P(function(resolve) {
                    resolve(value);
                });
            }
            return new (P || (P = Promise))(function(resolve, reject) {
                function fulfilled(value) {
                    try {
                        step(generator.next(value));
                    } catch (e) {
                        reject(e);
                    }
                }
                function rejected(value) {
                    try {
                        step(generator["throw"](value));
                    } catch (e) {
                        reject(e);
                    }
                }
                function step(result) {
                    result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                }
                step((generator = generator.apply(thisArg, _arguments || [])).next());
            });
        };
        var __generator = commonjsGlobal && commonjsGlobal.__generator || function(thisArg, body) {
            var _ = {
                label: 0,
                sent: function sent() {
                    if (t[0] & 1) throw t[1];
                    return t[1];
                },
                trys: [],
                ops: []
            }, f, y, t, g;
            return g = {
                next: verb(0),
                "throw": verb(1),
                "return": verb(2)
            }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                return this;
            }), g;
            function verb(n) {
                return function(v) {
                    return step([
                        n,
                        v
                    ]);
                };
            }
            function step(op) {
                if (f) throw new TypeError("Generator is already executing.");
                while(g && (g = 0, op[0] && (_ = 0)), _)try {
                    if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                    if (y = 0, t) op = [
                        op[0] & 2,
                        t.value
                    ];
                    switch(op[0]){
                        case 0:
                        case 1:
                            t = op;
                            break;
                        case 4:
                            _.label++;
                            return {
                                value: op[1],
                                done: false
                            };
                        case 5:
                            _.label++;
                            y = op[1];
                            op = [
                                0
                            ];
                            continue;
                        case 7:
                            op = _.ops.pop();
                            _.trys.pop();
                            continue;
                        default:
                            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                _ = 0;
                                continue;
                            }
                            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                _.label = op[1];
                                break;
                            }
                            if (op[0] === 6 && _.label < t[1]) {
                                _.label = t[1];
                                t = op;
                                break;
                            }
                            if (t && _.label < t[2]) {
                                _.label = t[2];
                                _.ops.push(op);
                                break;
                            }
                            if (t[2]) _.ops.pop();
                            _.trys.pop();
                            continue;
                    }
                    op = body.call(thisArg, _);
                } catch (e) {
                    op = [
                        6,
                        e
                    ];
                    y = 0;
                } finally{
                    f = t = 0;
                }
                if (op[0] & 5) throw op[1];
                return {
                    value: op[0] ? op[1] : void 0,
                    done: true
                };
            }
        };
        var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
            return mod && mod.__esModule ? mod : {
                "default": mod
            };
        };
        Object.defineProperty(StatsigClient$1, "__esModule", {
            value: true
        });
        var DynamicConfig_1 = __importDefault(DynamicConfig$1);
        var ErrorBoundary_1 = __importDefault(ErrorBoundary);
        var Errors_1 = Errors;
        var Layer_1 = __importDefault(Layer$1);
        var StatsigIdentity_1 = __importDefault(StatsigIdentity);
        var StatsigLogger_1 = __importDefault(StatsigLogger$1);
        var StatsigNetwork_1 = __importDefault(StatsigNetwork);
        var StatsigSDKOptions_1 = __importDefault(StatsigSDKOptions);
        var StatsigStore_1 = __importStar(StatsigStore);
        var ResponseVerification_1 = ResponseVerification;
        var StatsigLocalStorage_1 = __importDefault(StatsigLocalStorage$1);
        var Timing_1 = Timing;
        var LogEvent_1 = __importDefault(LogEvent);
        var LocalOverrides_1 = LocalOverrides;
        var StatsigClient = function() {
            function StatsigClient(sdkKey, user, options) {
                var _this = this;
                this._initCalled = false;
                this._pendingInitPromise = null;
                this._sdkKey = null;
                this._logLayerParameterExposureForLayer = function(layer, parameterName, isManualExposure) {
                    if (isManualExposure === void 0) isManualExposure = false;
                    var allocatedExperiment = '';
                    var exposures = layer._undelegatedSecondaryExposures;
                    var isExplicit = layer._explicitParameters.includes(parameterName);
                    if (isExplicit) {
                        allocatedExperiment = layer._allocatedExperimentName;
                        exposures = layer._secondaryExposures;
                    }
                    _this._logger.logLayerExposure(_this._identity._user, layer._name, layer._ruleID, exposures, allocatedExperiment, parameterName, isExplicit, layer._evaluationDetails, isManualExposure);
                };
                if ((options === null || options === void 0 ? void 0 : options.localMode) !== true && (typeof sdkKey !== 'string' || !sdkKey.startsWith('client-'))) throw new Errors_1.StatsigInvalidArgumentError('Invalid key provided.  You must use a Client SDK Key from the Statsig console to initialize the sdk');
                this._sdkKey = sdkKey;
                this._startTime = (0, Timing_1.now)();
                this._options = new StatsigSDKOptions_1.default(options);
                this._errorBoundary = new ErrorBoundary_1.default(sdkKey, this._options);
                this._ready = false;
                StatsigLocalStorage_1.default.disabled = this._options.disableLocalStorage;
                this._overrides = (0, LocalOverrides_1.loadOverridesFromLocalStorage)();
                this._identity = new StatsigIdentity_1.default(sdkKey, this._normalizeUser(user !== null && user !== void 0 ? user : null), this._options.overrideStableID);
                this._network = new StatsigNetwork_1.default(this._options, this._identity, this._errorBoundary);
                this._logger = new StatsigLogger_1.default(this._options, this._identity, this._network, this._errorBoundary);
                this._store = new StatsigStore_1.default(this._identity, this._logger.logConfigDefaultValueFallback, this._options.initializeValues);
                this._errorBoundary._setStatsigMetadata(this._identity._statsigMetadata);
                if (this._options.initializeValues != null) {
                    this._ready = true;
                    this._initCalled = true;
                    setTimeout(function() {
                        return _this._delayedSetup();
                    }, 20);
                }
            }
            StatsigClient.prototype.setInitializeValues = function(initializeValues) {
                var _this = this;
                this._errorBoundary._capture('setInitializeValues', function() {
                    _this._store.bootstrap(initializeValues);
                    if (!_this._ready) {
                        _this._ready = true;
                        _this._initCalled = true;
                    }
                    _this._logger.sendSavedRequests();
                }, function() {
                    _this._ready = true;
                    _this._initCalled = true;
                });
            };
            StatsigClient.prototype.initializeAsync = function() {
                return __awaiter(this, void 0, void 0, function() {
                    var _this = this;
                    return __generator(this, function(_a) {
                        return [
                            2,
                            this._errorBoundary._capture('initializeAsync', function() {
                                return __awaiter(_this, void 0, void 0, function() {
                                    var user;
                                    var _this = this;
                                    return __generator(this, function(_a) {
                                        if (this._pendingInitPromise != null) return [
                                            2,
                                            this._pendingInitPromise
                                        ];
                                        if (this._ready) return [
                                            2,
                                            Promise.resolve()
                                        ];
                                        this._initCalled = true;
                                        if (this._options.localMode) return [
                                            2,
                                            Promise.resolve()
                                        ];
                                        user = this._identity._user;
                                        this._pendingInitPromise = this._fetchAndSaveValues(user, this._options.initTimeoutMs).then(function() {
                                            return;
                                        }).catch(function(e) {
                                            _this._errorBoundary._logError('initializeAsync:fetchAndSaveValues', e);
                                            return {
                                                success: false,
                                                message: e.message
                                            };
                                        }).then(function() {
                                            return;
                                        }).finally(function() {
                                            return __awaiter(_this, void 0, void 0, function() {
                                                return __generator(this, function(_a) {
                                                    this._pendingInitPromise = null;
                                                    this._ready = true;
                                                    this._delayedSetup();
                                                    return [
                                                        2
                                                    ];
                                                });
                                            });
                                        });
                                        return [
                                            2,
                                            this._pendingInitPromise
                                        ];
                                    });
                                });
                            }, function() {
                                _this._ready = true;
                                _this._initCalled = true;
                                return Promise.resolve();
                            })
                        ];
                    });
                });
            };
            StatsigClient.prototype.getEvaluationDetails = function() {
                var _this = this;
                return this._errorBoundary._capture('getEvaluationDetails', function() {
                    return _this._store.getGlobalEvaluationDetails();
                }, function() {
                    return {
                        time: Date.now(),
                        reason: StatsigStore_1.EvaluationReason.Error
                    };
                });
            };
            StatsigClient.prototype.checkGate = function(gateName) {
                return this._checkGateImpl(gateName, 'checkGate');
            };
            StatsigClient.prototype.checkGateWithExposureLoggingDisabled = function(gateName) {
                return this._checkGateImpl(gateName, 'checkGateWithExposureLoggingDisabled');
            };
            StatsigClient.prototype.logGateExposure = function(gateName) {
                var _this = this;
                this._errorBoundary._swallow('logGateExposure', function() {
                    _this._logGateExposureImpl(gateName);
                });
            };
            StatsigClient.prototype.getConfig = function(configName) {
                return this._getConfigImpl(configName, 'getConfig');
            };
            StatsigClient.prototype.getConfigWithExposureLoggingDisabled = function(configName) {
                return this._getConfigImpl(configName, 'getConfigWithExposureLoggingDisabled');
            };
            StatsigClient.prototype.logConfigExposure = function(configName) {
                var _this = this;
                this._errorBoundary._swallow('logConfigExposure', function() {
                    _this._logConfigExposureImpl(configName);
                });
            };
            StatsigClient.prototype.getExperiment = function(experimentName) {
                return this.getConfig(experimentName);
            };
            StatsigClient.prototype.getExperimentWithExposureLoggingDisabled = function(experimentName) {
                return this.getConfigWithExposureLoggingDisabled(experimentName);
            };
            StatsigClient.prototype.logExperimentExposure = function(experimentName) {
                this.logConfigExposure(experimentName);
            };
            StatsigClient.prototype.getLayer = function(layerName) {
                return this._getLayerImpl(layerName, 'getLayer');
            };
            StatsigClient.prototype.getLayerWithExposureLoggingDisabled = function(layerName) {
                return this._getLayerImpl(layerName, 'getLayerWithExposureLoggingDisabled');
            };
            StatsigClient.prototype.logLayerParameterExposure = function(layerName, parameterName) {
                var _this = this;
                this._errorBoundary._swallow('logLayerParameterExposure', function() {
                    var layer = _this._getLayerFromStore(null, layerName);
                    _this._logLayerParameterExposureForLayer(layer, parameterName, true);
                });
            };
            StatsigClient.prototype.logEvent = function(eventName, value, metadata) {
                var _this = this;
                if (value === void 0) value = null;
                if (metadata === void 0) metadata = null;
                this._errorBoundary._swallow('logEvent', function() {
                    if (!_this._logger || !_this._identity._sdkKey) throw new Errors_1.StatsigUninitializedError(Errors_1.StatsigErrorMessage.REQUIRE_INITIALIZE_FOR_LOG_EVENT);
                    if (typeof eventName !== 'string' || eventName.length === 0) return;
                    var event = (0, LogEvent_1.default)(eventName, _this._identity._user, _this._identity._statsigMetadata, value, metadata);
                    _this._logger.log(event);
                });
            };
            StatsigClient.prototype.updateUserWithValues = function(user, values) {
                var _this = this;
                var updateStartTime = Date.now();
                var fireCompletionCallback;
                return this._errorBoundary._capture('updateUserWithValues', function() {
                    if (!_this.initializeCalled()) throw new Errors_1.StatsigUninitializedError(Errors_1.StatsigErrorMessage.REQUIRE_ASYNC_INITIALIZE);
                    fireCompletionCallback = function fireCompletionCallback(success, error) {
                        var cb = _this._options.updateUserCompletionCallback;
                        cb === null || cb === void 0 || cb(Date.now() - updateStartTime, success, error);
                    };
                    _this._identity._user = _this._normalizeUser(user);
                    _this._store.bootstrap(values);
                    fireCompletionCallback(true, null);
                    return true;
                }, function() {
                    fireCompletionCallback === null || fireCompletionCallback === void 0 || fireCompletionCallback(false, 'Failed to update user. An unexpected error occured.');
                    return false;
                });
            };
            StatsigClient.prototype.updateUser = function(user) {
                return __awaiter(this, void 0, void 0, function() {
                    var updateStartTime, fireCompletionCallback;
                    var _this = this;
                    return __generator(this, function(_a) {
                        updateStartTime = Date.now();
                        return [
                            2,
                            this._errorBoundary._capture('updateUser', function() {
                                return __awaiter(_this, void 0, void 0, function() {
                                    var currentUser;
                                    var _this = this;
                                    return __generator(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                if (!this.initializeCalled()) throw new Errors_1.StatsigUninitializedError(Errors_1.StatsigErrorMessage.REQUIRE_ASYNC_INITIALIZE);
                                                fireCompletionCallback = function fireCompletionCallback(success, error) {
                                                    var cb = _this._options.updateUserCompletionCallback;
                                                    cb === null || cb === void 0 || cb(Date.now() - updateStartTime, success, error);
                                                };
                                                this._identity._user = this._normalizeUser(user);
                                                this._store.updateUser();
                                                this._logger.resetDedupeKeys();
                                                if (!(this._pendingInitPromise != null)) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    this._pendingInitPromise
                                                ];
                                            case 1:
                                                _a.sent();
                                                _a.label = 2;
                                            case 2:
                                                if (this._options.localMode) {
                                                    fireCompletionCallback(true, null);
                                                    return [
                                                        2,
                                                        Promise.resolve(true)
                                                    ];
                                                }
                                                currentUser = this._identity._user;
                                                this._pendingInitPromise = this._fetchAndSaveValues(currentUser).finally(function() {
                                                    _this._pendingInitPromise = null;
                                                });
                                                return [
                                                    2,
                                                    this._pendingInitPromise.then(function() {
                                                        fireCompletionCallback(true, null);
                                                        return Promise.resolve(true);
                                                    }).catch(function(error) {
                                                        fireCompletionCallback(false, "Failed to update user: ".concat(error));
                                                        return Promise.resolve(false);
                                                    })
                                                ];
                                        }
                                    });
                                });
                            }, function() {
                                fireCompletionCallback(false, 'Failed to update user. An unexpected error occured.');
                                return Promise.resolve(false);
                            })
                        ];
                    });
                });
            };
            StatsigClient.prototype.shutdown = function() {
                var _this = this;
                this._errorBoundary._swallow('shutdown', function() {
                    _this._logger.shutdown();
                });
            };
            StatsigClient.prototype.getStableID = function() {
                var _this = this;
                return this._errorBoundary._capture('getStableID', function() {
                    return _this._identity._statsigMetadata.stableID;
                }, function() {
                    return '';
                });
            };
            StatsigClient.prototype.initializeCalled = function() {
                return this._initCalled;
            };
            StatsigClient.prototype.overrideGate = function(gate, result) {
                this._setOverride('gates', gate, result);
            };
            StatsigClient.prototype.overrideConfig = function(config, result) {
                this._setOverride('configs', config, result);
            };
            StatsigClient.prototype.overrideLayer = function(layer, result) {
                this._setOverride('layers', layer, result);
            };
            StatsigClient.prototype.setOverrides = function(overrides) {
                var _this = this;
                this._errorBoundary._swallow('setOverrides', function() {
                    _this._overrides = overrides !== null && overrides !== void 0 ? overrides : (0, LocalOverrides_1.makeEmptyOverrides)();
                    (0, LocalOverrides_1.saveOverridesToLocalStorage)(_this._overrides);
                });
            };
            StatsigClient.prototype.getOverrides = function() {
                var _this = this;
                return this._errorBoundary._capture('getOverrides', function() {
                    return _this._overrides;
                }, function() {
                    return (0, LocalOverrides_1.makeEmptyOverrides)();
                });
            };
            StatsigClient.prototype._delayedSetup = function() {
                var _this = this;
                this._errorBoundary._swallow('delayedSetup', function() {
                    _this._identity.saveStableID();
                    _this._logger.sendSavedRequests().then(function() {});
                });
            };
            StatsigClient.prototype._normalizeUser = function(user) {
                var userCopy = {};
                try {
                    userCopy = JSON.parse(JSON.stringify(user));
                } catch (error) {
                    throw new Errors_1.StatsigInvalidArgumentError('User object must be convertable to JSON string.');
                }
                if (this._options.environment != null) userCopy = __assign(__assign({}, userCopy), {
                    statsigEnvironment: this._options.environment
                });
                return userCopy;
            };
            StatsigClient.prototype._ensureStoreLoaded = function() {
                if (!this._store.isLoaded()) throw new Errors_1.StatsigUninitializedError();
            };
            StatsigClient.prototype._getEvaluationDetailsForError = function() {
                return {
                    time: Date.now(),
                    reason: StatsigStore_1.EvaluationReason.Error
                };
            };
            StatsigClient.prototype._fetchAndSaveValues = function(user, timeout) {
                if (timeout === void 0) timeout = this._options.initTimeoutMs;
                return __awaiter(this, void 0, void 0, function() {
                    var sinceTime, previousDerivedFields;
                    var _this = this;
                    return __generator(this, function(_a) {
                        sinceTime = null;
                        sinceTime = this._store.getLastUpdateTime(user);
                        previousDerivedFields = this._store.getPreviousDerivedFields(user);
                        return [
                            2,
                            this._network.fetchValues(user, sinceTime, timeout, previousDerivedFields).eventually(function(json) {
                                var _a;
                                if (!(0, ResponseVerification_1.verifySDKKeyUsed)(json, (_a = _this._sdkKey) !== null && _a !== void 0 ? _a : '', _this._errorBoundary)) return;
                                if (json === null || json === void 0 ? void 0 : json.has_updates) _this._store.save(user, json, false);
                            }).then(function(json) {
                                return __awaiter(_this, void 0, void 0, function() {
                                    var _this = this;
                                    return __generator(this, function(_a) {
                                        return [
                                            2,
                                            this._errorBoundary._swallow('fetchAndSaveValues', function() {
                                                return __awaiter(_this, void 0, void 0, function() {
                                                    var _a;
                                                    return __generator(this, function(_b) {
                                                        switch(_b.label){
                                                            case 0:
                                                                if (!(0, ResponseVerification_1.verifySDKKeyUsed)(json, (_a = this._sdkKey) !== null && _a !== void 0 ? _a : '', this._errorBoundary)) return [
                                                                    2
                                                                ];
                                                                if (!(json === null || json === void 0 ? void 0 : json.has_updates)) return [
                                                                    3,
                                                                    2
                                                                ];
                                                                return [
                                                                    4,
                                                                    this._store.save(user, json)
                                                                ];
                                                            case 1:
                                                                _b.sent();
                                                                return [
                                                                    3,
                                                                    3
                                                                ];
                                                            case 2:
                                                                if (json === null || json === void 0 ? void 0 : json.is_no_content) this._store.setEvaluationReason(StatsigStore_1.EvaluationReason.NetworkNotModified);
                                                                _b.label = 3;
                                                            case 3:
                                                                return [
                                                                    2
                                                                ];
                                                        }
                                                    });
                                                });
                                            })
                                        ];
                                    });
                                });
                            })
                        ];
                    });
                });
            };
            StatsigClient.prototype._checkGateImpl = function(gateName, callsite) {
                var _this = this;
                return this._errorBoundary._capture(callsite, function() {
                    if (typeof _this._overrides.gates[gateName] === 'boolean') return _this._overrides.gates[gateName];
                    var result = _this._getGateFromStore(gateName);
                    if (callsite === 'checkGate') _this._logGateExposureImpl(gateName, result);
                    return result.gate.value === true;
                }, function() {
                    return false;
                });
            };
            StatsigClient.prototype._getGateFromStore = function(gateName) {
                this._ensureStoreLoaded();
                if (typeof gateName !== 'string' || gateName.length === 0) throw new Errors_1.StatsigInvalidArgumentError('Must pass a valid string as the gateName.');
                return this._store.checkGate(gateName);
            };
            StatsigClient.prototype._logGateExposureImpl = function(gateName, fetchResult) {
                var isManualExposure = !fetchResult;
                var result = fetchResult !== null && fetchResult !== void 0 ? fetchResult : this._getGateFromStore(gateName);
                var gate = result.gate;
                this._logger.logGateExposure(this._identity._user, gateName, gate.value, gate.rule_id, gate.secondary_exposures, result.evaluationDetails, isManualExposure);
            };
            StatsigClient.prototype._getConfigImpl = function(configName, callsite) {
                var _this = this;
                return this._errorBoundary._capture(callsite, function() {
                    if (_this._overrides.configs[configName]) return new DynamicConfig_1.default(configName, _this._overrides.configs[configName], 'local_override', {
                        reason: StatsigStore_1.EvaluationReason.LocalOverride,
                        time: Date.now()
                    });
                    var result = _this._getConfigFromStore(configName);
                    if (callsite === 'getConfig') _this._logConfigExposureImpl(configName, result);
                    return result;
                }, function() {
                    return _this._getEmptyConfig(configName);
                });
            };
            StatsigClient.prototype._getConfigFromStore = function(configName) {
                this._ensureStoreLoaded();
                if (typeof configName !== 'string' || configName.length === 0) throw new Errors_1.StatsigInvalidArgumentError('Must pass a valid string as the configName.');
                return this._store.getConfig(configName);
            };
            StatsigClient.prototype._logConfigExposureImpl = function(configName, config) {
                var isManualExposure = !config;
                var localConfig = config !== null && config !== void 0 ? config : this._getConfigFromStore(configName);
                this._logger.logConfigExposure(this._identity._user, configName, localConfig._ruleID, localConfig._secondaryExposures, localConfig._evaluationDetails, isManualExposure);
            };
            StatsigClient.prototype._getLayerImpl = function(layerName, callsite) {
                var _this = this;
                return this._errorBoundary._capture(callsite, function() {
                    if (_this._overrides.layers[layerName]) return Layer_1.default._create(layerName, _this._overrides.layers[layerName], 'local_override', {
                        reason: StatsigStore_1.EvaluationReason.LocalOverride,
                        time: Date.now()
                    });
                    var logFunc = callsite === 'getLayer' ? _this._logLayerParameterExposureForLayer : null;
                    return _this._getLayerFromStore(logFunc, layerName);
                }, function() {
                    return Layer_1.default._create(layerName, {}, '', _this._getEvaluationDetailsForError());
                });
            };
            StatsigClient.prototype._getLayerFromStore = function(logParameterFunction, layerName) {
                this._ensureStoreLoaded();
                if (typeof layerName !== 'string' || layerName.length === 0) throw new Errors_1.StatsigInvalidArgumentError('Must pass a valid string as the layerName.');
                return this._store.getLayer(logParameterFunction, layerName);
            };
            StatsigClient.prototype._getEmptyConfig = function(configName) {
                return new DynamicConfig_1.default(configName, {}, '', this._getEvaluationDetailsForError());
            };
            StatsigClient.prototype._setOverride = function(type, key, result) {
                if (result == null) delete this._overrides[type][key];
                else this._overrides[type][key] = result;
                this.setOverrides(this._overrides);
            };
            return StatsigClient;
        }();
        StatsigClient$1.default = StatsigClient;
        (function(exports) {
            var __awaiter = commonjsGlobal && commonjsGlobal.__awaiter || function(thisArg, _arguments, P, generator) {
                function adopt(value) {
                    return value instanceof P ? value : new P(function(resolve) {
                        resolve(value);
                    });
                }
                return new (P || (P = Promise))(function(resolve, reject) {
                    function fulfilled(value) {
                        try {
                            step(generator.next(value));
                        } catch (e) {
                            reject(e);
                        }
                    }
                    function rejected(value) {
                        try {
                            step(generator["throw"](value));
                        } catch (e) {
                            reject(e);
                        }
                    }
                    function step(result) {
                        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                    }
                    step((generator = generator.apply(thisArg, _arguments || [])).next());
                });
            };
            var __generator = commonjsGlobal && commonjsGlobal.__generator || function(thisArg, body) {
                var _ = {
                    label: 0,
                    sent: function sent() {
                        if (t[0] & 1) throw t[1];
                        return t[1];
                    },
                    trys: [],
                    ops: []
                }, f, y, t, g;
                return g = {
                    next: verb(0),
                    "throw": verb(1),
                    "return": verb(2)
                }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                    return this;
                }), g;
                function verb(n) {
                    return function(v) {
                        return step([
                            n,
                            v
                        ]);
                    };
                }
                function step(op) {
                    if (f) throw new TypeError("Generator is already executing.");
                    while(g && (g = 0, op[0] && (_ = 0)), _)try {
                        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                        if (y = 0, t) op = [
                            op[0] & 2,
                            t.value
                        ];
                        switch(op[0]){
                            case 0:
                            case 1:
                                t = op;
                                break;
                            case 4:
                                _.label++;
                                return {
                                    value: op[1],
                                    done: false
                                };
                            case 5:
                                _.label++;
                                y = op[1];
                                op = [
                                    0
                                ];
                                continue;
                            case 7:
                                op = _.ops.pop();
                                _.trys.pop();
                                continue;
                            default:
                                if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                    _ = 0;
                                    continue;
                                }
                                if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                    _.label = op[1];
                                    break;
                                }
                                if (op[0] === 6 && _.label < t[1]) {
                                    _.label = t[1];
                                    t = op;
                                    break;
                                }
                                if (t && _.label < t[2]) {
                                    _.label = t[2];
                                    _.ops.push(op);
                                    break;
                                }
                                if (t[2]) _.ops.pop();
                                _.trys.pop();
                                continue;
                        }
                        op = body.call(thisArg, _);
                    } catch (e) {
                        op = [
                            6,
                            e
                        ];
                        y = 0;
                    } finally{
                        f = t = 0;
                    }
                    if (op[0] & 5) throw op[1];
                    return {
                        value: op[0] ? op[1] : void 0,
                        done: true
                    };
                }
            };
            var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
                return mod && mod.__esModule ? mod : {
                    "default": mod
                };
            };
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.EvaluationReason = exports.DynamicConfig = void 0;
            var Errors_1 = Errors;
            var StatsigClient_1 = __importDefault(StatsigClient$1);
            var StatsigStore_1 = StatsigStore;
            var DynamicConfig_1 = DynamicConfig$1;
            Object.defineProperty(exports, "DynamicConfig", {
                enumerable: true,
                get: function get() {
                    return __importDefault(DynamicConfig_1).default;
                }
            });
            var StatsigStore_2 = StatsigStore;
            Object.defineProperty(exports, "EvaluationReason", {
                enumerable: true,
                get: function get() {
                    return StatsigStore_2.EvaluationReason;
                }
            });
            var Statsig = function() {
                function Statsig() {}
                Statsig.initialize = function(sdkKey, user, options) {
                    var _a;
                    return __awaiter(this, void 0, void 0, function() {
                        var inst;
                        return __generator(this, function(_b) {
                            inst = (_a = Statsig.instance) !== null && _a !== void 0 ? _a : new StatsigClient_1.default(sdkKey, user, options);
                            if (!Statsig.instance) Statsig.instance = inst;
                            return [
                                2,
                                inst.initializeAsync()
                            ];
                        });
                    });
                };
                Statsig.setInitializeValues = function(initializeValues) {
                    Statsig._getClientX().setInitializeValues(initializeValues);
                };
                Statsig.checkGate = function(gateName) {
                    return Statsig._getClientX().checkGate(gateName);
                };
                Statsig.checkGateWithExposureLoggingDisabled = function(gateName) {
                    return Statsig._getClientX().checkGateWithExposureLoggingDisabled(gateName);
                };
                Statsig.manuallyLogGateExposure = function(gateName) {
                    Statsig._getClientX().logGateExposure(gateName);
                };
                Statsig.getConfig = function(configName) {
                    return Statsig._getClientX().getConfig(configName);
                };
                Statsig.getConfigWithExposureLoggingDisabled = function(configName) {
                    return Statsig._getClientX().getConfigWithExposureLoggingDisabled(configName);
                };
                Statsig.manuallyLogConfigExposure = function(configName) {
                    Statsig._getClientX().logConfigExposure(configName);
                };
                Statsig.getExperiment = function(experimentName) {
                    return Statsig._getClientX().getExperiment(experimentName);
                };
                Statsig.getExperimentWithExposureLoggingDisabled = function(experimentName) {
                    return Statsig._getClientX().getExperimentWithExposureLoggingDisabled(experimentName);
                };
                Statsig.manuallyLogExperimentExposure = function(configName) {
                    Statsig._getClientX().logExperimentExposure(configName);
                };
                Statsig.getLayer = function(layerName) {
                    return Statsig._getClientX().getLayer(layerName);
                };
                Statsig.getLayerWithExposureLoggingDisabled = function(layerName) {
                    return Statsig._getClientX().getLayerWithExposureLoggingDisabled(layerName);
                };
                Statsig.manuallyLogLayerParameterExposure = function(layerName, parameterName) {
                    Statsig._getClientX().logLayerParameterExposure(layerName, parameterName);
                };
                Statsig.logEvent = function(eventName, value, metadata) {
                    if (value === void 0) value = null;
                    if (metadata === void 0) metadata = null;
                    return Statsig._getClientX().logEvent(eventName, value, metadata);
                };
                Statsig.updateUser = function(user) {
                    return Statsig._getClientX().updateUser(user);
                };
                Statsig.updateUserWithValues = function(user, values) {
                    return Statsig._getClientX().updateUserWithValues(user, values);
                };
                Statsig.shutdown = function() {
                    Statsig._getClientX().shutdown();
                    Statsig.instance = null;
                };
                Statsig.overrideGate = function(gate, result) {
                    Statsig._getClientX().overrideGate(gate, result);
                };
                Statsig.overrideConfig = function(config, result) {
                    Statsig._getClientX().overrideConfig(config, result);
                };
                Statsig.overrideLayer = function(layer, result) {
                    Statsig._getClientX().overrideLayer(layer, result);
                };
                Statsig.setOverrides = function(overrides) {
                    Statsig._getClientX().setOverrides(overrides);
                };
                Statsig.getOverrides = function() {
                    return Statsig._getClientX().getOverrides();
                };
                Statsig.getStableID = function() {
                    return Statsig._getClientX().getStableID();
                };
                Statsig.getEvaluationDetails = function() {
                    var _a, _b;
                    return (_b = (_a = Statsig.instance) === null || _a === void 0 ? void 0 : _a.getEvaluationDetails()) !== null && _b !== void 0 ? _b : {
                        reason: StatsigStore_1.EvaluationReason.Uninitialized,
                        time: 0
                    };
                };
                Statsig.initializeCalled = function() {
                    return Statsig.instance != null && Statsig.instance.initializeCalled();
                };
                Statsig._getClientX = function() {
                    if (!Statsig.instance) throw new Errors_1.StatsigUninitializedError();
                    return Statsig.instance;
                };
                Statsig.instance = null;
                return Statsig;
            }();
            exports.default = Statsig;
        })(dist);
        var Statsig = getDefaultExportFromCjs(dist);
        var FeatureGateEnvironment = function(FeatureGateEnvironment) {
            FeatureGateEnvironment["Development"] = "development";
            FeatureGateEnvironment["Staging"] = "staging";
            FeatureGateEnvironment["Production"] = "production";
            return FeatureGateEnvironment;
        }({});
        var PerimeterType = function(PerimeterType) {
            PerimeterType["COMMERCIAL"] = "commercial";
            PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
            return PerimeterType;
        }({});
        var CLIENT_VERSION = "4.17.0";
        function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
            subClass.prototype = Object.create(superClass && superClass.prototype, {
                constructor: {
                    value: subClass,
                    writable: true,
                    configurable: true
                }
            });
            Object.defineProperty(subClass, "prototype", {
                writable: false
            });
            if (superClass) _setPrototypeOf(subClass, superClass);
        }
        function _assertThisInitialized(self1) {
            if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return self1;
        }
        function _possibleConstructorReturn(self1, call) {
            if (call && (_typeof$1(call) === "object" || typeof call === "function")) return call;
            else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
            return _assertThisInitialized(self1);
        }
        function _getPrototypeOf(o) {
            _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                return o.__proto__ || Object.getPrototypeOf(o);
            };
            return _getPrototypeOf(o);
        }
        function _isNativeFunction(fn) {
            try {
                return Function.toString.call(fn).indexOf("[native code]") !== -1;
            } catch (e) {
                return typeof fn === "function";
            }
        }
        function _wrapNativeSuper(Class) {
            var _cache = typeof Map === "function" ? new Map() : undefined;
            _wrapNativeSuper = function _wrapNativeSuper(Class) {
                if (Class === null || !_isNativeFunction(Class)) return Class;
                if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
                if (typeof _cache !== "undefined") {
                    if (_cache.has(Class)) return _cache.get(Class);
                    _cache.set(Class, Wrapper);
                }
                function Wrapper() {
                    return _construct(Class, arguments, _getPrototypeOf(this).constructor);
                }
                Wrapper.prototype = Object.create(Class.prototype, {
                    constructor: {
                        value: Wrapper,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                return _setPrototypeOf(Wrapper, Class);
            };
            return _wrapNativeSuper(Class);
        }
        function _createSuper(Derived) {
            var hasNativeReflectConstruct = _isNativeReflectConstruct();
            return function _createSuperInternal() {
                var Super = _getPrototypeOf(Derived), result;
                if (hasNativeReflectConstruct) {
                    var NewTarget = _getPrototypeOf(this).constructor;
                    result = Reflect.construct(Super, arguments, NewTarget);
                } else result = Super.apply(this, arguments);
                return _possibleConstructorReturn(this, result);
            };
        }
        function _isNativeReflectConstruct() {
            try {
                var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            } catch (t) {}
            return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
                return !!t;
            })();
        }
        var ResponseError = function(_Error) {
            _inherits(ResponseError, _Error);
            var _super = _createSuper(ResponseError);
            function ResponseError(message) {
                _classCallCheck(this, ResponseError);
                return _super.call(this, message);
            }
            return _createClass(ResponseError);
        }(_wrapNativeSuper(Error));
        function ownKeys$2(e, r) {
            var t = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                r && (o = o.filter(function(r) {
                    return Object.getOwnPropertyDescriptor(e, r).enumerable;
                })), t.push.apply(t, o);
            }
            return t;
        }
        function _objectSpread$2(e) {
            for(var r = 1; r < arguments.length; r++){
                var t = null != arguments[r] ? arguments[r] : {};
                r % 2 ? ownKeys$2(Object(t), !0).forEach(function(r) {
                    _defineProperty(e, r, t[r]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function(r) {
                    Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
                });
            }
            return e;
        }
        var DEFAULT_REQUEST_TIMEOUT_MS = 5000;
        var PROD_BASE_URL = 'https://api.atlassian.com/flags';
        var STAGING_BASE_URL = 'https://api.stg.atlassian.com/flags';
        var DEV_BASE_URL = 'https://api.dev.atlassian.com/flags';
        var FEDM_STAGING_BASE_URL = 'https://api.stg.atlassian-us-gov-mod.com/flags';
        var FEDM_PROD_BASE_URL = 'https://api.atlassian-us-gov-mod.com/flags';
        var GATEWAY_BASE_URL = '/gateway/api/flags';
        var Fetcher = function() {
            function Fetcher() {
                _classCallCheck(this, Fetcher);
            }
            _createClass(Fetcher, null, [
                {
                    key: "fetchClientSdk",
                    value: function() {
                        var _fetchClientSdk = _asyncToGenerator(regenerator.mark(function _callee(fetcherOptions) {
                            var targetApp, url;
                            return regenerator.wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        targetApp = fetcherOptions.targetApp;
                                        url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                        _context.prev = 2;
                                        _context.next = 5;
                                        return this.fetchRequest(url, 'GET', fetcherOptions);
                                    case 5:
                                        return _context.abrupt("return", _context.sent);
                                    case 8:
                                        _context.prev = 8;
                                        _context.t0 = _context["catch"](2);
                                        if (!(_context.t0 instanceof Error)) {
                                            _context.next = 12;
                                            break;
                                        }
                                        throw _context.t0;
                                    case 12:
                                        throw Error('Failed to retrieve client sdk key');
                                    case 13:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee, this, [
                                [
                                    2,
                                    8
                                ]
                            ]);
                        }));
                        function fetchClientSdk(_x) {
                            return _fetchClientSdk.apply(this, arguments);
                        }
                        return fetchClientSdk;
                    }()
                },
                {
                    key: "fetchExperimentValues",
                    value: function() {
                        var _fetchExperimentValues = _asyncToGenerator(regenerator.mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                            var requestBody;
                            return regenerator.wrap(function _callee2$(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        requestBody = {
                                            identifiers: identifiers,
                                            customAttributes: customAttributes,
                                            targetApp: fetcherOptions.targetApp
                                        };
                                        _context2.prev = 1;
                                        _context2.next = 4;
                                        return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                                    case 4:
                                        return _context2.abrupt("return", _context2.sent);
                                    case 7:
                                        _context2.prev = 7;
                                        _context2.t0 = _context2["catch"](1);
                                        if (!(_context2.t0 instanceof Error)) {
                                            _context2.next = 11;
                                            break;
                                        }
                                        throw _context2.t0;
                                    case 11:
                                        throw Error('Failed to retrieve experiment values');
                                    case 12:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2, this, [
                                [
                                    1,
                                    7
                                ]
                            ]);
                        }));
                        function fetchExperimentValues(_x2, _x3, _x4) {
                            return _fetchExperimentValues.apply(this, arguments);
                        }
                        return fetchExperimentValues;
                    }()
                },
                {
                    key: "handleResponseError",
                    value: function() {
                        var _handleResponseError = _asyncToGenerator(regenerator.mark(function _callee3(response) {
                            var body;
                            return regenerator.wrap(function _callee3$(_context3) {
                                while(true)switch(_context3.prev = _context3.next){
                                    case 0:
                                        if (response.ok) {
                                            _context3.next = 5;
                                            break;
                                        }
                                        _context3.next = 3;
                                        return response.text();
                                    case 3:
                                        body = _context3.sent;
                                        throw new ResponseError("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                                    case 5:
                                        if (!(response.status === 204)) {
                                            _context3.next = 7;
                                            break;
                                        }
                                        throw new ResponseError('Unexpected 204 response');
                                    case 7:
                                    case "end":
                                        return _context3.stop();
                                }
                            }, _callee3);
                        }));
                        function handleResponseError(_x5) {
                            return _handleResponseError.apply(this, arguments);
                        }
                        return handleResponseError;
                    }()
                },
                {
                    key: "extractResponseBody",
                    value: function() {
                        var _extractResponseBody = _asyncToGenerator(regenerator.mark(function _callee4(response) {
                            var value;
                            return regenerator.wrap(function _callee4$(_context4) {
                                while(true)switch(_context4.prev = _context4.next){
                                    case 0:
                                        _context4.next = 2;
                                        return response.text();
                                    case 2:
                                        value = _context4.sent;
                                        return _context4.abrupt("return", JSON.parse(value));
                                    case 4:
                                    case "end":
                                        return _context4.stop();
                                }
                            }, _callee4);
                        }));
                        function extractResponseBody(_x6) {
                            return _extractResponseBody.apply(this, arguments);
                        }
                        return extractResponseBody;
                    }()
                },
                {
                    key: "getBaseUrl",
                    value: function getBaseUrl(serviceEnv) {
                        var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                        var perimeter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PerimeterType.COMMERCIAL;
                        if (useGatewayUrl) return GATEWAY_BASE_URL;
                        if (perimeter === PerimeterType.FEDRAMP_MODERATE) switch(serviceEnv){
                            case FeatureGateEnvironment.Production:
                                return FEDM_PROD_BASE_URL;
                            case FeatureGateEnvironment.Staging:
                                return FEDM_STAGING_BASE_URL;
                            default:
                                throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                        }
                        else if (perimeter === PerimeterType.COMMERCIAL) switch(serviceEnv){
                            case FeatureGateEnvironment.Development:
                                return DEV_BASE_URL;
                            case FeatureGateEnvironment.Staging:
                                return STAGING_BASE_URL;
                            default:
                                return PROD_BASE_URL;
                        }
                        else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
                    }
                },
                {
                    key: "fetchRequest",
                    value: function() {
                        var _fetchRequest = _asyncToGenerator(regenerator.mark(function _callee5(path, method, fetcherOptions, body) {
                            var baseUrl, fetchTimeout, abortSignal, abortController, response;
                            return regenerator.wrap(function _callee5$(_context5) {
                                while(true)switch(_context5.prev = _context5.next){
                                    case 0:
                                        baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter);
                                        fetchTimeout = fetcherOptions.fetchTimeoutMs || DEFAULT_REQUEST_TIMEOUT_MS;
                                        if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                        else if (AbortController) {
                                            abortController = new AbortController();
                                            abortSignal = abortController.signal;
                                            setTimeout(function() {
                                                return abortController.abort();
                                            }, fetchTimeout);
                                        }
                                        _context5.next = 5;
                                        return fetch("".concat(baseUrl).concat(path), _objectSpread$2({
                                            method: method,
                                            headers: {
                                                'Content-Type': 'application/json',
                                                'X-Client-Name': 'feature-gate-js-client',
                                                'X-Client-Version': CLIENT_VERSION,
                                                'X-API-KEY': fetcherOptions.apiKey
                                            },
                                            signal: abortSignal
                                        }, body && {
                                            body: JSON.stringify(body)
                                        }));
                                    case 5:
                                        response = _context5.sent;
                                        _context5.next = 8;
                                        return this.handleResponseError(response);
                                    case 8:
                                        _context5.next = 10;
                                        return this.extractResponseBody(response);
                                    case 10:
                                        return _context5.abrupt("return", _context5.sent);
                                    case 11:
                                    case "end":
                                        return _context5.stop();
                                }
                            }, _callee5, this);
                        }));
                        function fetchRequest(_x7, _x8, _x9, _x10) {
                            return _fetchRequest.apply(this, arguments);
                        }
                        return fetchRequest;
                    }()
                }
            ]);
            return Fetcher;
        }();
        var _excluded = [
            "sdkKey",
            "updateUserCompletionCallback",
            "perimeter"
        ];
        function ownKeys$1(e, r) {
            var t = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                r && (o = o.filter(function(r) {
                    return Object.getOwnPropertyDescriptor(e, r).enumerable;
                })), t.push.apply(t, o);
            }
            return t;
        }
        function _objectSpread$1(e) {
            for(var r = 1; r < arguments.length; r++){
                var t = null != arguments[r] ? arguments[r] : {};
                r % 2 ? ownKeys$1(Object(t), !0).forEach(function(r) {
                    _defineProperty(e, r, t[r]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function(r) {
                    Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
                });
            }
            return e;
        }
        var DEFAULT_CLIENT_KEY = 'client-default-key';
        var DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/';
        var FeatureGates = function() {
            function FeatureGates() {
                _classCallCheck(this, FeatureGates);
            }
            _createClass(FeatureGates, null, [
                {
                    key: "initialize",
                    value: function() {
                        var _initialize = _asyncToGenerator(regenerator.mark(function _callee(clientOptions, identifiers, customAttributes) {
                            var startTime;
                            return regenerator.wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        if (!FeatureGates.initPromise) {
                                            _context.next = 3;
                                            break;
                                        }
                                        if (!FeatureGates.shallowEquals(clientOptions, FeatureGates.initOptions)) console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                        return _context.abrupt("return", FeatureGates.initPromise);
                                    case 3:
                                        startTime = performance.now();
                                        FeatureGates.initOptions = clientOptions;
                                        FeatureGates.initPromise = FeatureGates.init(clientOptions, identifiers, customAttributes).then(function() {
                                            FeatureGates.initCompleted = true;
                                        }).finally(function() {
                                            var endTime = performance.now();
                                            var totalTime = endTime - startTime;
                                            FeatureGates.fireClientEvent(startTime, totalTime, 'initialize', FeatureGates.initCompleted, clientOptions.apiKey);
                                        });
                                        return _context.abrupt("return", FeatureGates.initPromise);
                                    case 7:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        function initialize(_x, _x2, _x3) {
                            return _initialize.apply(this, arguments);
                        }
                        return initialize;
                    }()
                },
                {
                    key: "fireClientEvent",
                    value: function fireClientEvent(startTime, totalTime, action, success) {
                        var _FeatureGates$initOpt;
                        var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                        (_FeatureGates$initOpt = FeatureGates.initOptions.analyticsWebClient) === null || _FeatureGates$initOpt === void 0 || _FeatureGates$initOpt.then(function(analyticsWebClient) {
                            var attributes = _objectSpread$1({
                                targetApp: FeatureGates.initOptions.targetApp,
                                clientVersion: CLIENT_VERSION,
                                success: success,
                                startTime: startTime,
                                totalTime: totalTime
                            }, apiKey && {
                                apiKey: apiKey
                            });
                            analyticsWebClient.sendOperationalEvent({
                                action: action,
                                actionSubject: 'featureGatesClient',
                                attributes: attributes,
                                tags: [
                                    'measurement'
                                ],
                                source: '@atlaskit/feature-gate-js-client'
                            });
                        }).catch(function(err) {
                            if (FeatureGates.initOptions.environment !== FeatureGateEnvironment.Production) console.error('Analytics web client promise did not resolve', err);
                        });
                    }
                },
                {
                    key: "initializeFromValues",
                    value: function() {
                        var _initializeFromValues = _asyncToGenerator(regenerator.mark(function _callee2(clientOptions, identifiers, customAttributes) {
                            var initializeValues, startTime, _args2 = arguments;
                            return regenerator.wrap(function _callee2$(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        initializeValues = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : {};
                                        if (!FeatureGates.initPromise) {
                                            _context2.next = 4;
                                            break;
                                        }
                                        if (!FeatureGates.shallowEquals(clientOptions, FeatureGates.initOptions)) console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                        return _context2.abrupt("return", FeatureGates.initPromise);
                                    case 4:
                                        startTime = performance.now();
                                        FeatureGates.initOptions = clientOptions;
                                        FeatureGates.initPromise = FeatureGates.initFromValues(clientOptions, identifiers, customAttributes, initializeValues).then(function() {
                                            FeatureGates.initCompleted = true;
                                        }).finally(function() {
                                            var endTime = performance.now();
                                            var totalTime = endTime - startTime;
                                            FeatureGates.fireClientEvent(startTime, totalTime, 'initializeFromValues', FeatureGates.initCompleted);
                                        });
                                        return _context2.abrupt("return", FeatureGates.initPromise);
                                    case 8:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }));
                        function initializeFromValues(_x4, _x5, _x6) {
                            return _initializeFromValues.apply(this, arguments);
                        }
                        return initializeFromValues;
                    }()
                },
                {
                    key: "updateUser",
                    value: function() {
                        var _updateUser = _asyncToGenerator(regenerator.mark(function _callee3(fetchOptions, identifiers, customAttributes) {
                            var initializeValuesProducer;
                            return regenerator.wrap(function _callee3$(_context3) {
                                while(true)switch(_context3.prev = _context3.next){
                                    case 0:
                                        initializeValuesProducer = function initializeValuesProducer() {
                                            return Fetcher.fetchExperimentValues(fetchOptions, identifiers, customAttributes).then(function(_ref) {
                                                var experimentValues = _ref.experimentValues, customAttributes = _ref.customAttributes;
                                                return {
                                                    experimentValues: experimentValues,
                                                    customAttributesFromFetch: customAttributes
                                                };
                                            });
                                        };
                                        _context3.next = 3;
                                        return FeatureGates.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                                    case 3:
                                    case "end":
                                        return _context3.stop();
                                }
                            }, _callee3);
                        }));
                        function updateUser(_x7, _x8, _x9) {
                            return _updateUser.apply(this, arguments);
                        }
                        return updateUser;
                    }()
                },
                {
                    key: "updateUserWithValues",
                    value: function() {
                        var _updateUserWithValues = _asyncToGenerator(regenerator.mark(function _callee4(identifiers, customAttributes) {
                            var initializeValues, initializeValuesProducer, _args4 = arguments;
                            return regenerator.wrap(function _callee4$(_context4) {
                                while(true)switch(_context4.prev = _context4.next){
                                    case 0:
                                        initializeValues = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
                                        initializeValuesProducer = function initializeValuesProducer() {
                                            return Promise.resolve({
                                                experimentValues: initializeValues,
                                                customAttributesFromFetch: customAttributes
                                            });
                                        };
                                        _context4.next = 4;
                                        return FeatureGates.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                                    case 4:
                                    case "end":
                                        return _context4.stop();
                                }
                            }, _callee4);
                        }));
                        function updateUserWithValues(_x10, _x11) {
                            return _updateUserWithValues.apply(this, arguments);
                        }
                        return updateUserWithValues;
                    }()
                },
                {
                    key: "initializeCalled",
                    value: function initializeCalled() {
                        return FeatureGates.initPromise != null;
                    }
                },
                {
                    key: "initializeCompleted",
                    value: function initializeCompleted() {
                        return FeatureGates.initCompleted;
                    }
                },
                {
                    key: "checkGate",
                    value: function checkGate(gateName) {
                        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        try {
                            var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                            var evalMethod = fireGateExposure ? Statsig.checkGate.bind(Statsig) : Statsig.checkGateWithExposureLoggingDisabled.bind(Statsig);
                            return evalMethod(gateName);
                        } catch (error) {
                            if (!FeatureGates.hasCheckGateErrorOccurred) {
                                console.warn({
                                    msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                                    gateName: gateName,
                                    error: error
                                });
                                FeatureGates.hasCheckGateErrorOccurred = true;
                            }
                            return false;
                        }
                    }
                },
                {
                    key: "manuallyLogGateExposure",
                    value: function manuallyLogGateExposure(gateName) {
                        Statsig.manuallyLogGateExposure(gateName);
                    }
                },
                {
                    key: "getExperiment",
                    value: function getExperiment(experimentName) {
                        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        try {
                            var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                            var evalMethod = fireExperimentExposure ? Statsig.getExperiment.bind(Statsig) : Statsig.getExperimentWithExposureLoggingDisabled.bind(Statsig);
                            return evalMethod(experimentName);
                        } catch (error) {
                            if (!FeatureGates.hasGetExperimentErrorOccurred) {
                                console.warn({
                                    msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                                    experimentName: experimentName,
                                    error: error
                                });
                                FeatureGates.hasGetExperimentErrorOccurred = true;
                            }
                            return new dist.DynamicConfig(experimentName, {}, '', {
                                time: Date.now(),
                                reason: dist.EvaluationReason.Error
                            });
                        }
                    }
                },
                {
                    key: "getExperimentValue",
                    value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                        var experiment = FeatureGates.getExperiment(experimentName, options);
                        try {
                            var typeGuard = options.typeGuard;
                            return experiment.get(parameterName, defaultValue, typeGuard);
                        } catch (error) {
                            if (!FeatureGates.hasGetExperimentValueErrorOccurred) {
                                console.warn({
                                    msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                                    experimentName: experimentName,
                                    defaultValue: defaultValue,
                                    options: options,
                                    error: error
                                });
                                FeatureGates.hasGetExperimentValueErrorOccurred = true;
                            }
                            return defaultValue;
                        }
                    }
                },
                {
                    key: "manuallyLogExperimentExposure",
                    value: function manuallyLogExperimentExposure(experimentName) {
                        Statsig.manuallyLogExperimentExposure(experimentName);
                    }
                },
                {
                    key: "shutdownStatsig",
                    value: function shutdownStatsig() {
                        Statsig.shutdown();
                    }
                },
                {
                    key: "overrideGate",
                    value: function overrideGate(gateName, value) {
                        Statsig.overrideGate(gateName, value);
                    }
                },
                {
                    key: "clearGateOverride",
                    value: function clearGateOverride(gateName) {
                        Statsig.overrideGate(gateName, null);
                    }
                },
                {
                    key: "overrideConfig",
                    value: function overrideConfig(experimentName, values) {
                        Statsig.overrideConfig(experimentName, values);
                    }
                },
                {
                    key: "clearConfigOverride",
                    value: function clearConfigOverride(experimentName) {
                        Statsig.overrideConfig(experimentName, null);
                    }
                },
                {
                    key: "setOverrides",
                    value: function setOverrides(overrides) {
                        Statsig.setOverrides(_objectSpread$1({
                            gates: {},
                            configs: {},
                            layers: {}
                        }, overrides));
                    }
                },
                {
                    key: "getOverrides",
                    value: function getOverrides() {
                        return Statsig.getOverrides();
                    }
                },
                {
                    key: "clearAllOverrides",
                    value: function clearAllOverrides() {
                        Statsig.setOverrides(null);
                    }
                },
                {
                    key: "isCurrentUser",
                    value: function isCurrentUser(identifiers, customAttributes) {
                        return FeatureGates.shallowEquals(FeatureGates.currentIdentifiers, identifiers) && FeatureGates.shallowEquals(FeatureGates.currentAttributes, customAttributes);
                    }
                },
                {
                    key: "init",
                    value: function() {
                        var _init = _asyncToGenerator(regenerator.mark(function _callee5(clientOptions, identifiers, customAttributes) {
                            var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                            return regenerator.wrap(function _callee5$(_context5) {
                                while(true)switch(_context5.prev = _context5.next){
                                    case 0:
                                        fromValuesClientOptions = _objectSpread$1(_objectSpread$1({}, clientOptions), {}, {
                                            disableCurrentPageLogging: true
                                        });
                                        _context5.prev = 1;
                                        clientSdkKeyPromise = Fetcher.fetchClientSdk(clientOptions).then(function(value) {
                                            return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                        });
                                        experimentValuesPromise = Fetcher.fetchExperimentValues(clientOptions, identifiers, customAttributes);
                                        _context5.next = 6;
                                        return Promise.all([
                                            clientSdkKeyPromise,
                                            experimentValuesPromise
                                        ]);
                                    case 6:
                                        _yield$Promise$all = _context5.sent;
                                        _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                                        experimentValuesResult = _yield$Promise$all2[1];
                                        experimentValues = experimentValuesResult.experimentValues;
                                        customAttributesFromResult = experimentValuesResult.customAttributes;
                                        _context5.next = 20;
                                        break;
                                    case 13:
                                        _context5.prev = 13;
                                        _context5.t0 = _context5["catch"](1);
                                        if (_context5.t0 instanceof Error) console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context5.t0 === null || _context5.t0 === void 0 ? void 0 : _context5.t0.message));
                                        console.warn("Initialising Statsig client without values");
                                        _context5.next = 19;
                                        return FeatureGates.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                                    case 19:
                                        throw _context5.t0;
                                    case 20:
                                        _context5.next = 22;
                                        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
                                    case 22:
                                    case "end":
                                        return _context5.stop();
                                }
                            }, _callee5, this, [
                                [
                                    1,
                                    13
                                ]
                            ]);
                        }));
                        function init(_x12, _x13, _x14) {
                            return _init.apply(this, arguments);
                        }
                        return init;
                    }()
                },
                {
                    key: "initFromValues",
                    value: function() {
                        var _initFromValues = _asyncToGenerator(regenerator.mark(function _callee6(clientOptions, identifiers, customAttributes) {
                            var initializeValues, user, sdkKey, statsigOptions, _args6 = arguments;
                            return regenerator.wrap(function _callee6$(_context6) {
                                while(true)switch(_context6.prev = _context6.next){
                                    case 0:
                                        initializeValues = _args6.length > 3 && _args6[3] !== undefined ? _args6[3] : {};
                                        user = this.toStatsigUser(identifiers, customAttributes);
                                        FeatureGates.currentIdentifiers = identifiers;
                                        FeatureGates.currentAttributes = customAttributes;
                                        if (!clientOptions.sdkKey) clientOptions.sdkKey = DEFAULT_CLIENT_KEY;
                                        if (!clientOptions.eventLoggingApi) clientOptions.eventLoggingApi = DEFAULT_EVENT_LOGGING_API;
                                        if (clientOptions.perimeter === PerimeterType.FEDRAMP_MODERATE) clientOptions.disableAllLogging = true;
                                        sdkKey = clientOptions.sdkKey;
                                        statsigOptions = this.toStatsigOptions(clientOptions, initializeValues);
                                        _context6.prev = 9;
                                        _context6.next = 12;
                                        return Statsig.initialize(sdkKey, user, statsigOptions);
                                    case 12:
                                        _context6.next = 21;
                                        break;
                                    case 14:
                                        _context6.prev = 14;
                                        _context6.t0 = _context6["catch"](9);
                                        if (_context6.t0 instanceof Error) console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context6.t0 === null || _context6.t0 === void 0 ? void 0 : _context6.t0.message));
                                        console.warn("Initialising Statsig client with default sdk key and without values");
                                        _context6.next = 20;
                                        return Statsig.initialize(DEFAULT_CLIENT_KEY, user, _objectSpread$1(_objectSpread$1({}, statsigOptions), {}, {
                                            initializeValues: {}
                                        }));
                                    case 20:
                                        throw _context6.t0;
                                    case 21:
                                    case "end":
                                        return _context6.stop();
                                }
                            }, _callee6, this, [
                                [
                                    9,
                                    14
                                ]
                            ]);
                        }));
                        function initFromValues(_x15, _x16, _x17) {
                            return _initFromValues.apply(this, arguments);
                        }
                        return initFromValues;
                    }()
                },
                {
                    key: "toStatsigUser",
                    value: function toStatsigUser(identifiers, customAttributes) {
                        var user = {
                            customIDs: identifiers,
                            custom: customAttributes
                        };
                        if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
                        return user;
                    }
                },
                {
                    key: "updateUserUsingInitializeValuesProducer",
                    value: function() {
                        var _updateUserUsingInitializeValuesProducer = _asyncToGenerator(regenerator.mark(function _callee7(getInitializeValues, identifiers, customAttributes) {
                            var originalInitPromise, initializeValuesPromise, updateUserPromise;
                            return regenerator.wrap(function _callee7$(_context7) {
                                while(true)switch(_context7.prev = _context7.next){
                                    case 0:
                                        if (FeatureGates.initPromise) {
                                            _context7.next = 2;
                                            break;
                                        }
                                        throw new Error('The FeatureGates client must be initialized before you can update the user.');
                                    case 2:
                                        if (!FeatureGates.isCurrentUser(identifiers, customAttributes)) {
                                            _context7.next = 4;
                                            break;
                                        }
                                        return _context7.abrupt("return", FeatureGates.initPromise);
                                    case 4:
                                        originalInitPromise = FeatureGates.initPromise;
                                        _context7.prev = 5;
                                        _context7.next = 8;
                                        return FeatureGates.initPromise;
                                    case 8:
                                        _context7.next = 12;
                                        break;
                                    case 10:
                                        _context7.prev = 10;
                                        _context7.t0 = _context7["catch"](5);
                                    case 12:
                                        initializeValuesPromise = getInitializeValues();
                                        updateUserPromise = FeatureGates.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes);
                                        FeatureGates.initPromise = updateUserPromise.catch(function() {
                                            FeatureGates.initPromise = originalInitPromise;
                                        });
                                        return _context7.abrupt("return", updateUserPromise);
                                    case 16:
                                    case "end":
                                        return _context7.stop();
                                }
                            }, _callee7, null, [
                                [
                                    5,
                                    10
                                ]
                            ]);
                        }));
                        function updateUserUsingInitializeValuesProducer(_x18, _x19, _x20) {
                            return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                        }
                        return updateUserUsingInitializeValuesProducer;
                    }()
                },
                {
                    key: "updateStatsigClientUser",
                    value: function() {
                        var _updateStatsigClientUser = _asyncToGenerator(regenerator.mark(function _callee8(initializeValuesPromise, identifiers, customAttributes) {
                            var initializeValues, user, _FeatureGates$initOpt2, _FeatureGates$initOpt3, errMsg, success;
                            return regenerator.wrap(function _callee8$(_context8) {
                                while(true)switch(_context8.prev = _context8.next){
                                    case 0:
                                        _context8.prev = 0;
                                        _context8.next = 3;
                                        return initializeValuesPromise;
                                    case 3:
                                        initializeValues = _context8.sent;
                                        user = FeatureGates.toStatsigUser(identifiers, initializeValues.customAttributesFromFetch);
                                        _context8.next = 12;
                                        break;
                                    case 7:
                                        _context8.prev = 7;
                                        _context8.t0 = _context8["catch"](0);
                                        errMsg = _context8.t0 instanceof Error ? _context8.t0.message : JSON.stringify(_context8.t0);
                                        (_FeatureGates$initOpt2 = (_FeatureGates$initOpt3 = FeatureGates.initOptions).updateUserCompletionCallback) === null || _FeatureGates$initOpt2 === void 0 || _FeatureGates$initOpt2.call(_FeatureGates$initOpt3, false, errMsg);
                                        throw _context8.t0;
                                    case 12:
                                        success = Statsig.updateUserWithValues(user, initializeValues.experimentValues);
                                        if (!success) {
                                            _context8.next = 18;
                                            break;
                                        }
                                        FeatureGates.currentIdentifiers = identifiers;
                                        FeatureGates.currentAttributes = customAttributes;
                                        _context8.next = 19;
                                        break;
                                    case 18:
                                        throw new Error('Failed to update user. An unexpected error occured.');
                                    case 19:
                                    case "end":
                                        return _context8.stop();
                                }
                            }, _callee8, null, [
                                [
                                    0,
                                    7
                                ]
                            ]);
                        }));
                        function updateStatsigClientUser(_x21, _x22, _x23) {
                            return _updateStatsigClientUser.apply(this, arguments);
                        }
                        return updateStatsigClientUser;
                    }()
                },
                {
                    key: "toStatsigOptions",
                    value: function toStatsigOptions(options, initializeValues) {
                        options.sdkKey;
                        options.updateUserCompletionCallback;
                        options.perimeter;
                        var restClientOptions = _objectWithoutProperties(options, _excluded);
                        return _objectSpread$1(_objectSpread$1({}, restClientOptions), {}, {
                            initializeValues: initializeValues,
                            environment: {
                                tier: options.environment
                            },
                            disableCurrentPageLogging: true
                        }, options.updateUserCompletionCallback && {
                            updateUserCompletionCallback: FeatureGates.toStatsigUpdateUserCompletionCallback(options.updateUserCompletionCallback)
                        });
                    }
                },
                {
                    key: "toStatsigUpdateUserCompletionCallback",
                    value: function toStatsigUpdateUserCompletionCallback(callback) {
                        return function(_duration, success, message) {
                            callback(success, message);
                        };
                    }
                },
                {
                    key: "shallowEquals",
                    value: function shallowEquals(objectA, objectB) {
                        if (!objectA && !objectB) return true;
                        if (!objectA || !objectB) return false;
                        var aEntries = Object.entries(objectA);
                        var bEntries = Object.entries(objectB);
                        if (aEntries.length !== bEntries.length) return false;
                        var ascendingKeyOrder = function ascendingKeyOrder(_ref2, _ref3) {
                            var _ref4 = _slicedToArray(_ref2, 1), key1 = _ref4[0];
                            var _ref5 = _slicedToArray(_ref3, 1), key2 = _ref5[0];
                            return key1.localeCompare(key2);
                        };
                        aEntries.sort(ascendingKeyOrder);
                        bEntries.sort(ascendingKeyOrder);
                        for(var i = 0; i < aEntries.length; i++){
                            var _aEntries$i = _slicedToArray(aEntries[i], 2), aValue = _aEntries$i[1];
                            var _bEntries$i = _slicedToArray(bEntries[i], 2), bValue = _bEntries$i[1];
                            if (aValue !== bValue) return false;
                        }
                        return true;
                    }
                },
                {
                    key: "getPackageVersion",
                    value: function getPackageVersion() {
                        return CLIENT_VERSION;
                    }
                }
            ]);
            return FeatureGates;
        }();
        _defineProperty(FeatureGates, "initPromise", null);
        _defineProperty(FeatureGates, "initCompleted", false);
        _defineProperty(FeatureGates, "hasGetExperimentErrorOccurred", false);
        _defineProperty(FeatureGates, "hasGetExperimentValueErrorOccurred", false);
        _defineProperty(FeatureGates, "hasCheckGateErrorOccurred", false);
        var boundFGJS = FeatureGates;
        if (typeof window !== 'undefined') {
            if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = FeatureGates;
            else {
                var _boundFGJS, _boundFGJS$getPackage;
                boundFGJS = window.__FEATUREGATES_JS__;
                var boundVersion = ((_boundFGJS = boundFGJS) === null || _boundFGJS === void 0 || (_boundFGJS$getPackage = _boundFGJS.getPackageVersion) === null || _boundFGJS$getPackage === void 0 ? void 0 : _boundFGJS$getPackage.call(_boundFGJS)) || '4.10.0 or earlier';
                if (boundVersion !== CLIENT_VERSION) {
                    var message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat(boundVersion, " when module version ").concat(CLIENT_VERSION, " was loading.");
                    console.warn(message);
                }
            }
        }
        var FeatureGates$1 = boundFGJS;
        var getMeta = function getMeta(key) {
            var metaTag = document.querySelector("meta[name='ajs-" + key + "']");
            return metaTag === null ? undefined : metaTag.getAttribute('content') || undefined;
        };
        function getBooleanFeatureFlagOld(flagName) {
            if (AJS && AJS.DarkFeatures && AJS.DarkFeatures.isEnabled && AJS.DarkFeatures.isEnabled(flagName)) return true;
            var flagContent = window.featureFlags || getMeta('fe-feature-flags');
            if (!flagContent) return false;
            var flagJson = {};
            try {
                flagJson = typeof flagContent === 'object' ? flagContent : JSON.parse(flagContent);
            } catch (err) {
                return false;
            }
            if (!flagJson[flagName] || typeof flagJson[flagName].value !== 'boolean') return false;
            return flagJson[flagName].value;
        }
        function getBooleanFeatureFlagStatsig(flagName) {
            if (FeatureGates$1.initializeCompleted()) return FeatureGates$1.checkGate(flagName);
            analytics$1.trackGasV3FeatureFlagDefaultFalse(flagName);
            console.error("[ACJS] Feature flag service is not initialised. Default flag '" + flagName + "' to false");
            return false;
        }
        function getBooleanFeatureFlag(flagName, statsig) {
            if (statsig === void 0) statsig = false;
            if (statsig) return getBooleanFeatureFlagStatsig(flagName);
            return getBooleanFeatureFlagOld(flagName);
        }
        var performanceModuleDefined = false;
        var ADDON_KEY_CODEBARREL = 'com.codebarrel.addons.automation';
        function definePerformanceModule() {
            if (performanceModuleDefined) return;
            performanceModuleDefined = true;
            function isPerformanceModuleAllowed(cb) {
                return cb._context.extension.addon_key === ADDON_KEY_CODEBARREL;
            }
            var performanceModule = {
                getPerformanceTiming: function getPerformanceTiming(cb) {
                    return new Promise(function(resolve, reject) {
                        if (!isPerformanceModuleAllowed(cb)) reject(new Error('This is a restricted API'));
                        resolve(JSON.parse(JSON.stringify(window.performance.timing)));
                    });
                },
                getPerformanceNavigationTiming: function getPerformanceNavigationTiming(cb) {
                    return new Promise(function(resolve, reject) {
                        if (!isPerformanceModuleAllowed(cb)) reject(new Error('This is a restricted API'));
                        if (!window.PerformanceNavigationTiming) resolve(undefined);
                        var timing = window.performance.getEntriesByType('navigation');
                        resolve(JSON.parse(JSON.stringify(timing)));
                    });
                }
            };
            host$1.returnsPromise(performanceModule.getPerformanceTiming);
            host$1.returnsPromise(performanceModule.getPerformanceNavigationTiming);
            host$1.defineModule('_performance', performanceModule);
        }
        function isAllowListedFeatureFlag(flagName) {
            return flagName.indexOf('acjs-iframe-allowlist') === 0;
        }
        var defined = false;
        function defineFeatureFlagModule() {
            if (defined) return;
            defined = true;
            var featureFlagModule = {
                getBooleanFeatureFlag: function getBooleanFeatureFlag$1(flagName, statsig) {
                    return new Promise(function(resolve, reject) {
                        if (!isAllowListedFeatureFlag(flagName)) {
                            reject(new Error('Only allowlisted flags can be accessed from the iframe.'));
                            return;
                        }
                        resolve(getBooleanFeatureFlag(flagName, statsig));
                    });
                }
            };
            host$1.returnsPromise(featureFlagModule.getBooleanFeatureFlag);
            host$1.defineModule('_featureFlag', featureFlagModule);
        }
        function createSimpleXdmExtension(extension) {
            var extensionConfig = extensionConfigSanitizer(extension);
            var systemExtensionConfigOptions = ExtensionConfigurationOptionsStore$1.get();
            extension.options = extensionConfig.options = Util.extend({}, extensionConfig.options);
            extension.options.globalOptions = systemExtensionConfigOptions;
            loadConditionalModules(extension.addon_key);
            var iframeAttributes = host$1.create(extensionConfig, function() {
                if (!extension.options.noDOM) extension.$el = $(document.getElementById(extension.id));
                IframeActions.notifyBridgeEstablished(extension.$el, extension);
            }, function() {
                IframeActions.notifyUnloaded(extension.$el, extension);
            });
            extensionConfig.id = iframeAttributes.id;
            extension.id = iframeAttributes.id;
            Util.extend(iframeAttributes, iframeUtils.optionsToAttributes(extension.options));
            return {
                iframeAttributes: iframeAttributes,
                extension: extension
            };
        }
        function extensionConfigSanitizer(extension) {
            return {
                addon_key: extension.addon_key,
                key: extension.key,
                url: extension.url,
                options: extension.options
            };
        }
        function loadConditionalModules(addonKey) {
            if (addonKey === ADDON_KEY_CODEBARREL) definePerformanceModule();
            defineFeatureFlagModule();
        }
        var simpleXdmUtils = {
            createSimpleXdmExtension: createSimpleXdmExtension,
            extensionConfigSanitizer: extensionConfigSanitizer
        };
        var Iframe = function() {
            function Iframe() {
                this._contentResolver = false;
            }
            var _proto = Iframe.prototype;
            _proto.setContentResolver = function setContentResolver(callback) {
                this._contentResolver = callback;
            };
            _proto.resize = function resize(width, height, $el) {
                width = Util.stringToDimension(width);
                height = Util.stringToDimension(height);
                $el.css({
                    width: width,
                    height: height
                });
                $el.trigger('resized', {
                    width: width,
                    height: height
                });
            };
            _proto.simpleXdmExtension = function simpleXdmExtension(extension, $container) {
                if (!extension.url || urlUtils.hasJwt(extension.url) && urlUtils.isJwtExpired(extension.url)) {
                    if (this._contentResolver) jwtActions.requestRefreshUrl({
                        extension: extension,
                        resolver: this._contentResolver,
                        $container: $container
                    });
                    else console.error('JWT is expired and no content resolver was specified');
                } else this._appendExtension($container, this._simpleXdmCreate(extension));
            };
            _proto._simpleXdmCreate = function _simpleXdmCreate(extension) {
                var simpleXdmAttributes = simpleXdmUtils.createSimpleXdmExtension(extension);
                extension.id = simpleXdmAttributes.iframeAttributes.id;
                extension.$el = this.render(simpleXdmAttributes.iframeAttributes);
                return extension;
            };
            _proto._appendExtension = function _appendExtension($container, extension) {
                var existingFrame = $container.find('iframe');
                if (existingFrame.length > 0) existingFrame.destroy();
                if (extension.options.hideIframeUntilLoad) extension.$el.css({
                    visibility: 'hidden'
                }).load(function() {
                    extension.$el.css({
                        visibility: ''
                    });
                });
                $container.prepend(extension.$el);
                IframeActions.notifyIframeCreated(extension.$el, extension);
            };
            _proto._appendExtensionError = function _appendExtensionError($container, text) {
                var $error = $('<div class="connect-resolve-error"></div>');
                var $additionalText = $('<p />').text(text);
                $error.append('<p class="error">Error: The content resolver threw the following error:</p>');
                $error.append($additionalText);
                $container.prepend($error);
            };
            _proto.resolverResponse = function resolverResponse(data) {
                var simpleExtension = this._simpleXdmCreate(data.extension);
                this._appendExtension(data.$container, simpleExtension);
            };
            _proto.resolverFailResponse = function resolverFailResponse(data) {
                this._appendExtensionError(data.$container, data.errorText);
            };
            _proto.render = function render(attributes) {
                attributes = attributes || {};
                attributes.referrerpolicy = 'no-referrer';
                return $('<iframe />').attr(attributes).addClass('ap-iframe');
            };
            return Iframe;
        }();
        var IframeComponent = new Iframe();
        EventDispatcher$1.register('iframe-resize', function(data) {
            IframeComponent.resize(data.width, data.height, data.$el);
        });
        EventDispatcher$1.register('content-resolver-register-by-extension', function(data) {
            IframeComponent.setContentResolver(data.callback);
        });
        EventDispatcher$1.register('jwt-url-refreshed', function(data) {
            IframeComponent.resolverResponse(data);
        });
        EventDispatcher$1.register('jwt-url-refreshed-failed', function(data) {
            IframeComponent.resolverFailResponse(data);
        });
        EventDispatcher$1.register('after:iframe-bridge-established', function(data) {
            if (!data.extension.options.noDom) data.$el[0].bridgeEstablished = true;
            else data.extension.options.bridgeEstablished = true;
        });
        var ButtonActions = {
            clicked: function clicked($el) {
                EventDispatcher$1.dispatch('button-clicked', {
                    $el: $el
                });
            },
            toggle: function toggle($el, disabled) {
                EventDispatcher$1.dispatch('button-toggle', {
                    $el: $el,
                    disabled: disabled
                });
            },
            toggleVisibility: function toggleVisibility($el, hidden) {
                EventDispatcher$1.dispatch('button-toggle-visibility', {
                    $el: $el,
                    hidden: hidden
                });
            }
        };
        var BUTTON_TYPES = [
            'primary',
            'link',
            'secondary'
        ];
        var buttonId = 0;
        var Button$1 = function() {
            function Button() {
                this.AP_BUTTON_CLASS = 'ap-aui-button';
            }
            var _proto = Button.prototype;
            _proto.setType = function setType($button, type) {
                if (type && BUTTON_TYPES.indexOf(type) >= 0) $button.addClass('aui-button-' + type);
                return $button;
            };
            _proto.setDisabled = function setDisabled($button, disabled) {
                if (typeof disabled !== 'undefined' && !$button.data('immutable')) $button.attr('aria-disabled', disabled);
                return $button;
            };
            _proto.setHidden = function setHidden($button, hidden) {
                if (typeof hidden !== 'undefined' && !$button.data('immutable')) $button.toggle(!hidden);
                return $button;
            };
            _proto._setId = function _setId($button, id) {
                if (!id) {
                    id = 'ap-button-' + buttonId;
                    buttonId++;
                }
                $button.attr('id', id);
                return $button;
            };
            _proto._additionalClasses = function _additionalClasses($button, classes) {
                if (classes) {
                    if (typeof classes !== 'string') classes = classes.join(' ');
                    $button.addClass(classes);
                }
                return $button;
            };
            _proto.getName = function getName($button) {
                return $($button).data('name');
            };
            _proto.getText = function getText($button) {
                return $($button).text();
            };
            _proto.getIdentifier = function getIdentifier($button) {
                return $($button).data('identifier');
            };
            _proto.isVisible = function isVisible($button) {
                return $($button).is(':visible');
            };
            _proto.isEnabled = function isEnabled($button) {
                return !($($button).attr('aria-disabled') === 'true');
            };
            _proto.render = function render(options) {
                var $button = $('<button />');
                options = options || {};
                $button.addClass('aui-button ' + this.AP_BUTTON_CLASS);
                $button.text(options.text);
                $button.data(options.data);
                $button.data({
                    name: options.name || options.identifier,
                    identifier: options.identifier || buttonUtilsInstance.randomIdentifier(),
                    immutable: options.immutable || false
                });
                this._additionalClasses($button, options.additionalClasses);
                this.setType($button, options.type);
                this.setDisabled($button, options.disabled || false);
                this._setId($button, options.id);
                return $button;
            };
            return Button;
        }();
        var ButtonComponent = new Button$1();
        $(function() {
            $('body').on('click', '.' + ButtonComponent.AP_BUTTON_CLASS, function(e) {
                var $button = $(e.target).closest('.' + ButtonComponent.AP_BUTTON_CLASS);
                if ($button.attr('aria-disabled') !== 'true') ButtonActions.clicked($button);
            });
        });
        EventDispatcher$1.register('button-toggle', function(data) {
            ButtonComponent.setDisabled(data.$el, data.disabled);
        });
        EventDispatcher$1.register('button-toggle-visibility', function(data) {
            ButtonComponent.setHidden(data.$el, data.hidden);
        });
        var CONTAINER_CLASSES = [
            'ap-iframe-container'
        ];
        var IframeContainer = function() {
            function IframeContainer() {}
            var _proto = IframeContainer.prototype;
            _proto.createExtension = function createExtension(extension, options) {
                var $container = this._renderContainer();
                if (!options || options.loadingIndicator !== false) $container.append(this._renderLoadingIndicator());
                IframeComponent.simpleXdmExtension(extension, $container);
                return $container;
            };
            _proto._renderContainer = function _renderContainer(attributes) {
                var container = $('<div />').attr(attributes || {});
                container.addClass(CONTAINER_CLASSES.join(' '));
                return container;
            };
            _proto._renderLoadingIndicator = function _renderLoadingIndicator() {
                return LoadingComponent.render();
            };
            return IframeContainer;
        }();
        var IframeContainerComponent = new IframeContainer();
        EventDispatcher$1.register('iframe-create', function(data) {
            var id = 'embedded-' + data.extension.id;
            data.extension.$el.parents('.ap-iframe-container').attr('id', id);
        });
        function create(extension) {
            return IframeContainerComponent.createExtension(extension);
        }
        var ModuleActions = {
            defineCustomModule: function defineCustomModule(name, methods) {
                var data = {};
                if (!methods) data.methods = name;
                else {
                    data.methods = methods;
                    data.name = name;
                }
                EventDispatcher$1.dispatch('module-define-custom', data);
            }
        };
        var AnalyticsAction = {
            trackDeprecatedMethodUsed: function trackDeprecatedMethodUsed(methodUsed, extension) {
                EventDispatcher$1.dispatch('analytics-deprecated-method-used', {
                    methodUsed: methodUsed,
                    extension: extension
                });
            },
            trackIframeBridgeStart: function trackIframeBridgeStart(extension) {
                EventDispatcher$1.dispatch('iframe-bridge-start', {
                    extension: extension
                });
            },
            trackExternalEvent: function trackExternalEvent(name, values) {
                EventDispatcher$1.dispatch('analytics-external-event-track', {
                    eventName: name,
                    values: values
                });
            },
            trackContentResolverEvent: function trackContentResolverEvent(success, extra) {
                EventDispatcher$1.dispatch('analytics-content-resolver-track', {
                    success: success,
                    extra: extra
                });
            },
            trackIframePerformanceMetrics: function trackIframePerformanceMetrics(metrics, extension) {
                if (metrics && Object.getOwnPropertyNames(metrics).length > 0) EventDispatcher$1.dispatch('analytics-iframe-performance', {
                    metrics: metrics,
                    extension: extension
                });
            }
        };
        function _createForOfIteratorHelperLoose(o, allowArrayLike) {
            var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
            if (it) return (it = it.call(o)).next.bind(it);
            if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                if (it) o = it;
                var i = 0;
                return function() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        function _unsupportedIterableToArray(o, minLen) {
            if (!o) return;
            if (typeof o === "string") return _arrayLikeToArray(o, minLen);
            var n = Object.prototype.toString.call(o).slice(8, -1);
            if (n === "Object" && o.constructor) n = o.constructor.name;
            if (n === "Map" || n === "Set") return Array.from(o);
            if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
        }
        function _arrayLikeToArray(arr, len) {
            if (len == null || len > arr.length) len = arr.length;
            for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
            return arr2;
        }
        function sanitizeTriggers(triggers) {
            var onTriggers;
            if (Array.isArray(triggers)) onTriggers = triggers.join(' ');
            else if (typeof triggers === 'string') onTriggers = triggers.trim();
            return onTriggers;
        }
        function uniqueId() {
            return 'webitem-' + Math.floor(Math.random() * 1000000000).toString(16);
        }
        function getExtensionKey(cssClass) {
            var m = cssClass ? cssClass.match(/ap-plugin-key-([^\s]*)/) : null;
            return Array.isArray(m) ? m[1] : false;
        }
        function getKey(cssClass) {
            var m = cssClass ? cssClass.match(/ap-module-key-([^\s]*)/) : null;
            return Array.isArray(m) ? m[1] : false;
        }
        function getTargetKey(cssClass) {
            var m = cssClass ? cssClass.match(/ap-target-key-([^\s]*)/) : null;
            return Array.isArray(m) ? m[1] : false;
        }
        function getFullKey(cssClass) {
            return getExtensionKey(cssClass) + '__' + getKey(cssClass);
        }
        function getModuleOptionsByAddonAndModuleKey(type, addonKey, moduleKey) {
            var moduleType = type + 'Modules';
            if (window._AP && window._AP[moduleType] && window._AP[moduleType][addonKey] && window._AP[moduleType][addonKey][moduleKey]) return Util.extend({}, window._AP[moduleType][addonKey][moduleKey].options);
        }
        function getModuleOptionsForWebitem(type, cssClass) {
            var addon_key = getExtensionKey(cssClass);
            var targetKey = getTargetKey(cssClass);
            return getModuleOptionsByAddonAndModuleKey(type, addon_key, targetKey);
        }
        function getConfigFromTarget($target, cssClass, href) {
            var url = href || $target.attr('href');
            var convertedOptions = {};
            var iframeData;
            if (!url) url = $target.find('a').attr('href');
            if (url) {
                var hashIndex = url.indexOf('#');
                if (hashIndex >= 0) {
                    var hash = url.substring(hashIndex + 1);
                    try {
                        iframeData = JSON.parse(decodeURI(hash));
                    } catch (e) {
                        console.error('ACJS: cannot decode webitem anchor');
                    }
                    if (iframeData && window._AP && window._AP._convertConnectOptions) convertedOptions = window._AP._convertConnectOptions(iframeData);
                    else console.error('ACJS: cannot convert webitem url to connect iframe options');
                } else {
                    var fullKey = getFullKey(cssClass);
                    var type = isInlineDialogTrigger(cssClass) ? 'inlineDialog' : 'dialog';
                    var options = getModuleOptionsForWebitem(type, cssClass);
                    if (!options && window._AP && window._AP[type + 'Options']) options = Util.extend({}, window._AP[type + 'Options'][fullKey]) || {};
                    if (!options) {
                        options = {};
                        console.warn('no webitem ' + type + 'Options for ' + fullKey);
                    }
                    options.productContext = options.productContext || {};
                    var query = queryString.parse(queryString.extract(url));
                    Util.extend(options.productContext, query);
                    convertedOptions = {
                        addon_key: getExtensionKey(cssClass),
                        key: getKey(cssClass),
                        options: options
                    };
                }
            }
            return convertedOptions;
        }
        function isInlineDialogTrigger(classes) {
            return classes ? classes.includes('ap-inline-dialog') : false;
        }
        function isDialogTrigger(classes) {
            return classes ? classes.includes('ap-dialog') : false;
        }
        function getOptionsForWebItem($target, cssClass, href) {
            var fullKey = getFullKey(cssClass);
            var type = isInlineDialogTrigger(cssClass) ? 'inlineDialog' : 'dialog';
            var options = getModuleOptionsForWebitem(type, cssClass);
            if (!options && window._AP && window._AP[type + 'Options']) options = Util.extend({}, window._AP[type + 'Options'][fullKey]) || {};
            if (!options) {
                options = {};
                console.warn('no webitem ' + type + 'Options for ' + fullKey);
            }
            options.productContext = options.productContext || {};
            options.structuredContext = options.structuredContext || {};
            var convertedConfig = getConfigFromTarget($target, cssClass, href);
            if (convertedConfig && convertedConfig.options) {
                Util.extend(options.productContext, convertedConfig.options.productContext);
                Util.extend(options.structuredContext, convertedConfig.options.structuredContext);
                options.contextJwt = convertedConfig.options.contextJwt;
            }
            return options;
        }
        function collectParentElementAttributes(target, attributeNames) {
            var attributes = [];
            var current = target;
            var count = 0;
            while(current && current !== document.body && count++ < 1000){
                for(var _iterator = _createForOfIteratorHelperLoose(attributeNames), _step; !(_step = _iterator()).done;){
                    var attributeName = _step.value;
                    var attribute = current.getAttribute(attributeName);
                    if (attribute) attributes.push(attribute);
                }
                current = current.parentElement;
            }
            return attributes;
        }
        var WebItemUtils = {
            sanitizeTriggers: sanitizeTriggers,
            uniqueId: uniqueId,
            getExtensionKey: getExtensionKey,
            getKey: getKey,
            getOptionsForWebItem: getOptionsForWebItem,
            getModuleOptionsByAddonAndModuleKey: getModuleOptionsByAddonAndModuleKey,
            getConfigFromTarget: getConfigFromTarget
        };
        var ModuleProviders = function ModuleProviders() {
            var _this = this;
            this._providers = {};
            this.registerProvider = function(name, provider) {
                _this._providers[name] = provider;
            };
            this.getProvider = function(name) {
                return _this._providers[name];
            };
        };
        var ModuleProviders$1 = new ModuleProviders();
        var ACJSFrameworkAdaptor = function() {
            function ACJSFrameworkAdaptor() {
                this.moduleNamesToModules = new Map();
            }
            ACJSFrameworkAdaptor.prototype.registerModule = function(module1, props) {
                var moduleRegistrationName = module1.getModuleRegistrationName();
                this.moduleNamesToModules.set(moduleRegistrationName, module1);
            };
            ACJSFrameworkAdaptor.prototype.getModuleByName = function(moduleName) {
                return this.moduleNamesToModules.get(moduleName);
            };
            ACJSFrameworkAdaptor.prototype.getProviderByModuleName = function(moduleName) {
                var module1 = this.moduleNamesToModules.get(moduleName);
                if (module1 && module1.isEnabled()) return module1.getProvider();
                else return undefined;
            };
            return ACJSFrameworkAdaptor;
        }();
        var acjsFrameworkAdaptor = new ACJSFrameworkAdaptor();
        var WebItemActions = {
            addWebItem: function addWebItem(potentialWebItem) {
                var webitem;
                var existing = webItemInstance.getWebItemsBySelector(potentialWebItem.selector);
                if (existing) return false;
                else {
                    webitem = webItemInstance.setWebItem(potentialWebItem);
                    EventDispatcher$1.dispatch('webitem-added', {
                        webitem: webitem
                    });
                }
            },
            webitemInvoked: function webitemInvoked(isInlineDialog, data) {
                var eventName = isInlineDialog ? 'inline-dialog' : 'dialog';
                EventDispatcher$1.dispatch('webitem-invoked:' + eventName, data);
            }
        };
        var addedTriggersSet = new WeakSet();
        var WebItem = function() {
            function WebItem() {
                this._webitems = {};
                this._contentResolver = function noop() {};
            }
            var _proto = WebItem.prototype;
            _proto.setContentResolver = function setContentResolver(resolver) {
                this._contentResolver = resolver;
            };
            _proto.requestContent = function requestContent(extension) {
                if (extension.addon_key && extension.key) return this._contentResolver.call(null, Util.extend({
                    classifier: 'json'
                }, extension));
            };
            _proto.getWebItemsBySelector = function getWebItemsBySelector(selector) {
                var _this = this;
                var returnVal;
                Object.getOwnPropertyNames(this._webitems).some(function(key) {
                    var obj = _this._webitems[key];
                    if (obj.selector) {
                        if (obj.selector.trim() === selector.trim()) {
                            returnVal = obj;
                            return true;
                        }
                    }
                    return false;
                });
                return returnVal;
            };
            _proto.setWebItem = function setWebItem(potentialWebItem) {
                return this._webitems[potentialWebItem.name] = {
                    name: potentialWebItem.name,
                    selector: potentialWebItem.selector,
                    triggers: potentialWebItem.triggers
                };
            };
            _proto._removeTriggers = function _removeTriggers(webitem) {
                var _this2 = this;
                var onTriggers = WebItemUtils.sanitizeTriggers(webitem.triggers);
                $(function() {
                    $('body').off(onTriggers, webitem.selector, _this2._webitems[webitem.name]._on);
                });
                delete this._webitems[webitem.name]._on;
            };
            _proto._addTriggers = function _addTriggers(webitem) {
                var onTriggers = WebItemUtils.sanitizeTriggers(webitem.triggers);
                webitem._on = function(event) {
                    if (event.defaultPrevented) return;
                    var $target = $(event.target).closest(webitem.selector);
                    if ($target.hasClass('ap-dialog-ignore')) return;
                    event.preventDefault();
                    _triggerWebItem($target, event.type);
                };
                $(function() {
                    var attachHandlers = function attachHandlers(node) {
                        if (addedTriggersSet.has(node)) return;
                        addedTriggersSet.add(node);
                        $(node).on(onTriggers, webitem._on);
                    };
                    document.querySelectorAll(webitem.selector).forEach(function(node) {
                        attachHandlers(node);
                    });
                    var observer = new MutationObserver(function(mutationsList, observer) {
                        mutationsList.forEach(function(mutation) {
                            if (mutation.type !== 'childList') return;
                            mutation.addedNodes.forEach(function(node) {
                                if (node.nodeType !== Node.ELEMENT_NODE) return;
                                if (node.matches(webitem.selector)) attachHandlers(node);
                                else node.querySelectorAll(webitem.selector).forEach(function(childNode) {
                                    attachHandlers(childNode);
                                });
                            });
                        });
                    });
                    observer.observe(document.body, {
                        childList: true,
                        subtree: true
                    });
                    $('head').append("<style type=\"text/css\">" + webitem.selector + ".ap-link-webitem {pointer-events: auto;cursor: pointer;}</style>");
                });
            };
            return WebItem;
        }();
        function triggerWebItem(target, cssClass, href, eventType) {
            eventType = eventType || 'click';
            var $target = $(target);
            cssClass = cssClass || $target.attr('class');
            if (!isDialogWebItem(cssClass) || eventType === 'mouseenter' && !isInlineDialogTrigger(cssClass)) return;
            _triggerWebItem($target, eventType, cssClass, href, true);
        }
        function isDialogWebItem(classes) {
            return isDialogTrigger(classes) || isInlineDialogTrigger(classes);
        }
        function _triggerWebItem($target, eventType, cssClass, href, isModernApi) {
            cssClass = cssClass || $target.attr('class');
            isModernApi = isModernApi || false;
            var convertedOptions = WebItemUtils.getConfigFromTarget($target, cssClass, href);
            var extensionUrl = convertedOptions && convertedOptions.url ? convertedOptions.url : undefined;
            var extension = {
                addon_key: WebItemUtils.getExtensionKey(cssClass),
                key: WebItemUtils.getKey(cssClass),
                options: WebItemUtils.getOptionsForWebItem($target, cssClass, href),
                url: extensionUrl
            };
            if (extension.addon_key === 'com.addonengine.analytics' && !HostApi$1.isModuleDefined('analytics')) {
                console.log("ACJS-1164 Dropping event " + eventType + " for plugin " + extension.addon_key + " until AP.analytics loads...");
                return;
            }
            var isInlineDialog = isInlineDialogTrigger(cssClass);
            if (!isModernApi) EventDispatcher$1.dispatch('analytics-legacy-dialog-opened', {
                extension: extension,
                eventType: eventType,
                parentIds: collectParentElementAttributes($target.get(0), [
                    'data-testid',
                    'data-component-selector',
                    'data-fullscreen-id'
                ])
            });
            WebItemActions.webitemInvoked(isInlineDialog, {
                $target: $target,
                eventType: eventType,
                extension: extension
            });
        }
        var webItemInstance = new WebItem();
        EventDispatcher$1.register('webitem-added', function(data) {
            webItemInstance._addTriggers(data.webitem);
        });
        EventDispatcher$1.register('content-resolver-register-by-extension', function(data) {
            webItemInstance.setContentResolver(data.callback);
        });
        document.addEventListener('aui-responsive-menu-item-created', function(e) {
            var oldWebItem = e.detail.originalItem.querySelector('a[class*="ap-"]');
            if (oldWebItem) {
                var newWebItem = e.detail.newItem.querySelector('a');
                var classList = [].slice.call(oldWebItem.classList);
                classList.forEach(function(cls) {
                    if (/^ap-/.test(cls)) newWebItem.classList.add(cls);
                });
            }
        });
        var HostApi = function() {
            function HostApi() {
                var _this = this;
                this.targetSpecNoDialogs = EventActions.targetSpecNoDialogs;
                this.triggerWebItem = triggerWebItem;
                this.isDialogWebItem = isDialogWebItem;
                this.create = function(extension) {
                    return create(simpleXdmUtils.extensionConfigSanitizer(extension));
                };
                this.dialog = {
                    create: function create(extension, dialogOptions) {
                        var dialogBeanOptions = WebItemUtils.getModuleOptionsByAddonAndModuleKey('dialog', extension.addon_key, extension.key);
                        var completeOptions = Util.extend({}, dialogBeanOptions || {}, dialogOptions);
                        DialogExtensionActions.open(extension, completeOptions);
                    },
                    close: function close(addon_key, closeData) {
                        var frameworkAdaptor = _this.getFrameworkAdaptor();
                        var dialogProvider = frameworkAdaptor.getProviderByModuleName('dialog');
                        if (dialogProvider) {
                            dialogUtilsInstance.assertActiveDialogOrThrow(dialogProvider, addon_key);
                            EventActions.broadcast('dialog.close', {
                                addon_key: addon_key
                            }, closeData);
                            dialogProvider.close();
                        } else DialogExtensionActions.close();
                    }
                };
                this.registerContentResolver = {
                    resolveByExtension: function resolveByExtension(callback) {
                        _this._contentResolver = callback;
                        jwtActions.registerContentResolver({
                            callback: callback
                        });
                    }
                };
                this.getContentResolver = function() {
                    return _this._contentResolver;
                };
                this.registerProvider = function(componentName, component) {
                    ModuleProviders$1.registerProvider(componentName, component);
                };
                this.getProvider = function(componentName) {
                    return ModuleProviders$1.getProvider(componentName);
                };
                this.frameworkAdaptor = acjsFrameworkAdaptor;
            }
            var _proto = HostApi.prototype;
            _proto.createExtension = function createExtension(extension) {
                extension.options = extension.options || {};
                extension.options.noDom = true;
                var createdExtension = simpleXdmUtils.createSimpleXdmExtension(extension);
                AnalyticsAction.trackIframeBridgeStart(createdExtension.extension);
                return createdExtension;
            };
            _proto.registerExistingExtension = function registerExistingExtension(extension_id, data) {
                return host$1.registerExistingExtension(extension_id, data);
            };
            _proto.setFrameworkAdaptor = function setFrameworkAdaptor(frameworkAdaptor) {
                this.frameworkAdaptor = frameworkAdaptor;
            };
            _proto.getFrameworkAdaptor = function getFrameworkAdaptor() {
                return this.frameworkAdaptor;
            };
            _proto._cleanExtension = function _cleanExtension(extension) {
                return Util.pick(extension, [
                    'id',
                    'addon_key',
                    'key',
                    'options',
                    'url'
                ]);
            };
            _proto.onIframeEstablished = function onIframeEstablished(callback) {
                var wrapper = function wrapper(data) {
                    callback.call({}, {
                        $el: data.$el,
                        extension: this._cleanExtension(data.extension)
                    });
                };
                callback._wrapper = wrapper.bind(this);
                EventDispatcher$1.register('after:iframe-bridge-established', callback._wrapper);
            };
            _proto.offIframeEstablished = function offIframeEstablished(callback) {
                if (callback._wrapper) EventDispatcher$1.unregister('after:iframe-bridge-established', callback._wrapper);
                else throw new Error('cannot unregister event dispatch listener without _wrapper reference');
            };
            _proto.onIframeUnload = function onIframeUnload(callback) {
                var _this2 = this;
                EventDispatcher$1.register('after:iframe-unload', function(data) {
                    callback.call({}, {
                        $el: data.$el,
                        extension: _this2._cleanExtension(data.extension)
                    });
                });
            };
            _proto.onPublicEventDispatched = function onPublicEventDispatched(callback) {
                var wrapper = function wrapper(data) {
                    callback.call({}, {
                        type: data.type,
                        event: data.event,
                        extension: this._cleanExtension(data.sender)
                    });
                };
                callback._wrapper = wrapper.bind(this);
                EventDispatcher$1.register('after:event-public-dispatch', callback._wrapper);
            };
            _proto.offPublicEventDispatched = function offPublicEventDispatched(callback) {
                if (callback._wrapper) EventDispatcher$1.unregister('after:event-public-dispatch', callback._wrapper);
                else throw new Error('cannot unregister event dispatch listener without _wrapper reference');
            };
            _proto.onKeyEvent = function onKeyEvent(extension_id, key, modifiers, callback) {
                DomEventActions.registerKeyEvent({
                    extension_id: extension_id,
                    key: key,
                    modifiers: modifiers,
                    callback: callback
                });
            };
            _proto.offKeyEvent = function offKeyEvent(extension_id, key, modifiers, callback) {
                DomEventActions.unregisterKeyEvent({
                    extension_id: extension_id,
                    key: key,
                    modifiers: modifiers,
                    callback: callback
                });
            };
            _proto.onFrameClick = function onFrameClick(handleIframeClick) {
                if (typeof handleIframeClick !== 'function') throw new Error('handleIframeClick must be a function');
                DomEventActions.registerClickHandler(handleIframeClick);
            };
            _proto.offFrameClick = function offFrameClick() {
                DomEventActions.unregisterClickHandler();
            };
            _proto.destroy = function destroy(extension_id) {
                IframeActions.notifyIframeDestroyed({
                    id: extension_id
                });
            };
            _proto.defineModule = function defineModule(name, methods) {
                ModuleActions.defineCustomModule(name, methods);
            };
            _proto.isModuleDefined = function isModuleDefined(moduleName) {
                return host$1.isModuleDefined(moduleName);
            };
            _proto.broadcastEvent = function broadcastEvent(type, targetSpec, event) {
                EventActions.broadcast(type, targetSpec, event);
            };
            _proto.getExtensions = function getExtensions(filter) {
                return host$1.getExtensions(filter);
            };
            _proto.trackDeprecatedMethodUsed = function trackDeprecatedMethodUsed(methodUsed, extension) {
                AnalyticsAction.trackDeprecatedMethodUsed(methodUsed, extension);
            };
            _proto.trackAnalyticsEvent = function trackAnalyticsEvent(name, values) {
                AnalyticsAction.trackExternalEvent(name, values);
            };
            _proto.trackContentResolverEvent = function trackContentResolverEvent(success, extra) {
                AnalyticsAction.trackContentResolverEvent(success, extra);
            };
            _proto.setJwtClockSkew = function setJwtClockSkew(skew) {
                jwtActions.setClockSkew(skew);
            };
            _proto.isJwtExpired = function isJwtExpired(jwtString, tokenOnly) {
                if (tokenOnly) return jwtUtil.isJwtExpired(jwtString);
                return urlUtils.isJwtExpired(jwtString);
            };
            _proto.hasJwt = function hasJwt(url) {
                return urlUtils.hasJwt(url);
            };
            _proto.getBooleanFeatureFlag = function getBooleanFeatureFlag$1(flagName, statsig) {
                return getBooleanFeatureFlag(flagName, statsig);
            };
            _proto.setExtensionConfigurationOptions = function setExtensionConfigurationOptions(obj, value) {
                ExtensionConfigurationOptionsStore$1.set(obj, value);
            };
            _proto.getExtensionConfigurationOption = function getExtensionConfigurationOption(val) {
                return ExtensionConfigurationOptionsStore$1.get(val);
            };
            _proto.onIframeTimeout = function onIframeTimeout(callback) {
                var wrapper = function wrapper(data) {
                    callback.call({}, {
                        extension: this._cleanExtension(data.extension)
                    });
                };
                callback._wrapper = wrapper.bind(this);
                EventDispatcher$1.register('after:iframe-bridge-timeout', callback._wrapper);
            };
            _proto.offIframeTimeout = function offIframeTimeout(callback) {
                if (callback._wrapper) EventDispatcher$1.unregister('after:iframe-bridge-timeout', callback._wrapper);
                else throw new Error('cannot unregister event dispatch listener without _wrapper reference');
            };
            _proto.onIframePerformanceTelemetry = function onIframePerformanceTelemetry(callback) {
                var wrapper = function wrapper(data) {
                    callback.call({}, {
                        metrics: data.metrics,
                        extension: this._cleanExtension(data.extension)
                    });
                };
                callback._wrapper = wrapper.bind(this);
                EventDispatcher$1.register('after:analytics-iframe-performance', callback._wrapper);
            };
            _proto.offIframePerformanceTelemetry = function offIframePerformanceTelemetry(callback) {
                if (callback._wrapper) EventDispatcher$1.unregister('after:analytics-iframe-performance', callback._wrapper);
                else throw new Error('cannot unregister event dispatch listener without _wrapper reference');
            };
            _proto.onIframeVisible = function onIframeVisible(callback) {
                var wrapper = function wrapper(extension) {
                    callback.call({}, {
                        extension: this._cleanExtension(extension)
                    });
                };
                callback._wrapper = wrapper.bind(this);
                EventDispatcher$1.register('after:iframe-visible', callback._wrapper);
            };
            _proto.offIframeVisible = function offIframeVisible(callback) {
                if (callback._wrapper) EventDispatcher$1.unregister('after:iframe-visible', callback._wrapper);
                else throw new Error('cannot unregister event dispatch listener without _wrapper reference');
            };
            _proto.onContentResolverEvent = function onContentResolverEvent(callback) {
                var wrapper = function wrapper(data) {
                    callback.call({}, data);
                };
                callback._wrapper = wrapper.bind(this);
                EventDispatcher$1.register('after:analytics-content-resolver-track', callback._wrapper);
            };
            _proto.offContentResolverEvent = function offContentResolverEvent(callback) {
                if (callback._wrapper) EventDispatcher$1.unregister('after:analytics-content-resolver-track', callback._wrapper);
                else throw new Error('cannot unregister event dispatch listener without _wrapper reference');
            };
            _proto.onForwardAnalyticsEvent = function onForwardAnalyticsEvent(callback) {
                var wrapper = function wrapper(eventType, eventData) {
                    callback.call({}, eventType, eventData);
                };
                callback._wrapper = wrapper.bind(this);
                EventDispatcher$1.register('after:analytics-forward-event', callback._wrapper);
            };
            return HostApi;
        }();
        var HostApi$1 = new HostApi();
        var DLGID_PREFIX = 'ap-dialog-';
        var DIALOG_CLASS = 'ap-aui-dialog2';
        var DLGID_REGEXP = new RegExp("^" + DLGID_PREFIX + "[0-9A-Za-z]+$");
        var DIALOG_SIZES = [
            'small',
            'medium',
            'large',
            'xlarge',
            'fullscreen',
            'maximum'
        ];
        var DIALOG_BUTTON_CLASS = 'ap-aui-dialog-button';
        var DIALOG_BUTTON_CUSTOM_CLASS = 'ap-dialog-custom-button';
        var DIALOG_FOOTER_CLASS = 'aui-dialog2-footer';
        var DIALOG_FOOTER_ACTIONS_CLASS = 'aui-dialog2-footer-actions';
        var DIALOG_HEADER_ACTIONS_CLASS = 'header-control-panel';
        function getActiveDialog() {
            var $el = AJS.LayerManager.global.getTopLayer();
            if ($el && DLGID_REGEXP.test($el.attr('id'))) {
                var dialog = AJS.dialog2($el);
                dialog._id = dialog.$el.attr('id').replace(DLGID_PREFIX, '');
                return dialog;
            }
        }
        function getActionBar($dialog) {
            var $actionBar = $dialog.find('.' + DIALOG_HEADER_ACTIONS_CLASS);
            if (!$actionBar.length) $actionBar = $dialog.find('.' + DIALOG_FOOTER_ACTIONS_CLASS);
            return $actionBar;
        }
        function getButtonByIdentifier(id, $dialog) {
            var $actionBar = getActionBar($dialog);
            return $actionBar.find('.aui-button').filter(function() {
                return ButtonComponent.getIdentifier(this) === id;
            });
        }
        var Dialog$1 = function() {
            function Dialog() {}
            var _proto = Dialog.prototype;
            _proto._renderHeaderCloseBtn = function _renderHeaderCloseBtn() {
                var $close = $('<a />').addClass('aui-dialog2-header-close');
                var $closeBtn = $('<span />').addClass('aui-icon aui-icon-small aui-iconfont-close-dialog').text('Close');
                $close.append($closeBtn);
                return $close;
            };
            _proto._renderFullScreenHeader = function _renderFullScreenHeader($header, options) {
                var $titleContainer = $('<div />').addClass('header-title-container aui-item expanded');
                var $title = $('<div />').append($('<span />').addClass('header-title').text(options.header || ''));
                $titleContainer.append($title);
                $header.append($titleContainer).append(this._renderHeaderActions(options.actions, options.extension));
                return $header;
            };
            _proto._renderHeader = function _renderHeader(options) {
                var $header = $('<header />').addClass('aui-dialog2-header');
                if (options.size === 'fullscreen') return this._renderFullScreenHeader($header, options);
                if (options.header) {
                    var $title = $('<h2 />').addClass('aui-dialog2-header-main').text(options.header);
                    $header.append($title);
                }
                $header.append(this._renderHeaderCloseBtn());
                return $header;
            };
            _proto._renderHeaderActions = function _renderHeaderActions(actions, extension) {
                var $headerControls = $('<div />').addClass('aui-item ' + DIALOG_HEADER_ACTIONS_CLASS);
                actions[0].additionalClasses = [
                    'aui-icon',
                    'aui-icon-small',
                    'aui-iconfont-success'
                ];
                actions[1].additionalClasses = [
                    'aui-icon',
                    'aui-icon-small',
                    'aui-iconfont-close-dialog'
                ];
                var $actions = this._renderActionButtons(actions, extension);
                $actions.forEach(function($action) {
                    $headerControls.append($action);
                });
                return $headerControls;
            };
            _proto._renderContent = function _renderContent($content) {
                var $el = $('<div />').addClass('aui-dialog2-content');
                if ($content) $el.append($content);
                return $el;
            };
            _proto._renderFooter = function _renderFooter(options) {
                var $footer = $('<footer />').addClass(DIALOG_FOOTER_CLASS);
                if (options.size !== 'fullscreen') {
                    var $actions = this._renderFooterActions(options.actions, options.extension);
                    $footer.append($actions);
                }
                if (options.hint) {
                    var $hint = $('<div />').addClass('aui-dialog2-footer-hint').text(options.hint);
                    $footer.append($hint);
                }
                return $footer;
            };
            _proto._renderActionButtons = function _renderActionButtons(actions, extension) {
                var _this = this;
                var actionButtons = [];
                [].concat(actions).forEach(function(action) {
                    actionButtons.push(_this._renderDialogButton({
                        text: action.text,
                        name: action.name,
                        type: action.type,
                        additionalClasses: action.additionalClasses,
                        custom: action.custom || false,
                        identifier: action.identifier,
                        immutable: action.immutable,
                        disabled: action.disabled || false
                    }, extension));
                });
                return actionButtons;
            };
            _proto._renderFooterActions = function _renderFooterActions(actions, extension) {
                var $actions = $('<div />').addClass(DIALOG_FOOTER_ACTIONS_CLASS);
                var $buttons = this._renderActionButtons(actions, extension);
                $buttons.forEach(function($button) {
                    $actions.append($button);
                });
                return $actions;
            };
            _proto._renderDialogButton = function _renderDialogButton(options, extension) {
                options.additionalClasses = options.additionalClasses || [];
                options.additionalClasses.push(DIALOG_BUTTON_CLASS);
                if (options.custom) options.additionalClasses.push(DIALOG_BUTTON_CUSTOM_CLASS);
                var $button = ButtonComponent.render(options);
                $button.extension = extension;
                return $button;
            };
            _proto.render = function render(options) {
                var originalOptions = Util.extend({}, options);
                var sanitizedOptions = dialogUtilsInstance.sanitizeOptions(options);
                var $dialog = $('<section />').attr({
                    role: 'dialog',
                    id: DLGID_PREFIX + sanitizedOptions.id
                });
                $dialog.attr('data-aui-modal', 'true');
                $dialog.data({
                    'aui-remove-on-hide': true,
                    'extension': sanitizedOptions.extension
                });
                $dialog.addClass('aui-layer aui-dialog2 ' + DIALOG_CLASS);
                if (DIALOG_SIZES.indexOf(sanitizedOptions.size) >= 0) $dialog.addClass('aui-dialog2-' + sanitizedOptions.size);
                if (sanitizedOptions.size === 'fullscreen' || sanitizedOptions.size === 'maximum') {
                    if (sanitizedOptions.chrome) $dialog.addClass('ap-header-controls');
                    $dialog.addClass('aui-dialog2-maximum');
                }
                $dialog.append(this._renderContent(sanitizedOptions.$content));
                if (sanitizedOptions.chrome) {
                    $dialog.prepend(this._renderHeader({
                        header: sanitizedOptions.header,
                        actions: sanitizedOptions.actions,
                        size: sanitizedOptions.size
                    }));
                    $dialog.append(this._renderFooter({
                        extension: sanitizedOptions.extension,
                        actions: sanitizedOptions.actions,
                        hint: sanitizedOptions.hint,
                        size: sanitizedOptions.size
                    }));
                } else $dialog.addClass('aui-dialog2-chromeless');
                var dialog = AJS.dialog2($dialog);
                dialog._id = sanitizedOptions.id;
                if (sanitizedOptions.size === 'fullscreen') sanitizedOptions.height = sanitizedOptions.width = '100%';
                if (!sanitizedOptions.size || sanitizedOptions.size === 'fullscreen') AJS.layer($dialog).changeSize(sanitizedOptions.width, sanitizedOptions.height);
                if (sanitizedOptions.onHide) dialog.on('hide', sanitizedOptions.onHide);
                dialog.show();
                dialog.$el.data('extension', sanitizedOptions.extension);
                dialog.$el.data('originalOptions', originalOptions);
                return $dialog;
            };
            _proto.setIframeDimensions = function setIframeDimensions($iframe) {
                IframeComponent.resize('100%', '100%', $iframe);
            };
            _proto.getActive = function getActive() {
                return getActiveDialog();
            };
            _proto.buttonIsEnabled = function buttonIsEnabled(identifier) {
                var dialog = getActiveDialog();
                if (dialog) {
                    var $button = getButtonByIdentifier(identifier, dialog.$el);
                    return ButtonComponent.isEnabled($button);
                }
            };
            _proto.buttonIsVisible = function buttonIsVisible(identifier) {
                var dialog = getActiveDialog();
                if (dialog) {
                    var $button = getButtonByIdentifier(identifier, dialog.$el);
                    return ButtonComponent.isVisible($button);
                }
            };
            _proto.getByExtension = function getByExtension(extension) {
                var filterFunction;
                if (typeof extension === 'function') filterFunction = extension;
                else {
                    var keys = Object.getOwnPropertyNames(extension);
                    filterFunction = function filterFunction(dialog) {
                        var dialogData = $(dialog).data('extension');
                        return keys.every(function(key) {
                            return dialogData[key] === extension[key];
                        });
                    };
                }
                return $('.' + DIALOG_CLASS).toArray().filter(filterFunction).map(function($el) {
                    return AJS.dialog2($el);
                });
            };
            _proto.addButton = function addButton(extension, options) {
                options.custom = true;
                var $button = this._renderDialogButton(options, extension);
                var $dialog = this.getByExtension({
                    addon_key: extension.addon_key,
                    key: extension.key
                })[0].$el;
                var $actionBar = getActionBar($dialog);
                $actionBar.append($button);
                return $dialog;
            };
            return Dialog;
        }();
        var DialogComponent = new Dialog$1();
        EventDispatcher$1.register('iframe-bridge-established', function(data) {
            if (data.extension.options.isDialog) {
                var callback;
                var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
                var dialogProvider = frameworkAdaptor.getProviderByModuleName('dialog');
                if (dialogProvider) {
                    callback = dialogProvider.close;
                    dialogProvider.setButtonDisabled('submit', false);
                } else {
                    DialogActions.toggleButton({
                        identifier: 'submit',
                        enabled: true
                    });
                    callback = function callback() {
                        DialogActions.close({
                            dialog: getActiveDialog(),
                            extension: data.extension
                        });
                    };
                }
                if (!data.extension.options.preventDialogCloseOnEscape) {
                    DomEventActions.registerKeyEvent({
                        extension_id: data.extension.id,
                        key: 27,
                        callback: callback
                    });
                    EventDispatcher$1.registerOnce('dialog-close', function(d) {
                        DomEventActions.unregisterKeyEvent({
                            extension_id: data.extension.id,
                            key: 27
                        });
                    });
                }
            }
        });
        EventDispatcher$1.register('dialog-close-active', function(data) {
            var activeDialog = getActiveDialog();
            if (activeDialog) DialogActions.close({
                customData: data.customData,
                dialog: activeDialog,
                extension: data.extension
            });
        });
        EventDispatcher$1.register('dialog-close', function(data) {
            if (data.dialog) data.dialog.hide();
        });
        EventDispatcher$1.register('dialog-button-toggle', function(data) {
            var dialog = getActiveDialog();
            if (dialog) {
                var $button = getButtonByIdentifier(data.identifier, dialog.$el);
                ButtonActions.toggle($button, !data.enabled);
            }
        });
        EventDispatcher$1.register('dialog-button-toggle-visibility', function(data) {
            var dialog = getActiveDialog();
            if (dialog) {
                var $button = getButtonByIdentifier(data.identifier, dialog.$el);
                ButtonActions.toggleVisibility($button, data.hidden);
            }
        });
        EventDispatcher$1.register('button-clicked', function(data) {
            var $button = data.$el;
            if ($button.hasClass(DIALOG_BUTTON_CLASS)) {
                var $dialog = $button.parents('.' + DIALOG_CLASS);
                var $iframe = $dialog.find('iframe');
                if ($iframe.length && $iframe[0].bridgeEstablished) DialogActions.clickButton(ButtonComponent.getIdentifier($button), $button, $dialog.data('extension'));
                else DialogActions.close({
                    dialog: getActiveDialog(),
                    extension: $button.extension
                });
            }
        });
        if ($.fn) {
            EventDispatcher$1.register('iframe-create', function(data) {
                if (data.extension.options && data.extension.options.isDialog) DialogComponent.setIframeDimensions(data.extension.$el);
            });
            EventDispatcher$1.register('dialog-button-add', function(data) {
                DialogComponent.addButton(data.extension, data.button);
            });
            EventDispatcher$1.register('host-window-resize', Util.debounce(function() {
                $('.' + DIALOG_CLASS).each(function(i, dialog) {
                    var $dialog = $(dialog);
                    var sanitizedOptions = dialogUtilsInstance.sanitizeOptions($dialog.data('originalOptions'));
                    dialog.style.width = sanitizedOptions.width;
                    dialog.style.height = sanitizedOptions.height;
                });
            }, 100));
        }
        DomEventActions.registerWindowKeyEvent({
            keyCode: 27,
            callback: function callback() {
                DialogActions.closeActive({
                    customData: {},
                    extension: null
                });
            }
        });
        function getAccessNarrowingSpaceContext(extension) {
            var _AJS;
            if (extension != null && extension.options && (_AJS = AJS) != null && (_AJS = _AJS.Meta) != null && _AJS.get) {
                var productContext = _extends({}, extension.options.productContext || {});
                if (AJS.Meta.get('space-key')) productContext['an.spaceKey'] = AJS.Meta.get('space-key');
                return _extends({}, extension, {
                    options: _extends({}, extension.options, {
                        productContext: productContext
                    })
                });
            }
            return extension;
        }
        var DialogExtension = function() {
            function DialogExtension() {}
            var _proto = DialogExtension.prototype;
            _proto.render = function render(extension, dialogOptions) {
                extension.options = extension.options || {};
                dialogOptions = dialogOptions || {};
                extension.options.isDialog = true;
                extension.options.dialogId = dialogOptions.id;
                extension.options.callbackExtensionId = extension.callback_extension_id;
                extension.options.preventDialogCloseOnEscape = dialogOptions.closeOnEscape === false;
                extension.options.hostFrameOffset = dialogOptions.hostFrameOffset;
                extension.options.hideIframeUntilLoad = true;
                var $iframeContainer = IframeContainerComponent.createExtension(extension);
                var $dialog = DialogComponent.render({
                    extension: extension,
                    $content: $iframeContainer,
                    chrome: dialogOptions.chrome,
                    width: dialogOptions.width,
                    height: dialogOptions.height,
                    size: dialogOptions.size,
                    header: dialogOptions.header,
                    hint: dialogOptions.hint,
                    submitText: dialogOptions.submitText,
                    cancelText: dialogOptions.cancelText,
                    buttons: dialogOptions.buttons,
                    onHide: dialogOptions.onHide
                });
                return $dialog;
            };
            _proto.getActiveDialog = function getActiveDialog() {
                return DialogComponent.getActive();
            };
            _proto.buttonIsEnabled = function buttonIsEnabled(identifier) {
                return DialogComponent.buttonIsEnabled(identifier);
            };
            _proto.buttonIsVisible = function buttonIsVisible(identifier) {
                return DialogComponent.buttonIsVisible(identifier);
            };
            _proto.getByExtension = function getByExtension(extension) {
                if (typeof extension === 'string') extension = {
                    id: extension
                };
                return DialogComponent.getByExtension(extension);
            };
            return DialogExtension;
        }();
        var DialogExtensionComponent = new DialogExtension();
        EventDispatcher$1.register('dialog-extension-open', function(data) {
            var dialogExtension = getAccessNarrowingSpaceContext(data.extension);
            var dialogOptions = dialogUtilsInstance.sanitizeOptions(data.options);
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var dialogProvider = frameworkAdaptor.getProviderByModuleName('dialog');
            if (dialogProvider) {
                var getOnClickFunction = function getOnClickFunction(action) {
                    var key = dialogExtension.key;
                    var addon_key = dialogExtension.addon_key;
                    var eventData = {
                        button: {
                            identifier: action.identifier,
                            name: action.identifier,
                            text: action.text
                        }
                    };
                    if ([
                        'submit',
                        'cancel'
                    ].indexOf(action.identifier) >= 0) EventActions.broadcast("dialog." + action.identifier, {
                        addon_key: addon_key,
                        key: key
                    }, eventData);
                    EventActions.broadcast('dialog.button.click', {
                        addon_key: addon_key,
                        key: key
                    }, eventData);
                };
                dialogExtension.options.preventDialogCloseOnEscape = dialogOptions.closeOnEscape === false;
                dialogOptions.actions.map(function(action) {
                    return action.onClick = getOnClickFunction.bind(null, action);
                });
                dialogProvider.create(dialogOptions, dialogExtension);
            } else DialogExtensionComponent.render(dialogExtension, data.options);
        });
        var _dialogs = {};
        EventDispatcher$1.register('dialog-close', function(data) {
            var dialog = data.dialog;
            if (dialog && data.extension) {
                var targetSpec = {
                    addon_key: data.extension.addon_key,
                    id: data.extension.options.callbackExtensionId
                };
                EventActions.broadcast('dialog.close', targetSpec, data.customData);
            }
        });
        EventDispatcher$1.register('dialog-button-click', function(data) {
            var eventData = {
                button: {
                    name: ButtonComponent.getName(data.$el),
                    identifier: ButtonComponent.getIdentifier(data.$el),
                    text: ButtonComponent.getText(data.$el)
                }
            };
            var eventName = 'dialog.button.click';
            var buttonEventFilter = {
                addon_key: data.extension.addon_key,
                key: data.extension.key
            };
            buttonEventFilter.id = data.extension.id;
            if (!data.$el.hasClass('ap-dialog-custom-button')) EventActions.broadcast("dialog." + eventData.button.name, buttonEventFilter, eventData);
            EventActions.broadcast(eventName, buttonEventFilter, eventData);
        });
        var Dialog = function Dialog(options, callback) {
            callback = Util.last(arguments);
            var _id = callback._id;
            var extension = callback._context.extension;
            var dialogExtension = {
                addon_key: extension.addon_key,
                key: options.key,
                options: Util.pick(extension.options, [
                    'customData',
                    'productContext'
                ]),
                callback_extension_id: extension.id
            };
            dialogExtension.options.customData = options.customData;
            var dialogModuleOptions = dialogUtilsInstance.moduleOptionsFromGlobal(dialogExtension.addon_key, dialogExtension.key);
            if (typeof (dialogModuleOptions || {}).hostFrameOffset === 'number') dialogExtension.options.hostFrameOffset = dialogModuleOptions.hostFrameOffset;
            options = Util.extend({}, dialogModuleOptions || {}, options);
            options.id = _id;
            dialogUtilsInstance.trackMultipleDialogOpening(dialogExtension, options);
            DialogExtensionActions.open(dialogExtension, options);
            this.customData = options.customData;
            _dialogs[_id] = this;
        };
        var Button = function() {
            function Button(identifier, callback) {
                callback = Util.last(arguments);
                var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
                var dialogProvider = frameworkAdaptor.getProviderByModuleName('dialog');
                if (dialogProvider) {
                    dialogUtilsInstance.assertActiveDialogOrThrow(dialogProvider, callback._context.extension.addon_key);
                    this.name = identifier;
                    this.identifier = identifier;
                } else {
                    if (!DialogExtensionComponent.getActiveDialog()) throw new Error('Failed to find an active dialog.');
                    this.name = identifier;
                    this.identifier = identifier;
                    this.enabled = DialogExtensionComponent.buttonIsEnabled(identifier);
                    this.hidden = !DialogExtensionComponent.buttonIsVisible(identifier);
                }
            }
            var _proto = Button.prototype;
            _proto.enable = function enable() {
                this.setState({
                    enabled: true
                });
            };
            _proto.disable = function disable() {
                this.setState({
                    enabled: false
                });
            };
            _proto.isEnabled = function isEnabled(callback) {
                callback = Util.last(arguments);
                var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
                var dialogProvider = frameworkAdaptor.getProviderByModuleName('dialog');
                if (dialogProvider) callback(!dialogProvider.isButtonDisabled(this.identifier));
                else callback(this.enabled);
            };
            _proto.toggle = function toggle() {
                var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
                var dialogProvider = frameworkAdaptor.getProviderByModuleName('dialog');
                if (dialogProvider) dialogProvider.toggleButton(this.identifier);
                else this.setState({
                    enabled: !this.enabled
                });
            };
            _proto.setState = function setState(state) {
                var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
                var dialogProvider = frameworkAdaptor.getProviderByModuleName('dialog');
                if (dialogProvider) dialogProvider.setButtonDisabled(this.identifier, !state.enabled);
                else {
                    this.enabled = state.enabled;
                    DialogActions.toggleButton({
                        identifier: this.identifier,
                        enabled: this.enabled
                    });
                }
            };
            _proto.trigger = function trigger(callback) {
                callback = Util.last(arguments);
                if (this.enabled) DialogActions.dialogMessage({
                    name: this.name,
                    extension: callback._context.extension
                });
            };
            _proto.isHidden = function isHidden(callback) {
                callback = Util.last(arguments);
                var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
                var dialogProvider = frameworkAdaptor.getProviderByModuleName('dialog');
                if (dialogProvider) callback(dialogProvider.isButtonHidden(this.identifier));
                else callback(this.hidden);
            };
            _proto.hide = function hide() {
                this.setHidden(true);
            };
            _proto.show = function show() {
                this.setHidden(false);
            };
            _proto.setHidden = function setHidden(hidden) {
                var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
                var dialogProvider = frameworkAdaptor.getProviderByModuleName('dialog');
                if (dialogProvider) dialogProvider.setButtonHidden(this.identifier, hidden);
                else {
                    this.hidden = hidden;
                    DialogActions.toggleButtonVisibility({
                        identifier: this.identifier,
                        hidden: this.hidden
                    });
                }
            };
            return Button;
        }();
        function getDialogFromContext(context) {
            return _dialogs[context.extension.options.dialogId];
        }
        var CreateButton = function CreateButton(options, callback) {
            callback = Util.last(arguments);
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var dialogProvider = frameworkAdaptor.getProviderByModuleName('dialog');
            if (dialogProvider) {
                dialogUtilsInstance.assertActiveDialogOrThrow(dialogProvider, callback._context.extension.addon_key);
                dialogProvider.createButton({
                    identifier: options.identifier,
                    text: options.text,
                    hidden: false,
                    disabled: options.disabled || false,
                    onClick: function onClick() {
                        EventActions.broadcast('dialog.button.click', {
                            addon_key: callback._context.extension.addon_key,
                            key: callback._context.extension.key
                        }, {
                            button: {
                                identifier: options.identifier,
                                text: options.text
                            }
                        });
                    }
                });
            } else DialogExtensionActions.addUserButton({
                identifier: options.identifier,
                text: options.text
            }, callback._context.extension);
        };
        var dialog = {
            create: {
                constructor: Dialog
            },
            close: function close(data, callback) {
                callback = Util.last(arguments);
                var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
                var dialogProvider = frameworkAdaptor.getProviderByModuleName('dialog');
                if (dialogProvider) {
                    dialogUtilsInstance.assertActiveDialogOrThrow(dialogProvider, callback._context.extension.addon_key);
                    EventActions.broadcast('dialog.close', {
                        addon_key: callback._context.extension.addon_key
                    }, data);
                    dialogProvider.close();
                } else {
                    var dialogToClose;
                    if (callback._context.extension.options.isDialog) dialogToClose = DialogExtensionComponent.getByExtension(callback._context.extension.id)[0];
                    else dialogToClose = DialogExtensionComponent.getActiveDialog();
                    DialogActions.close({
                        customData: data,
                        dialog: dialogToClose,
                        extension: callback._context.extension
                    });
                }
            },
            getCustomData: function getCustomData(callback) {
                callback = Util.last(arguments);
                var dialog = getDialogFromContext(callback._context);
                if (dialog) callback(dialog.customData);
                else callback(undefined);
            },
            getButton: {
                constructor: Button,
                enable: Button.prototype.enable,
                disable: Button.prototype.disable,
                toggle: Button.prototype.toggle,
                isEnabled: Button.prototype.isEnabled,
                trigger: Button.prototype.trigger,
                hide: Button.prototype.hide,
                show: Button.prototype.show,
                isHidden: Button.prototype.isHidden
            },
            createButton: {
                constructor: CreateButton
            }
        };
        EventDispatcher$1.register('iframe-resize', function(data) {
            IframeComponent.resize(data.width, data.height, data.$el);
        });
        EventDispatcher$1.register('iframe-size-to-parent', function(data) {
            var height;
            var $el = Util.getIframeByExtensionId(data.extensionId);
            height = $(window).height() - $el.offset().top - 1 + 'px';
            if ($el.get(0).name.length > 0 && JSON.parse($el.get(0).name).options.moduleType === 'jiraProjectPages') height = '100%';
            EventDispatcher$1.dispatch('iframe-resize', {
                width: '100%',
                height: height,
                $el: $el
            });
        });
        EventDispatcher$1.register('hide-footer', function(hideFooter) {
            if (hideFooter) $('#footer').css({
                display: 'none'
            });
        });
        window.addEventListener('resize', function(e) {
            EventDispatcher$1.dispatch('host-window-resize', e);
        }, true);
        var EnvActions = {
            iframeResize: function iframeResize(width, height, context) {
                var $el;
                if (context.extension_id) $el = Util.getIframeByExtensionId(context.extension_id);
                else $el = context;
                EventDispatcher$1.dispatch('iframe-resize', {
                    width: width,
                    height: height,
                    $el: $el,
                    extension: context.extension
                });
            },
            sizeToParent: function sizeToParent(extensionId, hideFooter) {
                EventDispatcher$1.dispatch('iframe-size-to-parent', {
                    hideFooter: hideFooter,
                    extensionId: extensionId
                });
            },
            hideFooter: function hideFooter(_hideFooter) {
                EventDispatcher$1.dispatch('hide-footer', _hideFooter);
            }
        };
        var debounce = Util.debounce;
        var resizeFuncHolder = {};
        var ignoreResizeForExtension = [];
        var sizeToParentExtension = {};
        var env = {
            getLocation: function getLocation(callback) {
                callback = Util.last(arguments);
                var pageLocationProvider = ModuleProviders$1.getProvider('get-location');
                if (typeof pageLocationProvider === 'function') callback(pageLocationProvider());
                else callback(window.location.href);
            },
            resize: function resize(width, height, callback) {
                callback = Util.last(arguments);
                var addon = ModuleProviders$1.getProvider('addon');
                if (addon) addon.resize(width, height, callback._context);
                else {
                    var iframeId = callback._context.extension.id;
                    var options = callback._context.extension.options;
                    if (ignoreResizeForExtension.indexOf(iframeId) !== -1 || options && options.isDialog) return false;
                    if (!resizeFuncHolder[iframeId]) resizeFuncHolder[iframeId] = debounce(function(dwidth, dheight, dcallback) {
                        EnvActions.iframeResize(dwidth, dheight, dcallback._context);
                    }, 50);
                    resizeFuncHolder[iframeId](width, height, callback);
                }
                return true;
            },
            sizeToParent: debounce(function(hideFooter, callback) {
                callback = Util.last(arguments);
                var addon = ModuleProviders$1.getProvider('addon');
                if (addon) addon.sizeToParent(hideFooter, callback._context);
                else if (callback._context.extension.options.isFullPage) {
                    Util.getIframeByExtensionId(callback._context.extension_id).addClass('full-size-general-page');
                    Util.getIframeByExtensionId(callback._context.extension_id).addClass('sized-to-parent');
                    EnvActions.sizeToParent(callback._context.extension_id, hideFooter);
                    sizeToParentExtension[callback._context.extension_id] = {
                        hideFooter: hideFooter
                    };
                } else Util.getIframeByExtensionId(callback._context.extension_id).addClass('full-size-general-page-fail');
            }),
            hideFooter: function hideFooter(_hideFooter) {
                if (_hideFooter) EnvActions.hideFooter(_hideFooter);
            }
        };
        var _removeIframeReferenceAfterUnloadAndDestroyed = function _removeIframeReferenceAfterUnloadAndDestroyed(extensionId) {
            delete resizeFuncHolder[extensionId];
            delete sizeToParentExtension[extensionId];
            if (ignoreResizeForExtension.indexOf(extensionId) !== -1) ignoreResizeForExtension.splice(ignoreResizeForExtension.indexOf(extensionId), 1);
        };
        EventDispatcher$1.register('host-window-resize', function(data) {
            Object.getOwnPropertyNames(sizeToParentExtension).forEach(function(extensionId) {
                EnvActions.sizeToParent(extensionId, sizeToParentExtension[extensionId].hideFooter);
            });
        });
        EventDispatcher$1.register('after:iframe-unload', function(data) {
            _removeIframeReferenceAfterUnloadAndDestroyed(data.extension.id);
        });
        EventDispatcher$1.register('after:iframe-destroyed', function(data) {
            _removeIframeReferenceAfterUnloadAndDestroyed(data.extension.extension.id);
        });
        EventDispatcher$1.register('before:iframe-size-to-parent', function(data) {
            if (ignoreResizeForExtension.indexOf(data.extensionId) === -1) ignoreResizeForExtension.push(data.extensionId);
        });
        var InlineDialogActions = {
            hide: function hide($el) {
                EventDispatcher$1.dispatch('inline-dialog-hide', {
                    $el: $el
                });
            },
            refresh: function refresh($el) {
                EventDispatcher$1.dispatch('inline-dialog-refresh', {
                    $el: $el
                });
            },
            hideTriggered: function hideTriggered(extension_id, $el) {
                EventDispatcher$1.dispatch('inline-dialog-hidden', {
                    extension_id: extension_id,
                    $el: $el
                });
            },
            close: function close() {
                EventDispatcher$1.dispatch('inline-dialog-close', {});
            },
            created: function created(data) {
                EventDispatcher$1.dispatch('inline-dialog-opened', {
                    $el: data.$el,
                    trigger: data.trigger,
                    extension: data.extension
                });
            }
        };
        var inlineDialog = {
            hide: function hide(callback) {
                callback = Util.last(arguments);
                var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
                var inlineDialogProvider = frameworkAdaptor.getProviderByModuleName('inlineDialog');
                if (inlineDialogProvider) inlineDialogProvider.hide(callback._context);
                else InlineDialogActions.close();
            }
        };
        var MESSAGE_BAR_ID = 'ac-message-container';
        var MESSAGE_TYPES = [
            'generic',
            'error',
            'warning',
            'success',
            'info',
            'hint'
        ];
        var MSGID_PREFIX = 'ap-message-';
        var MSGID_REGEXP = new RegExp("^" + MSGID_PREFIX + "[0-9A-fa-f]+$");
        var _messages = {};
        function validateMessageId(msgId) {
            return MSGID_REGEXP.test(msgId);
        }
        function getMessageBar() {
            var $msgBar = $('#' + MESSAGE_BAR_ID);
            if ($msgBar.length < 1) $msgBar = $('<div id="' + MESSAGE_BAR_ID + '" />').appendTo('body');
            return $msgBar;
        }
        function filterMessageOptions(options) {
            var copy = {};
            var allowed = [
                'closeable',
                'fadeout',
                'delay',
                'duration',
                'id'
            ];
            if (typeof options === 'object') allowed.forEach(function(key) {
                if (key in options) copy[key] = options[key];
            });
            return copy;
        }
        var messageCloseListenerCreated = false;
        function showMessage(name, title, body, options) {
            if (!messageCloseListenerCreated) {
                createMessageCloseListener();
                messageCloseListenerCreated = true;
            }
            var $msgBar = getMessageBar();
            options = filterMessageOptions(options);
            $.extend(options, {
                title: title,
                body: AJS.escapeHtml(body)
            });
            if (MESSAGE_TYPES.indexOf(name) < 0) throw 'Invalid message type. Must be: ' + MESSAGE_TYPES.join(', ');
            if (validateMessageId(options.id)) {
                AJS.messages[name]($msgBar, options);
                $msgBar.css('margin-left', '-' + $msgBar.innerWidth() / 2 + 'px');
            }
        }
        function deprecatedShowMessage(name, title, body, options, callback) {
            var methodUsed = "AP.messages." + name;
            console.warn("DEPRECATED API - AP.messages." + name + " has been deprecated since ACJS 5.0 and will be removed in a future release. Use AP.flag.create instead.");
            AnalyticsAction.trackDeprecatedMethodUsed(methodUsed, callback._context.extension);
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var messageProvider = frameworkAdaptor.getProviderByModuleName('messages');
            if (messageProvider) {
                var messageType = name;
                var createMessage = messageProvider[messageType];
                if (!createMessage) messageProvider[messageType] = messageProvider.generic;
                createMessage(title, body, options);
            } else showMessage(name, title, body, options);
        }
        function createMessageCloseListener() {
            $(document).on('aui-message-close', function(e, $msg) {
                var _id = $msg.attr('id').replace(MSGID_PREFIX, '');
                if (_messages[_id]) {
                    if ($.isFunction(_messages[_id].onCloseTrigger)) _messages[_id].onCloseTrigger();
                    _messages[_id]._destroy();
                }
            });
        }
        function messageModule(messageType) {
            return {
                constructor: function constructor(title, body, options, callback) {
                    callback = Util.last(arguments);
                    var _id = callback._id;
                    if (typeof title !== 'string') title = '';
                    if (typeof body !== 'string') body = '';
                    if (typeof options !== 'object') options = {};
                    options.id = MSGID_PREFIX + _id;
                    deprecatedShowMessage(messageType, title, body, options, callback);
                    _messages[_id] = this;
                }
            };
        }
        var messages = {
            clear: function clear(msg) {
                var id = MSGID_PREFIX + msg._id;
                if (validateMessageId(id)) {
                    var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
                    var messageProvider = frameworkAdaptor.getProviderByModuleName('messages');
                    if (messageProvider) messageProvider.clear(id);
                    else $('#' + id).closeMessage();
                }
            },
            onClose: function onClose(msg, callback) {
                callback = Util.last(arguments);
                var id = msg._id;
                var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
                var messageProvider = frameworkAdaptor.getProviderByModuleName('messages');
                if (messageProvider) {
                    var fullId = MSGID_PREFIX + msg._id;
                    messageProvider.onClose(fullId, callback);
                } else if (_messages[id]) _messages[id].onCloseTrigger = callback;
            },
            generic: messageModule('generic'),
            error: messageModule('error'),
            warning: messageModule('warning'),
            success: messageModule('success'),
            info: messageModule('info'),
            hint: messageModule('hint')
        };
        var FlagActions = {
            actionInvoked: function actionInvoked(actionId, flagId) {
                EventDispatcher$1.dispatch('flag-action-invoked', {
                    id: flagId,
                    actionId: actionId
                });
            },
            open: function open(flagId) {
                EventDispatcher$1.dispatch('flag-open', {
                    id: flagId
                });
            },
            close: function close(flagId) {
                EventDispatcher$1.dispatch('flag-close', {
                    id: flagId
                });
            },
            closed: function closed(flagId) {
                EventDispatcher$1.dispatch('flag-closed', {
                    id: flagId
                });
            }
        };
        var FLAGID_PREFIX = 'ap-flag-';
        var FLAG_CLASS = 'ac-aui-flag';
        var FLAG_ACTION_CLASS = 'ac-flag-actions';
        var Flag$1 = function() {
            function Flag() {}
            var _proto = Flag.prototype;
            _proto.cleanKey = function cleanKey(dirtyKey) {
                var cleanFlagKeyRegExp = new RegExp('^' + FLAGID_PREFIX + '(.+)$');
                var matches = dirtyKey.match(cleanFlagKeyRegExp);
                if (matches && matches[1]) return matches[1];
                return null;
            };
            _proto._toHtmlString = function _toHtmlString(str) {
                if ($.type(str) === 'string') return str;
                else if ($.type(str) === 'object' && str instanceof $) return str.html();
            };
            _proto._renderBody = function _renderBody(body) {
                var body = this._toHtmlString(body);
                var $body = $('<div />').html(body);
                $('<p />').addClass(FLAG_ACTION_CLASS).appendTo($body);
                return $body.html();
            };
            _proto._renderActions = function _renderActions($flag, flagId, actions) {
                var $actionContainer = $flag.find('.' + FLAG_ACTION_CLASS);
                actions = actions || {};
                var $action;
                Object.getOwnPropertyNames(actions).forEach(function(key) {
                    $action = $('<a />').attr('href', '#').data({
                        'key': key,
                        'flag_id': flagId
                    }).text(actions[key]);
                    $actionContainer.append($action);
                }, this);
                return $flag;
            };
            _proto.render = function render(options) {
                bindFlagDomEvents();
                var _id = FLAGID_PREFIX + options.id;
                var auiFlag = AJS.flag({
                    type: options.type,
                    title: options.title,
                    body: this._renderBody(options.body),
                    close: options.close
                });
                auiFlag.setAttribute('id', _id);
                var $auiFlag = $(auiFlag);
                this._renderActions($auiFlag, options.id, options.actions);
                $auiFlag.addClass(FLAG_CLASS);
                $auiFlag.close = auiFlag.close;
                return $auiFlag;
            };
            _proto.close = function close(id) {
                var f = document.getElementById(id);
                f.close();
            };
            return Flag;
        }();
        var FlagComponent = new Flag$1();
        var flagDomEventsBound = false;
        function bindFlagDomEvents() {
            if (flagDomEventsBound) return;
            $(document).on('aui-flag-close', function(e) {
                var _id = e.target.id;
                var cleanFlagId = FlagComponent.cleanKey(_id);
                FlagActions.closed(cleanFlagId);
            });
            $(document).on('click', '.' + FLAG_ACTION_CLASS, function(e) {
                var $target = $(e.target);
                var actionKey = $target.data('key');
                var flagId = $target.data('flag_id');
                FlagActions.actionInvoked(actionKey, flagId);
            });
            flagDomEventsBound = true;
        }
        EventDispatcher$1.register('flag-close', function(data) {
            FlagComponent.close(data.id);
        });
        var _flags = {};
        var Flag = function() {
            function Flag(options, callback) {
                callback = Util.last(arguments);
                if (typeof options !== 'object') return;
                var flagId = callback._id;
                var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
                var flagProvider = frameworkAdaptor.getProviderByModuleName('flag');
                if (flagProvider) {
                    var actions = [];
                    if (typeof options.actions === 'object') actions = Object.getOwnPropertyNames(options.actions).map(function(key) {
                        return {
                            actionKey: key,
                            actionText: options.actions[key],
                            executeAction: FlagActions.actionInvoked.bind(null, key, flagId)
                        };
                    });
                    var type = options.type || 'info';
                    var flagOptions = {
                        id: flagId,
                        title: options.title,
                        body: options.body,
                        actions: actions,
                        onClose: FlagActions.closed,
                        close: options.close,
                        type: type.toLowerCase()
                    };
                    this.flag = flagProvider.create(flagOptions);
                    var addonProvider = ModuleProviders$1.getProvider('addon');
                    if (addonProvider && addonProvider.registerUnmountCallback) addonProvider.registerUnmountCallback(this.close.bind(this), callback._context);
                } else {
                    this.flag = FlagComponent.render({
                        type: options.type,
                        title: options.title,
                        body: AJS.escapeHtml(options.body),
                        actions: options.actions,
                        close: options.close,
                        id: flagId
                    });
                    FlagActions.open(this.flag.attr('id'));
                }
                this.onTriggers = {};
                this.extension = callback._context.extension;
                _flags[callback._id] = this;
                callback.call(null, callback._id);
            }
            var _proto = Flag.prototype;
            _proto.close = function close() {
                this.flag.close();
            };
            return Flag;
        }();
        function invokeTrigger(id, eventName, data) {
            if (_flags[id]) {
                var extension = _flags[id].extension;
                data = data || {};
                data.flagIdentifier = id;
                var targetSpec = {
                    id: extension.id
                };
                EventActions.broadcast(eventName, targetSpec, data);
            }
        }
        EventDispatcher$1.register('flag-closed', function(data) {
            invokeTrigger(data.id, 'flag.close');
            if (_flags[data.id]) delete _flags[data.id];
        });
        EventDispatcher$1.register('flag-action-invoked', function(data) {
            invokeTrigger(data.id, 'flag.action', {
                actionIdentifier: data.actionId
            });
        });
        var flag = {
            create: {
                constructor: Flag,
                close: Flag.prototype.close
            }
        };
        var analytics = {
            trackDeprecatedMethodUsed: function trackDeprecatedMethodUsed(methodUsed, callback) {
                callback = Util.last(arguments);
                AnalyticsAction.trackDeprecatedMethodUsed(methodUsed, callback._context.extension);
            },
            trackIframePerformanceMetrics: function trackIframePerformanceMetrics(metrics, callback) {
                callback = Util.last(arguments);
                AnalyticsAction.trackIframePerformanceMetrics(metrics, callback._context.extension);
            }
        };
        var TRIGGER_PERCENTAGE = 10;
        var activeGeneralPageAddon;
        var lastScrollEventTriggered;
        EventDispatcher$1.register('iframe-bridge-established', function(data) {
            if (data.extension.options.isFullPage) {
                window.addEventListener('scroll', scrollEventHandler);
                activeGeneralPageAddon = data.extension.id;
            }
        });
        EventDispatcher$1.register('iframe-destroyed', function(extension) {
            removeScrollEvent();
        });
        EventDispatcher$1.register('iframe-unload', function(extension) {
            removeScrollEvent();
        });
        function removeScrollEvent() {
            window.removeEventListener('scroll', scrollEventHandler);
            activeGeneralPageAddon = undefined;
            lastScrollEventTriggered = undefined;
        }
        function scrollEventHandler() {
            var documentHeight = document.documentElement.scrollHeight;
            var windowHeight = window.innerHeight;
            var boundary = documentHeight * (TRIGGER_PERCENTAGE / 100);
            if (window.pageYOffset <= boundary) triggerEvent('nearTop');
            else if (windowHeight + window.pageYOffset + boundary >= documentHeight) triggerEvent('nearBottom');
            else lastScrollEventTriggered = undefined;
        }
        function triggerEvent(type) {
            if (lastScrollEventTriggered === type) return;
            EventActions.broadcast('scroll.' + type, {
                id: activeGeneralPageAddon
            }, {});
            lastScrollEventTriggered = type;
        }
        var scrollPosition = {
            getPosition: function getPosition(callback) {
                callback = Util.last(arguments);
                if (callback._context.extension.options.isFullPage) {
                    var $el = Util.getIframeByExtensionId(callback._context.extension_id);
                    var offset = $el.offset();
                    var $window = $(window);
                    callback({
                        scrollY: $window.scrollTop() - offset.top,
                        scrollX: $window.scrollLeft() - offset.left,
                        width: window.innerWidth,
                        height: window.innerHeight
                    });
                }
            },
            setVerticalPosition: function setVerticalPosition(y, callback) {
                callback = Util.last(arguments);
                if (callback._context.extension.options && callback._context.extension.options.isFullPage) {
                    var $el = Util.getIframeByExtensionId(callback._context.extension_id);
                    var offset = $el.offset();
                    if (typeof y === 'number') document.documentElement.scrollTop = offset.top + y;
                }
            }
        };
        var DropdownActions = {
            itemSelected: function itemSelected(dropdown_id, item, extension) {
                EventDispatcher$1.dispatch('dropdown-item-selected', {
                    id: dropdown_id,
                    item: item,
                    extension: extension
                });
            }
        };
        function buildListItem(listItem) {
            var finishedListItem = {};
            if (typeof listItem === 'string') finishedListItem.content = listItem;
            else if (listItem.text && typeof listItem.text === 'string') {
                finishedListItem.content = listItem.text;
                if (typeof listItem.disabled === 'boolean') finishedListItem.disabled = listItem.disabled;
                if (typeof listItem.itemId !== 'undefined') finishedListItem.itemId = listItem.itemId;
            } else throw new Error('Unknown dropdown list item format.');
            return finishedListItem;
        }
        function moduleListToApiList(list) {
            return list.map(function(item) {
                if (item.list && Array.isArray(item.list)) {
                    var returnval = {
                        heading: item.heading
                    };
                    returnval.items = item.list.map(function(listitem) {
                        return buildListItem(listitem);
                    });
                    return returnval;
                }
            });
        }
        var dropdown = {
            create: function create(options, callback) {
                callback = Util.last(arguments);
                if (typeof options !== 'object') return;
                var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
                var dropdownProvider = frameworkAdaptor.getProviderByModuleName('dropdown');
                if (dropdownProvider) {
                    var dropdownGroups = moduleListToApiList(options.list);
                    var dropdownProviderOptions = {
                        dropdownId: options.dropdownId,
                        dropdownGroups: dropdownGroups,
                        dropdownItemNotifier: function dropdownItemNotifier(data) {
                            DropdownActions.itemSelected(data.dropdownId, data.item, callback._context.extension);
                        }
                    };
                    dropdownProvider.create(dropdownProviderOptions, callback._context);
                    return dropdownProviderOptions;
                }
            },
            showAt: function showAt(dropdownId, x, y, width) {
                var callback = Util.last(arguments);
                var rect = {
                    left: 0,
                    top: 0
                };
                var iframe = document.getElementById(callback._context.extension_id);
                if (iframe) rect = iframe.getBoundingClientRect();
                else console.error('ACJS: no iframe found for dropdown');
                var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
                var dropdownProvider = frameworkAdaptor.getProviderByModuleName('dropdown');
                if (dropdownProvider) {
                    var dropdownProviderArgs = {
                        dropdownId: dropdownId,
                        x: x,
                        y: y,
                        width: width
                    };
                    dropdownProvider.showAt(dropdownProviderArgs, {
                        iframeDimensions: rect,
                        onItemSelection: function onItemSelection(dropdownId, item) {
                            DropdownActions.itemSelected(dropdownId, item, callback._context.extension);
                        }
                    });
                }
            },
            hide: function hide(id) {
                var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
                var dropdownProvider = frameworkAdaptor.getProviderByModuleName('dropdown');
                if (dropdownProvider) dropdownProvider.hide(id);
            },
            itemDisable: function itemDisable(dropdownId, itemId) {
                var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
                var dropdownProvider = frameworkAdaptor.getProviderByModuleName('dropdown');
                if (dropdownProvider) dropdownProvider.itemDisable(dropdownId, itemId);
            },
            itemEnable: function itemEnable(dropdownId, itemId) {
                var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
                var dropdownProvider = frameworkAdaptor.getProviderByModuleName('dropdown');
                if (dropdownProvider) dropdownProvider.itemEnable(dropdownId, itemId);
            }
        };
        EventDispatcher$1.register('dropdown-item-selected', function(data) {
            EventActions.broadcast('dropdown-item-selected', {
                addon_key: data.extension.addon_key,
                key: data.extension.key
            }, {
                dropdownId: data.id,
                item: data.item
            });
        });
        EventDispatcher$1.register('iframe-destroyed', function(data) {
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var dropdownProvider = frameworkAdaptor.getProviderByModuleName('dropdown');
            if (dropdownProvider) dropdownProvider.destroyByExtension(data.extension.extension_id);
        });
        EventDispatcher$1.register('after:iframe-unload', function(data) {
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var dropdownProvider = frameworkAdaptor.getProviderByModuleName('dropdown');
            if (dropdownProvider) dropdownProvider.destroyByExtension(data.extension.extension_id);
        });
        function deprecateHost(fn, name, alternate, sinceVersion) {
            var called = false;
            return function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (!called && typeof console !== 'undefined' && console.warn) {
                    called = true;
                    console.warn("DEPRECATED API - " + name + " has been deprecated " + (sinceVersion ? "since ACJS " + sinceVersion : 'in ACJS') + (" and will be removed in a future release. " + (alternate ? "Use " + alternate + " instead." : 'No alternative will be provided.')));
                    var callback = Util.last(args);
                    if (callback && callback._context && callback._context.extension) analytics.trackDeprecatedMethodUsed(name, callback);
                }
                return fn.apply(void 0, args);
            };
        }
        var host = {
            focus: function focus() {
                window.document.querySelector('a').focus({
                    preventScroll: true
                });
                window.document.querySelector('a').blur();
            },
            getSelectedText: deprecateHost(function(callback) {
                callback('');
                return;
            }, 'AP.host.getSelectedText()')
        };
        var themeColorModes = [
            'light',
            'dark',
            'auto'
        ];
        var themeIds = [
            'light-increased-contrast',
            'light',
            'light-future',
            'light-brand-refresh',
            'dark',
            'dark-future',
            'dark-increased-contrast',
            'dark-brand-refresh',
            'legacy-light',
            'legacy-dark',
            'spacing',
            'shape',
            'typography-adg3',
            'typography-modernized'
        ];
        var THEME_DATA_ATTRIBUTE = 'data-theme';
        var COLOR_MODE_ATTRIBUTE = 'data-color-mode';
        var CSS_PREFIX = 'ds';
        var CURRENT_SURFACE_CSS_VAR = "--".concat(CSS_PREFIX, "-elevation-surface-current");
        var themeKinds = [
            'light',
            'dark',
            'spacing',
            'typography',
            'shape'
        ];
        var customThemeOptions = 'UNSAFE_themeOptions';
        var isThemeKind = function isThemeKind(themeKind) {
            return themeKinds.find(function(kind) {
                return kind === themeKind;
            }) !== undefined;
        };
        var isThemeIds = function isThemeIds(themeId) {
            return themeIds.find(function(id) {
                return id === themeId;
            }) !== undefined;
        };
        var isColorMode = function isColorMode(modeId) {
            return [
                'light',
                'dark',
                'auto'
            ].includes(modeId);
        };
        var themeStringToObject = function themeStringToObject(themeState) {
            return themeState.split(' ').map(function(theme) {
                return theme.split(/:([\s\S]*)/);
            }).reduce(function(themeObject, _ref) {
                var _ref2 = _slicedToArray(_ref, 2), kind = _ref2[0], id = _ref2[1];
                if (kind === 'colorMode' && isColorMode(id)) themeObject[kind] = id;
                if (isThemeKind(kind) && isThemeIds(id)) themeObject[kind] = id;
                if (kind === customThemeOptions) try {
                    themeObject[customThemeOptions] = JSON.parse(id);
                } catch (e) {}
                return themeObject;
            }, {});
        };
        function ownKeys(e, r) {
            var t = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                r && (o = o.filter(function(r) {
                    return Object.getOwnPropertyDescriptor(e, r).enumerable;
                })), t.push.apply(t, o);
            }
            return t;
        }
        function _objectSpread(e) {
            for(var r = 1; r < arguments.length; r++){
                var t = null != arguments[r] ? arguments[r] : {};
                r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
                    _defineProperty(e, r, t[r]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
                    Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
                });
            }
            return e;
        }
        var isThemeColorMode = function isThemeColorMode(colorMode) {
            return themeColorModes.find(function(mode) {
                return mode === colorMode;
            }) !== undefined;
        };
        var getGlobalTheme = function getGlobalTheme() {
            if (typeof document === 'undefined') return {};
            var element = document.documentElement;
            var colorMode = element.getAttribute(COLOR_MODE_ATTRIBUTE) || '';
            var theme = element.getAttribute(THEME_DATA_ATTRIBUTE) || '';
            return _objectSpread(_objectSpread({}, themeStringToObject(theme)), isThemeColorMode(colorMode) && {
                colorMode: colorMode
            });
        };
        var getGlobalTheme$1 = getGlobalTheme;
        var ThemeMutationObserver = function() {
            function ThemeMutationObserver(callback) {
                _classCallCheck(this, ThemeMutationObserver);
                _defineProperty(this, "legacyObserver", null);
                this.callback = callback;
                ThemeMutationObserver.callbacks.add(callback);
            }
            _createClass(ThemeMutationObserver, [
                {
                    key: "observe",
                    value: function observe() {
                        if (!ThemeMutationObserver.observer) {
                            ThemeMutationObserver.observer = new MutationObserver(function() {
                                var theme = getGlobalTheme$1();
                                ThemeMutationObserver.callbacks.forEach(function(callback) {
                                    return callback(theme);
                                });
                            });
                            ThemeMutationObserver.observer.observe(document.documentElement, {
                                attributeFilter: [
                                    THEME_DATA_ATTRIBUTE,
                                    COLOR_MODE_ATTRIBUTE
                                ]
                            });
                        }
                    }
                },
                {
                    key: "disconnect",
                    value: function disconnect() {
                        if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                        if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                            ThemeMutationObserver.observer.disconnect();
                            ThemeMutationObserver.observer = null;
                        }
                    }
                }
            ]);
            return ThemeMutationObserver;
        }();
        _defineProperty(ThemeMutationObserver, "observer", null);
        _defineProperty(ThemeMutationObserver, "callbacks", new Set());
        var getPluginFeatureFlags = function getPluginFeatureFlags() {
            return {
                isLoadCdnStylesOnlyEnabled: getBooleanFeatureFlag('acjs-iframe-allowlist-load_stylesheets_from_cdn', true)
            };
        };
        var getSurfaceValue = function getSurfaceValue(extension_id) {
            var iframe = document.getElementById(extension_id);
            if (!iframe) return;
            var styles = getComputedStyle(iframe);
            var currentSurface = styles.getPropertyValue(CURRENT_SURFACE_CSS_VAR);
            var raised = styles.getPropertyValue('--ds-surface-raised');
            var overlay = styles.getPropertyValue('--ds-surface-overlay');
            if (currentSurface === raised) return 'raised';
            if (currentSurface === overlay) return 'overlay';
        };
        function broadcastThemeChange(newTheme) {
            var featureFlags = getPluginFeatureFlags();
            if (ThemingModuleState.extensionIds.length) ThemingModuleState.extensionIds.forEach(function(id) {
                var surface = getSurfaceValue(id);
                host$1.broadcast('theme_changed', {
                    id: id
                }, {
                    newTheme: newTheme,
                    featureFlags: featureFlags,
                    surface: surface
                });
            });
        }
        var ThemingModuleState = {
            extensionIds: [],
            themeObserver: new ThemeMutationObserver(function(newTheme) {
                broadcastThemeChange(newTheme);
            })
        };
        var ThemingModule = {
            initializeTheming: function initializeTheming() {
                var callback = Util.last(arguments);
                var forceNoCleanup = arguments.length === 1 ? false : arguments[0];
                if (!callback || !callback._context || !callback._context.extension_id) return;
                var extension_id = callback._context.extension_id;
                if (!extension_id) return;
                var initialTheme = getGlobalTheme$1();
                var surface = getSurfaceValue(extension_id);
                var featureFlags = getPluginFeatureFlags();
                host$1.broadcast('theme_initialized', {
                    id: extension_id
                }, {
                    initialTheme: initialTheme,
                    featureFlags: featureFlags,
                    surface: surface,
                    forceNoCleanup: forceNoCleanup
                });
                if (!ThemingModuleState.extensionIds.includes(extension_id)) {
                    ThemingModuleState.extensionIds.push(extension_id);
                    ThemingModuleState.themeObserver.observe(document.documentElement);
                }
            },
            _finishedInitTheming: function _finishedInitTheming() {}
        };
        var page = {
            setTitle: function setTitle(title, callback) {
                callback = Util.last(arguments);
                if (callback._context.extension.options && callback._context.extension.options.isFullPage) {
                    var productSuffix = ' - ' + Util.guessProductFromModuleDefined(window.connectHost);
                    document.title = title + productSuffix;
                }
            }
        };
        var InlineDialogWebItemActions = {
            addExtension: function addExtension(data) {
                EventDispatcher$1.dispatch('inline-dialog-extension', {
                    $el: data.$el,
                    extension: data.extension
                });
            }
        };
        var InlineDialog = function() {
            function InlineDialog() {}
            var _proto = InlineDialog.prototype;
            _proto.resize = function resize(data) {
                var width = Util.stringToDimension(data.width);
                var height = Util.stringToDimension(data.height);
                var $content = data.$el.find('.contents');
                if ($content.length === 1) {
                    $content.css({
                        width: width,
                        height: height
                    });
                    InlineDialogActions.refresh(data.$el);
                }
            };
            _proto.refresh = function refresh($el) {
                if (!$el.is(':visible')) return;
                $el[0].popup.reset();
            };
            _proto._getInlineDialog = function _getInlineDialog($el) {
                return AJS.InlineDialog($el);
            };
            _proto._renderContainer = function _renderContainer() {
                return $('<div />').addClass('aui-inline-dialog-contents');
            };
            _proto._displayInlineDialog = function _displayInlineDialog(data) {
                InlineDialogActions.created({
                    $el: data.$el,
                    trigger: data.trigger,
                    extension: data.extension
                });
            };
            _proto.hideInlineDialog = function hideInlineDialog($el) {
                $el.hide();
            };
            _proto.closeInlineDialog = function closeInlineDialog() {
                $('.aui-inline-dialog').filter(function() {
                    return $(this).find('.ap-iframe-container').length > 0;
                }).hide();
            };
            _proto.render = function render(data) {
                var _this = this;
                var $inlineDialog = $(document.getElementById('inline-dialog-' + data.id));
                if ($inlineDialog.length !== 0) $inlineDialog.remove();
                var $el = AJS.InlineDialog(data.bindTo, data.id, function($placeholder, trigger, showInlineDialog) {
                    $placeholder.append(data.$content);
                    _this._displayInlineDialog({
                        extension: data.extension,
                        $el: $placeholder,
                        trigger: trigger
                    });
                    showInlineDialog();
                }, data.inlineDialogOptions);
                $el.css('z-index', 1000);
                return $el;
            };
            return InlineDialog;
        }();
        var InlineDialogComponent = new InlineDialog();
        EventDispatcher$1.register('iframe-resize', function(data) {
            var container = data.$el.parents('.aui-inline-dialog');
            if (container.length === 1) InlineDialogComponent.resize({
                width: data.width,
                height: data.height,
                $el: container
            });
        });
        EventDispatcher$1.register('inline-dialog-refresh', function(data) {
            InlineDialogComponent.refresh(data.$el);
        });
        EventDispatcher$1.register('inline-dialog-hide', function(data) {
            InlineDialogComponent.hideInlineDialog(data.$el);
        });
        EventDispatcher$1.register('inline-dialog-close', function(data) {
            InlineDialogComponent.closeInlineDialog();
        });
        var ITEM_NAME$1 = 'inline-dialog';
        var SELECTOR$1 = '.ap-inline-dialog';
        var WEBITEM_UID_KEY$1 = 'inline-dialog-target-uid';
        var InlineDialogWebItem = function() {
            function InlineDialogWebItem() {
                this._inlineDialogWebItemSpec = {
                    name: ITEM_NAME$1,
                    selector: SELECTOR$1,
                    triggers: [
                        'mouseenter',
                        'click'
                    ]
                };
                this._inlineDialogWebItems = {};
            }
            var _proto = InlineDialogWebItem.prototype;
            _proto.getWebItem = function getWebItem() {
                return this._inlineDialogWebItemSpec;
            };
            _proto._createInlineDialog = function _createInlineDialog(data) {
                var $inlineDialog = InlineDialogComponent.render({
                    extension: data.extension,
                    id: data.id,
                    bindTo: data.$target,
                    $content: $('<div />'),
                    inlineDialogOptions: data.extension.options
                });
                return $inlineDialog;
            };
            _proto.triggered = function triggered(data) {
                var eventType = data.eventType;
                var onHover = data.extension.options.onHover;
                if (eventType !== 'click' && !onHover) return;
                var $target = data.$target;
                var webitemId = $target.data(WEBITEM_UID_KEY$1);
                EventDispatcher$1.dispatch('analytics-inline-dialog-opened', {
                    extension: data.extension,
                    eventType: eventType,
                    onHover: onHover
                });
                if (eventType === 'click' && !onHover) {
                    if ($target.attr('data-inline-created') === 'true') return;
                    else $target.attr('data-inline-created', 'true');
                }
                var $inlineDialog = this._createInlineDialog({
                    id: webitemId,
                    extension: data.extension,
                    $target: $target,
                    options: data.extension.options || {}
                });
                $inlineDialog.show();
            };
            _proto.opened = function opened(data) {
                var $existingFrame = data.$el.find('iframe');
                var isExistingFrame = $existingFrame && $existingFrame.length === 1;
                if (isExistingFrame) {
                    var src = $existingFrame.attr('src');
                    var srcPresent = src.length > 0;
                    if (srcPresent) {
                        var srcHasJWT = urlUtils.hasJwt(src);
                        var srcHasValidJWT = srcHasJWT && !urlUtils.isJwtExpired(src);
                        if (srcHasValidJWT || !srcHasJWT) return false;
                    }
                }
                var dialogExtension = getAccessNarrowingSpaceContext(data.extension);
                var contentRequest = webItemInstance.requestContent(dialogExtension);
                if (!contentRequest) {
                    console.warn('no content resolver found');
                    return false;
                }
                contentRequest.then(function(content) {
                    content.options = content.options || {};
                    Util.extend(content.options, {
                        autoresize: true,
                        widthinpx: true
                    });
                    InlineDialogWebItemActions.addExtension({
                        $el: data.$el,
                        extension: content
                    });
                });
                return true;
            };
            _proto.addExtension = function addExtension(data) {
                var addon = create(data.extension);
                data.$el.empty().append(addon);
            };
            _proto.createIfNotExists = function createIfNotExists(data) {
                var $target = data.$target;
                var uid = $target.data(WEBITEM_UID_KEY$1);
                if (!uid) {
                    uid = WebItemUtils.uniqueId();
                    $target.data(WEBITEM_UID_KEY$1, uid);
                }
            };
            return InlineDialogWebItem;
        }();
        var inlineDialogInstance = new InlineDialogWebItem();
        var webitem$1 = inlineDialogInstance.getWebItem();
        EventDispatcher$1.register('before:webitem-invoked:' + webitem$1.name, function(data) {
            inlineDialogInstance.createIfNotExists(data);
        });
        EventDispatcher$1.register('webitem-invoked:' + webitem$1.name, function(data) {
            inlineDialogInstance.triggered(data);
        });
        EventDispatcher$1.register('inline-dialog-opened', function(data) {
            inlineDialogInstance.opened(data);
        });
        EventDispatcher$1.register('inline-dialog-extension', function(data) {
            inlineDialogInstance.addExtension(data);
        });
        WebItemActions.addWebItem(webitem$1);
        var ITEM_NAME = 'dialog';
        var SELECTOR = '.ap-dialog';
        var TRIGGERS = [
            'click'
        ];
        var WEBITEM_UID_KEY = 'dialog-target-uid';
        var DEFAULT_WEBITEM_OPTIONS = {
            chrome: true
        };
        var DialogWebItem = function() {
            function DialogWebItem() {
                this._dialogWebItem = {
                    name: ITEM_NAME,
                    selector: SELECTOR,
                    triggers: TRIGGERS
                };
            }
            var _proto = DialogWebItem.prototype;
            _proto.getWebItem = function getWebItem() {
                return this._dialogWebItem;
            };
            _proto._dialogOptions = function _dialogOptions(options) {
                return Util.extend({}, DEFAULT_WEBITEM_OPTIONS, options || {});
            };
            _proto.triggered = function triggered(data) {
                var $target = data.$target;
                var webitemId = $target.data(WEBITEM_UID_KEY);
                var dialogOptions = this._dialogOptions(data.extension.options);
                dialogOptions.id = webitemId;
                DialogExtensionActions.open(data.extension, dialogOptions);
            };
            _proto.createIfNotExists = function createIfNotExists(data) {
                var $target = data.$target;
                var uid = $target.data(WEBITEM_UID_KEY);
                if (!uid) {
                    uid = WebItemUtils.uniqueId();
                    $target.data(WEBITEM_UID_KEY, uid);
                }
            };
            return DialogWebItem;
        }();
        var dialogInstance = new DialogWebItem();
        var webitem = dialogInstance.getWebItem();
        EventDispatcher$1.register('webitem-invoked:' + webitem.name, function(data) {
            dialogInstance.triggered(data);
        });
        EventDispatcher$1.register('before:webitem-invoked:' + webitem.name, dialogInstance.createIfNotExists);
        WebItemActions.addWebItem(webitem);
        if (!window._AP) window._AP = {};
        if (!window._AP.version) window._AP.version = '5.3.157';
        host$1.defineModule('messages', messages);
        host$1.defineModule('flag', flag);
        host$1.defineModule('dialog', dialog);
        host$1.defineModule('inlineDialog', inlineDialog);
        host$1.defineModule('env', env);
        host$1.defineModule('events', events);
        host$1.defineModule('_analytics', analytics);
        host$1.defineModule('scrollPosition', scrollPosition);
        host$1.defineModule('dropdown', dropdown);
        host$1.defineModule('host', host);
        host$1.defineModule('theming', ThemingModule);
        host$1.defineModule('page', page);
        EventDispatcher$1.register('module-define-custom', function(data) {
            host$1.defineModule(data.name, data.methods);
        });
        host$1.registerRequestNotifier(function(data) {
            var dispatchEvent = function dispatchEvent() {
                if (data.type === 'req') {
                    var registeredExtension = host$1.getExtensions(function(ext) {
                        return ext.extension_id === data.extension_id;
                    })[0];
                    if (registeredExtension) {
                        var extension = registeredExtension.extension;
                        EventDispatcher$1.dispatch('method-invoked', _extends({}, data, {
                            extension: extension
                        }));
                    }
                }
            };
            if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(dispatchEvent, {
                timeout: 1000
            });
            else dispatchEvent();
        });
        host$1.setFeatureFlagGetter(getBooleanFeatureFlag);
        return HostApi$1;
    });
});
parcelRegister("ginVq", function(module, exports) {
    (function() {
        var CONFLUENCE_EMBED_WINDOW_NAME = 'embedded-confluence-iframe';
        var aniFrame = function() {
            return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function(callback) {
                window.setTimeout(callback, 50);
            };
        }();
        var getXDM = function() {
            return window.connectHost || window.AP;
        };
        var getRenderedExtension = function(XDM, filter) {
            var existingExtensions = XDM.getExtensions(filter);
            return existingExtensions.filter(function(extension) {
                return Boolean(document.getElementById(extension.extension_id));
            });
        };
        var loadModule = function(name, callback, retriesLeft) {
            try {
                var module = require(name);
                callback(module);
            } catch (error) {
                if (retriesLeft <= 0) {
                    console.error('Unable to load module: ' + name);
                    callback(null);
                } else setTimeout(function() {
                    loadModule(name, callback, retriesLeft - 1);
                }, 500);
            }
        };
        var waitForModule = function(connectHost, moduleName, callback, retriesLeft, timeout) {
            if (typeof retriesLeft === 'undefined') retriesLeft = 20;
            timeout = timeout || 500;
            if (!connectHost.isModuleDefined || retriesLeft <= 0) callback();
            else if (connectHost.isModuleDefined(moduleName)) callback(true);
            else setTimeout(function() {
                waitForModule(connectHost, moduleName, callback, retriesLeft - 1, timeout);
            }, timeout);
        };
        function decodeContext(ctx) {
            var decodedContext;
            if (typeof ctx === 'string' && ctx.length > 1) try {
                decodedContext = JSON.parse(ctx);
            } catch (e) {
                console.error('ACJS: failed to decode context', ctx);
            }
            if (typeof decodedContext !== 'object') decodedContext = {};
            return decodedContext;
        }
        window._AP = window._AP || {};
        window._AP.addonAttemptCounter = window._AP.addonAttemptCounter || {};
        window._AP._convertConnectOptions = function(data) {
            var convertedData = {
                url: data.url,
                ns: data.uniqueKey,
                addon_key: data.addon_key,
                key: data.key,
                containerId: "embedded-" + data.uniqueKey,
                options: {
                    history: {
                        state: ""
                    },
                    uniqueKey: data.uniqueKey,
                    origin: data.origin,
                    hostOrigin: data.hostOrigin,
                    moduleType: data.moduleType,
                    moduleLocation: data.moduleLocation,
                    isFullPage: data.general === "1",
                    autoresize: true,
                    user: {
                        timeZone: data.timeZone,
                        fullName: data.fullName,
                        uid: data.uid,
                        ukey: data.ukey
                    },
                    productContext: decodeContext(data.productCtx),
                    structuredContext: decodeContext(data.structuredContext),
                    contextJwt: data.contextJwt,
                    contextPath: data.cp,
                    width: data.w || data.width,
                    height: data.h || data.height,
                    sandbox: data.sandbox,
                    pearApp: data.pearApp,
                    noSub: data.noSub,
                    allowPathTraversal: data.allowPathTraversal,
                    targets: {
                        env: {
                            resize: 'both'
                        }
                    }
                }
            };
            if (typeof data.contentClassifier === 'string') convertedData.options.contentClassifier = data.contentClassifier;
            if (typeof data.hostFrameOffset === 'number') convertedData.options.hostFrameOffset = data.hostFrameOffset + 1;
            if (!window._AP.isSubHost) convertedData.options.history.state = window.location.hash ? window.location.hash.substr(2) : "";
            return convertedData;
        };
        function setRealUrl(iframe, data) {
            var contentDoc = iframe.contentDocument;
            var contents = {
                type: 'set_inner_iframe_url',
                iframeData: data,
                extension_id: JSON.parse(iframe.name).extension_id
            };
            var codeToInject = '(function(){ var w = window; for (var i=0; i<' + data.options.hostFrameOffset + '; i++){w = w.parent; } ' + 'w.postMessage(' + JSON.stringify(contents) + ', "*");' + '}());';
            contentDoc.open();
            contentDoc.write('<script>' + codeToInject + '</script>');
            contentDoc.close();
        }
        window._AP._createSub = function(cleanData) {
            var connectAddonFrame = document.createElement("iframe");
            var attributes = getXDM().subCreate(cleanData);
            attributes.width = cleanData.options.width || "";
            attributes.height = cleanData.options.height || "";
            attributes.style = "border:0;";
            attributes['class'] = "ap-iframe";
            attributes['data-addon-key'] = cleanData.addon_key;
            attributes['data-key'] = cleanData.key;
            delete attributes.src;
            Object.getOwnPropertyNames(attributes).forEach(function(key) {
                connectAddonFrame.setAttribute(key, attributes[key]);
            });
            return connectAddonFrame;
        };
        function findHostFrame(hostFrameOffset, initialFrame) {
            if (typeof hostFrameOffset !== 'number') return window.top;
            var host = initialFrame || window;
            for(var i = 0; i < hostFrameOffset; i++)host = host.parent;
            return host;
        }
        function ACJSisDefined(globalName) {
            return typeof window[globalName] !== "undefined";
        }
        function ACJSawaitGlobal(globalName, callback, interval) {
            interval = interval || 100;
            if (ACJSisDefined(globalName)) callback(window[globalName]);
            else var intervalFn = setInterval(function() {
                if (ACJSisDefined(globalName)) {
                    clearInterval(intervalFn);
                    callback(window[globalName]);
                }
            }, interval);
        }
        function appendConnectAddon(data) {
            window._AP.isSubHost = findHostFrame(data.hostFrameOffset) !== window;
            var convertedData = window._AP._convertConnectOptions(data);
            window._AP.addonAttemptCounter[convertedData.containerId] = 0;
            var iframe;
            if (window._AP.isSubHost) {
                if (window.AP && window.AP._data && window.AP._data.options && window.AP._data.options.globalOptions) convertedData.options.globalOptions = window.AP._data.options.globalOptions;
                const parentProductContext = window.AP && window.AP._data && window.AP._data.options && window.AP._data.options.productContext ? window.AP._data.options.productContext : {};
                convertedData.options.productContext = propagateParentProductContext(parentProductContext, convertedData.options.productContext);
                iframe = window._AP._createSub(convertedData);
                doAppend(iframe, convertedData);
            } else ACJSawaitGlobal('connectHost', function(ACJSHost) {
                var existingExtensions = getRenderedExtension(ACJSHost, {
                    addon_key: convertedData.addon_key,
                    key: convertedData.key
                });
                existingExtensions.forEach(function(existingAddon) {
                    if (existingAddon.extension.options.uniqueKey === convertedData.options.uniqueKey) {
                        var existingFrame = document.getElementById(existingAddon.extension_id);
                        ACJSHost.destroy(existingAddon.extension_id);
                        if (existingFrame) AJS.$(existingFrame).closest('.ap-iframe-container').remove();
                    }
                }, this);
                iframe = ACJSHost.create(convertedData);
                doAppend(iframe, convertedData);
            });
        }
        function propagateParentProductContext(parentContext, childContext) {
            const propagateContext = {};
            const propagateKeys = [
                "content.id",
                "issue.id",
                "issue.key",
                "page.id",
                "project.id",
                "project.key",
                "space.id",
                "space.key"
            ];
            propagateKeys.forEach((key)=>{
                if (parentContext[key]) propagateContext[key] = parentContext[key];
            });
            return Object.assign({}, propagateContext, childContext);
        }
        function doAppend(iframeToAppend, convertedData) {
            var container = document.getElementById(convertedData.containerId);
            window._AP.addonAttemptCounter[convertedData.containerId]++;
            if (!container) {
                if (window._AP.addonAttemptCounter[convertedData.containerId] <= 10) aniFrame(function() {
                    doAppend(iframeToAppend, convertedData);
                });
            } else {
                delete window._AP.addonAttemptCounter[convertedData.containerId];
                if (window._AP.isSubHost) {
                    container.appendChild(iframeToAppend);
                    setRealUrl(iframeToAppend, convertedData);
                } else {
                    var duplicateFrame = container.querySelector('.ap-iframe-container');
                    if (duplicateFrame) {
                        duplicateFrame.parentNode.removeChild(duplicateFrame);
                        if (AJS.log) AJS.log('AJS: duplicate iframe removed', convertedData, container);
                    }
                    iframeToAppend.appendTo(container);
                    iframeToAppend.data('addon-key', convertedData.addon_key);
                    iframeToAppend.data('key', convertedData.key);
                }
            }
        }
        window._AP.appendConnectAddon = function(data) {
            var isRunningTests = false;
            try {
                if (window.top.karma) isRunningTests = true;
            } catch (e) {}
            if (typeof data.hostFrameOffset === "undefined" && typeof window.connectHostFrameOffset !== "undefined") data.hostFrameOffset = window.connectHostFrameOffset;
            if (window.AJS && window.AJS.Confluence) {
                if (window.name.indexOf(CONFLUENCE_EMBED_WINDOW_NAME) !== -1) data.hostFrameOffset = 0;
            } else if (window.connectHost && !window.AP) data.hostFrameOffset = 0;
            if (window !== window.top && !isRunningTests && typeof data.hostFrameOffset === "undefined") {
                var callback = function(e) {
                    if (e.source === window.top && e.data && e.data.hostFrameOffset !== undefined) {
                        window.removeEventListener('message', callback);
                        data.hostFrameOffset = e.data.hostFrameOffset;
                        appendConnectAddon(data);
                    }
                };
                window.addEventListener('message', callback);
                window.top.postMessage({
                    type: 'get_host_offset'
                }, '*');
            } else {
                var emceeKeyRegex = /^com\.atlassian\.(jira|confluence)\.emcee($|\.local|\.staging|\.development\..*)/g;
                if (emceeKeyRegex.test(data.addon_key)) loadModule('ac/marketplace', function(marketplace) {
                    if (marketplace) ACJSawaitGlobal('connectHost', function(ACJSHost) {
                        ACJSHost.defineModule('marketplace', marketplace);
                    });
                    appendConnectAddon(data);
                }, 20);
                else if (data.addon_key === 'com.addonengine.analytics') ACJSawaitGlobal('connectHost', function(ACJSHost) {
                    waitForModule(ACJSHost, 'analytics', function() {
                        appendConnectAddon(data);
                    });
                });
                else appendConnectAddon(data);
            }
        };
    })();
});
parcelRegister("krjHY", function(module, exports) {
    $parcel$export(module.exports, "registerConnectStyles", ()=>$46173ccdb08c713a$export$a5b1d43a50325541);
    const $46173ccdb08c713a$export$a5b1d43a50325541 = ()=>(parcelRequire("lWMbf"));
});
parcelRegister("lWMbf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dhPRe").then(()=>parcelRequire('e2anT'));
});
parcelRegister("dMAhS", function(module, exports) {
    $parcel$export(module.exports, "registerContextCache", ()=>$677ca4b2bb74bd86$export$a8b2f612a8821ba7);
    $parcel$export(module.exports, "getToken", ()=>$677ca4b2bb74bd86$export$257b2d10b709d8ef);
    $parcel$export(module.exports, "getContext", ()=>$677ca4b2bb74bd86$export$31553aaa555c1514);
    var $53YYY;
    var $jDwcu;
    var $lDhBL;
    const $677ca4b2bb74bd86$var$CACHE_TIMEOUT = 30000;
    const $677ca4b2bb74bd86$var$addonContextCache = {};
    const $677ca4b2bb74bd86$var$getCacheKey = (extension)=>{
        if (extension.id && extension.id.length > 1) return extension.id;
        throw new Error('ACJS: cannot generate cache key for extension');
    };
    const $677ca4b2bb74bd86$var$_shapeFullContext = (cacheKey)=>$677ca4b2bb74bd86$var$addonContextCache[cacheKey]?.context?.contextObj;
    const $677ca4b2bb74bd86$var$isCacheExpired = (cachedAt)=>$677ca4b2bb74bd86$var$CACHE_TIMEOUT + cachedAt < Date.now();
    const $677ca4b2bb74bd86$var$shapeAddonContextCache = (structuredContext, contextJwt)=>({
            cachedAt: Date.now(),
            contextJwt: contextJwt,
            contextObj: structuredContext
        });
    const $677ca4b2bb74bd86$var$primeAddonContextCache = (addonData)=>{
        const cacheKey = $677ca4b2bb74bd86$var$getCacheKey(addonData);
        if (!$677ca4b2bb74bd86$var$addonContextCache[cacheKey] || !$677ca4b2bb74bd86$var$addonContextCache[cacheKey].promise && $677ca4b2bb74bd86$var$addonContextCache[cacheKey].context && $677ca4b2bb74bd86$var$isCacheExpired($677ca4b2bb74bd86$var$addonContextCache[cacheKey].context.cachedAt)) {
            addonData.classifier = 'json';
            $677ca4b2bb74bd86$var$addonContextCache[cacheKey] = $677ca4b2bb74bd86$var$addonContextCache[cacheKey] || {};
            $677ca4b2bb74bd86$var$addonContextCache[cacheKey].promise = (0, (0, parcelRequire("jDwcu")).resolveByExtension)(addonData, true).done((promiseData)=>{
                if (promiseData) $677ca4b2bb74bd86$var$addonContextCache[cacheKey].context = $677ca4b2bb74bd86$var$shapeAddonContextCache(promiseData.options.structuredContext, promiseData.options.contextJwt);
            });
        }
    };
    const $677ca4b2bb74bd86$var$checkNoJWT = (contextJwt)=>{
        if (!contextJwt || contextJwt.length < 2) throw new Error('ACJS: Cannot get token. Add-on does not support JWT authentication');
    };
    const $677ca4b2bb74bd86$var$iframeCreated = (data)=>{
        if ((0, (0, parcelRequire("lDhBL")).isValidExtensionOptionsForCache)(data.extension.options)) {
            const cacheKey = $677ca4b2bb74bd86$var$getCacheKey(data.extension);
            $677ca4b2bb74bd86$var$addonContextCache[cacheKey] = {
                context: $677ca4b2bb74bd86$var$shapeAddonContextCache(data.extension.options.structuredContext, data.extension.options.contextJwt)
            };
        } else $677ca4b2bb74bd86$var$primeAddonContextCache(data.extension);
    };
    const $677ca4b2bb74bd86$export$a8b2f612a8821ba7 = (connectHost)=>{
        connectHost.onIframeEstablished($677ca4b2bb74bd86$var$iframeCreated);
        connectHost.onIframeUnload((data)=>{
            delete $677ca4b2bb74bd86$var$addonContextCache[$677ca4b2bb74bd86$var$getCacheKey(data.extension)];
        });
    };
    const $677ca4b2bb74bd86$export$257b2d10b709d8ef = (callback)=>new Promise((resolve, reject)=>{
            const handleGetTokenError = (error, errorAttributes = {})=>(0, (0, parcelRequire("53YYY")).handleConnectError)('getToken', error, {
                    extId: callback._context?.extension?.id,
                    extKey: callback._context?.extension?.key,
                    addonKey: callback._context?.extension?.addon_key,
                    moduleKey: callback._context?.extension?.module_key,
                    ...errorAttributes
                });
            const cacheKey = $677ca4b2bb74bd86$var$getCacheKey(callback._context.extension);
            $677ca4b2bb74bd86$var$primeAddonContextCache(callback._context.extension);
            const addonContextCachePromise = $677ca4b2bb74bd86$var$addonContextCache[cacheKey].promise;
            if (addonContextCachePromise) addonContextCachePromise.done((promiseData)=>{
                try {
                    $677ca4b2bb74bd86$var$checkNoJWT(promiseData.options.contextJwt);
                    resolve(promiseData.options.contextJwt);
                } catch (error) {
                    const connectError = new (0, (0, parcelRequire("53YYY")).FetchConnectError)('getToken fails', error.status, error, true);
                    handleGetTokenError(connectError, {
                        isErrorInResolveFunc: true
                    });
                }
            }).fail((error)=>{
                const defaultErrorMsg = 'ACJS: content resolver failed to get context jwt token';
                const errorText = error.message || error.statusText || defaultErrorMsg;
                const newError = new (0, (0, parcelRequire("53YYY")).FetchConnectError)(errorText, error.status, error);
                handleGetTokenError(newError);
                reject(defaultErrorMsg);
            }).always(()=>{
                delete $677ca4b2bb74bd86$var$addonContextCache[cacheKey].promise;
            });
            else {
                $677ca4b2bb74bd86$var$checkNoJWT($677ca4b2bb74bd86$var$addonContextCache[cacheKey].context.contextJwt);
                resolve($677ca4b2bb74bd86$var$addonContextCache[cacheKey].context.contextJwt);
            }
        });
    $677ca4b2bb74bd86$export$257b2d10b709d8ef.returnsPromise = true;
    const $677ca4b2bb74bd86$export$31553aaa555c1514 = (callback)=>new Promise((resolve, reject)=>{
            const handleGetContextError = (error, errorAttrs = {})=>(0, (0, parcelRequire("53YYY")).handleConnectError)('getContext', error, {
                    extId: callback._context?.extension?.id,
                    extKey: callback._context?.extension?.key,
                    addonKey: callback._context?.extension?.addon_key,
                    moduleKey: callback._context?.extension?.module_key,
                    ...errorAttrs
                });
            const cacheKey = $677ca4b2bb74bd86$var$getCacheKey(callback._context.extension);
            $677ca4b2bb74bd86$var$primeAddonContextCache(callback._context.extension);
            const addonContextCachePromise = $677ca4b2bb74bd86$var$addonContextCache[cacheKey].promise;
            if (addonContextCachePromise) addonContextCachePromise.done((_data)=>{
                try {
                    resolve($677ca4b2bb74bd86$var$_shapeFullContext(cacheKey));
                } catch (error) {
                    const connectError = new (0, (0, parcelRequire("53YYY")).FetchConnectError)('getContext fails', error.status, error);
                    handleGetContextError(connectError, {
                        isErrorInResolveFunc: true
                    });
                }
            }).fail((error)=>{
                const defaultErrorMsg = 'ACJS: content resolver failed to get context';
                const errorText = error.message || error.statusText || defaultErrorMsg;
                const connectError = new (0, (0, parcelRequire("53YYY")).FetchConnectError)(errorText, error.status, error);
                handleGetContextError(connectError);
                reject(defaultErrorMsg);
            }).always(()=>{
                delete $677ca4b2bb74bd86$var$addonContextCache[cacheKey].promise;
            });
            else resolve($677ca4b2bb74bd86$var$_shapeFullContext(cacheKey));
        });
    $677ca4b2bb74bd86$export$31553aaa555c1514.returnsPromise = true;
});
parcelRegister("53YYY", function(module, exports) {
    $parcel$export(module.exports, "FetchConnectError", ()=>$13b0807a0800bc4d$export$630f7f9a7ae923d1);
    $parcel$export(module.exports, "handleConnectError", ()=>$13b0807a0800bc4d$export$a7a3f8c4788fb03d);
    var $jcw0u;
    var $ht021;
    function $13b0807a0800bc4d$var$is4xxError(statusCode) {
        return statusCode ? statusCode >= 400 && statusCode < 500 : false;
    }
    class $13b0807a0800bc4d$export$630f7f9a7ae923d1 extends (0, (0, parcelRequire("ht021")).default) {
        constructor(message, statusCode, cause, skipSentry){
            super(message, {
                cause: cause
            });
            this.name = cause && cause.name ? cause.name : 'NetworkError';
            this.statusCode = statusCode;
            this.skipSentry = typeof skipSentry === 'boolean' ? skipSentry : $13b0807a0800bc4d$var$is4xxError(statusCode);
        }
    }
    const $13b0807a0800bc4d$export$a7a3f8c4788fb03d = (id, error, errorAttrs = {})=>{
        const options = {
            error: error,
            meta: {
                id: id,
                packageName: 'jiraConnect'
            },
            attributes: {
                skipSentry: error.skipSentry,
                statusCode: error.statusCode,
                ...errorAttrs
            },
            sendToPrivacyUnsafeSplunk: true,
            skipSentry: error.skipSentry
        };
        (0, (0, parcelRequire("jcw0u")).default)(options);
        if (error.cause) (0, (0, parcelRequire("jcw0u")).default)({
            ...options,
            attributes: {
                ...options.attributes,
                isInnerError: true
            },
            error: error.cause
        });
    };
});
parcelRegister("jDwcu", function(module, exports) {
    $parcel$export(module.exports, "resolveByExtension", ()=>$5ea449091716ace2$export$af13c4a71cd8d0e0);
    $parcel$export(module.exports, "registerContentResolver", ()=>$5ea449091716ace2$export$5816c94c1182bc88);
    var $4R6GH;
    var $53YYY;
    var $dH9DT;
    var $5yXrM;
    var $aGk2k;
    const $5ea449091716ace2$var$sanitizeModuleKey = (moduleKey)=>new URL(moduleKey, window.location.origin).pathname.slice(1);
    const $5ea449091716ace2$var$getContentUrl = (pluginKey, moduleKey)=>`/plugins/servlet/ac/${encodeURIComponent(pluginKey)}/${encodeURIComponent($5ea449091716ace2$var$sanitizeModuleKey(moduleKey))}`;
    const $5ea449091716ace2$var$appendPrefixToCustomParameters = (params)=>{
        const newObj = {};
        Object.keys(params).forEach((key)=>{
            newObj[`ac.${key}`] = params[key];
        });
        return newObj;
    };
    const $5ea449091716ace2$var$updateClockSkew = (date)=>{
        const parsedServerDateTime = Math.round(Date.parse(date) / 1000);
        const now = Math.round(Date.now() / 1000);
        let skew;
        if (!Number.isNaN(parsedServerDateTime)) {
            skew = Math.abs(now - parsedServerDateTime);
            window.connectHost.setJwtClockSkew(skew + 60);
        }
    };
    const $5ea449091716ace2$var$cacheableLookup = (params)=>{
        const key = `${params.addon_key}__${params.key}`;
        const AP = (0, (0, parcelRequire("dH9DT")).getGlobalAP)();
        if (AP && AP.cacheableIframeUrls && AP.cacheableIframeUrls[key]) return AP.cacheableIframeUrls[key];
        return undefined;
    };
    const $5ea449091716ace2$var$fetchData = (contentResolverUrl, data, params, parametersToSendToServer)=>{
        const dataObj = {
            ...data,
            ...$5ea449091716ace2$var$appendPrefixToCustomParameters(parametersToSendToServer)
        };
        const handError = (error, extraAttrs = {})=>{
            (0, (0, parcelRequire("53YYY")).handleConnectError)('fetchModuleConfiguration', error, {
                extId: params?.id,
                extKey: params?.key,
                addonKey: params?.addon_key,
                moduleKey: params?.module_key,
                ...extraAttrs
            });
        };
        let requestBody;
        if ((0, (0, parcelRequire("4R6GH")).fg)('hix-5675_fix_connect_content_resolver_payload')) {
            requestBody = new URLSearchParams();
            for (const [key, value] of Object.entries(dataObj)){
                if (Array.isArray(value)) for (const arrayItem of value)requestBody.append(key, arrayItem);
                else requestBody.append(key, value);
            }
        } else requestBody = new URLSearchParams(dataObj);
        const fetchOptions = {
            method: 'POST',
            body: requestBody,
            headers: {
                'Content-Type': params.classifier === 'json' ? 'application/x-www-form-urlencoded' : 'text/html'
            }
        };
        const defaultFetchErrorMsg = 'Unable to retrieve addon module URL. Please check your specified module key.';
        return fetch(contentResolverUrl, fetchOptions).then((response)=>{
            $5ea449091716ace2$var$updateClockSkew(response.headers.get('Date'));
            const statusCode = response.status;
            const connectError = new (0, (0, parcelRequire("53YYY")).FetchConnectError)('Network request failed', statusCode);
            const errorAttrs = {
                errorText: defaultFetchErrorMsg
            };
            if (!response.ok) {
                response.text().catch(()=>'').then(()=>{
                    handError(connectError, {
                        ...errorAttrs
                    });
                });
                return Promise.reject(Object.assign(connectError, errorAttrs));
            }
            return response.json();
        }).then((responseJson)=>{
            if (params.addon_key && (0, (0, parcelRequire("dH9DT")).ErrorDebugAddonKeys).indexOf(params.addon_key) !== -1 && responseJson.status === 403) {
                const statusCode = responseJson.status;
                const connectError = new (0, (0, parcelRequire("53YYY")).FetchConnectError)(responseJson.message, statusCode);
                handError(connectError);
            }
            return responseJson;
        }).then((responseJson)=>(0, (0, parcelRequire("dH9DT")).getGlobalAP)()._convertConnectOptions(responseJson)).catch((error)=>{
            const errorText = error.message || error.statusText || defaultFetchErrorMsg;
            const responseText = typeof error.responseText === 'string' ? error.responseText.substring(0, 1000) : 'Something unexpected went wrong with the request';
            const httpStatusCode = error.status;
            if (window.connectHost && window.connectHost.trackContentResolverEvent && error) window.connectHost.trackContentResolverEvent(false, {
                extension: params,
                attrs: {
                    contentResolverUrl: contentResolverUrl,
                    httpStatusCode: httpStatusCode,
                    errorText: errorText,
                    responseText: responseText
                }
            });
            const connectError = new (0, (0, parcelRequire("53YYY")).FetchConnectError)(errorText, httpStatusCode, error);
            handError(connectError);
            return Promise.reject({
                text: defaultFetchErrorMsg,
                cause: connectError
            });
        });
    };
    const $5ea449091716ace2$export$af13c4a71cd8d0e0 = (params, noExtensionCreate)=>{
        const defer = new (0, (0, parcelRequire("5yXrM")).Deferred)();
        const cacheResp = $5ea449091716ace2$var$cacheableLookup(params);
        if (cacheResp && !noExtensionCreate) {
            defer.resolve((0, (0, parcelRequire("dH9DT")).getGlobalAP)()._convertConnectOptions({
                addon_key: params.addon_key,
                key: params.key,
                url: cacheResp,
                productCtx: JSON.stringify(params.options.productContext || {})
            }));
            return defer;
        }
        const data = {
            'plugin-key': params.addon_key,
            'product-context': JSON.stringify(params.options.productContext || {}),
            key: params.key,
            width: params.width || '100%',
            height: params.height || '100%',
            classifier: params.classifier || 'raw'
        };
        if (params.options.contentClassifier) data.classifier = [
            params.options.contentClassifier,
            data.classifier
        ];
        const customData = params.options.customData || {};
        const parametersToSendToServer = (0, (0, parcelRequire("aGk2k")).pick)(customData, (_key, value)=>{
            if ((0, (0, parcelRequire("dH9DT")).isObject)(value)) return false;
            if (typeof value === 'string' || value instanceof String) return value.length < 255;
            return true;
        });
        const contentResolverUrl = $5ea449091716ace2$var$getContentUrl(params.addon_key, params.key);
        $5ea449091716ace2$var$fetchData(contentResolverUrl, data, params, parametersToSendToServer).then((d)=>{
            defer.resolve(d);
        }).catch((error)=>{
            defer.reject(error);
        });
        return defer;
    };
    const $5ea449091716ace2$export$2257a97e4ce890e9 = (connectHost)=>function setInnerIframeUrl(event) {
            if (event?.data?.type === 'set_inner_iframe_url') {
                const { iframeData: iframeData } = event.data;
                iframeData.classifier = 'json';
                return $5ea449091716ace2$export$af13c4a71cd8d0e0(event.data.iframeData, true).then((data)=>{
                    data.id = event.data.extension_id;
                    connectHost.registerExistingExtension(data.id, {
                        extension: data
                    });
                    event.source.location = data.url;
                });
            }
            return undefined;
        };
    const $5ea449091716ace2$export$5816c94c1182bc88 = (connectHost)=>{
        connectHost.registerContentResolver.resolveByExtension($5ea449091716ace2$export$af13c4a71cd8d0e0);
        window.addEventListener('message', $5ea449091716ace2$export$2257a97e4ce890e9(connectHost));
    };
});
parcelRegister("5yXrM", function(module, exports) {
    $parcel$export(module.exports, "Deferred", ()=>$c03efee1461bc3e8$export$85f6557964517f1a);
    function $c03efee1461bc3e8$export$85f6557964517f1a() {
        const that = this;
        that._promise = new Promise((resolve, reject)=>{
            that.resolve = resolve;
            that.reject = reject;
        });
    }
    $c03efee1461bc3e8$export$85f6557964517f1a.prototype.then = function then(callbackResolve, callbackReject) {
        this._promise.then(callbackResolve, callbackReject);
        return this;
    };
    $c03efee1461bc3e8$export$85f6557964517f1a.prototype.finally = function _finally(callback) {
        this._promise.finally(callback);
        return this;
    };
    $c03efee1461bc3e8$export$85f6557964517f1a.prototype.done = function done(callback) {
        this._promise.then(callback);
        return this;
    };
    $c03efee1461bc3e8$export$85f6557964517f1a.prototype.fail = function fail(callback) {
        this._promise.catch((error)=>{
            callback(error, error);
        });
        return this;
    };
    $c03efee1461bc3e8$export$85f6557964517f1a.prototype.always = function always(callback) {
        this._promise.finally(callback);
        return this;
    };
});
parcelRegister("aGk2k", function(module, exports) {
    $parcel$export(module.exports, "pick", ()=>$3ee98d3b4e0d9140$export$357523c63a2253b9);
    const $3ee98d3b4e0d9140$export$357523c63a2253b9 = (obj, predicate)=>{
        const newObj = {};
        Object.keys(obj).forEach((key)=>{
            if (predicate(key, obj[key])) newObj[key] = obj[key];
        });
        return newObj;
    };
});
parcelRegister("lDhBL", function(module, exports) {
    $parcel$export(module.exports, "isValidExtensionOptionsForCache", ()=>$fbbc5ca84cefa097$export$5f169e8fa46bc8f3);
    const $fbbc5ca84cefa097$export$5f169e8fa46bc8f3 = (options)=>{
        const jwtIsFresh = !options.contextJwt || !window.connectHost.isJwtExpired(options.contextJwt, true);
        let validExtensionOptionsForCache = jwtIsFresh && !!options.structuredContext;
        if (validExtensionOptionsForCache) {
            const hasProductContext = options.productContext && Object.getOwnPropertyNames(options.productContext).length > 0;
            const hasStructuredContext = Object.getOwnPropertyNames(options.structuredContext).length > 0;
            const structuredContextIsValid = !hasProductContext || hasStructuredContext;
            if (!structuredContextIsValid) validExtensionOptionsForCache = false;
        }
        return validExtensionOptionsForCache;
    };
});
parcelRegister("2McXs", function(module, exports) {
    $parcel$export(module.exports, "registerDialogOptions", ()=>$93016470de8c03ff$export$9cc9c90f851e5c92);
    var $jcw0u;
    var $dH9DT;
    const $93016470de8c03ff$var$assignDataToGlobalAP = (data)=>{
        Object.keys(data).forEach((key)=>{
            if (Object.prototype.hasOwnProperty.call(data, key)) window._AP[key] = data[key];
        });
    };
    const $93016470de8c03ff$var$DEFAULT_DIALOG_OPTIONS_DATA_RESOURCE = {
        allJsVersion: '0.0.0',
        dialogModules: {},
        dialogOptions: {},
        inlineDialogOptions: {}
    };
    let $93016470de8c03ff$var$promiseFetchConnectDialogOptionsData = null;
    const $93016470de8c03ff$var$fetchConnectDialogOptionsData = ()=>{
        if ($93016470de8c03ff$var$promiseFetchConnectDialogOptionsData) return $93016470de8c03ff$var$promiseFetchConnectDialogOptionsData;
        const url = '/rest/internal/latest/connect/data/dialog';
        $93016470de8c03ff$var$promiseFetchConnectDialogOptionsData = fetch(url).then((response)=>response.json()).catch((error)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    packageName: 'jiraConnect',
                    teamName: 'onecloud',
                    id: 'fetchConnectDialogOptionsData'
                }
            });
            return $93016470de8c03ff$var$DEFAULT_DIALOG_OPTIONS_DATA_RESOURCE;
        });
        return $93016470de8c03ff$var$promiseFetchConnectDialogOptionsData;
    };
    const $93016470de8c03ff$export$9cc9c90f851e5c92 = async ()=>{
        if (!(0, (0, parcelRequire("dH9DT")).getGlobalAP)()) window._AP = {};
        const data = await $93016470de8c03ff$var$fetchConnectDialogOptionsData();
        $93016470de8c03ff$var$assignDataToGlobalAP(data);
    };
});
parcelRegister("gxmom", function(module, exports) {
    $parcel$export(module.exports, "registerIframeHandlers", ()=>$a660937966f5d8fd$export$742f2e79a0b30553);
    $parcel$export(module.exports, "registerAnalyticsHandler", ()=>$a660937966f5d8fd$export$24ca2c22589c989b);
    $parcel$export(module.exports, "registerAcCreate", ()=>$a660937966f5d8fd$export$4b002e6260d56211);
    var $fjcgS;
    var $dH9DT;
    const $a660937966f5d8fd$export$742f2e79a0b30553 = (connectHost)=>{
        (0, (0, parcelRequire("dH9DT")).getGlobalAP)()._addonAttemptCounter = {};
        connectHost.setExtensionConfigurationOptions('crev', window._AP.allJsVersion);
        connectHost.onIframeEstablished((data)=>{
            data.$el.closest('.ap-iframe-container').addClass('iframe-init');
        });
        connectHost.onFrameClick((frame)=>{
            frame.click();
        });
    };
    const $a660937966f5d8fd$export$24ca2c22589c989b = ()=>{
        window.define('ac/analytics', ()=>({
                emitGasV3: (eventType, event)=>{
                    (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
                        const analyticsClient = client.getInstance();
                        switch(eventType){
                            case 'operational':
                                analyticsClient.sendOperationalEvent(event);
                                break;
                            case 'page':
                                analyticsClient.sendPageEvent(event, undefined);
                                break;
                            case 'screen':
                                analyticsClient.sendScreenEvent(event);
                                break;
                            default:
                                throw new Error('ACJS: Unknown GasV3 event type');
                        }
                    });
                }
            }));
    };
    const $a660937966f5d8fd$export$4b002e6260d56211 = ()=>{
        window.define('ac/create', ()=>({
                appendConnectAddon: (data)=>(0, (0, parcelRequire("dH9DT")).getGlobalAP)().appendConnectAddon(data)
            }));
    };
});
parcelRegister("i5RmH", function(module, exports) {
    $parcel$export(module.exports, "registerCoreModules", ()=>$1e85364d2ed58592$export$7f6ed1473e70fb9);
    var $4brNC = parcelRequire("4brNC");
    var $fH7hc = parcelRequire("fH7hc");
    var $7eXvf = parcelRequire("7eXvf");
    var $dMAhS;
    var $8wnEm;
    var $cZwvK;
    const $1e85364d2ed58592$export$7f6ed1473e70fb9 = async (connectHost)=>{
        connectHost.defineModule('cookie', (0, ($parcel$interopDefault($4brNC))));
        connectHost.defineModule('history', (0, ($parcel$interopDefault($fH7hc))));
        connectHost.defineModule((0, ($parcel$interopDefault($7eXvf))));
        connectHost.defineModule('navigator', {
            _shouldThrottle: (0, parcelRequire("8wnEm"))._shouldThrottle,
            go: (0, parcelRequire("8wnEm")).go,
            reload: (0, parcelRequire("8wnEm")).reload
        });
        connectHost.defineModule('user', {
            getCurrentUser: (0, parcelRequire("cZwvK")).getCurrentUser,
            getLocale: (0, parcelRequire("cZwvK")).getLocale,
            getTimeZone: (0, parcelRequire("cZwvK")).getTimeZone,
            getUser: (0, parcelRequire("cZwvK")).getUser
        });
        connectHost.defineModule('context', {
            getToken: (0, parcelRequire("dMAhS")).getToken,
            getContext: (0, parcelRequire("dMAhS")).getContext
        });
    };
});
parcelRegister("4brNC", function(module, exports) {
    (function(f) {
        var g;
        module.exports = f();
    })(function() {
        var define, module1, exports;
        return (function e(t, n, r) {
            function s(o, u) {
                if (!n[o]) {
                    if (!t[o]) {
                        var a = undefined;
                        if (!u && a) return a(o, !0);
                        if (i) return i(o, !0);
                        var f = new Error("Cannot find module '" + o + "'");
                        throw f.code = "MODULE_NOT_FOUND", f;
                    }
                    var l = n[o] = {
                        exports: {}
                    };
                    t[o][0].call(l.exports, function(e) {
                        var n = t[o][1][e];
                        return s(n ? n : e);
                    }, l, l.exports, e, t, n, r);
                }
                return n[o].exports;
            }
            var i = undefined;
            for(var o = 0; o < r.length; o++)s(r[o]);
            return s;
        })({
            1: [
                function(_dereq_, module1, exports) {
                    'use strict';
                    Object.defineProperty(exports, '__esModule', {
                        value: true
                    });
                    var COOKIE_NAME = 'AJS.conglomerate.cookie';
                    var UNESCAPE_COOKIE_REGEX = /(\\|^"|"$)/g;
                    var CONSECUTIVE_PIPE_CHARS_REGEX = /\|\|+/g;
                    var ANY_QUOTE_REGEX = /"/g;
                    var REGEX_SPECIAL_CHARS = /[.*+?|^$()[\]{\\]/g;
                    var PIPE_PERCENT_ENCODED_UPPER = encodeURIComponent('|');
                    var PIPE_PERCENT_ENCODED_LOWER = encodeURIComponent('|').toLowerCase();
                    var PIPE_REPLACEMENT_STR = '**PIPE**';
                    var PIPE_PERCENT_ENCODED_REPLACEMENT_STR_UPPER = '**PIPE_PERCENT_ENCODED_UPPER**';
                    var PIPE_PERCENT_ENCODED_REPLACEMENT_STR_LOWER = '**PIPE_PERCENT_ENCODED_LOWER**';
                    var PERCENT_REPLACEMENT_STR = '**PERCENT**';
                    var EQUALS_REPLACEMENT_STR = '**EQUALS**';
                    function encodePipesAndPercents(str) {
                        if (typeof str !== 'string') return str;
                        if (str.indexOf(PIPE_REPLACEMENT_STR) !== -1 || str.indexOf(PIPE_PERCENT_ENCODED_REPLACEMENT_STR_UPPER) !== -1 || str.indexOf(PIPE_PERCENT_ENCODED_REPLACEMENT_STR_LOWER) !== -1) throw new Error('Cannot use cookies that contain ' + PIPE_REPLACEMENT_STR + ' or ' + PIPE_PERCENT_ENCODED_REPLACEMENT_STR_UPPER + PIPE_PERCENT_ENCODED_REPLACEMENT_STR_LOWER);
                        if (str.indexOf(PERCENT_REPLACEMENT_STR) !== -1) throw new Error('Cannot use cookies that contain ' + PERCENT_REPLACEMENT_STR);
                        if (str.indexOf(EQUALS_REPLACEMENT_STR) !== -1) throw new Error('Cannot use cookies that contain ' + EQUALS_REPLACEMENT_STR);
                        str = str.replace(new RegExp(regexEscape('|'), 'g'), PIPE_REPLACEMENT_STR);
                        str = str.replace(new RegExp(PIPE_PERCENT_ENCODED_UPPER, 'g'), PIPE_PERCENT_ENCODED_REPLACEMENT_STR_UPPER);
                        str = str.replace(new RegExp(PIPE_PERCENT_ENCODED_LOWER, 'g'), PIPE_PERCENT_ENCODED_REPLACEMENT_STR_LOWER);
                        str = str.replace(new RegExp('%', 'g'), PERCENT_REPLACEMENT_STR);
                        str = str.replace(new RegExp('=', 'g'), EQUALS_REPLACEMENT_STR);
                        return str;
                    }
                    function decodePipesAndPercents(str) {
                        if (typeof str !== 'string') return str;
                        str = str.replace(new RegExp(regexEscape(PIPE_REPLACEMENT_STR), 'g'), '|');
                        str = str.replace(new RegExp(regexEscape(PIPE_PERCENT_ENCODED_REPLACEMENT_STR_UPPER), 'g'), PIPE_PERCENT_ENCODED_UPPER);
                        str = str.replace(new RegExp(regexEscape(PIPE_PERCENT_ENCODED_REPLACEMENT_STR_LOWER), 'g'), PIPE_PERCENT_ENCODED_LOWER);
                        str = str.replace(new RegExp(regexEscape(PERCENT_REPLACEMENT_STR), 'g'), '%');
                        str = str.replace(new RegExp(regexEscape(EQUALS_REPLACEMENT_STR), 'g'), '=');
                        return str;
                    }
                    function regexEscape(str) {
                        return str.replace(REGEX_SPECIAL_CHARS, '\\$&');
                    }
                    function getValueFromConglomerate(name, cookieValue) {
                        cookieValue = cookieValue || '';
                        var reg = new RegExp(regexEscape(name) + '=([^|]+)');
                        var res = cookieValue.match(reg);
                        return res && res[1];
                    }
                    function addOrAppendToValue(name, value, cookieValue) {
                        var reg = new RegExp('(\\s|\\|)*\\b' + regexEscape(name) + '=[^|]*[|]*');
                        cookieValue = cookieValue || '';
                        cookieValue = cookieValue.replace(reg, '|');
                        if (value !== '') {
                            var pair = name + '=' + value;
                            if (cookieValue.length + pair.length < 4020) cookieValue += '|' + pair;
                        }
                        return cookieValue.replace(CONSECUTIVE_PIPE_CHARS_REGEX, '|');
                    }
                    function unescapeCookieValue(name) {
                        return name.replace(UNESCAPE_COOKIE_REGEX, '');
                    }
                    function getCookieValue(name) {
                        var reg = new RegExp('\\b' + regexEscape(name) + '=((?:[^\\\\;]+|\\\\.)*)(?:;|$)');
                        var res = document.cookie.match(reg);
                        return res && unescapeCookieValue(res[1]);
                    }
                    function saveCookie(name, value, days) {
                        var ex = '';
                        var d;
                        var quotedValue = '"' + value.replace(ANY_QUOTE_REGEX, '\\"') + '"';
                        if (days) {
                            d = new Date();
                            d.setTime(+d + days * 86400000);
                            ex = '; expires=' + d.toGMTString();
                        }
                        document.cookie = name + '=' + quotedValue + ex + ';path=/';
                    }
                    function save(name, value, expires) {
                        var cookieValue = getCookieValue(COOKIE_NAME);
                        cookieValue = addOrAppendToValue(name, value, cookieValue);
                        saveCookie(COOKIE_NAME, cookieValue, expires || 365);
                    }
                    function _read(name, defaultValue) {
                        var cookieValue = getCookieValue(COOKIE_NAME);
                        var value = getValueFromConglomerate(name, cookieValue);
                        if (value != null) return value;
                        return defaultValue;
                    }
                    function _erase(name) {
                        save(name, '');
                    }
                    function validateAddonKeyName(addonKey, name) {
                        if (!addonKey || addonKey.length === 0) throw new Error('addon key must be defined on cookies');
                        if (!name || name.length === 0) throw new Error('Name must be defined');
                    }
                    function prefixCookie(addonKey, name) {
                        validateAddonKeyName(addonKey, name);
                        return addonKey + '$$' + name;
                    }
                    function prefixLocalStorage(addonKey, name) {
                        validateAddonKeyName(addonKey, name);
                        return 'connect.cookie:' + addonKey + '$$' + name;
                    }
                    function addonKeyFromCallback(callback) {
                        if (callback && callback._context) return callback._context.extension.addon_key;
                        else throw new Error('addon key not found in callback');
                    }
                    function saveLocalStorage(addonKey, name, value, expireDays) {
                        var date = new Date();
                        date.setTime(date.getTime() + (expireDays || 365) * 86400000);
                        localStorage.setItem(prefixLocalStorage(addonKey, name), JSON.stringify({
                            expiry: date.getTime(),
                            value: value
                        }));
                    }
                    function readLocalStorage(addonKey, name) {
                        var itemStr = localStorage.getItem(prefixLocalStorage(addonKey, name));
                        if (itemStr === null) return;
                        var item = JSON.parse(itemStr);
                        if (item.expiry && new Date().getTime() > item.expiry) {
                            localStorage.removeItem(name);
                            return;
                        }
                        var value = item.value;
                        return typeof value === 'string' ? value : JSON.stringify(value);
                    }
                    exports['default'] = {
                        save: function save(name, value, expires) {
                            var callback = arguments[arguments.length - 1];
                            var addonKey = addonKeyFromCallback(callback);
                            if (callback._context) saveLocalStorage(addonKey, name, value, expires);
                        },
                        read: function read(name, callback) {
                            callback = arguments[arguments.length - 1];
                            var lsValue = readLocalStorage(addonKeyFromCallback(callback), name);
                            if (lsValue !== undefined) {
                                callback(lsValue);
                                return lsValue;
                            }
                            var cookieName = prefixCookie(addonKeyFromCallback(callback), encodePipesAndPercents(name));
                            var value = decodePipesAndPercents(_read(cookieName));
                            callback(value);
                            return value;
                        },
                        erase: function erase(name) {
                            var callback = arguments[arguments.length - 1];
                            var cookieName = prefixCookie(addonKeyFromCallback(callback), encodePipesAndPercents(name));
                            _erase(cookieName);
                            localStorage.removeItem(prefixLocalStorage(addonKeyFromCallback(callback), name));
                        }
                    };
                    module1.exports = exports['default'];
                },
                {}
            ]
        }, {}, [
            1
        ])(1);
    });
});
parcelRegister("fH7hc", function(module, exports) {
    (function(f) {
        var g;
        module.exports = f();
    })(function() {
        var define, module1, exports;
        return (function e(t, n, r) {
            function s(o, u) {
                if (!n[o]) {
                    if (!t[o]) {
                        var a = undefined;
                        if (!u && a) return a(o, !0);
                        if (i) return i(o, !0);
                        var f = new Error("Cannot find module '" + o + "'");
                        throw f.code = "MODULE_NOT_FOUND", f;
                    }
                    var l = n[o] = {
                        exports: {}
                    };
                    t[o][0].call(l.exports, function(e) {
                        var n = t[o][1][e];
                        return s(n ? n : e);
                    }, l, l.exports, e, t, n, r);
                }
                return n[o].exports;
            }
            var i = undefined;
            for(var o = 0; o < r.length; o++)s(r[o]);
            return s;
        })({
            1: [
                function(_dereq_, module1, exports) {
                    'use strict';
                    Object.defineProperty(exports, '__esModule', {
                        value: true
                    });
                    var _constants = _dereq_('./constants');
                    var _models = _dereq_('./models');
                    var _utils = _dereq_('./utils');
                    function broadcastEvents(eventName, evt) {
                        (0, _utils.callConnectHost)(function(ch) {
                            var extensions = (0, _utils.values)(ch.getExtensions());
                            extensions.forEach(function(ext) {
                                var addonKey = ext.extension.addon_key;
                                var current = new _models.Current({
                                    url: window.location.href,
                                    state: evt.state
                                });
                                var route = new _models.Route(current);
                                ch.broadcastEvent(eventName, {
                                    addon_key: addonKey
                                }, route.render(addonKey));
                            });
                        });
                    }
                    var registeredWindowListeners = false;
                    function registerWindowListeners() {
                        if (registeredWindowListeners) return;
                        window.addEventListener('popstate', function(e) {
                            var evt = (0, _utils.createEvent)('ap_popstate');
                            evt.state = (0, _utils.unwrapState)(e.state);
                            window.dispatchEvent(evt);
                        });
                        window.addEventListener('ap_popstate', function(e) {
                            var evt = (0, _utils.createEvent)('ap_changestate');
                            evt.state = e.state;
                            window.dispatchEvent(evt);
                            broadcastEvents(_constants.HISTORY_POPSTATE, e);
                        });
                        window.addEventListener('ap_pushstate', function(e) {
                            var evt = (0, _utils.createEvent)('ap_changestate');
                            evt.state = e.state;
                            window.dispatchEvent(evt);
                            broadcastEvents(_constants.HISTORY_PUSHSTATE, e);
                        });
                        window.addEventListener('ap_replacestate', function(e) {
                            var evt = (0, _utils.createEvent)('ap_changestate');
                            evt.state = e.state;
                            window.dispatchEvent(evt);
                            broadcastEvents(_constants.HISTORY_REPLACESTATE, e);
                        });
                        window.addEventListener('ap_changestate', function(e) {
                            broadcastEvents(_constants.HISTORY_CHANGESTATE, e);
                        });
                        registeredWindowListeners = true;
                    }
                    function _pushState(route) {
                        var renderedState = route.state.render();
                        var renderedURL = route.url.render();
                        window.history.pushState((0, _utils.wrapState)(renderedState), renderedURL.title, renderedURL.url);
                    }
                    function _replaceState(route) {
                        var renderedState = route.state.render();
                        var renderedURL = route.url.render();
                        window.history.replaceState((0, _utils.wrapState)(renderedState), renderedURL.title, renderedURL.url);
                    }
                    exports['default'] = {
                        _registerWindowListeners: function _registerWindowListeners() {
                            registerWindowListeners();
                        },
                        back: function back(callback) {
                            callback = arguments[arguments.length - 1];
                            this.go(-1, callback);
                        },
                        forward: function forward(callback) {
                            callback = arguments[arguments.length - 1];
                            this.go(1, callback);
                        },
                        go: function go(delta) {
                            var callback = arguments[arguments.length - 1];
                            if (callback._context.extension.options.isFullPage) window.history.go(delta);
                            else (0, _utils.log)("History is only available to page modules");
                        },
                        getState: function getState(type, callback) {
                            callback = arguments[arguments.length - 1];
                            var addonKey = callback._context.extension.addon_key;
                            var current = new _models.Current({
                                url: window.location.href,
                                state: (0, _utils.unwrapState)(window.history.state)
                            });
                            var route = new _models.Route(current);
                            var rendered = route.render(addonKey);
                            type = type ? typeof type === 'string' ? type : 'hash' : 'hash';
                            if (type === 'hash') callback(rendered.hash);
                            else if (type === 'all') callback(rendered);
                            else throw new Error('invalid type for getState');
                        },
                        pushState: function pushState(newState, callback) {
                            callback = arguments[arguments.length - 1];
                            var addonKey = callback._context.extension.addon_key;
                            var current = new _models.Current({
                                url: window.location.href,
                                state: (0, _utils.unwrapState)(window.history.state)
                            });
                            var currentRoute = new _models.Route(current);
                            var change = new _models.Change(newState, addonKey);
                            var changeRoute = new _models.Route(change);
                            if (callback._context.extension.options.isFullPage) {
                                if (changeRoute.url.isURLEqual(currentRoute.url)) {
                                    currentRoute.merge(changeRoute);
                                    _replaceState(currentRoute);
                                } else if (changeRoute.url.isPathnameEqual(currentRoute.url)) {
                                    currentRoute.merge(changeRoute);
                                    _pushState(currentRoute);
                                } else _pushState(changeRoute);
                                var _event = (0, _utils.createEvent)('ap_pushstate');
                                _event.state = (0, _utils.unwrapState)(window.history.state);
                                window.dispatchEvent(_event);
                            } else (0, _utils.log)('History is only available to page modules');
                        },
                        replaceState: function replaceState(newState, callback) {
                            callback = arguments[arguments.length - 1];
                            var addonKey = callback._context.extension.addon_key;
                            var current = new _models.Current({
                                url: window.location.href,
                                state: (0, _utils.unwrapState)(window.history.state)
                            });
                            var currentRoute = new _models.Route(current);
                            var change = new _models.Change(newState, addonKey);
                            var changeRoute = new _models.Route(change);
                            if (callback._context.extension.options.isFullPage) {
                                if (changeRoute.url.isURLEqual(currentRoute.url)) {
                                    currentRoute.merge(changeRoute);
                                    _replaceState(currentRoute);
                                } else if (changeRoute.url.isPathnameEqual(currentRoute.url)) {
                                    currentRoute.merge(changeRoute);
                                    _replaceState(currentRoute);
                                } else _replaceState(changeRoute);
                                var _event2 = (0, _utils.createEvent)('ap_replacestate');
                                _event2.state = (0, _utils.unwrapState)(window.history.state);
                                window.dispatchEvent(_event2);
                            } else (0, _utils.log)('History is only available to page modules');
                        }
                    };
                    module1.exports = exports['default'];
                },
                {
                    "./constants": 7,
                    "./models": 8,
                    "./utils": 9
                }
            ],
            2: [
                function(_dereq_, module1, exports) {
                    (function(global1) {
                        (function(root) {
                            var freeExports = typeof exports == 'object' && exports;
                            var freeModule = typeof module1 == 'object' && module1 && module1.exports == freeExports && module1;
                            var freeGlobal = typeof global1 == 'object' && global1;
                            if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) root = freeGlobal;
                            var punycode, maxInt = 2147483647, base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = '-', regexPunycode = /^xn--/, regexNonASCII = /[^ -~]/, regexSeparators = /\x2E|\u3002|\uFF0E|\uFF61/g, errors = {
                                'overflow': 'Overflow: input needs wider integers to process',
                                'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
                                'invalid-input': 'Invalid input'
                            }, baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, key;
                            function error(type) {
                                throw RangeError(errors[type]);
                            }
                            function map(array, fn) {
                                var length = array.length;
                                while(length--)array[length] = fn(array[length]);
                                return array;
                            }
                            function mapDomain(string, fn) {
                                return map(string.split(regexSeparators), fn).join('.');
                            }
                            function ucs2decode(string) {
                                var output = [], counter = 0, length = string.length, value, extra;
                                while(counter < length){
                                    value = string.charCodeAt(counter++);
                                    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                                        extra = string.charCodeAt(counter++);
                                        if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                                        else {
                                            output.push(value);
                                            counter--;
                                        }
                                    } else output.push(value);
                                }
                                return output;
                            }
                            function ucs2encode(array) {
                                return map(array, function(value) {
                                    var output = '';
                                    if (value > 0xFFFF) {
                                        value -= 0x10000;
                                        output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                                        value = 0xDC00 | value & 0x3FF;
                                    }
                                    output += stringFromCharCode(value);
                                    return output;
                                }).join('');
                            }
                            function basicToDigit(codePoint) {
                                if (codePoint - 48 < 10) return codePoint - 22;
                                if (codePoint - 65 < 26) return codePoint - 65;
                                if (codePoint - 97 < 26) return codePoint - 97;
                                return base;
                            }
                            function digitToBasic(digit, flag) {
                                return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
                            }
                            function adapt(delta, numPoints, firstTime) {
                                var k = 0;
                                delta = firstTime ? floor(delta / damp) : delta >> 1;
                                delta += floor(delta / numPoints);
                                for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
                                return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
                            }
                            function decode(input) {
                                var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, baseMinusT;
                                basic = input.lastIndexOf(delimiter);
                                if (basic < 0) basic = 0;
                                for(j = 0; j < basic; ++j){
                                    if (input.charCodeAt(j) >= 0x80) error('not-basic');
                                    output.push(input.charCodeAt(j));
                                }
                                for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
                                    for(oldi = i, w = 1, k = base;; k += base){
                                        if (index >= inputLength) error('invalid-input');
                                        digit = basicToDigit(input.charCodeAt(index++));
                                        if (digit >= base || digit > floor((maxInt - i) / w)) error('overflow');
                                        i += digit * w;
                                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                                        if (digit < t) break;
                                        baseMinusT = base - t;
                                        if (w > floor(maxInt / baseMinusT)) error('overflow');
                                        w *= baseMinusT;
                                    }
                                    out = output.length + 1;
                                    bias = adapt(i - oldi, out, oldi == 0);
                                    if (floor(i / out) > maxInt - n) error('overflow');
                                    n += floor(i / out);
                                    i %= out;
                                    output.splice(i++, 0, n);
                                }
                                return ucs2encode(output);
                            }
                            function encode(input) {
                                var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], inputLength, handledCPCountPlusOne, baseMinusT, qMinusT;
                                input = ucs2decode(input);
                                inputLength = input.length;
                                n = initialN;
                                delta = 0;
                                bias = initialBias;
                                for(j = 0; j < inputLength; ++j){
                                    currentValue = input[j];
                                    if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
                                }
                                handledCPCount = basicLength = output.length;
                                if (basicLength) output.push(delimiter);
                                while(handledCPCount < inputLength){
                                    for(m = maxInt, j = 0; j < inputLength; ++j){
                                        currentValue = input[j];
                                        if (currentValue >= n && currentValue < m) m = currentValue;
                                    }
                                    handledCPCountPlusOne = handledCPCount + 1;
                                    if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error('overflow');
                                    delta += (m - n) * handledCPCountPlusOne;
                                    n = m;
                                    for(j = 0; j < inputLength; ++j){
                                        currentValue = input[j];
                                        if (currentValue < n && ++delta > maxInt) error('overflow');
                                        if (currentValue == n) {
                                            for(q = delta, k = base;; k += base){
                                                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                                                if (q < t) break;
                                                qMinusT = q - t;
                                                baseMinusT = base - t;
                                                output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                                                q = floor(qMinusT / baseMinusT);
                                            }
                                            output.push(stringFromCharCode(digitToBasic(q, 0)));
                                            bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                                            delta = 0;
                                            ++handledCPCount;
                                        }
                                    }
                                    ++delta;
                                    ++n;
                                }
                                return output.join('');
                            }
                            function toUnicode(domain) {
                                return mapDomain(domain, function(string) {
                                    return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
                                });
                            }
                            function toASCII(domain) {
                                return mapDomain(domain, function(string) {
                                    return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
                                });
                            }
                            punycode = {
                                'version': '1.2.4',
                                'ucs2': {
                                    'decode': ucs2decode,
                                    'encode': ucs2encode
                                },
                                'decode': decode,
                                'encode': encode,
                                'toASCII': toASCII,
                                'toUnicode': toUnicode
                            };
                            if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define('punycode', function() {
                                return punycode;
                            });
                            else if (freeExports && !freeExports.nodeType) {
                                if (freeModule) freeModule.exports = punycode;
                                else for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
                            } else root.punycode = punycode;
                        })(this);
                    }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
                },
                {}
            ],
            3: [
                function(_dereq_, module1, exports) {
                    var punycode = _dereq_('punycode');
                    exports.parse = urlParse;
                    exports.resolve = urlResolve;
                    exports.resolveObject = urlResolveObject;
                    exports.format = urlFormat;
                    exports.Url = Url;
                    function Url() {
                        this.protocol = null;
                        this.slashes = null;
                        this.auth = null;
                        this.host = null;
                        this.port = null;
                        this.hostname = null;
                        this.hash = null;
                        this.search = null;
                        this.query = null;
                        this.pathname = null;
                        this.path = null;
                        this.href = null;
                    }
                    var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, delims = [
                        '<',
                        '>',
                        '"',
                        '`',
                        ' ',
                        '\r',
                        '\n',
                        '\t'
                    ], unwise = [
                        '{',
                        '}',
                        '|',
                        '\\',
                        '^',
                        '`'
                    ].concat(delims), autoEscape = [
                        '\''
                    ].concat(unwise), nonHostChars = [
                        '%',
                        '/',
                        '?',
                        ';',
                        '#'
                    ].concat(autoEscape), hostEndingChars = [
                        '/',
                        '?',
                        '#'
                    ], hostnameMaxLen = 255, hostnamePartPattern = /^[a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([a-z0-9A-Z_-]{0,63})(.*)$/, unsafeProtocol = {
                        'javascript': true,
                        'javascript:': true
                    }, hostlessProtocol = {
                        'javascript': true,
                        'javascript:': true
                    }, slashedProtocol = {
                        'http': true,
                        'https': true,
                        'ftp': true,
                        'gopher': true,
                        'file': true,
                        'http:': true,
                        'https:': true,
                        'ftp:': true,
                        'gopher:': true,
                        'file:': true
                    }, querystring = _dereq_('querystring');
                    function urlParse(url, parseQueryString, slashesDenoteHost) {
                        if (url && isObject(url) && url instanceof Url) return url;
                        var u = new Url;
                        u.parse(url, parseQueryString, slashesDenoteHost);
                        return u;
                    }
                    Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
                        if (!isString(url)) throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
                        var rest = url;
                        rest = rest.trim();
                        var proto = protocolPattern.exec(rest);
                        if (proto) {
                            proto = proto[0];
                            var lowerProto = proto.toLowerCase();
                            this.protocol = lowerProto;
                            rest = rest.substr(proto.length);
                        }
                        if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
                            var slashes = rest.substr(0, 2) === '//';
                            if (slashes && !(proto && hostlessProtocol[proto])) {
                                rest = rest.substr(2);
                                this.slashes = true;
                            }
                        }
                        if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
                            var hostEnd = -1;
                            for(var i = 0; i < hostEndingChars.length; i++){
                                var hec = rest.indexOf(hostEndingChars[i]);
                                if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
                            }
                            var auth, atSign;
                            if (hostEnd === -1) atSign = rest.lastIndexOf('@');
                            else atSign = rest.lastIndexOf('@', hostEnd);
                            if (atSign !== -1) {
                                auth = rest.slice(0, atSign);
                                rest = rest.slice(atSign + 1);
                                this.auth = decodeURIComponent(auth);
                            }
                            hostEnd = -1;
                            for(var i = 0; i < nonHostChars.length; i++){
                                var hec = rest.indexOf(nonHostChars[i]);
                                if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
                            }
                            if (hostEnd === -1) hostEnd = rest.length;
                            this.host = rest.slice(0, hostEnd);
                            rest = rest.slice(hostEnd);
                            this.parseHost();
                            this.hostname = this.hostname || '';
                            var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
                            if (!ipv6Hostname) {
                                var hostparts = this.hostname.split(/\./);
                                for(var i = 0, l = hostparts.length; i < l; i++){
                                    var part = hostparts[i];
                                    if (!part) continue;
                                    if (!part.match(hostnamePartPattern)) {
                                        var newpart = '';
                                        for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) newpart += 'x';
                                        else newpart += part[j];
                                        if (!newpart.match(hostnamePartPattern)) {
                                            var validParts = hostparts.slice(0, i);
                                            var notHost = hostparts.slice(i + 1);
                                            var bit = part.match(hostnamePartStart);
                                            if (bit) {
                                                validParts.push(bit[1]);
                                                notHost.unshift(bit[2]);
                                            }
                                            if (notHost.length) rest = '/' + notHost.join('.') + rest;
                                            this.hostname = validParts.join('.');
                                            break;
                                        }
                                    }
                                }
                            }
                            if (this.hostname.length > hostnameMaxLen) this.hostname = '';
                            else this.hostname = this.hostname.toLowerCase();
                            if (!ipv6Hostname) {
                                var domainArray = this.hostname.split('.');
                                var newOut = [];
                                for(var i = 0; i < domainArray.length; ++i){
                                    var s = domainArray[i];
                                    newOut.push(s.match(/[^A-Za-z0-9_-]/) ? 'xn--' + punycode.encode(s) : s);
                                }
                                this.hostname = newOut.join('.');
                            }
                            var p = this.port ? ':' + this.port : '';
                            var h = this.hostname || '';
                            this.host = h + p;
                            this.href += this.host;
                            if (ipv6Hostname) {
                                this.hostname = this.hostname.substr(1, this.hostname.length - 2);
                                if (rest[0] !== '/') rest = '/' + rest;
                            }
                        }
                        if (!unsafeProtocol[lowerProto]) for(var i = 0, l = autoEscape.length; i < l; i++){
                            var ae = autoEscape[i];
                            var esc = encodeURIComponent(ae);
                            if (esc === ae) esc = escape(ae);
                            rest = rest.split(ae).join(esc);
                        }
                        var hash = rest.indexOf('#');
                        if (hash !== -1) {
                            this.hash = rest.substr(hash);
                            rest = rest.slice(0, hash);
                        }
                        var qm = rest.indexOf('?');
                        if (qm !== -1) {
                            this.search = rest.substr(qm);
                            this.query = rest.substr(qm + 1);
                            if (parseQueryString) this.query = querystring.parse(this.query);
                            rest = rest.slice(0, qm);
                        } else if (parseQueryString) {
                            this.search = '';
                            this.query = {};
                        }
                        if (rest) this.pathname = rest;
                        if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '/';
                        if (this.pathname || this.search) {
                            var p = this.pathname || '';
                            var s = this.search || '';
                            this.path = p + s;
                        }
                        this.href = this.format();
                        return this;
                    };
                    function urlFormat(obj) {
                        if (isString(obj)) obj = urlParse(obj);
                        if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
                        return obj.format();
                    }
                    Url.prototype.format = function() {
                        var auth = this.auth || '';
                        if (auth) {
                            auth = encodeURIComponent(auth);
                            auth = auth.replace(/%3A/i, ':');
                            auth += '@';
                        }
                        var protocol = this.protocol || '', pathname = this.pathname || '', hash = this.hash || '', host = false, query = '';
                        if (this.host) host = auth + this.host;
                        else if (this.hostname) {
                            host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
                            if (this.port) host += ':' + this.port;
                        }
                        if (this.query && isObject(this.query) && Object.keys(this.query).length) query = querystring.stringify(this.query);
                        var search = this.search || query && '?' + query || '';
                        if (protocol && protocol.substr(-1) !== ':') protocol += ':';
                        if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
                            host = '//' + (host || '');
                            if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
                        } else if (!host) host = '';
                        if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
                        if (search && search.charAt(0) !== '?') search = '?' + search;
                        pathname = pathname.replace(/[?#]/g, function(match) {
                            return encodeURIComponent(match);
                        });
                        search = search.replace('#', '%23');
                        return protocol + host + pathname + search + hash;
                    };
                    function urlResolve(source, relative) {
                        return urlParse(source, false, true).resolve(relative);
                    }
                    Url.prototype.resolve = function(relative) {
                        return this.resolveObject(urlParse(relative, false, true)).format();
                    };
                    function urlResolveObject(source, relative) {
                        if (!source) return relative;
                        return urlParse(source, false, true).resolveObject(relative);
                    }
                    Url.prototype.resolveObject = function(relative) {
                        if (isString(relative)) {
                            var rel = new Url();
                            rel.parse(relative, false, true);
                            relative = rel;
                        }
                        var result = new Url();
                        Object.keys(this).forEach(function(k) {
                            result[k] = this[k];
                        }, this);
                        result.hash = relative.hash;
                        if (relative.href === '') {
                            result.href = result.format();
                            return result;
                        }
                        if (relative.slashes && !relative.protocol) {
                            Object.keys(relative).forEach(function(k) {
                                if (k !== 'protocol') result[k] = relative[k];
                            });
                            if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) result.path = result.pathname = '/';
                            result.href = result.format();
                            return result;
                        }
                        if (relative.protocol && relative.protocol !== result.protocol) {
                            if (!slashedProtocol[relative.protocol]) {
                                Object.keys(relative).forEach(function(k) {
                                    result[k] = relative[k];
                                });
                                result.href = result.format();
                                return result;
                            }
                            result.protocol = relative.protocol;
                            if (!relative.host && !hostlessProtocol[relative.protocol]) {
                                var relPath = (relative.pathname || '').split('/');
                                while(relPath.length && !(relative.host = relPath.shift()));
                                if (!relative.host) relative.host = '';
                                if (!relative.hostname) relative.hostname = '';
                                if (relPath[0] !== '') relPath.unshift('');
                                if (relPath.length < 2) relPath.unshift('');
                                result.pathname = relPath.join('/');
                            } else result.pathname = relative.pathname;
                            result.search = relative.search;
                            result.query = relative.query;
                            result.host = relative.host || '';
                            result.auth = relative.auth;
                            result.hostname = relative.hostname || relative.host;
                            result.port = relative.port;
                            if (result.pathname || result.search) {
                                var p = result.pathname || '';
                                var s = result.search || '';
                                result.path = p + s;
                            }
                            result.slashes = result.slashes || relative.slashes;
                            result.href = result.format();
                            return result;
                        }
                        var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/', isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/', mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split('/') || [], relPath = relative.pathname && relative.pathname.split('/') || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
                        if (psychotic) {
                            result.hostname = '';
                            result.port = null;
                            if (result.host) {
                                if (srcPath[0] === '') srcPath[0] = result.host;
                                else srcPath.unshift(result.host);
                            }
                            result.host = '';
                            if (relative.protocol) {
                                relative.hostname = null;
                                relative.port = null;
                                if (relative.host) {
                                    if (relPath[0] === '') relPath[0] = relative.host;
                                    else relPath.unshift(relative.host);
                                }
                                relative.host = null;
                            }
                            mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
                        }
                        if (isRelAbs) {
                            result.host = relative.host || relative.host === '' ? relative.host : result.host;
                            result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
                            result.search = relative.search;
                            result.query = relative.query;
                            srcPath = relPath;
                        } else if (relPath.length) {
                            if (!srcPath) srcPath = [];
                            srcPath.pop();
                            srcPath = srcPath.concat(relPath);
                            result.search = relative.search;
                            result.query = relative.query;
                        } else if (!isNullOrUndefined(relative.search)) {
                            if (psychotic) {
                                result.hostname = result.host = srcPath.shift();
                                var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
                                if (authInHost) {
                                    result.auth = authInHost.shift();
                                    result.host = result.hostname = authInHost.shift();
                                }
                            }
                            result.search = relative.search;
                            result.query = relative.query;
                            if (!isNull(result.pathname) || !isNull(result.search)) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
                            result.href = result.format();
                            return result;
                        }
                        if (!srcPath.length) {
                            result.pathname = null;
                            if (result.search) result.path = '/' + result.search;
                            else result.path = null;
                            result.href = result.format();
                            return result;
                        }
                        var last = srcPath.slice(-1)[0];
                        var hasTrailingSlash = (result.host || relative.host) && (last === '.' || last === '..') || last === '';
                        var up = 0;
                        for(var i = srcPath.length; i >= 0; i--){
                            last = srcPath[i];
                            if (last == '.') srcPath.splice(i, 1);
                            else if (last === '..') {
                                srcPath.splice(i, 1);
                                up++;
                            } else if (up) {
                                srcPath.splice(i, 1);
                                up--;
                            }
                        }
                        if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift('..');
                        if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) srcPath.unshift('');
                        if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') srcPath.push('');
                        var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';
                        if (psychotic) {
                            result.hostname = result.host = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
                            var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
                            if (authInHost) {
                                result.auth = authInHost.shift();
                                result.host = result.hostname = authInHost.shift();
                            }
                        }
                        mustEndAbs = mustEndAbs || result.host && srcPath.length;
                        if (mustEndAbs && !isAbsolute) srcPath.unshift('');
                        if (!srcPath.length) {
                            result.pathname = null;
                            result.path = null;
                        } else result.pathname = srcPath.join('/');
                        if (!isNull(result.pathname) || !isNull(result.search)) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
                        result.auth = relative.auth || result.auth;
                        result.slashes = result.slashes || relative.slashes;
                        result.href = result.format();
                        return result;
                    };
                    Url.prototype.parseHost = function() {
                        var host = this.host;
                        var port = portPattern.exec(host);
                        if (port) {
                            port = port[0];
                            if (port !== ':') this.port = port.substr(1);
                            host = host.substr(0, host.length - port.length);
                        }
                        if (host) this.hostname = host;
                    };
                    function isString(arg) {
                        return typeof arg === "string";
                    }
                    function isObject(arg) {
                        return typeof arg === 'object' && arg !== null;
                    }
                    function isNull(arg) {
                        return arg === null;
                    }
                    function isNullOrUndefined(arg) {
                        return arg == null;
                    }
                },
                {
                    "punycode": 2,
                    "querystring": 6
                }
            ],
            4: [
                function(_dereq_, module1, exports) {
                    'use strict';
                    function hasOwnProperty(obj, prop) {
                        return Object.prototype.hasOwnProperty.call(obj, prop);
                    }
                    module1.exports = function(qs, sep, eq, options) {
                        sep = sep || '&';
                        eq = eq || '=';
                        var obj = {};
                        if (typeof qs !== 'string' || qs.length === 0) return obj;
                        var regexp = /\+/g;
                        qs = qs.split(sep);
                        var maxKeys = 1000;
                        if (options && typeof options.maxKeys === 'number') maxKeys = options.maxKeys;
                        var len = qs.length;
                        if (maxKeys > 0 && len > maxKeys) len = maxKeys;
                        for(var i = 0; i < len; ++i){
                            var x = qs[i].replace(regexp, '%20'), idx = x.indexOf(eq), kstr, vstr, k, v;
                            if (idx >= 0) {
                                kstr = x.substr(0, idx);
                                vstr = x.substr(idx + 1);
                            } else {
                                kstr = x;
                                vstr = '';
                            }
                            k = decodeURIComponent(kstr);
                            v = decodeURIComponent(vstr);
                            if (!hasOwnProperty(obj, k)) obj[k] = v;
                            else if (isArray(obj[k])) obj[k].push(v);
                            else obj[k] = [
                                obj[k],
                                v
                            ];
                        }
                        return obj;
                    };
                    var isArray = Array.isArray || function(xs) {
                        return Object.prototype.toString.call(xs) === '[object Array]';
                    };
                },
                {}
            ],
            5: [
                function(_dereq_, module1, exports) {
                    'use strict';
                    var stringifyPrimitive = function(v) {
                        switch(typeof v){
                            case 'string':
                                return v;
                            case 'boolean':
                                return v ? 'true' : 'false';
                            case 'number':
                                return isFinite(v) ? v : '';
                            default:
                                return '';
                        }
                    };
                    module1.exports = function(obj, sep, eq, name) {
                        sep = sep || '&';
                        eq = eq || '=';
                        if (obj === null) obj = undefined;
                        if (typeof obj === 'object') return map(objectKeys(obj), function(k) {
                            var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
                            if (isArray(obj[k])) return map(obj[k], function(v) {
                                return ks + encodeURIComponent(stringifyPrimitive(v));
                            }).join(sep);
                            else return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
                        }).join(sep);
                        if (!name) return '';
                        return encodeURIComponent(stringifyPrimitive(name)) + eq + encodeURIComponent(stringifyPrimitive(obj));
                    };
                    var isArray = Array.isArray || function(xs) {
                        return Object.prototype.toString.call(xs) === '[object Array]';
                    };
                    function map(xs, f) {
                        if (xs.map) return xs.map(f);
                        var res = [];
                        for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
                        return res;
                    }
                    var objectKeys = Object.keys || function(obj) {
                        var res = [];
                        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
                        return res;
                    };
                },
                {}
            ],
            6: [
                function(_dereq_, module1, exports) {
                    'use strict';
                    exports.decode = exports.parse = _dereq_('./decode');
                    exports.encode = exports.stringify = _dereq_('./encode');
                },
                {
                    "./decode": 4,
                    "./encode": 5
                }
            ],
            7: [
                function(_dereq_, module1, exports) {
                    'use strict';
                    Object.defineProperty(exports, '__esModule', {
                        value: true
                    });
                    var STATE_AP_KEY = '_AP';
                    exports.STATE_AP_KEY = STATE_AP_KEY;
                    var QUERY_KEY_PREFIX = 'ac';
                    exports.QUERY_KEY_PREFIX = QUERY_KEY_PREFIX;
                    var QUERY_KEY_DELIMITER = '.';
                    exports.QUERY_KEY_DELIMITER = QUERY_KEY_DELIMITER;
                    var ANCHOR_PREFIX = "!";
                    exports.ANCHOR_PREFIX = ANCHOR_PREFIX;
                    var HISTORY_POPSTATE = 'history_popstate';
                    exports.HISTORY_POPSTATE = HISTORY_POPSTATE;
                    var HISTORY_PUSHSTATE = 'history_pushstate';
                    exports.HISTORY_PUSHSTATE = HISTORY_PUSHSTATE;
                    var HISTORY_REPLACESTATE = 'history_replacestate';
                    exports.HISTORY_REPLACESTATE = HISTORY_REPLACESTATE;
                    var HISTORY_CHANGESTATE = 'history_changestate';
                    exports.HISTORY_CHANGESTATE = HISTORY_CHANGESTATE;
                },
                {}
            ],
            8: [
                function(_dereq_, module1, exports) {
                    'use strict';
                    Object.defineProperty(exports, '__esModule', {
                        value: true
                    });
                    exports.Addon = Addon;
                    exports.Addons = Addons;
                    exports.Current = Current;
                    exports.Change = Change;
                    exports.State = State;
                    exports.URL = URL;
                    exports.Route = Route;
                    function _interopRequireDefault(obj) {
                        return obj && obj.__esModule ? obj : {
                            'default': obj
                        };
                    }
                    var _url = _dereq_('url');
                    var _url2 = _interopRequireDefault(_url);
                    var _utils = _dereq_('./utils');
                    function Addon(opts) {
                        opts = opts || {};
                        if (!opts.key) throw new Error('missing key for addon');
                        this.key = opts.key;
                        this.state = opts.state;
                        this.query = opts.query || {};
                        return this;
                    }
                    function Addons(opts) {
                        opts = opts || {};
                        opts.models = opts.models || [];
                        if (!(opts.models instanceof Array)) opts.models = [
                            opts.models
                        ];
                        opts.models = opts.models.map(function(model) {
                            if (model instanceof Addon) return model;
                            else return new Addon(model);
                        });
                        this.models = opts.models;
                        return this;
                    }
                    Addons.prototype.add = function(addon) {
                        this.models.push(addon);
                    };
                    Addons.prototype.remove = function(addon) {
                        this.models.splice(this.models.indexOf(addon), 1);
                    };
                    Addons.prototype.find = function(key) {
                        return (0, _utils.find)(this.models, function(addon) {
                            return addon.key === key;
                        });
                    };
                    Addons.prototype.merge = function(addon) {
                        var found = this.find(addon.key);
                        if (found) this.remove(found);
                        this.add(addon);
                    };
                    function Current(opts) {
                        opts = opts || {};
                        if (!opts.url) throw new Error('missing url');
                        var parsed = _url2['default'].parse(opts.url);
                        var addons = new Addons();
                        var queryArr = (0, _utils.parseQuery)(parsed.query).map(_utils.stripAddonQueryPrefix);
                        var normalizedQueryAddons = (0, _utils.normalizeQueryByAddons)(queryArr);
                        var queryAddons = normalizedQueryAddons.filter(function(item) {
                            return item.key;
                        });
                        var queryGlobal = normalizedQueryAddons.filter(function(item) {
                            return !item.key;
                        });
                        queryAddons.forEach(function(item) {
                            var created = new Addon(item);
                            addons.add(created);
                        });
                        this.url = new URL({
                            url: opts.url,
                            addons: addons,
                            global: queryGlobal
                        });
                        this.state = new State(opts.state);
                        return this;
                    }
                    function Change(opts, addonKey) {
                        var type = typeof opts;
                        var defaults = _url2['default'].parse(window.location.href);
                        var urlObject = {};
                        var options = {};
                        if (type === 'string') {
                            urlObject.protocol = defaults.protocol;
                            urlObject.slashes = defaults.slashes;
                            urlObject.hostname = defaults.hostname;
                            urlObject.pathname = defaults.pathname;
                            urlObject.port = defaults.port;
                            urlObject.search = defaults.search;
                            urlObject.query = defaults.query;
                            urlObject.hash = (0, _utils.addHash)((0, _utils.addHashPrefix)(opts));
                        } else if (type === 'object') {
                            var parsed = opts.href ? _url2['default'].parse(opts.href) : defaults;
                            urlObject.protocol = defaults.protocol;
                            urlObject.slashes = defaults.slashes;
                            urlObject.hostname = defaults.hostname;
                            urlObject.port = defaults.port;
                            urlObject.pathname = parsed.pathname || defaults.pathname;
                            urlObject.search = null;
                            urlObject.query = null;
                            urlObject.hash = opts.hash ? (0, _utils.addHash)((0, _utils.addHashPrefix)(opts.hash)) : null;
                            options.state = opts.state;
                            options.query = opts.query;
                        } else throw new Error('invalid option type');
                        var addonsState = new Addons();
                        var addonsURL = new Addons();
                        if (options.state) {
                            var addonState = new Addon({
                                key: addonKey,
                                state: options.state
                            });
                            addonsState.add(addonState);
                        }
                        if (options.query) {
                            var addonURL = new Addon({
                                key: addonKey,
                                query: options.query
                            });
                            addonsURL.add(addonURL);
                        }
                        var changeState = new State({
                            addons: addonsState
                        });
                        var changeURL = new URL({
                            url: _url2['default'].format(urlObject),
                            addons: addonsURL
                        });
                        this.state = changeState;
                        this.url = changeURL;
                        return this;
                    }
                    function State(opts) {
                        opts = opts || {};
                        opts.addons = opts.addons || [];
                        if (!(opts.addons instanceof Addons)) opts.addons = new Addons(opts.addons);
                        this.addons = opts.addons;
                        return this;
                    }
                    State.prototype.merge = function(instance) {
                        var self1 = this;
                        instance.addons.models.forEach(function(addon) {
                            self1.addons.merge(addon);
                        });
                    };
                    State.prototype.render = function() {
                        return (0, _utils.deepCopy)(this);
                    };
                    function URL(opts) {
                        opts = opts || {};
                        opts.addons = opts.addons || [];
                        opts.global = opts.global || [];
                        if (!(opts.parsed instanceof _url2['default'].Url)) opts.parsed = _url2['default'].parse(opts.url);
                        if (!(opts.addons instanceof Addons)) opts.addons = new Addons(opts.addons);
                        this.parsed = opts.parsed;
                        this.addons = opts.addons;
                        this.global = opts.global;
                        this.title = opts.title || window.document.title;
                    }
                    URL.prototype.isURLEqual = function(instance) {
                        return this.render().url === instance.render().url;
                    };
                    URL.prototype.isPathnameEqual = function(instance) {
                        var protocolEqual = this.parsed.protocol === instance.parsed.protocol;
                        var slashesEqual = this.parsed.slashes === instance.parsed.slashes;
                        var hostnameEqual = this.parsed.hostname === instance.parsed.hostname;
                        var pathnameEqual = this.parsed.pathname === instance.parsed.pathname;
                        return protocolEqual && slashesEqual && hostnameEqual && pathnameEqual;
                    };
                    URL.prototype.merge = function(instance) {
                        var self1 = this;
                        self1.parsed.hash = instance.parsed.hash;
                        instance.addons.models.forEach(function(addon) {
                            self1.addons.merge(addon);
                        });
                    };
                    URL.prototype.render = function() {
                        var deep = (0, _utils.deepCopy)(this);
                        var urlObj = deep.parsed;
                        var addonsDenormalizedQueryAddons = (0, _utils.denormalizeQueryByAddons)(this.addons.models);
                        var globalDenormalizedQueryAddons = (0, _utils.denormalizeQueryByAddons)(this.global);
                        var allQueryParams = addonsDenormalizedQueryAddons.concat(globalDenormalizedQueryAddons);
                        var prefixedQueryArr = allQueryParams.map(_utils.addAddonQueryPrefix);
                        var formattedQuery = (0, _utils.formatQuery)(prefixedQueryArr);
                        urlObj.query = formattedQuery;
                        urlObj.search = urlObj.query ? '?' + urlObj.query : null;
                        deep.url = _url2['default'].format(urlObj);
                        return deep;
                    };
                    function Route(opts) {
                        opts = opts || {};
                        if (!opts.url) throw new Error('missing url option');
                        if (!(opts.url instanceof URL)) opts.url = new URL(opts.url);
                        if (!opts.state) throw new Error('missing state option');
                        if (!(opts.state instanceof State)) opts.state = new State(opts.state);
                        this.url = opts.url;
                        this.state = opts.state;
                    }
                    Route.prototype.merge = function(route) {
                        this.url.merge(route.url);
                        this.state.merge(route.state);
                    };
                    Route.prototype.render = function(addonKey) {
                        return (0, _utils.deepCopy)({
                            key: addonKey,
                            hash: (0, _utils.stripHashPrefix)((0, _utils.stripHash)(this.url.parsed.hash)),
                            query: this.url.addons.find(addonKey) ? this.url.addons.find(addonKey).query : null,
                            title: this.url.title,
                            href: this.url.parsed.href,
                            state: this.state.addons.find(addonKey) ? this.state.addons.find(addonKey).state : null
                        });
                    };
                },
                {
                    "./utils": 9,
                    "url": 3
                }
            ],
            9: [
                function(_dereq_, module1, exports) {
                    "use strict";
                    Object.defineProperty(exports, "__esModule", {
                        value: true
                    });
                    exports.find = find;
                    exports.values = values;
                    exports.stripHash = stripHash;
                    exports.stripHashPrefix = stripHashPrefix;
                    exports.addHash = addHash;
                    exports.addHashPrefix = addHashPrefix;
                    exports.splitQueryParam = splitQueryParam;
                    exports.joinQueryParam = joinQueryParam;
                    exports.parseQuery = parseQuery;
                    exports.formatQuery = formatQuery;
                    exports.stripAddonQueryPrefix = stripAddonQueryPrefix;
                    exports.addAddonQueryPrefix = addAddonQueryPrefix;
                    exports.normalizeQueryByAddons = normalizeQueryByAddons;
                    exports.denormalizeQueryByAddons = denormalizeQueryByAddons;
                    exports.deepCopy = deepCopy;
                    exports.wrapState = wrapState;
                    exports.unwrapState = unwrapState;
                    exports.createEvent = createEvent;
                    exports.callConnectHost = callConnectHost;
                    exports.log = log;
                    function _defineProperty(obj, key, value) {
                        if (key in obj) Object.defineProperty(obj, key, {
                            value: value,
                            enumerable: true,
                            configurable: true,
                            writable: true
                        });
                        else obj[key] = value;
                        return obj;
                    }
                    var _constants = _dereq_('./constants');
                    function find(arr, iterator) {
                        for(var i = 0, l = arr.length; i < l; i += 1){
                            if (iterator(arr[i])) return arr[i];
                        }
                    }
                    function values(obj) {
                        var values = [];
                        if (!obj) return values;
                        for(var key in obj)values.push(obj[key]);
                        return values;
                    }
                    function stripHash(str) {
                        return str ? str.slice(str.search("#") + 1) : null;
                    }
                    function stripHashPrefix(text) {
                        if (text === undefined || text === null || text === "") return "";
                        return text.toString().replace(new RegExp("^" + _constants.ANCHOR_PREFIX), "");
                    }
                    function addHash(str) {
                        return '#' + str;
                    }
                    function addHashPrefix(text) {
                        if (text === undefined || text === null) throw "You must supply text to prefix";
                        return _constants.ANCHOR_PREFIX + stripHashPrefix(text);
                    }
                    function splitQueryParam(paramString) {
                        var split = paramString ? paramString.split('=') : [];
                        var key = split[0] || null;
                        var value = split[1] || null;
                        if (split.length === 2) {
                            var _key = split[0];
                            var _value = split[1];
                            return {
                                key: _key,
                                value: _value
                            };
                        } else return null;
                    }
                    function joinQueryParam(paramObject) {
                        if ('key' in paramObject && 'value' in paramObject) return [
                            paramObject.key,
                            '=',
                            paramObject.value
                        ].join('');
                        else return null;
                    }
                    function parseQuery(queryString) {
                        var params = queryString ? queryString.split('&') : [];
                        return params.map(function(paramString) {
                            return splitQueryParam(paramString);
                        }).filter(function(item) {
                            return item;
                        });
                    }
                    function formatQuery(queryArr) {
                        var mapped = queryArr.map(function(paramObject) {
                            return joinQueryParam(paramObject);
                        }).filter(function(item) {
                            return item;
                        });
                        return mapped.length ? mapped.join('&') : null;
                    }
                    function stripAddonQueryPrefix(queryObject) {
                        var split = queryObject.key ? queryObject.key.split(_constants.QUERY_KEY_DELIMITER) : [];
                        var prefix = _constants.QUERY_KEY_PREFIX;
                        if (split.length >= 3) {
                            if (prefix === split[0]) {
                                var addonKey = split.slice(1, split.length - 1).join(_constants.QUERY_KEY_DELIMITER);
                                var queryKey = split.slice(split.length - 1).join(_constants.QUERY_KEY_DELIMITER);
                                return {
                                    addonKey: addonKey,
                                    key: queryKey,
                                    value: queryObject.value
                                };
                            } else return queryObject;
                        } else return queryObject;
                    }
                    function addAddonQueryPrefix(queryObject) {
                        var prefix = _constants.QUERY_KEY_PREFIX;
                        if ('addonKey' in queryObject && queryObject.addonKey) {
                            var queryKey = [
                                prefix,
                                queryObject.addonKey,
                                queryObject.key
                            ].join(_constants.QUERY_KEY_DELIMITER);
                            return {
                                key: queryKey,
                                value: queryObject.value
                            };
                        } else return queryObject;
                    }
                    function normalizeQueryByAddons(queryArr) {
                        var addons = [];
                        queryArr.forEach(function(query) {
                            var key = query.key;
                            var value = query.value;
                            var addonKey = query.addonKey;
                            var filtered = addons.filter(function(addon) {
                                return addon.key === addonKey;
                            });
                            if (filtered && filtered.length) {
                                var found = filtered[0];
                                found.query[key] = value;
                            } else addons.push({
                                key: addonKey,
                                query: _defineProperty({}, key, value)
                            });
                        });
                        return addons;
                    }
                    function denormalizeQueryByAddons(addonArr) {
                        var query = [];
                        addonArr.forEach(function(addon) {
                            var addonKey = addon.key;
                            Object.keys(addon.query).forEach(function(key) {
                                var value = addon.query[key];
                                query.push({
                                    addonKey: addonKey,
                                    key: key,
                                    value: value
                                });
                            });
                        });
                        return query;
                    }
                    function deepCopy(obj) {
                        return JSON.parse(JSON.stringify(obj));
                    }
                    function wrapState(state) {
                        var rootState = {};
                        rootState[_constants.STATE_AP_KEY] = state;
                        return rootState;
                    }
                    function unwrapState(state) {
                        return state && state[_constants.STATE_AP_KEY] ? state[_constants.STATE_AP_KEY] : null;
                    }
                    function createEvent(eventName) {
                        if (typeof Event === 'function') {
                            var evt = new Event(eventName);
                            return evt;
                        } else {
                            var evt = document.createEvent('Event');
                            evt.initEvent(eventName, false, false);
                            return evt;
                        }
                    }
                    function callConnectHost(cb) {
                        if (_dereq_ && _dereq_.amd) _dereq_([
                            'connect-host'
                        ], function(connectHost) {
                            cb(connectHost);
                        });
                        else cb(window.connectHost);
                    }
                    function log(toLog, type) {
                        if (!type) type = 'log';
                        console[type].call(null, 'Atlassian Connect JS History: ', toLog);
                    }
                },
                {
                    "./constants": 7
                }
            ]
        }, {}, [
            1
        ])(1);
    });
});
parcelRegister("7eXvf", function(module, exports) {
    (function(f) {
        var g;
        module.exports = f();
    })(function() {
        var define, module1, exports;
        return (function e(t, n, r) {
            function s(o, u) {
                if (!n[o]) {
                    if (!t[o]) {
                        var a = undefined;
                        if (!u && a) return a(o, !0);
                        if (i) return i(o, !0);
                        var f = new Error("Cannot find module '" + o + "'");
                        throw f.code = "MODULE_NOT_FOUND", f;
                    }
                    var l = n[o] = {
                        exports: {}
                    };
                    t[o][0].call(l.exports, function(e) {
                        var n = t[o][1][e];
                        return s(n ? n : e);
                    }, l, l.exports, e, t, n, r);
                }
                return n[o].exports;
            }
            var i = undefined;
            for(var o = 0; o < r.length; o++)s(r[o]);
            return s;
        })({
            1: [
                function(_dereq_, module1, exports) {
                    'use strict';
                    Object.defineProperty(exports, '__esModule', {
                        value: true
                    });
                    var XHR_PROPERTIES = [
                        'status',
                        'statusText',
                        'responseText'
                    ];
                    var XHR_PROPERTIESBINARY = [
                        'status',
                        'statusText',
                        'response'
                    ];
                    var XHR_HEADERS = [
                        'Content-Type',
                        'ETag',
                        'Link'
                    ];
                    if (getBooleanFeatureFlag('com.atlassian.connect.acjs.hc-43-whitelist-language-headers', false)) var REQUEST_HEADERS_WHITELIST = [
                        'If-Match',
                        'If-None-Match',
                        'X-Atlassian-Force-Account-ID',
                        'X-Force-Accept-Language',
                        'Accept-Language'
                    ];
                    else var REQUEST_HEADERS_WHITELIST = [
                        'If-Match',
                        'If-None-Match',
                        'X-Atlassian-Force-Account-ID'
                    ];
                    var requestMarshal;
                    function getBooleanFeatureFlag(flagName, defaultValue) {
                        if (window.connectHost && window.connectHost.getBooleanFeatureFlag) return window.connectHost.getBooleanFeatureFlag(flagName);
                        return defaultValue;
                    }
                    function getContextPath() {
                        if (window.AJS && window.AJS.contextPath) return window.AJS.contextPath();
                        var el = document.querySelector('meta[name=ajs-context-path]');
                        if (el) return el.getAttribute('content');
                        return '';
                    }
                    function stripJWTUrls(str) {
                        return str.replace(/(http[s]?:\/\/[^"]*?&jwt=[A-Za-z0-9-_=]+\.[A-Za-z0-9-_=]+\.?[A-Za-z0-9-_.+/=]*.*?)\\"/gi, '\\"');
                    }
                    function toJSON(xhr, isBinary) {
                        var json = {
                            headers: {}
                        };
                        if (isBinary) XHR_PROPERTIESBINARY.forEach(function(v, i) {
                            json[v] = xhr[v];
                            if (v === 'response') try {
                                JSON.parse(xhr[v]);
                                json[v] = stripJWTUrls(xhr[v]);
                            } catch (e) {}
                        }, this);
                        else XHR_PROPERTIES.forEach(function(v, i) {
                            json[v] = xhr[v];
                            if (v === 'responseText') try {
                                JSON.parse(xhr[v]);
                                json[v] = stripJWTUrls(xhr[v]);
                            } catch (e) {}
                        }, this);
                        XHR_HEADERS.forEach(function(v, i) {
                            json.headers[v] = xhr.getResponseHeader(v);
                        }, this);
                        return json;
                    }
                    function appendFormData(formData, key, value) {
                        if (value._isBlob && value.blob && value.name) formData.append(key, value.blob, value.name);
                        else formData.append(key, value);
                        return formData;
                    }
                    function handleMultipartRequest(ajaxOptions) {
                        ajaxOptions.contentType = false;
                        ajaxOptions.processData = false;
                        if (ajaxOptions.data && typeof ajaxOptions.data === 'object') {
                            var formData = new FormData();
                            Object.keys(ajaxOptions.data).forEach(function(key) {
                                var formValue = ajaxOptions.data[key];
                                if (Array.isArray(formValue)) formValue.forEach(function(val, index) {
                                    formData = appendFormData(formData, key + '[' + index + ']', val);
                                });
                                else formData = appendFormData(formData, key, formValue);
                            });
                            ajaxOptions.data = formData;
                            ajaxOptions.headers['X-Atlassian-Token'] = 'no-check';
                        } else throw new Error('For a Multipart request, data must to be an Object');
                        return ajaxOptions;
                    }
                    function addRequestMarshal(marshal) {
                        if (typeof marshal === 'function') requestMarshal = marshal;
                        else throw new Error('ACJS request marshal must be a function');
                    }
                    function removeRequestMarshal() {
                        requestMarshal = undefined;
                    }
                    exports.stripJWTUrls = stripJWTUrls;
                    exports.addRequestMarshal = addRequestMarshal;
                    exports.removeRequestMarshal = removeRequestMarshal;
                    exports['default'] = {
                        request: function request(args, callback) {
                            var contextPath = getContextPath();
                            var headers = {};
                            callback = arguments[arguments.length - 1];
                            var _callback$_context$extension = callback._context.extension;
                            var addonKey = _callback$_context$extension.addon_key;
                            var moduleKey = _callback$_context$extension.key;
                            var allowPathTraversal = _callback$_context$extension.options.allowPathTraversal;
                            if (typeof args === 'string') args = {
                                url: args
                            };
                            var url = contextPath + args.url;
                            if (!allowPathTraversal) {
                                var fullUrl = new URL(url, document.baseURI);
                                if (!fullUrl.pathname.startsWith(contextPath)) {
                                    if (window.connectHost && window.connectHost.trackAnalyticsEvent) window.connectHost.trackAnalyticsEvent('jsapi.request.prevent-path-traversal', {
                                        addonKey: addonKey,
                                        moduleKey: moduleKey,
                                        url: url
                                    });
                                    return callback('Request url must include context path \'' + contextPath + '\'', {});
                                }
                            }
                            args.headers = args.headers || {};
                            Object.getOwnPropertyNames(args.headers).forEach(function(k) {
                                headers[k.toLowerCase()] = args.headers[k];
                            }, this);
                            function done(data, textStatus, xhr) {
                                callback(false, toJSON(xhr, isBinaryData), data);
                            }
                            function fail(xhr, textStatus, errorThrown) {
                                callback(errorThrown, toJSON(xhr, isBinaryData), errorThrown);
                            }
                            var ajaxOptions = {
                                url: url,
                                type: args.type || 'GET',
                                data: args.data,
                                dataType: 'text',
                                contentType: args.contentType,
                                cache: typeof args.cache !== 'undefined' ? !!args.cache : undefined,
                                headers: {
                                    'Accept': headers.accept || '*/*',
                                    'AP-Client-Key': addonKey
                                }
                            };
                            if (ajaxOptions.contentType === 'multipart/form-data') ajaxOptions = handleMultipartRequest(ajaxOptions);
                            if (ajaxOptions.data && typeof ajaxOptions.data === 'object' && ajaxOptions.type.toUpperCase() === 'GET') Object.keys(ajaxOptions.data).forEach(function(key) {
                                ajaxOptions.url += (ajaxOptions.url.indexOf('?') >= 0 ? '&' : '?') + encodeURIComponent(key) + '=' + encodeURIComponent(ajaxOptions.data[key]);
                            });
                            if (args.experimental === true) ajaxOptions.headers['X-ExperimentalApi'] = 'opt-in';
                            REQUEST_HEADERS_WHITELIST.forEach(function(header, index) {
                                if (headers[header.toLowerCase()]) ajaxOptions.headers[header] = headers[header.toLowerCase()];
                            }, this);
                            if (!ajaxOptions.cache) ajaxOptions.url += (ajaxOptions.url.indexOf('?') >= 0 ? '&' : '?') + '_r=' + new Date().getTime();
                            var request = new XMLHttpRequest();
                            request.open(ajaxOptions.type, ajaxOptions.url, true);
                            var isBinaryData = false;
                            if (args.binaryAttachment) {
                                isBinaryData = true;
                                request.responseType = "arraybuffer";
                            }
                            if (ajaxOptions.contentType) ajaxOptions.headers['Content-type'] = ajaxOptions.contentType;
                            Object.getOwnPropertyNames(ajaxOptions.headers).forEach(function(headerName) {
                                request.setRequestHeader(headerName, ajaxOptions.headers[headerName]);
                            });
                            request.onload = function() {
                                if (this.status >= 200 && this.status < 300) {
                                    if (isBinaryData) done(request.response, request.statusText, request);
                                    else done(request.responseText, request.statusText, request);
                                } else if (isBinaryData) fail(request, request.statusText, request.response);
                                else fail(request, request.statusText, request.responseText);
                            };
                            request.onerror = function() {
                                if (isBinaryData) fail(request, request.statusText, request.response);
                                else fail(request, request.statusText, request.responseText);
                            };
                            try {
                                var marshalResponse = true;
                                if (requestMarshal) marshalResponse = requestMarshal.call(null, ajaxOptions);
                                if (marshalResponse === true) request.send(ajaxOptions.data || null);
                                else {
                                    request.abort();
                                    fail(request, typeof marshalResponse === 'string' ? marshalResponse : undefined, marshalResponse);
                                }
                            } catch (e) {
                                request.abort();
                                fail(request, undefined, e);
                                console.error('ACJS Request: ', e.message, e);
                            }
                        }
                    };
                },
                {}
            ]
        }, {}, [
            1
        ])(1);
    });
});
parcelRegister("8wnEm", function(module, exports) {
    $parcel$export(module.exports, "go", ()=>$bb2d6bce4a8abdf5$export$93bb224d05b3906d);
    $parcel$export(module.exports, "_shouldThrottle", ()=>$bb2d6bce4a8abdf5$export$da2528204b4513b);
    $parcel$export(module.exports, "reload", ()=>$bb2d6bce4a8abdf5$export$32da5b5043dcd88c);
    var $7oGEb;
    var $5UQTz;
    var $bW9IK;
    const $bb2d6bce4a8abdf5$var$THROTTLE_WAIT_LIMIT = 120000;
    const $bb2d6bce4a8abdf5$var$REQUEST_LIMIT = 5;
    const $bb2d6bce4a8abdf5$export$93bb224d05b3906d = (target, context, callback)=>{
        const finalTarget = target.toLowerCase();
        const finalContext = context || {};
        if (!finalContext.addonKey) finalContext.addonKey = callback._context.extension.addon_key;
        if (!(0, (0, parcelRequire("bW9IK")).isApiEnabled)()) {
            console.error('connect navigation api not yet implemented for this product');
            return;
        }
        const productRoutes = (0, (0, parcelRequire("5UQTz")).getRoutes)();
        if ((0, (0, parcelRequire("5UQTz")).hasRoutes)() && finalTarget in productRoutes) {
            const newRouteValue = productRoutes[finalTarget];
            if (typeof newRouteValue === 'function') newRouteValue(finalContext, (0, (0, parcelRequire("bW9IK")).goToUrl));
            else {
                const url = (0, (0, parcelRequire("bW9IK")).buildUrl)(newRouteValue, finalContext);
                (0, (0, parcelRequire("bW9IK")).goToUrl)(url);
            }
        } else console.error(`The URL target ${finalTarget} is not available. Valid targets are: ${Object.keys(productRoutes).toString()}`);
    };
    const $bb2d6bce4a8abdf5$export$da2528204b4513b = (wait, reloadLimit)=>{
        let lastReloadTimestamp = Number(window.localStorage.getItem('lastReloadTimestamp'));
        let reloadAttempts = Number(window.localStorage.getItem('reloadAttempts'));
        const now = Date.now();
        if (now - lastReloadTimestamp > wait) reloadAttempts = 0;
        if (reloadAttempts >= reloadLimit) {
            console.error(`Reloads must be ${wait}ms apart after ${reloadAttempts} reload attempts.`);
            return true;
        }
        lastReloadTimestamp = now;
        reloadAttempts += 1;
        window.localStorage.setItem('lastReloadTimestamp', String(lastReloadTimestamp));
        window.localStorage.setItem('reloadAttempts', String(reloadAttempts));
        return false;
    };
    const $bb2d6bce4a8abdf5$export$32da5b5043dcd88c = ()=>{
        if ($bb2d6bce4a8abdf5$export$da2528204b4513b($bb2d6bce4a8abdf5$var$THROTTLE_WAIT_LIMIT, $bb2d6bce4a8abdf5$var$REQUEST_LIMIT)) return;
        if ((0, (0, parcelRequire("7oGEb")).isInIframe)()) (0, (0, parcelRequire("bW9IK")).getTopmostSameOriginWindow)(window).location.reload();
        else window.location.reload();
    };
});
parcelRegister("7oGEb", function(module, exports) {
    $parcel$export(module.exports, "provideNavigationApi", ()=>$6e1dad164f29ee43$export$26d28e8849b2805f);
    $parcel$export(module.exports, "isInIframe", ()=>$6e1dad164f29ee43$export$9f140ed41af5108c);
    $parcel$export(module.exports, "canSpaTransition", ()=>$6e1dad164f29ee43$export$59e771495885068f);
    $parcel$export(module.exports, "getContainerApi", ()=>$6e1dad164f29ee43$export$91ed870fd8df2bcb);
    $parcel$export(module.exports, "getNavigationApi", ()=>$6e1dad164f29ee43$export$da4e5a44286a0dd0);
    let $6e1dad164f29ee43$var$containerApi = null;
    let $6e1dad164f29ee43$var$navigationApi = null;
    const $6e1dad164f29ee43$export$3927fb5df700a968 = (api)=>{
        $6e1dad164f29ee43$var$containerApi = api;
    };
    const $6e1dad164f29ee43$export$26d28e8849b2805f = (api)=>{
        $6e1dad164f29ee43$var$navigationApi = api;
    };
    const $6e1dad164f29ee43$export$9f140ed41af5108c = ()=>$6e1dad164f29ee43$var$containerApi !== null;
    const $6e1dad164f29ee43$export$59e771495885068f = ()=>$6e1dad164f29ee43$var$navigationApi !== null;
    const $6e1dad164f29ee43$export$91ed870fd8df2bcb = ()=>$6e1dad164f29ee43$var$containerApi;
    const $6e1dad164f29ee43$export$da4e5a44286a0dd0 = ()=>$6e1dad164f29ee43$var$navigationApi;
    const $6e1dad164f29ee43$export$6ba42130b045ede1 = ()=>{
        $6e1dad164f29ee43$var$containerApi = null;
        $6e1dad164f29ee43$var$navigationApi = null;
    };
});
parcelRegister("5UQTz", function(module, exports) {
    $parcel$export(module.exports, "hasRoutes", ()=>$841ccda199c99453$export$c70a73463e2fc7f1);
    $parcel$export(module.exports, "addRoutes", ()=>$841ccda199c99453$export$6560ffa99142788a);
    $parcel$export(module.exports, "getRoutes", ()=>$841ccda199c99453$export$2f7745f2f5ab3897);
    let $841ccda199c99453$var$routes = {
        addonmodule: (context, callback)=>{
            const addonKey = context && context.addonKey;
            const moduleKey = context && context.moduleKey;
            if (!addonKey) throw new Error('Missing addonKey parameter in the context.');
            if (!moduleKey) throw new Error('Missing moduleKey parameter in the context.');
            const addonPath = $841ccda199c99453$var$createPathSegmentFromContext([
                addonKey,
                moduleKey
            ]);
            let url = `/plugins/servlet/ac/${addonPath}`;
            if (context.context !== undefined) console.warn('DEPRECATED API - The context field has been deprecated in favor of customData.');
            const paramsToPlaceInURL = {
                ...context.context || {},
                ...context.customData || {}
            };
            const queryParameters = $841ccda199c99453$var$createQueryParamFromContext(paramsToPlaceInURL);
            url = queryParameters !== '' ? `${url}?${queryParameters}` : url;
            callback.apply(undefined, [
                url
            ]);
        },
        site: (context, callback)=>{
            if (!context) return;
            function sanitizePathOrThrow(url) {
                const parsed = new URL(url, document.baseURI);
                const pathname = parsed.pathname.replace(/\/+/g, '/');
                if (pathname.toLowerCase().indexOf('plugins/servlet/ac-redirect') !== -1) throw new Error('Cannot use legacy redirect filter in Navigator API');
            }
            if (context.relativeUrl) {
                if (typeof context.relativeUrl !== 'string' || context.relativeUrl[0] !== '/') throw new Error('Invalid relativeUrl passed in context');
                sanitizePathOrThrow(context.relativeUrl);
                const url = `${window.location.protocol}//${window.location.hostname}${context.relativeUrl}`;
                callback.apply(undefined, [
                    url
                ]);
            } else if (context.absoluteUrl) {
                const allowed = `${window.location.protocol}//${window.location.hostname}/`;
                if (typeof context.absoluteUrl !== 'string' || context.absoluteUrl.indexOf(allowed) !== 0) throw new Error('Invalid absoluteUrl passed in context');
                sanitizePathOrThrow(context.absoluteUrl);
                callback.apply(undefined, [
                    context.absoluteUrl
                ]);
            } else throw new Error('No context supplied to Navigator API');
        }
    };
    function $841ccda199c99453$var$createPathSegmentFromContext(segments) {
        const path = segments.map(encodeURIComponent).join('/');
        const url = new URL(path, window.location.origin);
        return url.pathname.slice(1);
    }
    function $841ccda199c99453$var$createQueryParamFromContext(params) {
        return Object.keys(params).map((prop)=>[
                `ac.${prop}`,
                params[prop]
            ].map(encodeURIComponent).join('=')).join('&');
    }
    const $841ccda199c99453$export$c70a73463e2fc7f1 = ()=>$841ccda199c99453$var$routes && Object.getOwnPropertyNames($841ccda199c99453$var$routes).length !== 0;
    const $841ccda199c99453$export$6560ffa99142788a = (newRoutes)=>{
        $841ccda199c99453$var$routes = Object.assign($841ccda199c99453$var$routes, newRoutes);
    };
    const $841ccda199c99453$export$2f7745f2f5ab3897 = ()=>$841ccda199c99453$var$routes;
});
parcelRegister("bW9IK", function(module, exports) {
    $parcel$export(module.exports, "enableApi", ()=>$c5d1a441161a4fb7$export$73698f81575c4d90);
    $parcel$export(module.exports, "isApiEnabled", ()=>$c5d1a441161a4fb7$export$3d2f848dec6b9859);
    $parcel$export(module.exports, "buildUrl", ()=>$c5d1a441161a4fb7$export$b5cd97dee32de81d);
    $parcel$export(module.exports, "goToUrl", ()=>$c5d1a441161a4fb7$export$4f3a4fc7726e3f59);
    $parcel$export(module.exports, "hasContext", ()=>$c5d1a441161a4fb7$export$1fda64d8edbe0e8d);
    $parcel$export(module.exports, "appendQueryParam", ()=>$c5d1a441161a4fb7$export$19016b549dc8a281);
    $parcel$export(module.exports, "getTopmostSameOriginWindow", ()=>$c5d1a441161a4fb7$export$74ba7c47f97c6a7b);
    var $9hCSe = parcelRequire("9hCSe");
    var $7oGEb;
    let $c5d1a441161a4fb7$var$isEnabled = false;
    const $c5d1a441161a4fb7$export$73698f81575c4d90 = ()=>{
        $c5d1a441161a4fb7$var$isEnabled = true;
    };
    const $c5d1a441161a4fb7$export$aa1e4c36f6a3acc3 = ()=>{
        $c5d1a441161a4fb7$var$isEnabled = false;
    };
    const $c5d1a441161a4fb7$export$3d2f848dec6b9859 = ()=>$c5d1a441161a4fb7$var$isEnabled;
    const $c5d1a441161a4fb7$export$b5cd97dee32de81d = (urlTemplate, context)=>{
        let finalUrlTemplate = urlTemplate;
        if (urlTemplate[0] !== '/') finalUrlTemplate = `/${urlTemplate}`;
        return (0, ($parcel$interopDefault($9hCSe))).parse(finalUrlTemplate).expand(context);
    };
    const $c5d1a441161a4fb7$export$4f3a4fc7726e3f59 = (url)=>{
        const goTo = function() {
            window.location.href = url;
        };
        if ((0, (0, parcelRequire("7oGEb")).isInIframe)()) {
            const containerApi = (0, (0, parcelRequire("7oGEb")).getContainerApi)();
            containerApi && containerApi.navigate && containerApi.navigate(url, goTo);
        } else if ((0, (0, parcelRequire("7oGEb")).canSpaTransition)()) {
            const navApi = (0, (0, parcelRequire("7oGEb")).getNavigationApi)();
            navApi && navApi.navigate && navApi.navigate(url);
        } else goTo();
    };
    const $c5d1a441161a4fb7$export$1fda64d8edbe0e8d = (context, fieldName)=>{
        if (!context[fieldName]) {
            console.error(`Missing ${fieldName} in navigator context`);
            return false;
        }
        return true;
    };
    const $c5d1a441161a4fb7$export$19016b549dc8a281 = (url, key, value)=>`${url + (url.indexOf('?') > -1 ? '&' : '?') + key}=${encodeURIComponent(value)}`;
    const $c5d1a441161a4fb7$export$74ba7c47f97c6a7b = (win)=>{
        function satisfiesSameOrigin(w) {
            try {
                if (w.location.href == null) return false;
            } catch (e) {
                return false;
            }
            return true;
        }
        function isTopMostWindow(w) {
            return w === w.parent;
        }
        let topWindow = win;
        while(!isTopMostWindow(topWindow) && satisfiesSameOrigin(topWindow.parent))topWindow = topWindow.parent;
        return topWindow;
    };
});
parcelRegister("9hCSe", function(module, exports) {
    (function(exportCallback) {
        "use strict";
        var UriTemplateError = function() {
            function UriTemplateError(options) {
                this.options = options;
            }
            UriTemplateError.prototype.toString = function() {
                if (JSON && JSON.stringify) return JSON.stringify(this.options);
                else return this.options;
            };
            return UriTemplateError;
        }();
        var objectHelper = function() {
            function isArray(value) {
                return Object.prototype.toString.apply(value) === '[object Array]';
            }
            function isString(value) {
                return Object.prototype.toString.apply(value) === '[object String]';
            }
            function isNumber(value) {
                return Object.prototype.toString.apply(value) === '[object Number]';
            }
            function isBoolean(value) {
                return Object.prototype.toString.apply(value) === '[object Boolean]';
            }
            function join(arr, separator) {
                var result = '', first = true, index;
                for(index = 0; index < arr.length; index += 1){
                    if (first) first = false;
                    else result += separator;
                    result += arr[index];
                }
                return result;
            }
            function map(arr, mapper) {
                var result = [], index = 0;
                for(; index < arr.length; index += 1)result.push(mapper(arr[index]));
                return result;
            }
            function filter(arr, predicate) {
                var result = [], index = 0;
                for(; index < arr.length; index += 1)if (predicate(arr[index])) result.push(arr[index]);
                return result;
            }
            function deepFreezeUsingObjectFreeze(object) {
                if (typeof object !== "object" || object === null) return object;
                Object.freeze(object);
                var property, propertyName;
                for(propertyName in object)if (object.hasOwnProperty(propertyName)) {
                    property = object[propertyName];
                    if (typeof property === "object") deepFreeze(property);
                }
                return object;
            }
            function deepFreeze(object) {
                if (typeof Object.freeze === 'function') return deepFreezeUsingObjectFreeze(object);
                return object;
            }
            return {
                isArray: isArray,
                isString: isString,
                isNumber: isNumber,
                isBoolean: isBoolean,
                join: join,
                map: map,
                filter: filter,
                deepFreeze: deepFreeze
            };
        }();
        var charHelper = function() {
            function isAlpha(chr) {
                return chr >= 'a' && chr <= 'z' || chr >= 'A' && chr <= 'Z';
            }
            function isDigit(chr) {
                return chr >= '0' && chr <= '9';
            }
            function isHexDigit(chr) {
                return isDigit(chr) || chr >= 'a' && chr <= 'f' || chr >= 'A' && chr <= 'F';
            }
            return {
                isAlpha: isAlpha,
                isDigit: isDigit,
                isHexDigit: isHexDigit
            };
        }();
        var pctEncoder = function() {
            var utf8 = {
                encode: function(chr) {
                    return unescape(encodeURIComponent(chr));
                },
                numBytes: function(firstCharCode) {
                    if (firstCharCode <= 0x7F) return 1;
                    else if (0xC2 <= firstCharCode && firstCharCode <= 0xDF) return 2;
                    else if (0xE0 <= firstCharCode && firstCharCode <= 0xEF) return 3;
                    else if (0xF0 <= firstCharCode && firstCharCode <= 0xF4) return 4;
                    return 0;
                },
                isValidFollowingCharCode: function(charCode) {
                    return 0x80 <= charCode && charCode <= 0xBF;
                }
            };
            function encodeCharacter(chr) {
                var result = '', octets = utf8.encode(chr), octet, index;
                for(index = 0; index < octets.length; index += 1){
                    octet = octets.charCodeAt(index);
                    result += '%' + (octet < 0x10 ? '0' : '') + octet.toString(16).toUpperCase();
                }
                return result;
            }
            function isPercentDigitDigit(text, start) {
                return text.charAt(start) === '%' && charHelper.isHexDigit(text.charAt(start + 1)) && charHelper.isHexDigit(text.charAt(start + 2));
            }
            function parseHex2(text, start) {
                return parseInt(text.substr(start, 2), 16);
            }
            function isPctEncoded(chr) {
                if (!isPercentDigitDigit(chr, 0)) return false;
                var firstCharCode = parseHex2(chr, 1);
                var numBytes = utf8.numBytes(firstCharCode);
                if (numBytes === 0) return false;
                for(var byteNumber = 1; byteNumber < numBytes; byteNumber += 1){
                    if (!isPercentDigitDigit(chr, 3 * byteNumber) || !utf8.isValidFollowingCharCode(parseHex2(chr, 3 * byteNumber + 1))) return false;
                }
                return true;
            }
            function pctCharAt(text, startIndex) {
                var chr = text.charAt(startIndex);
                if (!isPercentDigitDigit(text, startIndex)) return chr;
                var utf8CharCode = parseHex2(text, startIndex + 1);
                var numBytes = utf8.numBytes(utf8CharCode);
                if (numBytes === 0) return chr;
                for(var byteNumber = 1; byteNumber < numBytes; byteNumber += 1){
                    if (!isPercentDigitDigit(text, startIndex + 3 * byteNumber) || !utf8.isValidFollowingCharCode(parseHex2(text, startIndex + 3 * byteNumber + 1))) return chr;
                }
                return text.substr(startIndex, 3 * numBytes);
            }
            return {
                encodeCharacter: encodeCharacter,
                isPctEncoded: isPctEncoded,
                pctCharAt: pctCharAt
            };
        }();
        var rfcCharHelper = function() {
            function isVarchar(chr) {
                return charHelper.isAlpha(chr) || charHelper.isDigit(chr) || chr === '_' || pctEncoder.isPctEncoded(chr);
            }
            function isUnreserved(chr) {
                return charHelper.isAlpha(chr) || charHelper.isDigit(chr) || chr === '-' || chr === '.' || chr === '_' || chr === '~';
            }
            function isReserved(chr) {
                return chr === ':' || chr === '/' || chr === '?' || chr === '#' || chr === '[' || chr === ']' || chr === '@' || chr === '!' || chr === '$' || chr === '&' || chr === '(' || chr === ')' || chr === '*' || chr === '+' || chr === ',' || chr === ';' || chr === '=' || chr === "'";
            }
            return {
                isVarchar: isVarchar,
                isUnreserved: isUnreserved,
                isReserved: isReserved
            };
        }();
        var encodingHelper = function() {
            function encode(text, passReserved) {
                var result = '', index, chr = '';
                if (typeof text === "number" || typeof text === "boolean") text = text.toString();
                for(index = 0; index < text.length; index += chr.length){
                    chr = text.charAt(index);
                    result += rfcCharHelper.isUnreserved(chr) || passReserved && rfcCharHelper.isReserved(chr) ? chr : pctEncoder.encodeCharacter(chr);
                }
                return result;
            }
            function encodePassReserved(text) {
                return encode(text, true);
            }
            function encodeLiteralCharacter(literal, index) {
                var chr = pctEncoder.pctCharAt(literal, index);
                if (chr.length > 1) return chr;
                else return rfcCharHelper.isReserved(chr) || rfcCharHelper.isUnreserved(chr) ? chr : pctEncoder.encodeCharacter(chr);
            }
            function encodeLiteral(literal) {
                var result = '', index, chr = '';
                for(index = 0; index < literal.length; index += chr.length){
                    chr = pctEncoder.pctCharAt(literal, index);
                    if (chr.length > 1) result += chr;
                    else result += rfcCharHelper.isReserved(chr) || rfcCharHelper.isUnreserved(chr) ? chr : pctEncoder.encodeCharacter(chr);
                }
                return result;
            }
            return {
                encode: encode,
                encodePassReserved: encodePassReserved,
                encodeLiteral: encodeLiteral,
                encodeLiteralCharacter: encodeLiteralCharacter
            };
        }();
        var operators = function() {
            var bySymbol = {};
            function create(symbol) {
                bySymbol[symbol] = {
                    symbol: symbol,
                    separator: symbol === '?' ? '&' : symbol === '' || symbol === '+' || symbol === '#' ? ',' : symbol,
                    named: symbol === ';' || symbol === '&' || symbol === '?',
                    ifEmpty: symbol === '&' || symbol === '?' ? '=' : '',
                    first: symbol === '+' ? '' : symbol,
                    encode: symbol === '+' || symbol === '#' ? encodingHelper.encodePassReserved : encodingHelper.encode,
                    toString: function() {
                        return this.symbol;
                    }
                };
            }
            create('');
            create('+');
            create('#');
            create('.');
            create('/');
            create(';');
            create('?');
            create('&');
            return {
                valueOf: function(chr) {
                    if (bySymbol[chr]) return bySymbol[chr];
                    if ("=,!@|".indexOf(chr) >= 0) return null;
                    return bySymbol[''];
                }
            };
        }();
        function isDefined(object) {
            var propertyName;
            if (object === null || object === undefined) return false;
            if (objectHelper.isArray(object)) return object.length > 0;
            if (typeof object === "string" || typeof object === "number" || typeof object === "boolean") return true;
            for(propertyName in object){
                if (object.hasOwnProperty(propertyName) && isDefined(object[propertyName])) return true;
            }
            return false;
        }
        var LiteralExpression = function() {
            function LiteralExpression(literal) {
                this.literal = encodingHelper.encodeLiteral(literal);
            }
            LiteralExpression.prototype.expand = function() {
                return this.literal;
            };
            LiteralExpression.prototype.toString = LiteralExpression.prototype.expand;
            return LiteralExpression;
        }();
        var parse = function() {
            function parseExpression(expressionText) {
                var operator, varspecs = [], varspec = null, varnameStart = null, maxLengthStart = null, index, chr = '';
                function closeVarname() {
                    var varname = expressionText.substring(varnameStart, index);
                    if (varname.length === 0) throw new UriTemplateError({
                        expressionText: expressionText,
                        message: "a varname must be specified",
                        position: index
                    });
                    varspec = {
                        varname: varname,
                        exploded: false,
                        maxLength: null
                    };
                    varnameStart = null;
                }
                function closeMaxLength() {
                    if (maxLengthStart === index) throw new UriTemplateError({
                        expressionText: expressionText,
                        message: "after a ':' you have to specify the length",
                        position: index
                    });
                    varspec.maxLength = parseInt(expressionText.substring(maxLengthStart, index), 10);
                    maxLengthStart = null;
                }
                operator = function(operatorText) {
                    var op = operators.valueOf(operatorText);
                    if (op === null) throw new UriTemplateError({
                        expressionText: expressionText,
                        message: "illegal use of reserved operator",
                        position: index,
                        operator: operatorText
                    });
                    return op;
                }(expressionText.charAt(0));
                index = operator.symbol.length;
                varnameStart = index;
                for(; index < expressionText.length; index += chr.length){
                    chr = pctEncoder.pctCharAt(expressionText, index);
                    if (varnameStart !== null) {
                        if (chr === '.') {
                            if (varnameStart === index) throw new UriTemplateError({
                                expressionText: expressionText,
                                message: "a varname MUST NOT start with a dot",
                                position: index
                            });
                            continue;
                        }
                        if (rfcCharHelper.isVarchar(chr)) continue;
                        closeVarname();
                    }
                    if (maxLengthStart !== null) {
                        if (index === maxLengthStart && chr === '0') throw new UriTemplateError({
                            expressionText: expressionText,
                            message: "A :prefix must not start with digit 0",
                            position: index
                        });
                        if (charHelper.isDigit(chr)) {
                            if (index - maxLengthStart >= 4) throw new UriTemplateError({
                                expressionText: expressionText,
                                message: "A :prefix must have max 4 digits",
                                position: index
                            });
                            continue;
                        }
                        closeMaxLength();
                    }
                    if (chr === ':') {
                        if (varspec.maxLength !== null) throw new UriTemplateError({
                            expressionText: expressionText,
                            message: "only one :maxLength is allowed per varspec",
                            position: index
                        });
                        if (varspec.exploded) throw new UriTemplateError({
                            expressionText: expressionText,
                            message: "an exploeded varspec MUST NOT be varspeced",
                            position: index
                        });
                        maxLengthStart = index + 1;
                        continue;
                    }
                    if (chr === '*') {
                        if (varspec === null) throw new UriTemplateError({
                            expressionText: expressionText,
                            message: "exploded without varspec",
                            position: index
                        });
                        if (varspec.exploded) throw new UriTemplateError({
                            expressionText: expressionText,
                            message: "exploded twice",
                            position: index
                        });
                        if (varspec.maxLength) throw new UriTemplateError({
                            expressionText: expressionText,
                            message: "an explode (*) MUST NOT follow to a prefix",
                            position: index
                        });
                        varspec.exploded = true;
                        continue;
                    }
                    if (chr === ',') {
                        varspecs.push(varspec);
                        varspec = null;
                        varnameStart = index + 1;
                        continue;
                    }
                    throw new UriTemplateError({
                        expressionText: expressionText,
                        message: "illegal character",
                        character: chr,
                        position: index
                    });
                }
                if (varnameStart !== null) closeVarname();
                if (maxLengthStart !== null) closeMaxLength();
                varspecs.push(varspec);
                return new VariableExpression(expressionText, operator, varspecs);
            }
            function parse(uriTemplateText) {
                var index, chr, expressions = [], braceOpenIndex = null, literalStart = 0;
                for(index = 0; index < uriTemplateText.length; index += 1){
                    chr = uriTemplateText.charAt(index);
                    if (literalStart !== null) {
                        if (chr === '}') throw new UriTemplateError({
                            templateText: uriTemplateText,
                            message: "unopened brace closed",
                            position: index
                        });
                        if (chr === '{') {
                            if (literalStart < index) expressions.push(new LiteralExpression(uriTemplateText.substring(literalStart, index)));
                            literalStart = null;
                            braceOpenIndex = index;
                        }
                        continue;
                    }
                    if (braceOpenIndex !== null) {
                        if (chr === '{') throw new UriTemplateError({
                            templateText: uriTemplateText,
                            message: "brace already opened",
                            position: index
                        });
                        if (chr === '}') {
                            if (braceOpenIndex + 1 === index) throw new UriTemplateError({
                                templateText: uriTemplateText,
                                message: "empty braces",
                                position: braceOpenIndex
                            });
                            try {
                                expressions.push(parseExpression(uriTemplateText.substring(braceOpenIndex + 1, index)));
                            } catch (error) {
                                if (error.prototype === UriTemplateError.prototype) throw new UriTemplateError({
                                    templateText: uriTemplateText,
                                    message: error.options.message,
                                    position: braceOpenIndex + error.options.position,
                                    details: error.options
                                });
                                throw error;
                            }
                            braceOpenIndex = null;
                            literalStart = index + 1;
                        }
                        continue;
                    }
                    throw new Error('reached unreachable code');
                }
                if (braceOpenIndex !== null) throw new UriTemplateError({
                    templateText: uriTemplateText,
                    message: "unclosed brace",
                    position: braceOpenIndex
                });
                if (literalStart < uriTemplateText.length) expressions.push(new LiteralExpression(uriTemplateText.substr(literalStart)));
                return new UriTemplate(uriTemplateText, expressions);
            }
            return parse;
        }();
        var VariableExpression = function() {
            function prettyPrint(value) {
                return JSON && JSON.stringify ? JSON.stringify(value) : value;
            }
            function isEmpty(value) {
                if (!isDefined(value)) return true;
                if (objectHelper.isString(value)) return value === '';
                if (objectHelper.isNumber(value) || objectHelper.isBoolean(value)) return false;
                if (objectHelper.isArray(value)) return value.length === 0;
                for(var propertyName in value){
                    if (value.hasOwnProperty(propertyName)) return false;
                }
                return true;
            }
            function propertyArray(object) {
                var result = [], propertyName;
                for(propertyName in object)if (object.hasOwnProperty(propertyName)) result.push({
                    name: propertyName,
                    value: object[propertyName]
                });
                return result;
            }
            function VariableExpression(templateText, operator, varspecs) {
                this.templateText = templateText;
                this.operator = operator;
                this.varspecs = varspecs;
            }
            VariableExpression.prototype.toString = function() {
                return this.templateText;
            };
            function expandSimpleValue(varspec, operator, value) {
                var result = '';
                value = value.toString();
                if (operator.named) {
                    result += encodingHelper.encodeLiteral(varspec.varname);
                    if (value === '') {
                        result += operator.ifEmpty;
                        return result;
                    }
                    result += '=';
                }
                if (varspec.maxLength !== null) value = value.substr(0, varspec.maxLength);
                result += operator.encode(value);
                return result;
            }
            function valueDefined(nameValue) {
                return isDefined(nameValue.value);
            }
            function expandNotExploded(varspec, operator, value) {
                var arr = [], result = '';
                if (operator.named) {
                    result += encodingHelper.encodeLiteral(varspec.varname);
                    if (isEmpty(value)) {
                        result += operator.ifEmpty;
                        return result;
                    }
                    result += '=';
                }
                if (objectHelper.isArray(value)) {
                    arr = value;
                    arr = objectHelper.filter(arr, isDefined);
                    arr = objectHelper.map(arr, operator.encode);
                    result += objectHelper.join(arr, ',');
                } else {
                    arr = propertyArray(value);
                    arr = objectHelper.filter(arr, valueDefined);
                    arr = objectHelper.map(arr, function(nameValue) {
                        return operator.encode(nameValue.name) + ',' + operator.encode(nameValue.value);
                    });
                    result += objectHelper.join(arr, ',');
                }
                return result;
            }
            function expandExplodedNamed(varspec, operator, value) {
                var isArray = objectHelper.isArray(value), arr = [];
                if (isArray) {
                    arr = value;
                    arr = objectHelper.filter(arr, isDefined);
                    arr = objectHelper.map(arr, function(listElement) {
                        var tmp = encodingHelper.encodeLiteral(varspec.varname);
                        if (isEmpty(listElement)) tmp += operator.ifEmpty;
                        else tmp += '=' + operator.encode(listElement);
                        return tmp;
                    });
                } else {
                    arr = propertyArray(value);
                    arr = objectHelper.filter(arr, valueDefined);
                    arr = objectHelper.map(arr, function(nameValue) {
                        var tmp = encodingHelper.encodeLiteral(nameValue.name);
                        if (isEmpty(nameValue.value)) tmp += operator.ifEmpty;
                        else tmp += '=' + operator.encode(nameValue.value);
                        return tmp;
                    });
                }
                return objectHelper.join(arr, operator.separator);
            }
            function expandExplodedUnnamed(operator, value) {
                var arr = [], result = '';
                if (objectHelper.isArray(value)) {
                    arr = value;
                    arr = objectHelper.filter(arr, isDefined);
                    arr = objectHelper.map(arr, operator.encode);
                    result += objectHelper.join(arr, operator.separator);
                } else {
                    arr = propertyArray(value);
                    arr = objectHelper.filter(arr, function(nameValue) {
                        return isDefined(nameValue.value);
                    });
                    arr = objectHelper.map(arr, function(nameValue) {
                        return operator.encode(nameValue.name) + '=' + operator.encode(nameValue.value);
                    });
                    result += objectHelper.join(arr, operator.separator);
                }
                return result;
            }
            VariableExpression.prototype.expand = function(variables) {
                var expanded = [], index, varspec, value, valueIsArr, oneExploded = false, operator = this.operator;
                for(index = 0; index < this.varspecs.length; index += 1){
                    varspec = this.varspecs[index];
                    value = variables[varspec.varname];
                    if (value === null || value === undefined) continue;
                    if (varspec.exploded) oneExploded = true;
                    valueIsArr = objectHelper.isArray(value);
                    if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") expanded.push(expandSimpleValue(varspec, operator, value));
                    else if (varspec.maxLength && isDefined(value)) throw new Error('Prefix modifiers are not applicable to variables that have composite values. You tried to expand ' + this + " with " + prettyPrint(value));
                    else if (!varspec.exploded) {
                        if (operator.named || !isEmpty(value)) expanded.push(expandNotExploded(varspec, operator, value));
                    } else if (isDefined(value)) {
                        if (operator.named) expanded.push(expandExplodedNamed(varspec, operator, value));
                        else expanded.push(expandExplodedUnnamed(operator, value));
                    }
                }
                if (expanded.length === 0) return "";
                else return operator.first + objectHelper.join(expanded, operator.separator);
            };
            return VariableExpression;
        }();
        var UriTemplate = function() {
            function UriTemplate(templateText, expressions) {
                this.templateText = templateText;
                this.expressions = expressions;
                objectHelper.deepFreeze(this);
            }
            UriTemplate.prototype.toString = function() {
                return this.templateText;
            };
            UriTemplate.prototype.expand = function(variables) {
                var index, result = '';
                for(index = 0; index < this.expressions.length; index += 1)result += this.expressions[index].expand(variables);
                return result;
            };
            UriTemplate.parse = parse;
            UriTemplate.UriTemplateError = UriTemplateError;
            return UriTemplate;
        }();
        exportCallback(UriTemplate);
    })(function(UriTemplate) {
        "use strict";
        module.exports = UriTemplate;
    });
});
parcelRegister("cZwvK", function(module, exports) {
    $parcel$export(module.exports, "getUser", ()=>$a926109b642703d4$export$7cbf767827cd68ba);
    $parcel$export(module.exports, "getCurrentUser", ()=>$a926109b642703d4$export$e5432d4c8eb97ea7);
    $parcel$export(module.exports, "getTimeZone", ()=>$a926109b642703d4$export$c3133dbc11f66777);
    $parcel$export(module.exports, "getLocale", ()=>$a926109b642703d4$export$180605366c04f0cd);
    var $dH9DT;
    const $a926109b642703d4$export$7cbf767827cd68ba = (callback)=>{
        const data = callback._context.extension.options.user;
        const fullName = typeof data.uid === 'undefined' && typeof data.ukey === 'undefined' ? null : (0, (0, parcelRequire("dH9DT")).getMeta)('remote-user-fullname') || null;
        callback({
            fullName: fullName,
            id: data.uid,
            key: data.ukey
        });
    };
    const $a926109b642703d4$export$e5432d4c8eb97ea7 = (callback)=>{
        const atlassianAccountId = (0, (0, parcelRequire("dH9DT")).getMeta)('atlassian-account-id') || null;
        const accountType = (0, (0, parcelRequire("dH9DT")).getMeta)('account-type') || null;
        callback({
            atlassianAccountId: atlassianAccountId,
            accountType: accountType
        });
    };
    const $a926109b642703d4$export$c3133dbc11f66777 = (callback)=>{
        callback(callback._context.extension.options.user.timeZone);
    };
    const $a926109b642703d4$export$180605366c04f0cd = (callback)=>{
        const userLocale = (0, (0, parcelRequire("dH9DT")).getMeta)('user-locale');
        callback(userLocale);
    };
});
parcelRegister("hAzkC", function(module, exports) {
    $parcel$export(module.exports, "registerDashboardItemEvents", ()=>$64f630b683689bef$export$8383c54277d3f27c);
    $parcel$export(module.exports, "setDashboardItemTitle", ()=>$64f630b683689bef$export$38ac4c404e60eefa);
    $parcel$export(module.exports, "isDashboardItemEditable", ()=>$64f630b683689bef$export$f286d5133269adb9);
    var $dH9DT;
    const $64f630b683689bef$var$ready = (callback)=>{
        if (document.readyState !== 'loading') callback();
        document.addEventListener('DOMContentLoaded', callback);
    };
    const $64f630b683689bef$var$resizeGadget = (target, height)=>{
        if (window.dashboardSpaBridge) {
            const gadget = target.closest('[data-gadget-id]');
            if (gadget && height) {
                const gadgetId = gadget.getAttribute('data-gadget-id');
                window.dashboardSpaBridge.setGadgetHeight(gadgetId, height.replace(/[^0-9.]/g, ''));
            }
        }
    };
    const $64f630b683689bef$export$8383c54277d3f27c = (connectHost)=>{
        connectHost.onIframeEstablished((data)=>{
            $64f630b683689bef$var$resizeGadget(data.$el);
        });
        $64f630b683689bef$var$ready(()=>{
            (0, (0, parcelRequire("dH9DT")).getJQuery)()('body').on('resized', '.ap-container', (e, dimensions)=>{
                $64f630b683689bef$var$resizeGadget(e.target, dimensions.height);
            });
        });
    };
    const $64f630b683689bef$export$38ac4c404e60eefa = (title, callback)=>{
        if (window.dashboardSpaBridge) {
            const container = document.getElementById(callback._context.extension_id);
            if (container) {
                const gadget = container.closest('[data-gadget-id]');
                if (gadget) {
                    const gadgetId = gadget.getAttribute('data-gadget-id');
                    window.dashboardSpaBridge.setGadgetTitle(gadgetId, title);
                }
            }
        }
    };
    const $64f630b683689bef$export$f286d5133269adb9 = (callback)=>{
        if (window.dashboardSpaBridge) {
            const container = document.getElementById(callback._context.extension_id);
            if (container) {
                const gadget = container.closest('[data-gadget-id]');
                if (gadget) {
                    const gadgetId = gadget.getAttribute('data-gadget-id');
                    const isEditable = window.dashboardSpaBridge.isGadgetConfigurable(gadgetId);
                    callback(isEditable);
                }
            }
        }
    };
});
parcelRegister("84zci", function(module, exports) {
    $parcel$export(module.exports, "registerJiraModules", ()=>$deddea1692e0bd16$export$678cf6bca310aa87);
    var $3w0nn;
    const $deddea1692e0bd16$export$678cf6bca310aa87 = (connectHost)=>{
        connectHost.defineModule('jira', (0, (0, parcelRequire("3w0nn")).jiraModule));
    };
});
parcelRegister("3w0nn", function(module, exports) {
    $parcel$export(module.exports, "jiraModule", ()=>$b4db77df861cc270$export$ffc0ed89cd56064);
    var $hAzkC;
    var $6PGpa;
    var $1n05T;
    var $bDlZS;
    var $1RlBh;
    var $j7NoY;
    var $aVXdO;
    const $b4db77df861cc270$export$ffc0ed89cd56064 = {
        refreshIssuePage: (0, parcelRequire("1n05T")).refreshIssuePage,
        updateIssueGlance: (0, parcelRequire("1n05T")).updateIssueGlance,
        getWorkflowConfiguration: (0, parcelRequire("aVXdO")).getWorkflowConfiguration,
        _submitWorkflowConfigurationResponse: (0, parcelRequire("aVXdO"))._submitWorkflowConfigurationResponse,
        isDashboardItemEditable: (0, parcelRequire("hAzkC")).isDashboardItemEditable,
        setDashboardItemTitle: (0, parcelRequire("hAzkC")).setDashboardItemTitle,
        openCreateIssueDialog: (0, parcelRequire("bDlZS")).openCreateIssueDialog,
        openIssueDialog: (0, parcelRequire("bDlZS")).openIssueDialog,
        openDatePicker: (0, parcelRequire("6PGpa")).openDatePicker,
        initJQLEditor: (0, parcelRequire("1RlBh")).initJQLEditor,
        showJQLEditor: (0, parcelRequire("1RlBh")).showJQLEditor,
        isNativeApp: (0, parcelRequire("j7NoY")).isNativeApp
    };
});
parcelRegister("6PGpa", function(module, exports) {
    $parcel$export(module.exports, "openDatePicker", ()=>$cb1f64ab07da5b90$export$621a48d450e82cf);
    var $c54aU;
    const $cb1f64ab07da5b90$var$defaultPos = {
        top: 0,
        left: 0
    };
    const $cb1f64ab07da5b90$var$_options = (options, callback)=>{
        const finalOptions = options;
        finalOptions.onSelect = (calendarInstance, date)=>{
            window.connectHost.broadcastEvent('jira_date_selected', {
                id: callback._context.extension_id
            }, {
                isoDate: calendarInstance.date.toISOString(),
                date: date
            });
            if (calendarInstance.dateClicked) calendarInstance.callCloseHandler();
        };
        const iframeBox = document.getElementById(callback._context.extension_id)?.getBoundingClientRect();
        finalOptions.position = options.position || $cb1f64ab07da5b90$var$defaultPos;
        finalOptions.position.top += iframeBox?.top ?? 0;
        finalOptions.position.left += iframeBox?.left ?? 0;
        return finalOptions;
    };
    const $cb1f64ab07da5b90$export$621a48d450e82cf = (options, callback)=>{
        const finalOptions = $cb1f64ab07da5b90$var$_options(options, callback);
        (0, (0, parcelRequire("c54aU")).show)(finalOptions);
        return finalOptions;
    };
});
parcelRegister("c54aU", function(module, exports) {
    $parcel$export(module.exports, "show", ()=>$43d7c31c7bc2a4ca$export$57bf213be019eeb0);
    var $8Rkzz = parcelRequire("8Rkzz");
    var $805TZ;
    const $43d7c31c7bc2a4ca$var$DEFAULT_DATEPICKER_CONFIG = {
        dateFormat: '%e/%b/%y',
        dateTimeFormat: '%e/%b/%y %I:%M %p',
        timeFormat: '12',
        firstDay: 1,
        useISO8601WeekNumbers: false
    };
    let $43d7c31c7bc2a4ca$var$fetchDatePickerConfigPromise = null;
    function $43d7c31c7bc2a4ca$var$fetchDatePickerConfig() {
        return fetch('/rest/internal/latest/connect/data/datepicker').then((response)=>response.json()).catch(()=>$43d7c31c7bc2a4ca$var$DEFAULT_DATEPICKER_CONFIG);
    }
    function $43d7c31c7bc2a4ca$var$initCal() {
        const initCalendarPromise = new Promise((resolve)=>{
            (0, (0, parcelRequire("805TZ")).loadCalendarResources)(resolve);
        });
        if ($43d7c31c7bc2a4ca$var$fetchDatePickerConfigPromise === null) $43d7c31c7bc2a4ca$var$fetchDatePickerConfigPromise = $43d7c31c7bc2a4ca$var$fetchDatePickerConfig();
        return Promise.all([
            $43d7c31c7bc2a4ca$var$fetchDatePickerConfigPromise,
            initCalendarPromise
        ]).then((results)=>results[0]);
    }
    function $43d7c31c7bc2a4ca$var$initAndShow(params) {
        $43d7c31c7bc2a4ca$var$initCal().then($43d7c31c7bc2a4ca$var$showInternal.bind(this, params)).catch(console.error);
    }
    function $43d7c31c7bc2a4ca$var$showInternal(params, config) {
        let cal = window.calendar;
        const firstDayOfWeekDefault = Calendar._FD ? undefined : 1;
        if (cal) cal.hide();
        let finalParams = params || {};
        finalParams = Object.assign(finalParams, config, {
            singleClick: 'true',
            inputField: {}
        });
        cal = new Calendar(finalParams.useISO8601WeekNumbers ? 1 : firstDayOfWeekDefault, finalParams.date, new Date().toISOString(), finalParams.onSelect || (0, ($parcel$interopDefault($8Rkzz))), (calParam)=>{
            calParam.hide();
            calParam.destroy();
        });
        window.calendar = cal;
        cal.weekNumbers = true;
        cal.showsOtherMonths = false;
        cal.params = finalParams;
        cal.showsTime = finalParams.showTime;
        cal.time24 = finalParams.timeFormat === '24';
        const formatString = finalParams.showTime ? finalParams.dateTimeFormat : finalParams.dateFormat;
        cal.setDateFormat(formatString);
        cal.create();
        cal.refresh();
        cal.showAt(finalParams.position.left || 0, finalParams.position.top || 0);
        return cal;
    }
    const $43d7c31c7bc2a4ca$export$57bf213be019eeb0 = $43d7c31c7bc2a4ca$var$initAndShow;
});
parcelRegister("805TZ", function(module, exports) {
    $parcel$export(module.exports, "loadCalendarResources", ()=>$af7eba98619391e0$export$5aed7c13cbb290bf);
    var $lzeFL;
    var $4su49;
    var $6sEtc;
    var $dH9DT;
    const $af7eba98619391e0$var$getLocale = ()=>(0, (0, parcelRequire("dH9DT")).getMeta)('user-locale') || (0, (0, parcelRequire("lzeFL")).defaultLocale);
    const $af7eba98619391e0$export$5aed7c13cbb290bf = (cb)=>{
        const locale = $af7eba98619391e0$var$getLocale();
        const wrmKey = (0, (0, parcelRequire("6sEtc")).default)(locale);
        (0, (0, parcelRequire("4su49")).asyncWrmRequire)([
            wrmKey
        ]).then(cb);
    };
});
parcelRegister("4su49", function(module, exports) {
    $parcel$export(module.exports, "asyncWrmRequire", ()=>$ae90ef6541667ecb$export$1024fe099ca05f05);
    $parcel$export(module.exports, "asyncWrmRequireWithPrefetch", ()=>$ae90ef6541667ecb$export$3ca0de203efa570e);
    var $8JNtu;
    var $5Ik5Y;
    const $ae90ef6541667ecb$export$1024fe099ca05f05 = (resourcesToRequire)=>(0, (0, parcelRequire("8JNtu")).wrmRequire)(resourcesToRequire);
    const $ae90ef6541667ecb$export$3ca0de203efa570e = (resourcesToRequire, batchUrl)=>(0, (0, parcelRequire("5Ik5Y")).wrmRequireWithPrefetch)(resourcesToRequire, batchUrl);
});
parcelRegister("6sEtc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f3196b461144533e$export$2e2bcd8739ae039);
    const $f3196b461144533e$var$calendarLocaleMap = {
        cs_CZ: 'calendar-cs',
        da_DK: 'calendar-da',
        de_DE: 'calendar-de',
        en_GB: 'calendar-en',
        en_UK: 'calendar-en',
        en_ZZ: 'calendar-en',
        en_US: 'calendar-en',
        es_ES: 'calendar-es',
        et_EE: 'calendar-en',
        fi_FI: 'calendar-fi',
        fr_FR: 'calendar-fr',
        hu_HU: 'calendar-hu',
        is_IS: 'calendar-en',
        it_IT: 'calendar-it',
        ja_JP: 'calendar-jp',
        ko_KR: 'calendar-ko',
        nb_NO: 'calendar-no',
        nl_NL: 'calendar-nl',
        pl_PL: 'calendar-pl',
        pt_BR: 'calendar-pt',
        pt_PT: 'calendar-pt',
        ro_RO: 'calendar-ro',
        ru_RU: 'calendar-ru',
        sk_SK: 'calendar-sk',
        sv_SE: 'calendar-sv',
        tr_TR: 'calendar-tr',
        zh_CN: 'calendar-zh',
        zh_TW: 'calendar-zh'
    };
    const $f3196b461144533e$var$getCalendarResource = (locale)=>$f3196b461144533e$var$calendarLocaleMap[locale] || $f3196b461144533e$var$calendarLocaleMap.en_US;
    var $f3196b461144533e$export$2e2bcd8739ae039 = (locale)=>`wrc!jira.webresources:${$f3196b461144533e$var$getCalendarResource(locale)}`;
});
parcelRegister("1n05T", function(module, exports) {
    $parcel$export(module.exports, "refreshIssuePage", ()=>$9a14664a765ea037$export$482358e36f87d06b);
    $parcel$export(module.exports, "updateIssueGlance", ()=>$9a14664a765ea037$export$251c332773cefeaa);
    var $fjcgS;
    const $9a14664a765ea037$var$REFRESH_ISSUE_PAGE_EVENT = 'legacy_refreshIssuePage';
    const $9a14664a765ea037$var$UPDATE_ISSUE_GLANCE_EVENT = 'legacy_updateIssueGlance';
    const $9a14664a765ea037$export$482358e36f87d06b = ()=>{
        const event = new CustomEvent($9a14664a765ea037$var$REFRESH_ISSUE_PAGE_EVENT);
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((analyticsClient)=>{
            analyticsClient.getInstance().sendTrackEvent({
                source: 'jiraConnect',
                actionSubject: 'refreshIssuePage',
                action: 'called',
                attributes: {
                    isSpa: !!window.__SPA__
                }
            });
        });
        document.dispatchEvent(event);
    };
    const $9a14664a765ea037$export$251c332773cefeaa = (data, callback)=>{
        const event = new CustomEvent($9a14664a765ea037$var$UPDATE_ISSUE_GLANCE_EVENT, {
            detail: [
                null,
                {
                    addonKey: callback._context.extension.addon_key,
                    moduleKey: callback._context.extension.key,
                    data: data
                }
            ]
        });
        document.dispatchEvent(event);
    };
});
parcelRegister("bDlZS", function(module, exports) {
    $parcel$export(module.exports, "openCreateIssueDialog", ()=>$32d0c3ecfe65817e$export$1ccba88f31e61cc8);
    $parcel$export(module.exports, "openIssueDialog", ()=>$32d0c3ecfe65817e$export$de105a441f8fcccf);
    var $4R6GH;
    var $4su49;
    const $32d0c3ecfe65817e$export$1ccba88f31e61cc8 = (fields, callback)=>{
        if ((0, (0, parcelRequire("4R6GH")).fg)('ecosystem_api_to_show_modern_gic')) {
            document.dispatchEvent(new CustomEvent('openIssueCreateDialog', {
                detail: {
                    triggerPointKey: 'connect-app-ecosystem',
                    payload: {
                        isEcosystemAPI: true,
                        callback: callback,
                        prefilledFields: fields ? {
                            pid: fields?.pid,
                            issuetype: fields?.issueType,
                            ...fields?.fields
                        } : {}
                    }
                }
            }));
            return;
        }
        (0, (0, parcelRequire("4su49")).asyncWrmRequire)([
            'wrc!com.atlassian.jira.jira-quick-edit-plugin:quick-create-issue'
        ]).then(()=>{
            if (!JIRA || !JIRA.Forms || !JIRA.Forms.createCreateIssueForm) {
                console.warn('Connect: Create issue form is not available');
                return;
            }
            const dialog = JIRA.Forms.createCreateIssueForm(fields).asDialog({
                trigger: document.createElement('a'),
                id: 'create-issue-dialog',
                windowTitle: document.title.replace(/ - Jira$/, ''),
                shouldLoadHeritageFormDialogContext: true,
                triggerPointKey: 'ecosystemApiCreateIssue'
            });
            dialog.show();
            let sanitizedIssues = [];
            const createCallback = (_event, issues)=>{
                sanitizedIssues = issues.map((issue)=>issue.createdIssueDetails);
            };
            JIRA.one('QuickCreateIssue.sessionComplete', createCallback);
            dialog.bind('Dialog.hide', ()=>{
                if (typeof callback === 'function') callback.call({}, sanitizedIssues);
            });
        });
    };
    const $32d0c3ecfe65817e$export$de105a441f8fcccf = (issueKey, callback)=>{
        (0, (0, parcelRequire("4su49")).asyncWrmRequire)([
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:async-modals'
        ]).then(()=>{
            const modalsPromise = window.require('jira/async-modals');
            modalsPromise.then((modals)=>{
                if (!modals.showConnectIssueModal) {
                    console.warn('Connect: open issue dialog is not available');
                    callback('OPEN_ISSUE_DIALOG_IS_NOT_AVAILABLE');
                    return;
                }
                modals.showConnectIssueModal({
                    issueKey: issueKey,
                    onCancel: callback,
                    onError: callback
                });
            });
        });
    };
});
parcelRegister("1RlBh", function(module, exports) {
    $parcel$export(module.exports, "initJQLEditor", ()=>$08b99cafd4fda946$export$f8f43a2661a2efdc);
    $parcel$export(module.exports, "showJQLEditor", ()=>$08b99cafd4fda946$export$a77b12a5b8963378);
    const $08b99cafd4fda946$var$escapeHTML = (str)=>{
        const special = {
            '<': '&lt;',
            '>': '&gt;',
            '&': '&amp;',
            "'": '&#39;',
            '`': '&#96;'
        };
        return str.replace(/[&"'<>`]/g, (char)=>{
            if (typeof special[char] === 'string') return special[char];
            return '&quot;';
        });
    };
    const $08b99cafd4fda946$var$TEMPLATES = {
        dialog: (options)=>{
            const sectionId = $08b99cafd4fda946$var$escapeHTML(options.sectionId || '');
            const header = $08b99cafd4fda946$var$escapeHTML(options.header || '');
            const src = $08b99cafd4fda946$var$escapeHTML(options.src || '');
            const frameId = $08b99cafd4fda946$var$escapeHTML(options.frameId || '');
            const submitButtonId = $08b99cafd4fda946$var$escapeHTML(options.submitButtonId || '');
            const cancelButtonId = $08b99cafd4fda946$var$escapeHTML(options.cancelButtonId || '');
            const descriptionText = $08b99cafd4fda946$var$escapeHTML(options.descriptionText || '');
            const submitText = $08b99cafd4fda946$var$escapeHTML(options.submitText || '');
            const cancelText = $08b99cafd4fda946$var$escapeHTML(options.cancelText || '');
            const html = `
<section id="${sectionId}" class="aui-dialog2 aui-dialog2-xlarge aui-layer" data-aui-remove-on-hide="true" role="dialog" aria-hidden="true">
    <header class="aui-dialog2-header">
        <h2>${header}</h2>
    </header>
    <div style="height: 100%; overflow: hidden; display: flex; flex-direction: column; background-color: ${"var(--ds-surface-overlay, #FFFFFF)"};">
        <p>${descriptionText}</p>
        <iframe src="${src}" id="${frameId}" style="flex: 1; border: none;"></iframe>
    </div>
    <footer class="aui-dialog2-footer">
        <div class="aui-dialog2-footer-actions">
            <button id="${submitButtonId}" class="aui-button aui-button-primary">
                ${submitText}
            </button>
            <button id="${cancelButtonId}" class="aui-button aui-button-link">
                ${cancelText}
            </button>
        </div>
    </footer>
</section>
            `;
            return html.trim();
        }
    };
    const $08b99cafd4fda946$var$frameId = 'connect-app-jql-editor-frame-id';
    const $08b99cafd4fda946$var$sectionId = 'connect-app-jql-editor-section-id';
    const $08b99cafd4fda946$var$submitButtonId = 'connect-app-jql-editor-submit-id';
    const $08b99cafd4fda946$var$cancelButtonId = 'connect-app-jql-editor-cancel-id';
    const $08b99cafd4fda946$export$f8f43a2661a2efdc = ()=>{};
    const $08b99cafd4fda946$export$a77b12a5b8963378 = (options, callback)=>{
        const src = `/issues/?app=true&jql=${options.jql || ''}`;
        const container = document.createElement('div');
        container.innerHTML = $08b99cafd4fda946$var$TEMPLATES.dialog({
            src: src,
            frameId: $08b99cafd4fda946$var$frameId,
            sectionId: $08b99cafd4fda946$var$sectionId,
            submitButtonId: $08b99cafd4fda946$var$submitButtonId,
            cancelButtonId: $08b99cafd4fda946$var$cancelButtonId,
            header: options.header || 'JQL Editor',
            submitText: options.submitText || 'Submit',
            cancelText: options.cancelText || 'Cancel',
            descriptionText: (options.descriptionText || '').substring(0, 512)
        });
        document.body.appendChild(container.firstChild);
        const onCancel = (e)=>{
            e.preventDefault();
            AJS.dialog2(`#${$08b99cafd4fda946$var$sectionId}`).hide();
        };
        const onSubmit = (e)=>{
            e.preventDefault();
            const frameDocument = document.getElementById($08b99cafd4fda946$var$frameId).contentWindow.document;
            frameDocument.querySelector('.search-button').click();
            const jql = new URLSearchParams(frameDocument.location.search).get('jql');
            AJS.dialog2(`#${$08b99cafd4fda946$var$sectionId}`).hide();
            callback({
                jql: jql
            });
        };
        AJS.dialog2(`#${$08b99cafd4fda946$var$sectionId}`).show();
        document.getElementById($08b99cafd4fda946$var$cancelButtonId)?.addEventListener('click', onCancel);
        document.getElementById($08b99cafd4fda946$var$submitButtonId)?.addEventListener('click', onSubmit);
    };
});
parcelRegister("j7NoY", function(module, exports) {
    $parcel$export(module.exports, "isNativeApp", ()=>$91d7f786954e47db$export$1efe58f5634014d1);
    var $4R6GH;
    const $91d7f786954e47db$export$1efe58f5634014d1 = (callback)=>{
        const userAgent = (0, (0, parcelRequire("4R6GH")).fg)('jfp-magma-undefined-navigator') ? globalThis.navigator?.userAgent : window.navigator.userAgent;
        let result = false;
        const iOS = /iPhone|iPod|iPad/i.test(userAgent);
        const containsSafari = /Safari/i.test(userAgent);
        const android = /Android/i.test(userAgent);
        const hasWvString = /wv/i.test(userAgent);
        if (iOS && !containsSafari) result = true;
        else if (android && hasWvString) result = true;
        callback(result);
    };
});
parcelRegister("aVXdO", function(module, exports) {
    $parcel$export(module.exports, "registerWorkflowEvents", ()=>$8f9d4d59f8462bdd$export$2a42d5696be1004);
    $parcel$export(module.exports, "getWorkflowConfiguration", ()=>$8f9d4d59f8462bdd$export$47077912f910d247);
    $parcel$export(module.exports, "_submitWorkflowConfigurationResponse", ()=>$8f9d4d59f8462bdd$export$4ec07293221010d8);
    var $9Fgs0;
    let $8f9d4d59f8462bdd$var$workflowSubmissionCallback = ()=>{};
    const $8f9d4d59f8462bdd$export$2a42d5696be1004 = (connectHost)=>{
        connectHost.onIframeEstablished((ext)=>{
            const { moduleType: moduleType } = ext.extension.options;
            if (moduleType && (0, (0, parcelRequire("9Fgs0")).isOnWorkflowElementPage)(moduleType) && (0, (0, parcelRequire("9Fgs0")).isWorkflowElementExtension)(ext.extension)) {
                const workflowElementId = (0, (0, parcelRequire("9Fgs0")).getWorkflowElementId)(moduleType);
                if (typeof workflowElementId === 'string') (0, (0, parcelRequire("9Fgs0")).registerSubmissionButton)(moduleType, workflowElementId, (callback)=>{
                    $8f9d4d59f8462bdd$var$workflowSubmissionCallback = callback;
                    connectHost.broadcastEvent('jira_workflow_post_function_submit', {
                        id: ext.extension.id
                    });
                });
            }
        });
    };
    const $8f9d4d59f8462bdd$export$47077912f910d247 = (callback)=>{
        if (typeof callback !== 'function') return false;
        const { moduleType: moduleType } = callback._context.extension.options;
        if (!moduleType || !(0, (0, parcelRequire("9Fgs0")).isOnWorkflowElementPage)(moduleType)) return false;
        const productContext = callback._context.extension?.options?.productContext;
        const val = (0, (0, parcelRequire("9Fgs0")).workflowElementConfigInput)(moduleType, productContext?.[`${(0, (0, parcelRequire("9Fgs0")).getWorkflowElementName)(moduleType)}.id`]);
        if (callback) callback(val);
        return true;
    };
    const $8f9d4d59f8462bdd$export$4ec07293221010d8 = (data)=>{
        $8f9d4d59f8462bdd$var$workflowSubmissionCallback(data);
    };
});
parcelRegister("9Fgs0", function(module, exports) {
    $parcel$export(module.exports, "getWorkflowElementName", ()=>$fc39437b3a1a55ed$export$6ddbba7c02f0071d);
    $parcel$export(module.exports, "getWorkflowElementId", ()=>$fc39437b3a1a55ed$export$4fa76f00a14322f7);
    $parcel$export(module.exports, "workflowElementConfigInput", ()=>$fc39437b3a1a55ed$export$8f6d97134a58e3af);
    $parcel$export(module.exports, "isOnWorkflowElementPage", ()=>$fc39437b3a1a55ed$export$8a3515e64a5462ae);
    $parcel$export(module.exports, "registerSubmissionButton", ()=>$fc39437b3a1a55ed$export$c6f23e119e570a4e);
    $parcel$export(module.exports, "isWorkflowElementExtension", ()=>$fc39437b3a1a55ed$export$90d72e4f8ced2d81);
    var $dH9DT;
    const $fc39437b3a1a55ed$var$delegate = (container, selector, type, listener, options)=>{
        container.addEventListener(type, function(event) {
            const { target: target } = event;
            if (target && target instanceof Element) {
                const matched = target.closest(selector);
                if (matched) listener.apply(matched, arguments);
            }
        }, options);
    };
    function $fc39437b3a1a55ed$export$6ddbba7c02f0071d(moduleType) {
        if (moduleType === 'jiraWorkflowPostFunctions' && document.querySelectorAll("input[name='postFunction.id']").length > 0) return 'postFunction';
        if (moduleType === 'jiraWorkflowConditions' && document.querySelectorAll("input[name='condition.id']").length > 0) return 'condition';
        if (moduleType === 'jiraWorkflowValidators' && document.querySelectorAll("input[name='validator.id']").length > 0) return 'validator';
        return null;
    }
    function $fc39437b3a1a55ed$export$4fa76f00a14322f7(moduleType) {
        if (!moduleType) throw new Error('Missing module type');
        const inputName = (0, (0, parcelRequire("dH9DT")).escapeSelector)($fc39437b3a1a55ed$export$6ddbba7c02f0071d(moduleType));
        const selector = `input[name='${inputName}.id']`;
        const elem = document.querySelector(selector);
        return elem && elem.value;
    }
    function $fc39437b3a1a55ed$export$8f6d97134a58e3af(moduleType, workflowElementId, val) {
        const idPrefix = (0, (0, parcelRequire("dH9DT")).escapeSelector)($fc39437b3a1a55ed$export$6ddbba7c02f0071d(moduleType));
        const idPostfix = (0, (0, parcelRequire("dH9DT")).escapeSelector)(workflowElementId);
        const selector = `#${idPrefix}-config-${idPostfix}`;
        const element = document.querySelector(selector);
        if (val && element) element.value = val;
        return element ? element.value : undefined;
    }
    function $fc39437b3a1a55ed$export$8a3515e64a5462ae(moduleType) {
        return Boolean($fc39437b3a1a55ed$export$6ddbba7c02f0071d(moduleType));
    }
    function $fc39437b3a1a55ed$export$c6f23e119e570a4e(moduleType, workflowElementId, callback, repeat) {
        if (!moduleType) throw new Error('Missing module type');
        if (!$fc39437b3a1a55ed$export$8a3515e64a5462ae(moduleType)) throw new Error('Not on a workflow configuration page');
        let done = false;
        $fc39437b3a1a55ed$var$delegate(document, '#add_submit, #update_submit', 'click', (e)=>{
            if (!done || repeat) {
                e.preventDefault();
                const workflowSubmissionCallback = (either)=>{
                    if (either.valid) {
                        $fc39437b3a1a55ed$export$8f6d97134a58e3af(moduleType, workflowElementId, either.value);
                        done = true;
                        const { target: target } = e;
                        if (target && 'click' in target) target.click();
                    }
                };
                callback(workflowSubmissionCallback);
            }
        });
    }
    function $fc39437b3a1a55ed$export$90d72e4f8ced2d81(extension) {
        if (extension && extension.options && extension.options.productContext && extension.options.moduleType) {
            const ctx = extension.options.productContext;
            const { moduleType: moduleType } = extension.options;
            if (moduleType && ctx[`${$fc39437b3a1a55ed$export$6ddbba7c02f0071d(moduleType)}.id`] && ctx[`${$fc39437b3a1a55ed$export$6ddbba7c02f0071d(moduleType)}.id`].length > 5) return true;
        }
        return false;
    }
});
parcelRegister("50DPg", function(module, exports) {
    $parcel$export(module.exports, "registerJiraRoutes", ()=>$0331663820643a94$export$5e6c900dd6c96dc5);
    var $5UQTz;
    var $bW9IK;
    const $0331663820643a94$export$5e6c900dd6c96dc5 = ()=>{
        const routes = {
            filters: '/secure/ManageFilters.jspa',
            projects: '/secure/BrowseProjects.jspa',
            boards: '/secure/ManageRapidViews.jspa',
            dashboards: '/secure/ConfigurePortalPages!default.jspa',
            dashboard: '/secure/Dashboard.jspa?selectPageId={dashboardId}',
            issue: '/browse/{issueKey}',
            userprofile: (context, callback)=>{
                const profileBaseUrl = '/secure/admin/user/ViewProfile.jspa';
                let url;
                if ((0, (0, parcelRequire("bW9IK")).hasContext)(context, 'userAccountId')) url = (0, (0, parcelRequire("bW9IK")).appendQueryParam)(profileBaseUrl, 'accountId', context.userAccountId);
                else if ((0, (0, parcelRequire("bW9IK")).hasContext)(context, 'username')) url = (0, (0, parcelRequire("bW9IK")).appendQueryParam)(profileBaseUrl, 'username', context.username);
                else url = `${profileBaseUrl}?name=`;
                callback(url);
            },
            projectadminsummary: '/plugins/servlet/project-config/{projectKey}/summary',
            projectadmintabpanel: '/plugins/servlet/ac/{addonKey}/{adminPageKey}?project.key={projectKey}&project.id={projectId}'
        };
        (0, (0, parcelRequire("5UQTz")).addRoutes)(routes);
        (0, (0, parcelRequire("bW9IK")).enableApi)();
    };
});
parcelRegister("3Vshz", function(module, exports) {
    $parcel$export(module.exports, "waitForLegacyConnectWRM", ()=>$5af026b2ec006ed7$export$879ee0ac429a02f9);
    var $cQZXC;
    const $5af026b2ec006ed7$export$879ee0ac429a02f9 = (timeout)=>Promise.race([
            (0, (0, parcelRequire("cQZXC")).waitForHeritage)(),
            new Promise((_, reject)=>setTimeout(()=>reject(new Error('timeout waiting for heritage batch')), timeout))
        ]);
});
